unit PrjFormPeriodicData;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PrjFormDefault,
  Vcl.Imaging.GIFImg,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Controls,
  WEBLib.StdCtrls,
  PrjClassHBMDataAccess,
  Vcl.Imaging.jpeg,
  WEBLib.ExtCtrls,
  WEBLib.ComCtrls,
  WEBLib.CheckLst,
  Types,
  Vcl.Grids,
  WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, WEBLib.CDS, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection;

type
  TPrjFormsPeriodicData = class(TPrjFormsDefault)
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    lblAbteilung: TLabel;
    spedAbteilung: TSpinEdit;
    lblFallnummer: TLabel;
    spedFallNummer: TSpinEdit;
    PageControl: TPageControl;
    pgSeite1: TTabSheet;
    pgSeite3: TTabSheet;
    pgSeite4: TTabSheet;
    pgSeite5: TTabSheet;
    pgSeite6: TTabSheet;
    pnErloeseWahlleistung: TPanel;
    Lab0_Stat21: TLabel;
    Lab0_Stat31: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebImageControl1: TImageControl;
    lblAbteilungsName: TLabel;
    RFE_Stat1Unterk: TDBEdit;
    RFE_Stat2Unterk: TDBEdit;
    RFE_Stat3Unterk: TDBEdit;
    RFE_Stat1Arzt: TDBEdit;
    RFE_Stat2Arzt: TDBEdit;
    RFE_Stat3Arzt: TDBEdit;
    pnErloesKorrekturen: TPanel;
    Lab0_Stat11: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    RFE_ErlKorrU1: TDBEdit;
    RFE_ErlKorrU2: TDBEdit;
    RFE_ErlKorrU3: TDBEdit;
    RFE_ErlKorrU4: TDBEdit;
    RFE_ErlKorrU5: TDBEdit;
    pnInvestKosten: TPanel;
    WebLabel14: TLabel;
    RFE_InvestProBett: TDBEdit;
    pnUmwandlungKosten: TPanel;
    Lab0_Stat14: TLabel;
    Lab0_Stat24: TLabel;
    Lab0_Stat34: TLabel;
    Lab0_Stat13: TLabel;
    Lab0_Stat23: TLabel;
    Lab0_Stat33: TLabel;
    RFE_UmwKoS2toS1: TDBEdit;
    RFE_UmwKoS3toS1: TDBEdit;
    RFE_UmwKoS1toS2: TDBEdit;
    RFE_UmwKoS3toS2: TDBEdit;
    RFE_UmwKoS1toS3: TDBEdit;
    RFE_UmwKoS2toS3: TDBEdit;
    pnDRGVerwaltung: TPanel;
    pnAnteileMode: TPanel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    lblFallName: TLabel;
    RF2_agBewRel: TDBEdit;
    RF2_PflgBewRel: TDBEdit;
    pnErloeseKorrekturen: TPanel;
    Lab_ErloesKor: TLabel;
    Lab_agErloes: TLabel;
    Lab_PflgErloes: TLabel;
    pnPersonalDaten: TPanel;
    WebLabel49: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel52: TLabel;
    WebLabel53: TLabel;
    WebLabel54: TLabel;
    WebLabel55: TLabel;
    WebLabel56: TLabel;
    WebLabel57: TLabel;
    WebLabel58: TLabel;
    WebLabel59: TLabel;
    WebLabel60: TLabel;
    WebLabel61: TLabel;
    WebLabel62: TLabel;
    WebLabel63: TLabel;
    WebLabel64: TLabel;
    WebLabel65: TLabel;
    WebLabel66: TLabel;
    WebLabel67: TLabel;
    LFE_ArbZeitA: TDBEdit;
    RFE_StdSatzA: TDBEdit;
    RFE_GehNebKoA: TDBEdit;
    RFE_MaxUeberA: TDBEdit;
    RFE_UeZuschlA: TDBEdit;
    RFE_EinstlKoA: TDBEdit;
    RFE_EntlasKoA: TDBEdit;
    RFE_MaxEinstA: TDBEdit;
    RFE_MaxEntlaA: TDBEdit;
    RFE_TrainKstA: TDBEdit;
    RFE_FremdPKoA: TDBEdit;
    RFE_GehChefA: TDBEdit;
    LFE_ArbZeitP: TDBEdit;
    RFE_StdSatzP: TDBEdit;
    RFE_GehNebKoP: TDBEdit;
    RFE_MaxUeberP: TDBEdit;
    RFE_UeZuschlP: TDBEdit;
    RFE_EinstlKoP: TDBEdit;
    RFE_EntlasKoP: TDBEdit;
    RFE_MaxEinstP: TDBEdit;
    RFE_MaxEntlaP: TDBEdit;
    RFE_TrainKstP: TDBEdit;
    RFE_FremdPKoP: TDBEdit;
    LFE_ArbZeitM: TDBEdit;
    RFE_StdSatzM: TDBEdit;
    RFE_GehNebKoM: TDBEdit;
    RFE_MaxUeberM: TDBEdit;
    RFE_UeZuschlM: TDBEdit;
    RFE_EinstlKoM: TDBEdit;
    RFE_EntlasKoM: TDBEdit;
    RFE_MaxEinstM: TDBEdit;
    RFE_MaxEntlaM: TDBEdit;
    RFE_TrainKstM: TDBEdit;
    RFE_FremdPKoM: TDBEdit;
    RFE_GehDirek: TDBEdit;
    RFE_Rueckst: TDBEdit;
    RFE_AbFktGN: TDBEdit;
    RFE_AnGZeit: TDBEdit;
    pnCodierDienst: TPanel;
    WebLabel89: TLabel;
    WebLabel90: TLabel;
    WebLabel91: TLabel;
    WebLabel93: TLabel;
    RFE_FallSatz: TDBEdit;
    RFE_FaellePro: TDBEdit;
    RFE_CodLeasing: TDBEdit;
    RFE_CodInfrStr: TDBEdit;
    pnGenerelles: TPanel;
    WebLabel81: TLabel;
    WebLabel82: TLabel;
    WebLabel83: TLabel;
    WebLabel84: TLabel;
    WebLabel85: TLabel;
    WebLabel86: TLabel;
    WebLabel87: TLabel;
    WebLabel88: TLabel;
    RFE_AbschrDAnl: TDBEdit;
    RFE_AbschrSGeb: TDBEdit;
    RFE_AbschrDEin: TDBEdit;
    RFE_AbtRestBdg: TDBEdit;
    RFE_Patientver: TDBEdit;
    RFE_AntWahlL: TDBEdit;
    RFE_InstndSI: TDBEdit;
    RFE_InstndSA: TDBEdit;
    pnKassenDaten: TPanel;
    WebLabel96: TLabel;
    WebLabel97: TLabel;
    WebLabel98: TLabel;
    RFE_PktKorrFkt: TDBEdit;
    RFE_PktWertPer: TDBEdit;
    RFE_PktWertMed: TDBEdit;
    pnSonstiges: TPanel;
    WebLabel68: TLabel;
    WebLabel69: TLabel;
    WebLabel71: TLabel;
    WebLabel73: TLabel;
    WebLabel74: TLabel;
    WebLabel75: TLabel;
    lblKrankenhaus1: TLabel;
    lblKrankenhaus2: TLabel;
    lblKrankenhaus3: TLabel;
    lblKrankenhaus4: TLabel;
    lblKrankenhaus5: TLabel;
    WebLabel107: TLabel;
    WebLabel108: TLabel;
    RFE_AusOrdAufw1: TDBEdit;
    RFE_AusOrdErtr1: TDBEdit;
    RFE_ForderTrag1: TDBEdit;
    RFE_Forder_KHG1: TDBEdit;
    RFE_Dummy1: TDBEdit;
    RFE_Verblk_KHG1: TDBEdit;
    RFE_Kapitalerh1: TDBEdit;
    RFE_FoerderMtl1: TDBEdit;
    RFE_AusOrdAufw2: TDBEdit;
    RFE_AusOrdErtr2: TDBEdit;
    RFE_ForderTrag2: TDBEdit;
    RFE_Forder_KHG2: TDBEdit;
    RFE_Dummy2: TDBEdit;
    RFE_Verblk_KHG2: TDBEdit;
    RFE_Kapitalerh2: TDBEdit;
    RFE_FoerderMtl2: TDBEdit;
    RFE_AusOrdAufw3: TDBEdit;
    RFE_AusOrdErtr3: TDBEdit;
    RFE_ForderTrag3: TDBEdit;
    RFE_Forder_KHG3: TDBEdit;
    RFE_Dummy3: TDBEdit;
    RFE_Verblk_KHG3: TDBEdit;
    RFE_Kapitalerh3: TDBEdit;
    RFE_FoerderMtl3: TDBEdit;
    RFE_AusOrdAufw4: TDBEdit;
    RFE_AusOrdErtr4: TDBEdit;
    RFE_ForderTrag4: TDBEdit;
    RFE_Forder_KHG4: TDBEdit;
    RFE_Dummy4: TDBEdit;
    RFE_Verblk_KHG4: TDBEdit;
    RFE_Kapitalerh4: TDBEdit;
    RFE_FoerderMtl4: TDBEdit;
    RFE_AusOrdAufw5: TDBEdit;
    RFE_AusOrdErtr5: TDBEdit;
    RFE_ForderTrag5: TDBEdit;
    RFE_Forder_KHG5: TDBEdit;
    RFE_Dummy5: TDBEdit;
    RFE_Verblk_KHG5: TDBEdit;
    RFE_Kapitalerh5: TDBEdit;
    RFE_FoerderMtl5: TDBEdit;
    pnSoftSkills: TPanel;
    pnFallZahlen: TPanel;
    WebLabel40: TLabel;
    weblabStation1: TLabel;
    weblabStation2: TLabel;
    weblabStation3: TLabel;
    WebLabel44: TLabel;
    WebLabel45: TLabel;
    WebLabel46: TLabel;
    WebLabel47: TLabel;
    WebLabel48: TLabel;
    WebLabel105: TLabel;
    LF2_Fallzahl: TDBEdit;
    LF2_Stati1: TDBEdit;
    LF2_Stati2: TDBEdit;
    LF2_Stati3: TDBEdit;
    RF2_MVerwd: TDBEdit;
    RF2_GVerwD: TDBEdit;
    RF2_UebAnt: TDBEdit;
    RF2_UebTag: TDBEdit;
    pnFinanzdaten: TPanel;
    WebLabel1: TLabel;
    RFE_ZinsUeberz: TDBEdit;
    RFE_ZinsKurzfr: TDBEdit;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    RFE_ZinsLangfr: TDBEdit;
    WebLabel4: TLabel;
    RFE_ZinsAnlage: TDBEdit;
    WebLabel17: TLabel;
    RFE_SteuerSatz1: TDBEdit;
    WebLabel18: TLabel;
    RFE_SteuerSatz2: TDBEdit;
    WebLabel19: TLabel;
    RFE_KassenMind: TDBEdit;
    WebLabel28: TLabel;
    RFE_FoerderBett: TDBEdit;
    WebLabel29: TLabel;
    RFE_Sonstiges1: TDBEdit;
    strGridStationCosts: TStringGrid;
    strGridSoftSkills: TStringGrid;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    WebLabel92: TLabel;
    WebLabel94: TLabel;
    WebLabel95: TLabel;
    RFE_AntRestErl: TDBEdit;
    WebLabel112: TLabel;
    WebLabel113: TLabel;
    RFE_VerwKosten: TDBEdit;
    pnVerwaltung: TPanel;
    WebLabel101: TLabel;
    WebLabel102: TLabel;
    WebLabel7: TLabel;
    WebLabel103: TLabel;
    WebLabel104: TLabel;
    RFE_PflgWert: TDBEdit;
    WebLabel100: TLabel;
    WebLabel99: TLabel;
    RFE_FallBaWert: TDBEdit;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel30: TLabel;
    WebLabel70: TLabel;
    WebLabel72: TLabel;
    WebLabel106: TLabel;
    WebLabel109: TLabel;
    WebLabel110: TLabel;
    cbxkhEinsMVZCheckbox: TDBCheckBox;
    WebLabel15: TLabel;
    cbxkhZweiMVZCheckbox: TDBCheckBox;
    cbxkhDreiMVZCheckbox: TDBCheckBox;
    cbxkhVierMVZCheckbox: TDBCheckBox;
    cbxkhFuenfMVZCheckbox: TDBCheckBox;
    WebLabel16: TLabel;
    WebLabel111: TLabel;
    WebLabel114: TLabel;
    WebLabel115: TLabel;
    WebLabel116: TLabel;
    cbxFallName: TComboBox;
    lblNAVFallName: TLabel;
    DRGDataSource: TDataSource;
    XDataWebDataSetDRG: TXDataWebDataSet;
    XDataWebConnection1: TXDataWebConnection;
    XDataWebDataSetPeriode: TXDataWebDataSet;
    XDataWebDataSetPersonalDaten: TXDataWebDataSet;
    PersonalDataSource: TDataSource;
    XDataWebDataSetHospitalMisc1: TXDataWebDataSet;
    HospitalMisc1WebDataSource: TDataSource;
    XDataWebDataSetHospital: TXDataWebDataSet;
    XDataWebDataSetWahlleistungen: TXDataWebDataSet;
    WahlleistungenWebDataSource: TDataSource;
    XDataWebDataSetHospitalMisc2: TXDataWebDataSet;
    XDataWebDataSetHospitalMisc3: TXDataWebDataSet;
    XDataWebDataSetHospitalMisc4: TXDataWebDataSet;
    XDataWebDataSetHospitalMisc5: TXDataWebDataSet;
    HospitalMisc2WebDataSource: TDataSource;
    HospitalMisc3WebDataSource: TDataSource;
    HospitalMisc4WebDataSource: TDataSource;
    HospitalMisc5WebDataSource: TDataSource;
    XDataWebDataSetPeriodMisc: TXDataWebDataSet;
    PeriodMiscWebDataSource: TDataSource;
    WebMessageDlg: TMessageDlg;
    procedure btnCloseClick(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
    procedure cbxFallNameChange(Sender: TObject);
    procedure DRGDataSourceDataChange(Sender: TObject; Field: TField);
    procedure PageControlChange(Sender: TObject);
    procedure spedAbteilungChanged(Sender: TObject);
    procedure spedFallNummerChanged(Sender: TObject);

    procedure spedPeriodeChanged(Sender: TObject);
    procedure strGridSoftSkillsGetEditText(Sender: TObject; ACol, ARow: LongInt; var Value: string);
    procedure strGridSoftSkillsSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
    procedure strGridStationCostsGetEditText(Sender: TObject; ACol, ARow: LongInt; var Value: string);
    procedure strGridStationCostsSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
    procedure WebFormCreate(Sender: TObject);
    procedure XDataWebDataSetDRGAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalMisc1AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalMisc2AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalMisc3AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalMisc4AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetHospitalMisc5AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetPeriodeAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetPeriodMiscAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetPersonalDatenAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetWahlleistungenAfterOpen(DataSet: TDataSet);
  private
    FDataChanged: Boolean;
    FSelectedPageIndex: Integer;
    FGetValue : string;

    function SaveGridPG3StationCosts: Boolean;
    function SaveGridPG6SoftSkills: Boolean;
    { Private-Deklarationen }
  strict private
    function DrawGridPG3StationCosts: Boolean;
    function DrawGridPG6SoftSkills: Boolean;
    [Async]
    function InteractiveSaveData(const ACloseForm: Boolean): Boolean; async; virtual;

    [Async]
    function SaveData: Boolean; async;

    [Async]
    function SetupData: Boolean; async;

  public
    [Async]
    function Done: Boolean; async; override;
    [Async]
    function Init: Boolean; async; override;

    function ToggleGUI: boolean; virtual;


    { Public-Deklarationen }
  protected
    procedure SetMenuEnable(value: boolean); override;
  published
    property DataChanged: Boolean read FDataChanged write FDataChanged default false;
    property SelectedPageIndex: Integer read FSelectedPageIndex write FSelectedPageIndex default 0;
  protected procedure LoadDFMValues; override; end;

const
   cDataSaveMsg = 'Sollen die Änderungen an den Geschäftsjahr abhängigen Daten gespeichert werden ?';

var
  PrjFormsPeriodicData: TPrjFormsPeriodicData;

implementation

{$R *.dfm}

uses
  wxBaseClassWebTools,
  PrjFormMain,
  HBMWebData,
  HBMWebDef,
  PrjClassHelperClasses;



function TPrjFormsPeriodicData.Init: Boolean;
var LIDx : integer;
begin
  WaitMessage.Show;
  try
    spedPeriode.MinValue   := 0;
    spedPeriode.MaxValue   := 9;
    spedPeriode.Value      := DataModule.HBMDefaultData.AktuellePeriode;

    spedAbteilung.MinValue  := 1;
    spedAbteilung.MaxValue  := 3;
    spedAbteilung.Value     := 1;

    spedFallNummer.Value    := 1;
    spedFallNummer.MinValue := 1;
    spedFallNummer.MaxValue := drgFaelle.Count;

    await(SetUpData);

    cbxFallName.Items.Clear;
    for LIDx := 0 to drgFaelle.Count - 1 do
    begin
      cbxFallName.Items.AddObject(drgFaelle.Items[LIDx].FContent, drgFaelle.Items[LIDx]);
    end;
    if cbxFallName.Items.Count > 0 then
      cbxFallName.ItemIndex := 0;

    Lab0_Stat11.Caption := Stationen.FindAssignment(1).FContent;
    Lab0_Stat13.Caption := Stationen.FindAssignment(1).FContent;
    Lab0_Stat14.Caption := Stationen.FindAssignment(1).FContent;

    Lab0_Stat21.Caption := Stationen.FindAssignment(3).FContent;
    Lab0_Stat23.Caption := Stationen.FindAssignment(2).FContent;
    Lab0_Stat24.Caption := Stationen.FindAssignment(3).FContent;

    Lab0_Stat31.Caption := Stationen.FindAssignment(2).FContent;
    Lab0_Stat33.Caption := Stationen.FindAssignment(3).FContent;
    Lab0_Stat34.Caption := Stationen.FindAssignment(2).FContent;

    weblabStation1.Caption := Stationen.FindAssignment(2).FContent;
    weblabStation2.Caption := Stationen.FindAssignment(3).FContent;
    weblabStation3.Caption := Stationen.FindAssignment(1).FContent;

    lblAbteilungsName.Caption := 'Stationsdaten : ' + Abteilungen.FindAssignment(spedAbteilung.Value).FContent;

    PageControl.ActivePageIndex := SelectedPageIndex;
    btnSave.Enabled             := False;
    DataChanged                 := False;

    ToggleGUI;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.Init', slDebug);
    Result := false;
  end;
  WaitMessage.Hide;
end;

procedure TPrjFormsPeriodicData.cbxFallNameChange(Sender: TObject);
var LTableProperties : TTableProperties;
begin
  if Assigned(cbxFallName.Items.Objects[cbxFallName.ItemIndex]) then
  begin
    LTableProperties := TTableProperties(cbxFallName.Items.Objects[cbxFallName.ItemIndex]);
    if Assigned(LTableProperties) then
    begin
//      AktFall               := LTableProperties.FAssignment;
      spedFallNummer.Value  := LTableProperties.FAssignment;
      spedFallNummerChanged(Self);
    end;
  end;
end;

procedure TPrjFormsPeriodicData.spedFallNummerChanged(Sender: TObject);
begin
  WaitMessage.Show;
  spedFallNummer.Enabled  := False;
  cbxFallName.Enabled     := false;
  spedPeriode.Enabled     := False;

  if DataChanged then
  begin
    Self.Done;
  end;
  SetUpData;

  spedFallNummer.Enabled  := True;
  spedPeriode.Enabled     := True;
  cbxFallName.Enabled     := True;
  WaitMessage.Hide;
end;

procedure TPrjFormsPeriodicData.spedPeriodeChanged(Sender: TObject);
begin
  WaitMessage.Show;
  spedFallNummer.Enabled  := False;
  spedPeriode.Enabled     := False;
  cbxFallName.Enabled     := false;

  if DataChanged then
  begin
    Self.Done;
  end;
  SetUpData;

  spedFallNummer.Enabled  := True;
  spedPeriode.Enabled     := True;
  cbxFallName.Enabled     := True;
  ToggleGUI;
  WaitMessage.Hide;
end;

function TPrjFormsPeriodicData.SetupData: Boolean;
begin
  Result := true;
  try
//    AktFall                                   := spedFallNummer.Value;
    DataModule.HBMDefaultData.AktuellePeriode := spedPeriode.Value;
//    AktlPer                                   := spedPeriode.Value;
    cbxFallName.ItemIndex                     := spedFallNummer.Value - 1;


    XDataWebDataSetPeriode.Cancel;
    XDataWebDataSetDRG.Cancel;
    XDataWebDataSetPersonalDaten.Cancel;
    XDataWebDataSetHospital.Cancel;
    XDataWebDataSetHospitalMisc1.Cancel;
    XDataWebDataSetHospitalMisc2.Cancel;
    XDataWebDataSetHospitalMisc3.Cancel;
    XDataWebDataSetHospitalMisc4.Cancel;
    XDataWebDataSetHospitalMisc5.Cancel;
    XDataWebDataSetWahlleistungen.Cancel;
    XDataWebDataSetPeriodMisc.Cancel;

    XDataWebDataSetPeriode.Close;
    XDataWebDataSetDRG.Close;
    XDataWebDataSetPersonalDaten.Close;
    XDataWebDataSetHospital.Close;
    XDataWebDataSetHospitalMisc1.Close;
    XDataWebDataSetHospitalMisc2.Close;
    XDataWebDataSetHospitalMisc3.Close;
    XDataWebDataSetHospitalMisc4.Close;
    XDataWebDataSetHospitalMisc5.Close;
    XDataWebDataSetWahlleistungen.Close;
    XDataWebDataSetPeriodMisc.Close;

    XDataWebDataSetPeriode.Connection         := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetDRG.Connection             := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetPersonalDaten.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospital.Connection        := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospitalMisc1.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospitalMisc2.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospitalMisc3.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospitalMisc4.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetHospitalMisc5.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetWahlleistungen.Connection  := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetPeriodMisc.Connection      := PrjFormsMain.XDataWebConnectionMain;

    XDataWebDataSetPeriode.QueryString      := '$filter=(HPID_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString +
                                               ' ) AND (HPID_PERIOD_NUMBER eq ' + DataModule.HBMDefaultData.AktuellePeriode.ToString +
                                               ' ) AND (HPID_DRG_ID eq ' + spedFallNummer.Value.ToString + ')';
    await(XDataWebDataSetPeriode.Load);

    PageControlChange(Self);
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.SetupData', slError);
    Result := false;
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetPeriodeAfterOpen(DataSet: TDataSet);
begin
  try
    if not XDataWebDataSetPeriode.IsEmpty then
    begin
      XDataWebDataSetDRG.Close;
      XDataWebDataSetDRG.QueryString  := '$filter=(DDRG_IDENTIFIER eq ' + XDataWebDataSetPeriode.FieldByName('HPID_DRG_ID').AsInteger.ToString + ') AND ' +
                                         '(DDRG_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                         '(DDRG_PERIOD_ID eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ')';
      XDataWebDataSetDRG.Load;

      XDataWebDataSetPersonalDaten.Close;
      XDataWebDataSetPersonalDaten.QueryString  := '$filter=(Hfnd_Periodic_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hfnd_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ')';

      XDataWebDataSetPersonalDaten.Load;

      XDataWebDataSetWahlleistungen.Close;
      XDataWebDataSetWahlleistungen.QueryString  := '$filter=(HBOS_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                    '(HBOS_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                    '(HBOS_department_id eq ' + spedAbteilung.Value.ToString + ')';
      XDataWebDataSetWahlleistungen.Load;

//      XDataWebDataSetHospital.Close;
//      XDataWebDataSetHospital.QueryString  := '$filter=(Hhpt_Periodic_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                              '(Hhpt_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ')' ;
//      XDataWebDataSetHospital.Load;


      XDataWebDataSetHospitalMisc1.Close;
      XDataWebDataSetHospitalMisc1.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                   '(Hhmc_Hospital_Id eq 1)';
      XDataWebDataSetHospitalMisc1.Load;

      XDataWebDataSetHospitalMisc2.Close;
      XDataWebDataSetHospitalMisc2.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                   '(Hhmc_Hospital_Id eq 2)';
      XDataWebDataSetHospitalMisc2.Load;


      XDataWebDataSetHospitalMisc3.Close;
      XDataWebDataSetHospitalMisc3.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                   '(Hhmc_Hospital_Id eq 3)';
      XDataWebDataSetHospitalMisc3.Load;


      XDataWebDataSetHospitalMisc4.Close;
      XDataWebDataSetHospitalMisc4.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                   '(Hhmc_Hospital_Id eq 4)';
      XDataWebDataSetHospitalMisc4.Load;


      XDataWebDataSetHospitalMisc5.Close;
      XDataWebDataSetHospitalMisc5.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                   '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                   '(Hhmc_Hospital_Id eq 5)';
      XDataWebDataSetHospitalMisc5.Load;



      XDataWebDataSetPeriodMisc.Close;
      XDataWebDataSetPeriodMisc.QueryString  := '$filter=(Hmpm_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                              '(Hmpm_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ')' ;


      XDataWebDataSetPeriodMisc.Load;
    end else
    begin
      wxBaseWriteLog.Write('No data found for ' + XDataWebDataSetPeriode.EntitySetName + ' with filter [' + XDataWebDataSetPeriode.QueryString + ']', slDebug);
    end;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.XDataWebDataSetPeriodeAfterOpen', slError);
  end;
end;

procedure TPrjFormsPeriodicData.btnCloseClick(Sender: TObject);
begin
  if not DataChanged then
    close
  else
    InteractiveSaveData(true);
end;

procedure TPrjFormsPeriodicData.WebFormCreate(Sender: TObject);
begin
  Self.FormIdentifier := wxFrmPeridicData;
end;

procedure TPrjFormsPeriodicData.btnSaveClick(Sender: TObject);
begin
  WaitMessage.Show;
  try
    SaveData;
    Self.Done;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.btnSaveClick', slDebug);
  end;
  WaitMessage.Hide;
end;

function TPrjFormsPeriodicData.Done: Boolean;
begin
  result := true;
  try
    DataChanged := false;
    ToggleGUI;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.Done', slDebug);
    result := false;
  end;
end;


function TPrjFormsPeriodicData.SaveGridPG3StationCosts: Boolean;
var aRow            : integer;
var aCol            : integer;
begin
  try
    Result    := true;
    for aRow := 1 to strGridStationCosts.RowCount - 1 do
    begin
      for aCol := 0 to strGridStationCosts.ColCount - 1 do
      begin
        case aRow - 1 of
          1 : begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          2 : begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Amount').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Cost').AsFloat     := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          3 : begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          4 : begin
              end;
          6 : begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          7 : begin
              end;
          8 : begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          9 : begin
              end;
          11: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          12: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          13: begin
              end;
          14: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          15: begin
              end;
          17: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          18: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          19: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          20: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          21: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          22: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          23: begin
              end;
          25: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          26: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          27: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Amount').AsFloat  := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Cost').AsFloat    := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          28: begin
                case aCol of
                  1 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Amount').AsFloat := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                  2 : XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Cost').AsFloat   := StrtoFloat(strGridStationCosts.Cells[aCol, aRow]);
                end;
              end;
          29: begin
              end;
        end;
      end;
    end;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.SaveGridPG3StationCosts', slDebug);
    Result := false;
  end;
end;

function TPrjFormsPeriodicData.DrawGridPG3StationCosts: Boolean;
var aRow            : integer;
var aCol            : integer;
var LAktFall        : integer;

  function IsHeadline(aRow: LONGINT): BOOLEAN;
  begin
    Result:= (aRow  IN [1, 6, 11, 17, 25]);
  end;

  function IsSumZeile(aRow: LONGINT): BOOLEAN;
  begin
    Result:= aRow IN [5, 10, 16, 24, 30..33];          //A001
  end;

  function IsSumSpalte(aCol: LONGINT): BOOLEAN;
  begin
    Result:= (aCol = 3);
  end;

  function OutGesperrt(aCol,aRow: LONGINT): BOOLEAN;
  begin
    Result:= IsHeadLine(aRow) OR (IsSumZeile(aRow) AND NOT IsSumSpalte(aCol));
  end;

  function Nk(x: INTEGER): INTEGER;
  begin
    if x = 1 then
      result := 2
    else
      result := 3;
  end;

//  function GetPZeilenTyp(AValue : integer) : P_P2ZeilenTyp;
//  begin
//    result := dummy;
//    case AValue of
//      1 : result := Menge;
//      2 : result := Kost;
//      3 : result := Summe;
//    else
//      result := dummy;
//    end;
//  end;


begin
  try
    Result                          := true;
    strGridStationCosts.RowCount    := 34;
    LAktFall                        := drgFaelle.FindAssignment(spedFallNummer.Value).FPrevAssignment;
    strGridStationCosts.FixedRows   := 1;
    strGridStationCosts.Cells[0,0]  := '';
    strGridStationCosts.Cells[1,0]  := 'Menge / Einheit';
    strGridStationCosts.Cells[2,0]  := 'Kosten / EUR';
    strGridStationCosts.Cells[3,0]  := 'Summe / EUR';

    for aRow := 1 to strGridStationCosts.RowCount - 1 do
    begin
      case aRow - 1 of
          0: strGridStationCosts.Cells[0, aRow] := 'NORMALSTATION';       //Überschr.
          1: strGridStationCosts.Cells[0, aRow] := 'Arztdienst';
          2: strGridStationCosts.Cells[0, aRow] := 'Pflegedienst';
          3: strGridStationCosts.Cells[0, aRow] := 'Medizinischer Bed.';
          4: strGridStationCosts.Cells[0, aRow] := 'Gesamtkosten';
          5: strGridStationCosts.Cells[0, aRow] := 'INTENSIVSTATION';     //Überschr.
          6: strGridStationCosts.Cells[0, aRow] := 'Personal';
          7: strGridStationCosts.Cells[0, aRow] := ' ';
          8: strGridStationCosts.Cells[0, aRow] := 'Medizinischer Bed.';
          9: strGridStationCosts.Cells[0, aRow] := 'Gesamtkosten';
         10: strGridStationCosts.Cells[0, aRow] := 'ZENTRAL-OP';          //Überschr.
         11: strGridStationCosts.Cells[0, aRow] := 'Personal';
         12: strGridStationCosts.Cells[0, aRow] := 'MTD';
         13: strGridStationCosts.Cells[0, aRow] := ' ';
         14: strGridStationCosts.Cells[0, aRow] := 'Medizinischer Bed.';
         15: strGridStationCosts.Cells[0, aRow] := 'Gesamtkosten';
         16: strGridStationCosts.Cells[0, aRow] := 'RESTLICHE INSTITUTE'; //Überschr.
         17: strGridStationCosts.Cells[0, aRow] := 'Pers.Kost. ' + Institute.FindAssignment(3).FContent;
         18: strGridStationCosts.Cells[0, aRow] := 'Pers.Kost. ' + Institute.FindAssignment(4).FContent;
         19: strGridStationCosts.Cells[0, aRow] := 'Pers.Kost. ' + Institute.FindAssignment(5).FContent;
         20: strGridStationCosts.Cells[0, aRow] := 'Mediz.Bed. ' + Institute.FindAssignment(3).FContent;
         21: strGridStationCosts.Cells[0, aRow] := 'Mediz.Bed. ' + Institute.FindAssignment(4).FContent;
         22: strGridStationCosts.Cells[0, aRow] := 'Mediz.Bed. ' + Institute.FindAssignment(5).FContent;
         23: strGridStationCosts.Cells[0, aRow] := 'Gesamtkosten';
         24: strGridStationCosts.Cells[0, aRow] := 'BASISLEISTUNGEN';     //Überschr.
         25: strGridStationCosts.Cells[0, aRow] := 'Personal Kosten';
         26: strGridStationCosts.Cells[0, aRow] := 'Bedarf v. '  + Institute.FindAssignment(6).FContent;
         27: strGridStationCosts.Cells[0, aRow] := 'Lebensmittel';
         28: strGridStationCosts.Cells[0, aRow] := 'Sonst.Verw.Kosten';    //A001   neu dazu
         29: strGridStationCosts.Cells[0, aRow] := 'Gesamtkosten.';        //der Rest +1
         30: strGridStationCosts.Cells[0, aRow] := 'Ges. Personalkosten';
         31: strGridStationCosts.Cells[0, aRow] := 'Ges. Sachkosten';
         32: strGridStationCosts.Cells[0, aRow] := 'Fallkosten';
      end;
      strGridStationCosts.CellElements[0, aRow].style.setProperty('text-align','left');

      for aCol := 0 to strGridStationCosts.ColCount - 1 do
      begin
        if IsHeadline(aRow) then
        begin
          strGridStationCosts.CellElements[aCol,aRow].style.setProperty('background-color', '#F5F6CE');
        end;

        if not OutGesperrt(aCol,aRow) then
        begin
          case aRow - 1 of
            1 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Cost').AsFloat , 8, Nk(aCol));
                  end;
                end;
            2 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            3 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            4 : begin
                  case aCol of
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str( ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Med_Serv_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Nursing_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Medical_Need_Cost').AsFloat
                                                                               ), 8, Nk(aCol));
                  end;
                end;

            6 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            7 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                  end;
                end;
            8 : begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            9 : begin
                  case aCol of
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str( ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Staff_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Intensiv_Med_Needs_Cost').AsFloat
                                                                               ) , 8, Nk(aCol));
                  end;
                end;

            11: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            12: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            13: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(0, 8, Nk(aCol));
                  end;
                end;

            14: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            15: begin
                  case aCol of
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str( ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Personal_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Mtd_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Zentral_Med_Needs_Cost').AsFloat
                                                                               ), 8, Nk(aCol));
                  end;
                end;
            17: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            18: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            19: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            20: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            21: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            22: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            23: begin
                  case aCol of
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str( ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Pers_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Anest_Need_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Radio_Need_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Inst_Lab_Need_Cost').AsFloat
                                                                               ), 8, Nk(aCol));
                  end;
                end;
            25: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            26: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            27: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            28: begin
                  case aCol of
                    1 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Amount').AsFloat, 8, Nk(aCol));
                    2 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Cost').AsFloat, 8, Nk(aCol));
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str(XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Amount').AsFloat *
                                                                              XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Cost').AsFloat, 8, Nk(aCol));
                  end;
                end;
            29: begin
                  case aCol of
                    3 : strGridStationCosts.Cells[aCol, aRow] := Str_F_To_Str( ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Pers_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Clean_Need_Cost').AsFloat
                                                                               ) +
                                                                               ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Food_Cost').AsFloat
                                                                               ) +
                                                                              ( XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Amount').AsFloat *
                                                                                 XDataWebDataSetDRG.FieldByName('Ddrg_Precalc_Basic_Admin_Cost').AsFloat
                                                                               ) , 8, Nk(aCol));
                  end;
                end;
            30: begin
                  case aCol of
                    3 :  // summe
                  end;
                end;
            31: begin
                  case aCol of
                    3 :  // summe
                  end;
                end;
            32: begin
                  case aCol of
                    3 :  // summe
                  end;
                end;





//
//                       25 :   s := Str_F_To_Str(GetPPg2BA_PersKoFld(LAktFall, LP_P2ZeilenTyp), 8, Nk(aCol));
//                       26 :   s := Str_F_To_Str(GetPPg2BA_SachKoWFld(LAktFall, LP_P2ZeilenTyp), 8, Nk(aCol));
//                       27 :   s := Str_F_To_Str(GetPPg2BA_SachKoLFld(LAktFall, LP_P2ZeilenTyp), 8, Nk(aCol));
//                       28 :   s := Str_F_To_Str(GetPPg2BA_SachKoVFld(LAktFall, LP_P2ZeilenTyp), 8, Nk(aCol));  {A001   neu dazu}
//                       29 :   s := Str_F_To_Str(GetPPg2SumBasisLeist(LAktFall), 8, Nk(aCol));  {der Rest +1     }
//
//                       30 :   s := Str_F_To_Str(GetPPg2SumPersKosten(LAktFall), 8, Nk(aCol));
//                       31 :   s := Str_F_To_Str(GetPPg2SumSachKosten(LAktFall), 8, Nk(aCol));
//                       32 :   s := Str_F_To_Str(GetPPg2FallKosten(LAktFall), 8, Nk(aCol));
          end;
        end;
      end;
    end;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.DrawGridPG3StationCosts', slDebug);
    Result := false;
  end;
end;

function TPrjFormsPeriodicData.SaveGridPG6SoftSkills: Boolean;
var LRow : integer;
var LCol : integer;
begin
  try
    if not XDataWebDataSetHospitalMisc1.IsEmpty and
       not XDataWebDataSetHospitalMisc2.IsEmpty and
       not XDataWebDataSetHospitalMisc3.IsEmpty and
       not XDataWebDataSetHospitalMisc4.IsEmpty and
       not XDataWebDataSetHospitalMisc5.IsEmpty then
    begin
      Result                        := true;
      for LRow := 0 to SoftSkills.Count - 1 do
      begin

        for LCol := 1 to strGridSoftSkills.ColCount - 1 do
        begin
          case LCol of
            1 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                end;
            2 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                end;
            3 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                end;
            4 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                end;
            5 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                end;
          end;
        end;
      end;
    end;

  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.SaveGridPG6SoftSkills', slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodicData.DrawGridPG6SoftSkills: Boolean;
var LRow : integer;
var LCol : integer;
var LSumme : integer;
begin
  try
    if not XDataWebDataSetHospitalMisc1.IsEmpty and
       not XDataWebDataSetHospitalMisc2.IsEmpty and
       not XDataWebDataSetHospitalMisc3.IsEmpty and
       not XDataWebDataSetHospitalMisc4.IsEmpty and
       not XDataWebDataSetHospitalMisc5.IsEmpty then
    begin
      Result                        := true;
      strGridSoftSkills.RowCount    := SoftSkills.Count + 2;
      strGridSoftSkills.Cells[0, 0] := 'Softskills';

      for LRow := 0 to SoftSkills.Count - 1 do
      begin
        strGridSoftSkills.Cells[0, LRow + 1] := SoftSkills.FindAssignment(LRow + 1).FContent;

        for LCol := 1 to strGridSoftSkills.ColCount - 1 do
        begin
          case LCol of
            1 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                  if XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Hospital_Name').AsString =  '' then
                    strGridSoftSkills.Cells[LCol, 0]        := 'Krankenhaus [' + LCol.ToString + ']'
                  else
                    strGridSoftSkills.Cells[LCol, 0]        := XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Hospital_Name').AsString;
                end;
            2 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                  if XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Hospital_Name').AsString =  '' then
                    strGridSoftSkills.Cells[LCol, 0]        := 'Krankenhaus [' + LCol.ToString + ']'
                  else
                    strGridSoftSkills.Cells[LCol, 0]        := XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Hospital_Name').AsString;
                end;
            3 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                  if XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Hospital_Name').AsString =  '' then
                    strGridSoftSkills.Cells[LCol, 0]        := 'Krankenhaus [' + LCol.ToString + ']'
                  else
                    strGridSoftSkills.Cells[LCol, 0]        := XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Hospital_Name').AsString;
                end;
            4 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                  if XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Hospital_Name').AsString =  '' then
                    strGridSoftSkills.Cells[LCol, 0]        := 'Krankenhaus [' + LCol.ToString + ']'
                  else
                    strGridSoftSkills.Cells[LCol, 0]        := XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Hospital_Name').AsString;
                end;
            5 : begin
                  strGridSoftSkills.Cells[LCol, LRow + 1] := FloatToStr(XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Softskill_Typ').AsFloat);
                  if XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Hospital_Name').AsString =  '' then
                    strGridSoftSkills.Cells[LCol, 0]        := 'Krankenhaus [' + LCol.ToString + ']'
                  else
                    strGridSoftSkills.Cells[LCol, 0]        := XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Hospital_Name').AsString;
                end;
          end;
          strGridSoftSkills.CellElements[LCol, 0].style.setProperty('text-align','center');
          strGridSoftSkills.CellElements[LCol, LRow + 1].style.setProperty('text-align','center');
        end;
      end;

      LSumme := 0;
      strGridSoftSkills.Cells[0, strGridSoftSkills.RowCount - 1 ] := 'Summe';

      for LCol := 1 to strGridSoftSkills.ColCount - 1 do
      begin
        for LRow := 1 to strGridSoftSkills.RowCount - 2 do
        begin
          LSumme := LSumme + StrToInt(strGridSoftSkills.Cells[LCol, LRow ]);
        end;
        strGridSoftSkills.Cells[LCol, strGridSoftSkills.RowCount - 1 ] := LSumme.ToString;
        strGridSoftSkills.CellElements[LCol, strGridSoftSkills.RowCount - 1].style.setProperty('background-color', '#' + ColorToHex(clInfoBk));
        strGridSoftSkills.CellElements[LCol, strGridSoftSkills.RowCount - 1].style.setProperty('text-align','center');
        LSumme := 0;
      end;
    end;

  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.DrawGridPG6SoftSkills', slDebug);
    result := false;
  end;
end;

procedure TPrjFormsPeriodicData.DRGDataSourceDataChange(Sender: TObject; Field: TField);
begin
  if Assigned(Field) then
  begin
    DataChanged     := true;
    btnSave.Enabled := DataChanged;
  end;
end;

function TPrjFormsPeriodicData.InteractiveSaveData(const ACloseForm: Boolean): Boolean;
var LModalResult : TModalResult;
begin
  WaitMessage.Hide;
  LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cDataSaveMsg, mtConfirmation, [mbYes,mbNo]));
  if LModalResult = mrYes then
  begin
    try
      Result := await(SaveData) and await(Self.Done);
    except
      result := false;
    end;
  end else
  begin
    result := false;
  end;
  DataChanged := result;

  if ACloseForm then
    close;
end;

procedure TPrjFormsPeriodicData.PageControlChange(Sender: TObject);
begin
  if PageControl.ActivePageIndex = 0 then
  begin
    spedAbteilung.Enabled   := true;
    spedFallNummer.Enabled  := false;
    cbxFallName.Enabled     := false;
    spedPeriode.Enabled     := true;
  end else if PageControl.ActivePageIndex = 1 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := true;
    cbxFallName.Enabled     := true;
    spedPeriode.Enabled     := true;
  end else if PageControl.ActivePageIndex = 2 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    cbxFallName.Enabled     := false;
    spedPeriode.Enabled     := true;
  end else if PageControl.ActivePageIndex = 3 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    cbxFallName.Enabled     := false;
    spedPeriode.Enabled     := true;
  end else if PageControl.ActivePageIndex = 4 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    cbxFallName.Enabled     := false;
    spedPeriode.Enabled     := true;
  end else if PageControl.ActivePageIndex = 5 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    cbxFallName.Enabled     := false;
    spedPeriode.Enabled     := true;
  end;
end;

function TPrjFormsPeriodicData.SaveData: Boolean;
begin
  result      := true;
  try
    SaveGridPG3StationCosts;

    XDataWebDataSetDRG.Post;
    XDataWebDataSetPersonalDaten.Post;
    XDataWebDataSetWahlleistungen.Post;
    XDataWebDataSetPeriodMisc.Post;

    XDataWebDataSetHospitalMisc1.Post;
    XDataWebDataSetHospitalMisc2.Post;
    XDataWebDataSetHospitalMisc3.Post;
    XDataWebDataSetHospitalMisc4.Post;
    XDataWebDataSetHospitalMisc5.Post;

    XDataWebDataSetDRG.ApplyUpdates;
    XDataWebDataSetPersonalDaten.ApplyUpdates;
    XDataWebDataSetWahlleistungen.ApplyUpdates;
    XDataWebDataSetPeriodMisc.ApplyUpdates;

    XDataWebDataSetHospitalMisc1.ApplyUpdates;
    XDataWebDataSetHospitalMisc2.ApplyUpdates;
    XDataWebDataSetHospitalMisc3.ApplyUpdates;
    XDataWebDataSetHospitalMisc4.ApplyUpdates;
    XDataWebDataSetHospitalMisc5.ApplyUpdates;

    XDataWebDataSetDRG.Edit;
    XDataWebDataSetPersonalDaten.Edit;
    XDataWebDataSetWahlleistungen.Edit;
    XDataWebDataSetPeriodMisc.Edit;

    XDataWebDataSetHospitalMisc1.Edit;
    XDataWebDataSetHospitalMisc2.Edit;
    XDataWebDataSetHospitalMisc3.Edit;
    XDataWebDataSetHospitalMisc4.Edit;
    XDataWebDataSetHospitalMisc5.Edit;


//    LAktFall  := drgFaelle.FindAssignment(AktFall).FPrevAssignment;
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat1,WahlU,StrToFloat(RFE_Stat1Unterk.Text));
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat1,WahlA,StrToFloat(RFE_Stat1Arzt.Text));
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat2,WahlU,StrToFloat(RFE_Stat2Unterk.Text));
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat2,WahlA,StrToFloat(RFE_Stat2Arzt.Text));
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat3,WahlU,StrToFloat(RFE_Stat3Unterk.Text));
//    inc(LErrorStep);
//    SetPPg0BettDat   (AktAbtl,Stat3,WahlA,StrToFloat(RFE_Stat3Arzt.Text));
//    inc(LErrorStep);
//Hier kommen die neuen Erloeskorrekturen rein. Korrektur je Abteilung  und Untern.
//    SetPPg0ErlKorrUx (1, AktAbtl, StrToFloat(RFE_ErlKorrU1.Text));
//    inc(LErrorStep);
//    SetPPg0ErlKorrUx (2, AktAbtl, StrToFloat(RFE_ErlKorrU2.Text));
//    inc(LErrorStep);
//    SetPPg0ErlKorrUx (3, AktAbtl, StrToFloat(RFE_ErlKorrU3.Text));
//    inc(LErrorStep);
//    SetPPg0ErlKorrUx (4, AktAbtl, StrToFloat(RFE_ErlKorrU4.Text));
//    inc(LErrorStep);
//    SetPPg0ErlKorrUx (5, AktAbtl, StrToFloat(RFE_ErlKorrU5.Text));
//    inc(LErrorStep);
//    SetPPg0InvestBett(AktAbtl,StrToFloat(RFE_InvestProBett.Text));
//    inc(LErrorStep);
//    SetPPg0KassenAPS (AktAbtl,StrToFloat(RFE_KassenAPS.Text));
//    SetPPg0Frei      (AktAbtl,StrToFloat(RFE_Frei.Text));
//    SetPPg0UmwaKst   (AktAbtl,Stat1,Stat2,StrToFloat(RFE_UmwKoS1toS2.Text));
//    inc(LErrorStep);
//    SetPPg0UmwaKst   (AktAbtl,Stat1,Stat3,StrToFloat(RFE_UmwKoS1toS3.Text));
//    inc(LErrorStep);
//    SetPPg0UmwaKst   (AktAbtl,Stat2,Stat1,StrToFloat(RFE_UmwKoS2toS1.Text));
//    inc(LErrorStep);
//    SetPPg0UmwaKst   (AktAbtl,Stat2,Stat3,StrToFloat(RFE_UmwKoS2toS3.Text));
//    inc(LErrorStep);
//    SetPPg0UmwaKst   (AktAbtl,Stat3,Stat1,StrToFloat(RFE_UmwKoS3toS1.Text));
//    inc(LErrorStep);
//    SetPPg0UmwaKst   (AktAbtl,Stat3,Stat2,StrToFloat(RFE_UmwKoS3toS2.Text));
//    inc(LErrorStep);
//    LTmpBool := SetPPg0KHxMVZDabei(1,AktAbtl,CBX_MVZ_Dabei_KH1.Checked);
//    LTmpBool := LTmpBool OR SetPPg0KHxMVZDabei(2,AktAbtl,CBX_MVZ_Dabei_KH2.Checked);
//    LTmpBool := LTmpBool OR SetPPg0KHxMVZDabei(3,AktAbtl,CBX_MVZ_Dabei_KH3.Checked);
//    LTmpBool := LTmpBool OR SetPPg0KHxMVZDabei(4,AktAbtl,CBX_MVZ_Dabei_KH4.Checked);
//    LTmpBool := LTmpBool OR SetPPg0KHxMVZDabei(5,AktAbtl,CBX_MVZ_Dabei_KH5.Checked);
//    SetPPg2agBewRel(LAktFall, StrToFloat(RF2_agBewRel.Text));
//    inc(LErrorStep);
//    SetPPg2PflgBewRel(LAktFall, StrToFloat(RF2_PflgBewRel.Text));
//    inc(LErrorStep);
//    SetPPg2FallZahl(LAktFall, StrToInt(LF2_FallZahl.Text));

//    inc(LErrorStep);
//    SetPPg2FallStat(Stat1, LAktFall, StrToInt(LF2_Stati1.Text));
//    inc(LErrorStep);
//    SetPPg2FallStat(Stat2, LAktFall, StrToInt(LF2_Stati2.Text));
//    inc(LErrorStep);
//    SetPPg2FallStat(Stat3, LAktFall, StrToInt(LF2_Stati3.Text));
//    inc(LErrorStep);
//    SetPPg2DurchVerwD(LAktFall, StrToFloat(RF2_MVerwd.Text));
//    inc(LErrorStep);
//    SetPPg2GrenzVerwD(LAktFall, StrToFloat(RF2_GVerwD.Text));
//    inc(LErrorStep);
//    SetPPg2UeberAntl(LAktFall, StrToFloat(RF2_UebAnt.Text));
//    inc(LErrorStep);
//    SetPPg2UeberTage(LAktFall, StrToFloat(RF2_UebTag.Text));
//    inc(LErrorStep);
//    SetPPg3ZinsUeberz (StrToFloat(RFE_ZinsUeberz.Text));
//    inc(LErrorStep);
//    SetPPg3ZinsKurzfr (StrToFloat(RFE_ZinsKurzfr.Text));
//    inc(LErrorStep);
//    SetPPg3ZinsLangfr (StrToFloat(RFE_ZinsLangfr.Text));
//    inc(LErrorStep);
//    SetPPg3ZinsAnlage (StrToFloat(RFE_ZinsAnlage.Text));
//    inc(LErrorStep);
//    SetPPg3SteuerSatz1(StrToFloat(RFE_SteuerSatz1.Text));
//    inc(LErrorStep);
//    SetPPg3SteuerSatz2(StrToFloat(RFE_SteuerSatz2.Text));
//    inc(LErrorStep);
//    SetPPg3KassenMind (StrToFloat(RFE_KassenMind.Text));
//    inc(LErrorStep);
//    SetPPg3FoerderBett(StrToFloat(RFE_FoerderBett.Text));
//    inc(LErrorStep);
//    SetPPg3Sonstiges1 (StrToFloat(RFE_Sonstiges1.Text));
//    inc(LErrorStep);
//    SetPPG4ArbZeit(ArztD, StrToInt(LFE_ArbZeitA.Text));
//    inc(LErrorStep);
//    SetPPG4ArbZeit(PflgD, StrToInt(LFE_ArbZeitP.Text));
//    inc(LErrorStep);
//    SetPPG4ArbZeit(MTAD,  StrToInt(LFE_ArbZeitM.Text));
//    inc(LErrorStep);
//    SetPPG4StdSatz(ArztD, StrToFloat(RFE_StdSatzA.Text));
//    inc(LErrorStep);
//    SetPPG4StdSatz(PflgD, StrToFloat(RFE_StdSatzP.Text));
//    inc(LErrorStep);
//    SetPPG4StdSatz(MTAD,  StrToFloat(RFE_StdSatzM.Text));
//    inc(LErrorStep);
//    SetPPG4GehNebKo(ArztD,StrToFloat(RFE_GehNebKoA.Text));
//    inc(LErrorStep);
//    SetPPG4GehNebKo(PflgD,StrToFloat(RFE_GehNebKoP.Text));
//    inc(LErrorStep);
//    SetPPG4GehNebKo(MTAD, StrToFloat(RFE_GehNebKoM.Text));
//    inc(LErrorStep);
//    SetPPG4MaxUeber(ArztD,StrToFloat(RFE_MaxUeberA.Text));
//    inc(LErrorStep);
//    SetPPG4MaxUeber(PflgD,StrToFloat(RFE_MaxUeberP.Text));
//    inc(LErrorStep);
//    SetPPG4MaxUeber(MTAD, StrToFloat(RFE_MaxUeberM.Text));
//    inc(LErrorStep);
//    SetPPG4UeZuschl(ArztD,StrToFloat(RFE_UeZuschlA.Text));
//    inc(LErrorStep);
//    SetPPG4UeZuschl(PflgD,StrToFloat(RFE_UeZuschlP.Text));
//    inc(LErrorStep);
//    SetPPG4UeZuschl(MTAD, StrToFloat(RFE_UeZuschlM.Text));
//    inc(LErrorStep);
//    SetPPG4EinstlKo(ArztD,StrToFloat(RFE_EinstlKoA.Text));
//    inc(LErrorStep);
//    SetPPG4EinstlKo(PflgD,StrToFloat(RFE_EinstlKoP.Text));
//    inc(LErrorStep);
//    SetPPG4EinstlKo(MTAD, StrToFloat(RFE_EinstlKoM.Text));
//    inc(LErrorStep);
//    SetPPG4EntlasKo(ArztD,StrToFloat(RFE_EntlasKoA.Text));
//    inc(LErrorStep);
//    SetPPG4EntlasKo(PflgD,StrToFloat(RFE_EntlasKoP.Text));
//    inc(LErrorStep);
//    SetPPG4EntlasKo(MTAD, StrToFloat(RFE_EntlasKoM.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEinst(ArztD,StrToFloat(RFE_MaxEinstA.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEinst(PflgD,StrToFloat(RFE_MaxEinstP.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEinst(MTAD, StrToFloat(RFE_MaxEinstM.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEntla(ArztD,StrToFloat(RFE_MaxEntlaA.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEntla(PflgD,StrToFloat(RFE_MaxEntlaP.Text));
//    inc(LErrorStep);
//    SetPPG4MaxEntla(MTAD, StrToFloat(RFE_MaxEntlaM.Text));
//    inc(LErrorStep);
//    SetPPG4TrainKst(ArztD,StrToFloat(RFE_TrainKstA.Text));
//    inc(LErrorStep);
//    SetPPG4TrainKst(PflgD,StrToFloat(RFE_TrainKstP.Text));
//    inc(LErrorStep);
//    SetPPG4TrainKst(MTAD, StrToFloat(RFE_TrainKstM.Text));
//    inc(LErrorStep);
//    SetPPG4FremdPKo(ArztD,StrToFloat(RFE_FremdPKoA.Text));
//    inc(LErrorStep);
//    SetPPG4FremdPKo(PflgD,StrToFloat(RFE_FremdPKoP.Text));
//    inc(LErrorStep);
//    SetPPG4FremdPKo(MTAD, StrToFloat(RFE_FremdPKoM.Text));
//    inc(LErrorStep);
//    SetPPG4GehChefA (StrToFloat(RFE_GehChefA.Text));  //Wert fuer einen Chefarzt/Jahr zuzuegl. GehaltsnebenKo
//    inc(LErrorStep);
//    SetPPG4GehDirekt(StrToFloat(RFE_GehDirek.Text));  //Wert fuer alle Direktoren, Gehalt+Praemie
//    inc(LErrorStep);
//    SetPPG4PRueckst(StrToFloat(RFE_Rueckst.Text));
//    inc(LErrorStep);
//    SetPPG4AbbFktGN(StrToFloat(RFE_AbFktGN.Text));
//    inc(LErrorStep);
//    Set_PPG4AnGZeit(StrToFloat(RFE_AnGZeit.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdAufw(5,StrToFloat(RFE_AusOrdAufw5.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdAufw(4,StrToFloat(RFE_AusOrdAufw4.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdAufw(3,StrToFloat(RFE_AusOrdAufw3.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdAufw(2,StrToFloat(RFE_AusOrdAufw2.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdAufw(1,StrToFloat(RFE_AusOrdAufw1.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdErtr(5,StrToFloat(RFE_AusOrdErtr5.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdErtr(4,StrToFloat(RFE_AusOrdErtr4.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdErtr(3,StrToFloat(RFE_AusOrdErtr3.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdErtr(2,StrToFloat(RFE_AusOrdErtr2.Text));
//    inc(LErrorStep);
//    SetPPg5AusOrdErtr(1,StrToFloat(RFE_AusOrdErtr1.Text));
//    inc(LErrorStep);
//    SetPPg5Frei1     (5,StrToFloat(RFE_ForderTrag5.Text));
//    inc(LErrorStep);
//    SetPPg5Frei1     (4,StrToFloat(RFE_ForderTrag4.Text));
//    inc(LErrorStep);
//    SetPPg5Frei1     (3,StrToFloat(RFE_ForderTrag3.Text));
//    inc(LErrorStep);
//    SetPPg5Frei1     (2,StrToFloat(RFE_ForderTrag2.Text));
//    inc(LErrorStep);
//    SetPPg5Frei1     (1,StrToFloat(RFE_ForderTrag1.Text));
//    inc(LErrorStep);
//    SetPPg5Forder_KHG(5,StrToFloat(RFE_Forder_KHG5.Text));
//    inc(LErrorStep);
//    SetPPg5Forder_KHG(4,StrToFloat(RFE_Forder_KHG4.Text));
//    inc(LErrorStep);
//    SetPPg5Forder_KHG(3,StrToFloat(RFE_Forder_KHG3.Text));
//    inc(LErrorStep);
//    SetPPg5Forder_KHG(2,StrToFloat(RFE_Forder_KHG2.Text));
//    inc(LErrorStep);
//    SetPPg5Forder_KHG(1,StrToFloat(RFE_Forder_KHG1.Text));
//    inc(LErrorStep);
//    SetPPg5Frei(5,StrToFloat(RFE_Dummy5.Text));
//    inc(LErrorStep);
//    SetPPg5Frei(4,StrToFloat(RFE_Dummy4.Text));
//    inc(LErrorStep);
//    SetPPg5Frei(3,StrToFloat(RFE_Dummy3.Text));
//    inc(LErrorStep);
//    SetPPg5Frei(2,StrToFloat(RFE_Dummy2.Text));
//    inc(LErrorStep);
//    SetPPg5Frei(1,StrToFloat(RFE_Dummy1.Text));
//    inc(LErrorStep);
//    SetPPg5Verblk_KHG(5,StrToFloat(RFE_Verblk_KHG5.Text));
//    inc(LErrorStep);
//    SetPPg5Verblk_KHG(4,StrToFloat(RFE_Verblk_KHG4.Text));
//    inc(LErrorStep);
//    SetPPg5Verblk_KHG(3,StrToFloat(RFE_Verblk_KHG3.Text));
//    inc(LErrorStep);
//    SetPPg5Verblk_KHG(2,StrToFloat(RFE_Verblk_KHG2.Text));
//    inc(LErrorStep);
//    SetPPg5Verblk_KHG(1,StrToFloat(RFE_Verblk_KHG1.Text));
//    inc(LErrorStep);
//    SetPPg5Kapitalerh(5,StrToFloat(RFE_Kapitalerh5.Text));
//    inc(LErrorStep);
//    SetPPg5Kapitalerh(4,StrToFloat(RFE_Kapitalerh4.Text));
//    inc(LErrorStep);
//    SetPPg5Kapitalerh(3,StrToFloat(RFE_Kapitalerh3.Text));
//    inc(LErrorStep);
//    SetPPg5Kapitalerh(2,StrToFloat(RFE_Kapitalerh2.Text));
//    inc(LErrorStep);
//    SetPPg5Kapitalerh(1,StrToFloat(RFE_Kapitalerh1.Text));
//    inc(LErrorStep);
//    SetPPg5FoerderMtl(5,StrToFloat(RFE_FoerderMtl5.Text));
//    inc(LErrorStep);
//    SetPPg5FoerderMtl(4,StrToFloat(RFE_FoerderMtl4.Text));
//    inc(LErrorStep);
//    SetPPg5FoerderMtl(3,StrToFloat(RFE_FoerderMtl3.Text));
//    inc(LErrorStep);
//    SetPPg5FoerderMtl(2,StrToFloat(RFE_FoerderMtl2.Text));
//    inc(LErrorStep);
//    SetPPg5FoerderMtl(1,StrToFloat(RFE_FoerderMtl1.Text));
//    inc(LErrorStep);
//    {Generelles}
//    SetPPg6AbschrDAnl(StrToFLoat(RFE_AbschrDAnl.Text));
//    inc(LErrorStep);
//    SetPPg6AbschrSGeb(StrToFLoat(RFE_AbschrSGeb.Text));
//    inc(LErrorStep);
//    SetPPg6AbschrDEin(StrToFLoat(RFE_AbschrDEin.Text));
//    inc(LErrorStep);
//    // SetPPg6AbtRestBdg(RFE_AbtRestBdg.Text);  {frei}
//    SetPPg6PatientVer(StrToFLoat(RFE_PatientVer.Text)); {Patientenverteilung}
//    inc(LErrorStep);
//    SetPPg6AntWahlL  (StrToFLoat(RFE_AntWahlL.Text));   {anteil Wahlleistung Unterkunft}
//    inc(LErrorStep);
//    SetPPg6InstndSI  (StrToFLoat(RFE_InstndSI.Text));   {Instandhaltung Gebäude}
//    inc(LErrorStep);
//    SetPPg6InstndSA  (StrToFLoat(RFE_InstndSA.Text));
//    inc(LErrorStep);
//    {Verwaltung}
//    SetPPg6VerwKosten(StrToFLoat(RFE_VerwKosten.Text));
//    inc(LErrorStep);
//    SetPPg6AntRestErl(StrToFLoat(RFE_AntRestErl.Text));
//    inc(LErrorStep);
//    {Kassendaten}
//    SetPPg6PktKorrFkt(StrToFLoat(RFE_PktKorrFkt.Text)); {Korrekturfaktor Erlös}
//    inc(LErrorStep);
//    SetPPg6PktWertPer(StrToFLoat(RFE_PktWertPer.Text)); {Korrekturfaktor Personal}
//    inc(LErrorStep);
//    SetPPg6PktWertMed(StrToFLoat(RFE_PktWertMed.Text)); {Korrekturfaktor Sachkosten}
//    inc(LErrorStep);
//    SetPPg6PflgWert  (StrToFLoat(RFE_PflgWert.Text));   {Fall Pflege Wert}
//    inc(LErrorStep);
//    SetPPg6BaFallWert(StrToFLoat(RFE_FallBaWert.Text)); {Fall Basis Wert}
//    inc(LErrorStep);
//    {Codierdienst}
//    SetPPg6FallSatz  (StrToFLoat(RFE_FallSatz.Text));   {Gebuehr je codierter Fall}
//    inc(LErrorStep);
//    SetPPg6FaellePro (StrToFLoat(RFE_FaellePro.Text));  {Anz Fall-Codier je Platz p.a.}
//    inc(LErrorStep);
//    SetPPg6CodLeasing(StrToFLoat(RFE_CodLeasing.Text)); {Codier Leasingkost je Platz p.a.}
//    inc(LErrorStep);
//    SetPPg6CodInfrStr(StrToFLoat(RFE_CodInfrStr.Text)); {Codier Infrastrukturkosten je Platz p.a.}
//    inc(LErrorStep);
//    SaveGridPG3StationCosts;
//    inc(LErrorStep);
//    for j := 1 to strGridSoftSkills.RowCount - 2 do    { -2 weil Summenzeile dabei ist}
//    begin
//      SetSoftNameX(j,strGridSoftSkills.Cells[0,j]);
//      for u:= 1 to strGridSoftSkills.TotalColCount - 1 Do
//      begin
//        SetPPg7SoftSkill (u, j, StrToInt(strGridSoftSkills.Cells[u,j])); {A_to_B  ignoriert Blanks}
//      end;
//    end;

  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.SaveData ', slDebug);
    result := false;
    DataChanged := Result;
  end;
  DataChanged := Result;
end;

procedure TPrjFormsPeriodicData.SetMenuEnable(value: boolean);
begin
//  inherited;
end;

procedure TPrjFormsPeriodicData.spedAbteilungChanged(Sender: TObject);
begin
//  AktAbtl                   := Round(spedAbteilung.Value);
  lblAbteilungsName.Caption := 'Stationsdaten : ' + Abteilungen.FindAssignment(spedAbteilung.Value).FContent;

  case PageControl.ActivePageIndex of
    0 : begin
          XDataWebDataSetWahlleistungen.Cancel;
          XDataWebDataSetWahlleistungen.Close;
          XDataWebDataSetWahlleistungen.QueryString  := '$filter=(HBOS_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
                                                        '(HBOS_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                                        '(HBOS_department_id eq ' + spedAbteilung.Value.ToString + ')';
          XDataWebDataSetWahlleistungen.Load;
        end;
  end;
end;

procedure TPrjFormsPeriodicData.strGridSoftSkillsGetEditText(Sender: TObject; ACol, ARow: LongInt; var Value: string);
begin
  FGetValue := Value;
end;

procedure TPrjFormsPeriodicData.strGridSoftSkillsSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
begin
  try
    DataChanged := FGetValue.ToDouble <> Value.ToDouble;
  except
    DataChanged := true;
  end;
end;

procedure TPrjFormsPeriodicData.strGridStationCostsGetEditText(Sender: TObject; ACol, ARow: LongInt; var Value: string);
begin
  FGetValue := Value;
end;

procedure TPrjFormsPeriodicData.strGridStationCostsSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
  function Nk(x: INTEGER): INTEGER;
  begin
    if x = 1 then
      result := 2
    else
      result := 3;
  end;

begin
  try
    DataChanged := FGetValue.ToDouble <> Value.ToDouble;
  except
    DataChanged := true;
  end;

  if (ACol = 1) or (ACol = 2) then
  begin
    case ARow of
      1 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      2 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      3 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      4 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      6 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      7 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      8 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      9 : begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      11: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      12: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      13: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      14: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      15: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      17: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      18: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      19: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      20: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      21: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      22: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      23: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      25: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      26: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      27: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      28: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
      29: begin
            strGridStationCosts.Cells[3, aRow] := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[1, ARow]) *
                                                                StrToFloat(strGridStationCosts.Cells[2, ARow]) , 8, Nk(aCol));
          end;
    end;
    strGridStationCosts.Cells[3, 5]   := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[3, 2]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 3]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 4]), 8, Nk(aCol));

    strGridStationCosts.Cells[3, 10]  := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[3, 7]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 9]), 8, Nk(aCol));


    strGridStationCosts.Cells[3, 16]  := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[3, 12]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 13]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 15]), 8, Nk(aCol));

    strGridStationCosts.Cells[3, 24]  := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[3, 18]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 19]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 20]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 21]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 22]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 23]), 8, Nk(aCol));

    strGridStationCosts.Cells[3, 30]  := Str_F_To_Str( StrToFloat(strGridStationCosts.Cells[3, 26]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 27]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 28]) +
                                                       StrToFloat(strGridStationCosts.Cells[3, 29]), 8, Nk(aCol));
    ToggleGUI;
  end;
end;

function TPrjFormsPeriodicData.ToggleGUI: boolean;
begin
  Result := true;
  try
    cbxkhEinsMVZCheckbox.Enabled := DataModule.HBMDefaultData.AktuellePeriode > 0;
    cbxkhZweiMVZCheckbox.Enabled := DataModule.HBMDefaultData.AktuellePeriode > 0;
    cbxkhDreiMVZCheckbox.Enabled := DataModule.HBMDefaultData.AktuellePeriode > 0;
    cbxkhVierMVZCheckbox.Enabled := DataModule.HBMDefaultData.AktuellePeriode > 0;
    cbxkhFuenfMVZCheckbox.Enabled := DataModule.HBMDefaultData.AktuellePeriode > 0;
    btnSave.Enabled               := DataChanged;


    try
      Lab_PflgErloes.Caption  := Str_F_To_Str( XDataWebDataSetDRG.FieldByName('DDRG_CARE_PAYMENT_VALUE').AsFloat *
                                               XDataWebDataSetDRG.FieldByName('DDRG_RELATIVE_FACTOR').AsFloat *
                                               XDataWebDataSetDRG.FieldByName('DDRG_MEDIUM_STAY').AsFloat , 8, 2) + ' €';
    except
      Lab_PflgErloes.Caption  := Str_F_To_Str( 0 , 8, 2);

    end;


    try
      Lab_agErloes.Caption  := Str_F_to_Str( XDataWebDataSetDRG.FieldByName('DDRG_COUNTRY_BASE_DRG_VALUE').AsFloat *
                                             XDataWebDataSetDRG.FieldByName('DDRG_RELATIVE_FACTOR').AsFloat, 8, 2) + ' €';
    except
      Lab_agErloes.Caption  := Str_F_To_Str( 0 , 8, 2);
    end;

  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodicData.ToggleGUI', slDebug);
    result := false;
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetDRGAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetDRG.IsEmpty then
  begin
    XDataWebDataSetDRG.Edit;
    DrawGridPG3StationCosts;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetDRG.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalAfterOpen(DataSet: TDataSet);
begin
//  XDataWebDataSetHospitalMisc1.Close;
//  XDataWebDataSetHospitalMisc1.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                               '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                               '(Hhmc_Hospital_Id eq 1)';
//  XDataWebDataSetHospitalMisc1.Load;
//
//  XDataWebDataSetHospitalMisc2.Close;
//  XDataWebDataSetHospitalMisc2.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                               '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                               '(Hhmc_Hospital_Id eq 2)';
//  XDataWebDataSetHospitalMisc2.Load;
//
//
//  XDataWebDataSetHospitalMisc3.Close;
//  XDataWebDataSetHospitalMisc3.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                               '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                               '(Hhmc_Hospital_Id eq 3)';
//  XDataWebDataSetHospitalMisc3.Load;
//
//
//  XDataWebDataSetHospitalMisc4.Close;
//  XDataWebDataSetHospitalMisc4.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                               '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                               '(Hhmc_Hospital_Id eq 4)';
//  XDataWebDataSetHospitalMisc4.Load;
//
//
//  XDataWebDataSetHospitalMisc5.Close;
//  XDataWebDataSetHospitalMisc5.QueryString  := '$filter=(Hhmc_Period_Id eq ' + XDataWebDataSetPeriode.FieldByName('HPID_PERIOD_NUMBER').AsInteger.ToString + ') AND ' +
//                                               '(Hhmc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                               '(Hhmc_Hospital_Id eq 5)';
//  XDataWebDataSetHospitalMisc5.Load;


end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalMisc1AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetHospitalMisc1.IsEmpty then
  begin
    XDataWebDataSetHospitalMisc1.Edit;
    DrawGridPG6SoftSkills;
    if XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Hospital_Name').AsString = '' then
      lblKrankenhaus1.Caption := 'Krankenhaus 1'
    else
      lblKrankenhaus1.Caption := XDataWebDataSetHospitalMisc1.FieldByName('Hhmc_Hospital_Name').AsString;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetHospitalMisc1.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalMisc2AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetHospitalMisc2.IsEmpty then
  begin
    XDataWebDataSetHospitalMisc2.Edit;
    DrawGridPG6SoftSkills;
    if XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Hospital_Name').AsString = '' then
      lblKrankenhaus2.Caption := 'Krankenhaus 2'
    else
      lblKrankenhaus2.Caption := XDataWebDataSetHospitalMisc2.FieldByName('Hhmc_Hospital_Name').AsString;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetHospitalMisc2.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalMisc3AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetHospitalMisc3.IsEmpty then
  begin
    XDataWebDataSetHospitalMisc3.Edit;
    DrawGridPG6SoftSkills;
    if XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Hospital_Name').AsString = '' then
      lblKrankenhaus3.Caption := 'Krankenhaus 3'
    else
      lblKrankenhaus3.Caption := XDataWebDataSetHospitalMisc3.FieldByName('Hhmc_Hospital_Name').AsString;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetHospitalMisc3.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalMisc4AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetHospitalMisc4.IsEmpty then
  begin
    XDataWebDataSetHospitalMisc4.Edit;
    DrawGridPG6SoftSkills;
    if XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Hospital_Name').AsString = '' then
      lblKrankenhaus4.Caption := 'Krankenhaus 4'
    else
      lblKrankenhaus4.Caption := XDataWebDataSetHospitalMisc4.FieldByName('Hhmc_Hospital_Name').AsString;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetHospitalMisc4.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetHospitalMisc5AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetHospitalMisc5.IsEmpty then
  begin
    XDataWebDataSetHospitalMisc5.Edit;
    DrawGridPG6SoftSkills;
    if XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Hospital_Name').AsString = '' then
      lblKrankenhaus5.Caption := 'Krankenhaus 5'
    else
      lblKrankenhaus5.Caption := XDataWebDataSetHospitalMisc5.FieldByName('Hhmc_Hospital_Name').AsString;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetHospitalMisc5.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetPeriodMiscAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetPeriodMisc.IsEmpty then
  begin
    XDataWebDataSetPeriodMisc.Edit;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetPeriodMisc.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetPersonalDatenAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetPersonalDaten.IsEmpty then
  begin
    XDataWebDataSetPersonalDaten.Edit;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetPersonalDaten.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.XDataWebDataSetWahlleistungenAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetWahlleistungen.IsEmpty then
  begin
    XDataWebDataSetWahlleistungen.Edit;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetWahlleistungen.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodicData.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPeriode');
  lblAbteilung := TLabel.Create('LabelNAVAbteilung');
  lblFallnummer := TLabel.Create('LabelNAVFallnummer');
  lblNAVFallName := TLabel.Create('LabelNAVFallName');
  btnClose := TButton.Create('btnNAVBack');
  btnSave := TButton.Create('btnNAVSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPeriode');
  btnPrint := TButton.Create('btnNAVPrint');
  btnCancel := TButton.Create('btnNAVCancel');
  brnHelp := TButton.Create('btnNAVHelp');
  spedAbteilung := TSpinEdit.Create('SpinEdNAVAbteilung');
  spedFallNummer := TSpinEdit.Create('SpinEdNAVFallnummer');
  cbxFallName := TComboBox.Create('ComboBoxNAVFallName');
  PageControl := TPageControl.Create('periodischeDatenTabControl');
  pgSeite1 := TTabSheet.Create('periodicSeiteEins');
  pnErloeseWahlleistung := TPanel.Create('pnErloeseWahlleistung');
  Lab0_Stat11 := TLabel.Create('stationEinsLabel');
  Lab0_Stat21 := TLabel.Create('stationZweiLabel');
  Lab0_Stat31 := TLabel.Create('stationDreiLabel');
  WebLabel5 := TLabel.Create('unterkunftWLZweiHeadline');
  WebLabel6 := TLabel.Create('arztWLEinsHeadline');
  WebImageControl1 := TImageControl.Create(Self);
  lblAbteilungsName := TLabel.Create('lblAbteilungsName');
  WebLabel34 := TLabel.Create('erloeseDivWLNormalLabel');
  WebLabel22 := TLabel.Create('erloeseDivWLZweiLabel');
  WebLabel23 := TLabel.Create('erloeseDivWLEinsLabel');
  WebLabel24 := TLabel.Create('unterkunftWLEinsHeadline');
  WebLabel25 := TLabel.Create('unterkunftWLNormalHeadline');
  WebLabel26 := TLabel.Create('arztWLNormalHeadline');
  WebLabel27 := TLabel.Create('arztWLZweiHeadline');
  RFE_Stat1Unterk := TDBEdit.Create('stationEinsUnterkunftInput');
  RFE_Stat2Unterk := TDBEdit.Create('stationZweiUnterkunftInput');
  RFE_Stat3Unterk := TDBEdit.Create('stationDreiUnterkunftInput');
  RFE_Stat1Arzt := TDBEdit.Create('stationEinsArztInput');
  RFE_Stat2Arzt := TDBEdit.Create('stationZweiArztInput');
  RFE_Stat3Arzt := TDBEdit.Create('stationDreiArztInput');
  pnErloesKorrekturen := TPanel.Create('pnErloesKorrekturen');
  WebLabel10 := TLabel.Create('krankenhausZweiLabel');
  WebLabel11 := TLabel.Create('krankenhausDreiLabel');
  WebLabel12 := TLabel.Create('krankenhausVierLabel');
  WebLabel13 := TLabel.Create('krankenhausFuenfLabel');
  WebLabel31 := TLabel.Create('erloesKorrekturKHEinsHeadline');
  WebLabel72 := TLabel.Create('erloesKorrekturKHZweiHeadline');
  WebLabel106 := TLabel.Create('erloesKorrekturKHFuenfHeadline');
  WebLabel109 := TLabel.Create('erloesKorrekturKHDreiHeadline');
  WebLabel110 := TLabel.Create('erloesKorrekturKHVierHeadline');
  WebLabel15 := TLabel.Create('khEinsMVZLabel');
  WebLabel16 := TLabel.Create('krankenhausEinsLabel');
  WebLabel111 := TLabel.Create('khZweiMVZLabel');
  WebLabel114 := TLabel.Create('khDreiMVZLabel');
  WebLabel115 := TLabel.Create('khVierMVZLabel');
  WebLabel116 := TLabel.Create('khFuenfMVZLabel');
  RFE_ErlKorrU1 := TDBEdit.Create('krankenhausEinsInput');
  RFE_ErlKorrU2 := TDBEdit.Create('krankenhausZweiInput');
  RFE_ErlKorrU3 := TDBEdit.Create('krankenhausDreiInput');
  RFE_ErlKorrU4 := TDBEdit.Create('krankenhausVierInput');
  RFE_ErlKorrU5 := TDBEdit.Create('krankenhausFuenfInput');
  pnInvestKosten := TPanel.Create('pnInvestKosten');
  WebLabel14 := TLabel.Create('investitionskostenLabel');
  WebLabel33 := TLabel.Create('investitionskostenHeadline');
  RFE_InvestProBett := TDBEdit.Create('investitionskostenInput');
  cbxkhEinsMVZCheckbox := TDBCheckBox.Create('khEinsMVZCheckbox');
  cbxkhZweiMVZCheckbox := TDBCheckBox.Create('khZweiMVZCheckbox');
  cbxkhDreiMVZCheckbox := TDBCheckBox.Create('khDreiMVZCheckbox');
  cbxkhVierMVZCheckbox := TDBCheckBox.Create('khVierMVZCheckbox');
  cbxkhFuenfMVZCheckbox := TDBCheckBox.Create('khFuenfMVZCheckbox');
  pnUmwandlungKosten := TPanel.Create('pnUmwandlungKosten');
  Lab0_Stat14 := TLabel.Create('krankenhausEinsRowUmwandlungLabel');
  Lab0_Stat24 := TLabel.Create('krankenhausZweiRowUmwandlungLabel');
  Lab0_Stat34 := TLabel.Create('krankenhausDreiRowUmwandlungLabel');
  Lab0_Stat13 := TLabel.Create('krankenhausEinsColUmwandlungLabel');
  Lab0_Stat23 := TLabel.Create('krankenhausZweiColUmwandlungLabel');
  Lab0_Stat33 := TLabel.Create('krankenhausDreiColUmwandlungLabel');
  WebLabel32 := TLabel.Create('umwandlungDivWLNormalLabel');
  WebLabel30 := TLabel.Create('umwandlungDivWLZweiLabel');
  WebLabel70 := TLabel.Create('umwandlungDivWLEinsLabel');
  RFE_UmwKoS2toS1 := TDBEdit.Create('krankenhausZweiEinsUmwandlungInput');
  RFE_UmwKoS3toS1 := TDBEdit.Create('krankenhausDreiEinsUmwandlungInput');
  RFE_UmwKoS1toS2 := TDBEdit.Create('krankenhausEinsZweiUmwandlungInput');
  RFE_UmwKoS3toS2 := TDBEdit.Create('krankenhausDreiZweiUmwandlungInput');
  RFE_UmwKoS1toS3 := TDBEdit.Create('krankenhausEinsDreiUmwandlungInput');
  RFE_UmwKoS2toS3 := TDBEdit.Create('krankenhausZweiDreiUmwandlungInput');
  WebMessageDlg := TMessageDlg.Create(Self);
  pgSeite3 := TTabSheet.Create('periodicSeiteDrei');
  pnDRGVerwaltung := TPanel.Create('pnDRGVerwaltung');
  WebLabel102 := TLabel.Create('agDRGVorkalkulationEinzelkostenHeadline');
  strGridStationCosts := TStringGrid.Create(Self);
  pnErloeseKorrekturen := TPanel.Create('pnErloeseKorrekturen');
  Lab_ErloesKor := TLabel.Create('erloesKorrekturLabel');
  Lab_agErloes := TLabel.Create('agErloesLabel');
  Lab_PflgErloes := TLabel.Create('pflegeErloesLabel');
  WebLabel7 := TLabel.Create('erloesKorrekturHeadline');
  WebLabel103 := TLabel.Create('agErloesHeadline');
  WebLabel104 := TLabel.Create('pflegeErloesHeadline');
  pnAnteileMode := TPanel.Create('pnAnteileMode');
  WebLabel20 := TLabel.Create('bewRelLabel');
  WebLabel21 := TLabel.Create('bewRelPflegeLabel');
  lblFallName := TLabel.Create('anteileModeHeadline');
  WebLabel100 := TLabel.Create('pflegeentgeldwertLabel');
  WebLabel99 := TLabel.Create('landesbasisFallwertLabel');
  RF2_agBewRel := TDBEdit.Create('bewRelInput');
  RF2_PflgBewRel := TDBEdit.Create('bewRelPflegeInput');
  RFE_PflgWert := TDBEdit.Create('pflegeentgeldwertInput');
  RFE_FallBaWert := TDBEdit.Create('landesbasisFallwertInput');
  pnFallZahlen := TPanel.Create('pnFallZahlen');
  WebLabel40 := TLabel.Create('fallzahlenHeadline');
  weblabStation1 := TLabel.Create('stationEinsVolumenLabel');
  weblabStation2 := TLabel.Create('stationZweiVolumenLabel');
  weblabStation3 := TLabel.Create('stationDreiVolumenLabel');
  WebLabel44 := TLabel.Create('volumenLabel');
  WebLabel45 := TLabel.Create('verweildauerHeadline');
  WebLabel46 := TLabel.Create('mittlereVerweildauerLabel');
  WebLabel47 := TLabel.Create('grenzVerweildauerLabel');
  WebLabel48 := TLabel.Create('ueberzVerweildauerLabel');
  WebLabel105 := TLabel.Create('uebTageLabel');
  LF2_Fallzahl := TDBEdit.Create('volumenInput');
  LF2_Stati1 := TDBEdit.Create('stationEinsVolumenInput');
  LF2_Stati2 := TDBEdit.Create('stationZweiVolumenInput');
  LF2_Stati3 := TDBEdit.Create('stationDreiVolumenInput');
  RF2_MVerwd := TDBEdit.Create('mittlereVerweildauerInput');
  RF2_GVerwD := TDBEdit.Create('grenzVerweildauerInput');
  RF2_UebAnt := TDBEdit.Create('ueberzVerweildauerInput');
  RF2_UebTag := TDBEdit.Create('uebTageInput');
  pgSeite4 := TTabSheet.Create('periodicSeiteVier');
  pnPersonalDaten := TPanel.Create('pnPersonalDaten');
  WebLabel49 := TLabel.Create('pgVierJahresarbeitsstundenLabel');
  WebLabel50 := TLabel.Create('pgVierStundensatzLabel');
  WebLabel51 := TLabel.Create('pgVierMinGehaltsnebenkostenLabel');
  WebLabel52 := TLabel.Create('pgVierMaxUeberstundenLabel');
  WebLabel53 := TLabel.Create('pgVierUeberstundenzuschlagLabel');
  WebLabel54 := TLabel.Create('pgVierEinstellungskostenLabel');
  WebLabel55 := TLabel.Create('pgVierEntlassungskostenLabel');
  WebLabel56 := TLabel.Create('pgVierMaxEinstellungenLabel');
  WebLabel57 := TLabel.Create('pgVierMaxEntlassungenLabel');
  WebLabel58 := TLabel.Create('pgVierTrainingskostenLabel');
  WebLabel59 := TLabel.Create('pgVierKostenFremdpersonalLabel');
  WebLabel60 := TLabel.Create('pgVierGehaltChefarztLabel');
  WebLabel61 := TLabel.Create('pgVierArztHeadline');
  WebLabel62 := TLabel.Create('pgVierPflegeHeadline');
  WebLabel63 := TLabel.Create('pgVierInstitutHeadline');
  WebLabel64 := TLabel.Create('pgVierGehaltGeschaeftsfuehrungLabel');
  WebLabel65 := TLabel.Create('pgVierPensionsrueckstellungLabel');
  WebLabel66 := TLabel.Create('pgVierAnrechnungGespartLabel');
  WebLabel67 := TLabel.Create('pgVierAufbaufunktionLabel');
  WebLabel36 := TLabel.Create('personaldatenHeadline');
  LFE_ArbZeitA := TDBEdit.Create('pgVierJahresarbeitsstundenArztInput');
  RFE_StdSatzA := TDBEdit.Create('pgVierStundensatzArztInput');
  RFE_GehNebKoA := TDBEdit.Create('pgVierMinGehaltsnebenkostenArztInput');
  RFE_MaxUeberA := TDBEdit.Create('pgVierMaxUeberstundenArztInput');
  RFE_UeZuschlA := TDBEdit.Create('pgVierUeberstundenzuschlagArztInput');
  RFE_EinstlKoA := TDBEdit.Create('pgVierEinstellungskostenArztInput');
  RFE_EntlasKoA := TDBEdit.Create('pgVierEntlassungskostenArztInput');
  RFE_MaxEinstA := TDBEdit.Create('pgVierMaxEinstellungenArztInput');
  RFE_MaxEntlaA := TDBEdit.Create('pgVierMaxEntlassungenArztInput');
  RFE_TrainKstA := TDBEdit.Create('pgVierTrainingskostenArztInput');
  RFE_FremdPKoA := TDBEdit.Create('pgVierKostenFremdpersonalArztInput');
  RFE_GehChefA := TDBEdit.Create('pgVierGehaltChefarztInput');
  LFE_ArbZeitP := TDBEdit.Create('pgVierJahresarbeitsstundenPflegeInput');
  RFE_StdSatzP := TDBEdit.Create('pgVierStundensatzPflegeInput');
  RFE_GehNebKoP := TDBEdit.Create('pgVierMinGehaltsnebenkostenPflegeInput');
  RFE_MaxUeberP := TDBEdit.Create('pgVierMaxUeberstundenPflegeInput');
  RFE_UeZuschlP := TDBEdit.Create('pgVierUeberstundenzuschlagPflegeInput');
  RFE_EinstlKoP := TDBEdit.Create('pgVierEinstellungskostenPflegeInput');
  RFE_EntlasKoP := TDBEdit.Create('pgVierEntlassungskostenPflegeInput');
  RFE_MaxEinstP := TDBEdit.Create('pgVierMaxEinstellungenPflegeInput');
  RFE_MaxEntlaP := TDBEdit.Create('pgVierMaxEntlassungenPflegeInput');
  RFE_TrainKstP := TDBEdit.Create('pgVierTrainingskostenPflegeInput');
  RFE_FremdPKoP := TDBEdit.Create('pgVierKostenFremdpersonalPflegeInput');
  LFE_ArbZeitM := TDBEdit.Create('pgVierJahresarbeitsstundenInstitutInput');
  RFE_StdSatzM := TDBEdit.Create('pgVierStundensatzInstitutInput');
  RFE_GehNebKoM := TDBEdit.Create('pgVierMinGehaltsnebenkostenInstitutInput');
  RFE_MaxUeberM := TDBEdit.Create('pgVierMaxUeberstundenInstitutInput');
  RFE_UeZuschlM := TDBEdit.Create('pgVierUeberstundenzuschlagInstitutInput');
  RFE_EinstlKoM := TDBEdit.Create('pgVierEinstellungskostenInstitutInput');
  RFE_EntlasKoM := TDBEdit.Create('pgVierEntlassungskostenInstitutInput');
  RFE_MaxEinstM := TDBEdit.Create('pgVierMaxEinstellungenInstitutInput');
  RFE_MaxEntlaM := TDBEdit.Create('pgVierMaxEntlassungenInstitutInput');
  RFE_TrainKstM := TDBEdit.Create('pgVierTrainingskostenInstitutInput');
  RFE_FremdPKoM := TDBEdit.Create('pgVierKostenFremdpersonalInstitutInput');
  RFE_GehDirek := TDBEdit.Create('pgVierGehaltGeschaeftsfuehrungInput');
  RFE_Rueckst := TDBEdit.Create('pgVierPensionsrueckstellungInput');
  RFE_AbFktGN := TDBEdit.Create('pgVierAufbaufunktionInput');
  RFE_AnGZeit := TDBEdit.Create('pgVierAnrechnungGespartInput');
  pnFinanzdaten := TPanel.Create('pnPeriodicFinanzdaten');
  WebLabel1 := TLabel.Create('zinssatzUeberziehungsKreditLabel');
  WebLabel2 := TLabel.Create('zinssatzKurzKreditLabel');
  WebLabel3 := TLabel.Create('zinssatzMittelKreditLabel');
  WebLabel4 := TLabel.Create('zinssatzGeldanlageLabel');
  WebLabel17 := TLabel.Create('steuersatzEinsLabel');
  WebLabel18 := TLabel.Create('steuersatzZweiLabel');
  WebLabel19 := TLabel.Create('kassenmindestbestandLabel');
  WebLabel28 := TLabel.Create('foerderbetragProBettLabel');
  WebLabel29 := TLabel.Create('periodicFinanzenSonstigesLabel');
  WebLabel38 := TLabel.Create('finanzdatenHeadline');
  RFE_ZinsUeberz := TDBEdit.Create('zinssatzUeberziehungsKreditInput');
  RFE_ZinsKurzfr := TDBEdit.Create('zinssatzKurzKreditInput');
  RFE_ZinsLangfr := TDBEdit.Create('zinssatzMittelKreditInput');
  RFE_ZinsAnlage := TDBEdit.Create('zinssatzGeldanlageInput');
  RFE_SteuerSatz1 := TDBEdit.Create('steuersatzEinsInput');
  RFE_SteuerSatz2 := TDBEdit.Create('steuersatzZweiInput');
  RFE_KassenMind := TDBEdit.Create('kassenmindestbestandInput');
  RFE_FoerderBett := TDBEdit.Create('foerderbetragProBettInput');
  RFE_Sonstiges1 := TDBEdit.Create('periodicFinanzenSonstigesInput');
  pgSeite5 := TTabSheet.Create('periodicSeiteFuenf');
  pnCodierDienst := TPanel.Create('pnCodierDienst');
  WebLabel89 := TLabel.Create('fallsatzLabel');
  WebLabel90 := TLabel.Create('faelleProCodierLabel');
  WebLabel91 := TLabel.Create('leasingrateLabel');
  WebLabel93 := TLabel.Create('infrakostenLabel');
  WebLabel95 := TLabel.Create('codierDienstHeadline');
  RFE_FallSatz := TDBEdit.Create('fallsatzInput');
  RFE_FaellePro := TDBEdit.Create('faelleProCodierInput');
  RFE_CodLeasing := TDBEdit.Create('leasingrateInput');
  RFE_CodInfrStr := TDBEdit.Create('infrakostenInput');
  pnGenerelles := TPanel.Create('pnGenerelles');
  WebLabel81 := TLabel.Create('abschDauerAnlagenLabel');
  WebLabel82 := TLabel.Create('abschSatzGebaeudeLabel');
  WebLabel83 := TLabel.Create('abschDauerEinrichtungLabel');
  WebLabel84 := TLabel.Create('freiLabel');
  WebLabel85 := TLabel.Create('patientenverteilungLabel');
  WebLabel86 := TLabel.Create('anteilWahlleistungenLabel');
  WebLabel87 := TLabel.Create('instandhaltungGebaeudeLabel');
  WebLabel88 := TLabel.Create('instandhaltungMedGeraeteLabel');
  WebLabel94 := TLabel.Create('generellesHeadline');
  RFE_AbschrDAnl := TDBEdit.Create('abschDauerAnlagenInput');
  RFE_AbschrSGeb := TDBEdit.Create('abschSatzGebaeudeInput');
  RFE_AbschrDEin := TDBEdit.Create('abschDauerEinrichtungInput');
  RFE_AbtRestBdg := TDBEdit.Create('freiInput');
  RFE_Patientver := TDBEdit.Create('patientenverteilungInput');
  RFE_AntWahlL := TDBEdit.Create('anteilWahlleistungenInput');
  RFE_InstndSI := TDBEdit.Create('instandhaltungGebaeudeInput');
  RFE_InstndSA := TDBEdit.Create('instandhaltungMedGeraeteInput');
  pnKassenDaten := TPanel.Create('pnKassenDaten');
  WebLabel96 := TLabel.Create('korrekturfaktorErloesLabel');
  WebLabel97 := TLabel.Create('korrekturfaktorPersonalLabel');
  WebLabel98 := TLabel.Create('korrekturfaktorSachkostenLabel');
  WebLabel92 := TLabel.Create('kassendatenHeadline');
  WebLabel112 := TLabel.Create('resteerloesLabel');
  WebLabel113 := TLabel.Create('anteilVerwaltungskostenLabel');
  RFE_PktKorrFkt := TDBEdit.Create('korrekturfaktorErloesInput');
  RFE_PktWertPer := TDBEdit.Create('korrekturfaktorPersonalInput');
  RFE_PktWertMed := TDBEdit.Create('korrekturfaktorSachkostenInput');
  RFE_AntRestErl := TDBEdit.Create('resteerloesInput');
  RFE_VerwKosten := TDBEdit.Create('anteilVerwaltungskostenInput');
  pnSonstiges := TPanel.Create('pnSonstiges');
  WebLabel68 := TLabel.Create('pgFuenfAusserAufwandLabel');
  WebLabel69 := TLabel.Create('pgFuenfAusserErtragLabel');
  WebLabel71 := TLabel.Create('pgFuenfForderungenLabel');
  WebLabel73 := TLabel.Create('pgFuenfVerbindlichkeitenLabel');
  WebLabel74 := TLabel.Create('pgFuenfKapitalerhoehungLabel');
  WebLabel75 := TLabel.Create('pgFuenfZweckFoerdermittelLabel');
  lblKrankenhaus1 := TLabel.Create('pgFuenfKHEinsHeadline');
  lblKrankenhaus2 := TLabel.Create('pgFuenfKHZweiHeadline');
  lblKrankenhaus3 := TLabel.Create('pgFuenfKHDreiHeadline');
  lblKrankenhaus4 := TLabel.Create('pgFuenfKHVierHeadline');
  lblKrankenhaus5 := TLabel.Create('pgFuenfKHFuenfHeadline');
  WebLabel107 := TLabel.Create('pgFuenfFreiEinsLabel');
  WebLabel108 := TLabel.Create('pgFuenfFreiZweiLabel');
  WebLabel39 := TLabel.Create('sonstigeDatenHeadline');
  RFE_AusOrdAufw1 := TDBEdit.Create('pgFuenfAusserAufwandKHEinsInput');
  RFE_AusOrdErtr1 := TDBEdit.Create('pgFuenfAusserErtragKHEinsInput');
  RFE_ForderTrag1 := TDBEdit.Create('pgFuenfFreiEinsKHEinsInput');
  RFE_Forder_KHG1 := TDBEdit.Create('pgFuenfForderungenKHEinsInput');
  RFE_Dummy1 := TDBEdit.Create('pgFuenfFreiZweiKHEinsInput');
  RFE_Verblk_KHG1 := TDBEdit.Create('pgFuenfVerbindlichkeitenKHEinsInput');
  RFE_Kapitalerh1 := TDBEdit.Create('pgFuenfKapitalerhoehungKHEinsInput');
  RFE_FoerderMtl1 := TDBEdit.Create('pgFuenfZweckFoerdermittelKHEinsInput');
  RFE_AusOrdAufw2 := TDBEdit.Create('pgFuenfAusserAufwandKHZweiInput');
  RFE_AusOrdErtr2 := TDBEdit.Create('pgFuenfAusserErtragKHZweiInput');
  RFE_ForderTrag2 := TDBEdit.Create('pgFuenfFreiEinsKHZweiInput');
  RFE_Forder_KHG2 := TDBEdit.Create('pgFuenfForderungenKHZweiInput');
  RFE_Dummy2 := TDBEdit.Create('pgFuenfFreiZweiKHZweiInput');
  RFE_Verblk_KHG2 := TDBEdit.Create('pgFuenfVerbindlichkeitenKHZweiInput');
  RFE_Kapitalerh2 := TDBEdit.Create('pgFuenfKapitalerhoehungKHZweiInput');
  RFE_FoerderMtl2 := TDBEdit.Create('pgFuenfZweckFoerdermittelKHZweiInput');
  RFE_AusOrdAufw3 := TDBEdit.Create('pgFuenfAusserAufwandKHDreiInput');
  RFE_AusOrdErtr3 := TDBEdit.Create('pgFuenfAusserErtragKHDreiInput');
  RFE_ForderTrag3 := TDBEdit.Create('pgFuenfFreiEinsKHDreiInput');
  RFE_Forder_KHG3 := TDBEdit.Create('pgFuenfForderungenKHDreiInput');
  RFE_Dummy3 := TDBEdit.Create('pgFuenfFreiZweiKHDreiInput');
  RFE_Verblk_KHG3 := TDBEdit.Create('pgFuenfVerbindlichkeitenKHDreiInput');
  RFE_Kapitalerh3 := TDBEdit.Create('pgFuenfKapitalerhoehungKHDreiInput');
  RFE_FoerderMtl3 := TDBEdit.Create('pgFuenfZweckFoerdermittelKHDreiInput');
  RFE_AusOrdAufw4 := TDBEdit.Create('pgFuenfAusserAufwandKHVierInput');
  RFE_AusOrdErtr4 := TDBEdit.Create('pgFuenfAusserErtragKHVierInput');
  RFE_ForderTrag4 := TDBEdit.Create('pgFuenfFreiEinsKHVierInput');
  RFE_Forder_KHG4 := TDBEdit.Create('pgFuenfForderungenKHVierInput');
  RFE_Dummy4 := TDBEdit.Create('pgFuenfFreiZweiKHVierInput');
  RFE_Verblk_KHG4 := TDBEdit.Create('pgFuenfVerbindlichkeitenKHVierInput');
  RFE_Kapitalerh4 := TDBEdit.Create('pgFuenfKapitalerhoehungKHVierInput');
  RFE_FoerderMtl4 := TDBEdit.Create('pgFuenfZweckFoerdermittelKHVierInput');
  RFE_AusOrdAufw5 := TDBEdit.Create('pgFuenfAusserAufwandKHFuenfInput');
  RFE_AusOrdErtr5 := TDBEdit.Create('pgFuenfAusserErtragKHFuenfInput');
  RFE_ForderTrag5 := TDBEdit.Create('pgFuenfFreiEinsKHFuenfInput');
  RFE_Forder_KHG5 := TDBEdit.Create('pgFuenfForderungenKHFuenfInput');
  RFE_Dummy5 := TDBEdit.Create('pgFuenfFreiZweiKHFuenfInput');
  RFE_Verblk_KHG5 := TDBEdit.Create('pgFuenfVerbindlichkeitenKHFuenfInput');
  RFE_Kapitalerh5 := TDBEdit.Create('pgFuenfKapitalerhoehungKHFuenfInput');
  RFE_FoerderMtl5 := TDBEdit.Create('pgFuenfZweckFoerdermittelKHFuenfInput');
  pnVerwaltung := TPanel.Create('pnVerwaltung');
  WebLabel101 := TLabel.Create('verwaltungHeadline');
  pgSeite6 := TTabSheet.Create('periodicSeiteSechs');
  pnSoftSkills := TPanel.Create('pnPeriodicSoftskills');
  WebLabel37 := TLabel.Create('softskillsHeadline');
  strGridSoftSkills := TStringGrid.Create(Self);
  DRGDataSource := TDataSource.Create(Self);
  XDataWebDataSetDRG := TXDataWebDataSet.Create(Self);
  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  XDataWebDataSetPeriode := TXDataWebDataSet.Create(Self);
  XDataWebDataSetPersonalDaten := TXDataWebDataSet.Create(Self);
  PersonalDataSource := TDataSource.Create(Self);
  XDataWebDataSetHospitalMisc1 := TXDataWebDataSet.Create(Self);
  HospitalMisc1WebDataSource := TDataSource.Create(Self);
  XDataWebDataSetHospital := TXDataWebDataSet.Create(Self);
  XDataWebDataSetWahlleistungen := TXDataWebDataSet.Create(Self);
  WahlleistungenWebDataSource := TDataSource.Create(Self);
  XDataWebDataSetHospitalMisc2 := TXDataWebDataSet.Create(Self);
  XDataWebDataSetHospitalMisc3 := TXDataWebDataSet.Create(Self);
  XDataWebDataSetHospitalMisc4 := TXDataWebDataSet.Create(Self);
  XDataWebDataSetHospitalMisc5 := TXDataWebDataSet.Create(Self);
  HospitalMisc2WebDataSource := TDataSource.Create(Self);
  HospitalMisc3WebDataSource := TDataSource.Create(Self);
  HospitalMisc4WebDataSource := TDataSource.Create(Self);
  HospitalMisc5WebDataSource := TDataSource.Create(Self);
  XDataWebDataSetPeriodMisc := TXDataWebDataSet.Create(Self);
  PeriodMiscWebDataSource := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  lblAbteilung.BeforeLoadDFMValues;
  lblFallnummer.BeforeLoadDFMValues;
  lblNAVFallName.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  spedAbteilung.BeforeLoadDFMValues;
  spedFallNummer.BeforeLoadDFMValues;
  cbxFallName.BeforeLoadDFMValues;
  PageControl.BeforeLoadDFMValues;
  pgSeite1.BeforeLoadDFMValues;
  pnErloeseWahlleistung.BeforeLoadDFMValues;
  Lab0_Stat11.BeforeLoadDFMValues;
  Lab0_Stat21.BeforeLoadDFMValues;
  Lab0_Stat31.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  lblAbteilungsName.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  RFE_Stat1Unterk.BeforeLoadDFMValues;
  RFE_Stat2Unterk.BeforeLoadDFMValues;
  RFE_Stat3Unterk.BeforeLoadDFMValues;
  RFE_Stat1Arzt.BeforeLoadDFMValues;
  RFE_Stat2Arzt.BeforeLoadDFMValues;
  RFE_Stat3Arzt.BeforeLoadDFMValues;
  pnErloesKorrekturen.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel72.BeforeLoadDFMValues;
  WebLabel106.BeforeLoadDFMValues;
  WebLabel109.BeforeLoadDFMValues;
  WebLabel110.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel111.BeforeLoadDFMValues;
  WebLabel114.BeforeLoadDFMValues;
  WebLabel115.BeforeLoadDFMValues;
  WebLabel116.BeforeLoadDFMValues;
  RFE_ErlKorrU1.BeforeLoadDFMValues;
  RFE_ErlKorrU2.BeforeLoadDFMValues;
  RFE_ErlKorrU3.BeforeLoadDFMValues;
  RFE_ErlKorrU4.BeforeLoadDFMValues;
  RFE_ErlKorrU5.BeforeLoadDFMValues;
  pnInvestKosten.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  RFE_InvestProBett.BeforeLoadDFMValues;
  cbxkhEinsMVZCheckbox.BeforeLoadDFMValues;
  cbxkhZweiMVZCheckbox.BeforeLoadDFMValues;
  cbxkhDreiMVZCheckbox.BeforeLoadDFMValues;
  cbxkhVierMVZCheckbox.BeforeLoadDFMValues;
  cbxkhFuenfMVZCheckbox.BeforeLoadDFMValues;
  pnUmwandlungKosten.BeforeLoadDFMValues;
  Lab0_Stat14.BeforeLoadDFMValues;
  Lab0_Stat24.BeforeLoadDFMValues;
  Lab0_Stat34.BeforeLoadDFMValues;
  Lab0_Stat13.BeforeLoadDFMValues;
  Lab0_Stat23.BeforeLoadDFMValues;
  Lab0_Stat33.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel70.BeforeLoadDFMValues;
  RFE_UmwKoS2toS1.BeforeLoadDFMValues;
  RFE_UmwKoS3toS1.BeforeLoadDFMValues;
  RFE_UmwKoS1toS2.BeforeLoadDFMValues;
  RFE_UmwKoS3toS2.BeforeLoadDFMValues;
  RFE_UmwKoS1toS3.BeforeLoadDFMValues;
  RFE_UmwKoS2toS3.BeforeLoadDFMValues;
  WebMessageDlg.BeforeLoadDFMValues;
  pgSeite3.BeforeLoadDFMValues;
  pnDRGVerwaltung.BeforeLoadDFMValues;
  WebLabel102.BeforeLoadDFMValues;
  strGridStationCosts.BeforeLoadDFMValues;
  pnErloeseKorrekturen.BeforeLoadDFMValues;
  Lab_ErloesKor.BeforeLoadDFMValues;
  Lab_agErloes.BeforeLoadDFMValues;
  Lab_PflgErloes.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel103.BeforeLoadDFMValues;
  WebLabel104.BeforeLoadDFMValues;
  pnAnteileMode.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  lblFallName.BeforeLoadDFMValues;
  WebLabel100.BeforeLoadDFMValues;
  WebLabel99.BeforeLoadDFMValues;
  RF2_agBewRel.BeforeLoadDFMValues;
  RF2_PflgBewRel.BeforeLoadDFMValues;
  RFE_PflgWert.BeforeLoadDFMValues;
  RFE_FallBaWert.BeforeLoadDFMValues;
  pnFallZahlen.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  weblabStation1.BeforeLoadDFMValues;
  weblabStation2.BeforeLoadDFMValues;
  weblabStation3.BeforeLoadDFMValues;
  WebLabel44.BeforeLoadDFMValues;
  WebLabel45.BeforeLoadDFMValues;
  WebLabel46.BeforeLoadDFMValues;
  WebLabel47.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel105.BeforeLoadDFMValues;
  LF2_Fallzahl.BeforeLoadDFMValues;
  LF2_Stati1.BeforeLoadDFMValues;
  LF2_Stati2.BeforeLoadDFMValues;
  LF2_Stati3.BeforeLoadDFMValues;
  RF2_MVerwd.BeforeLoadDFMValues;
  RF2_GVerwD.BeforeLoadDFMValues;
  RF2_UebAnt.BeforeLoadDFMValues;
  RF2_UebTag.BeforeLoadDFMValues;
  pgSeite4.BeforeLoadDFMValues;
  pnPersonalDaten.BeforeLoadDFMValues;
  WebLabel49.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel52.BeforeLoadDFMValues;
  WebLabel53.BeforeLoadDFMValues;
  WebLabel54.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  WebLabel58.BeforeLoadDFMValues;
  WebLabel59.BeforeLoadDFMValues;
  WebLabel60.BeforeLoadDFMValues;
  WebLabel61.BeforeLoadDFMValues;
  WebLabel62.BeforeLoadDFMValues;
  WebLabel63.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel65.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel67.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  LFE_ArbZeitA.BeforeLoadDFMValues;
  RFE_StdSatzA.BeforeLoadDFMValues;
  RFE_GehNebKoA.BeforeLoadDFMValues;
  RFE_MaxUeberA.BeforeLoadDFMValues;
  RFE_UeZuschlA.BeforeLoadDFMValues;
  RFE_EinstlKoA.BeforeLoadDFMValues;
  RFE_EntlasKoA.BeforeLoadDFMValues;
  RFE_MaxEinstA.BeforeLoadDFMValues;
  RFE_MaxEntlaA.BeforeLoadDFMValues;
  RFE_TrainKstA.BeforeLoadDFMValues;
  RFE_FremdPKoA.BeforeLoadDFMValues;
  RFE_GehChefA.BeforeLoadDFMValues;
  LFE_ArbZeitP.BeforeLoadDFMValues;
  RFE_StdSatzP.BeforeLoadDFMValues;
  RFE_GehNebKoP.BeforeLoadDFMValues;
  RFE_MaxUeberP.BeforeLoadDFMValues;
  RFE_UeZuschlP.BeforeLoadDFMValues;
  RFE_EinstlKoP.BeforeLoadDFMValues;
  RFE_EntlasKoP.BeforeLoadDFMValues;
  RFE_MaxEinstP.BeforeLoadDFMValues;
  RFE_MaxEntlaP.BeforeLoadDFMValues;
  RFE_TrainKstP.BeforeLoadDFMValues;
  RFE_FremdPKoP.BeforeLoadDFMValues;
  LFE_ArbZeitM.BeforeLoadDFMValues;
  RFE_StdSatzM.BeforeLoadDFMValues;
  RFE_GehNebKoM.BeforeLoadDFMValues;
  RFE_MaxUeberM.BeforeLoadDFMValues;
  RFE_UeZuschlM.BeforeLoadDFMValues;
  RFE_EinstlKoM.BeforeLoadDFMValues;
  RFE_EntlasKoM.BeforeLoadDFMValues;
  RFE_MaxEinstM.BeforeLoadDFMValues;
  RFE_MaxEntlaM.BeforeLoadDFMValues;
  RFE_TrainKstM.BeforeLoadDFMValues;
  RFE_FremdPKoM.BeforeLoadDFMValues;
  RFE_GehDirek.BeforeLoadDFMValues;
  RFE_Rueckst.BeforeLoadDFMValues;
  RFE_AbFktGN.BeforeLoadDFMValues;
  RFE_AnGZeit.BeforeLoadDFMValues;
  pnFinanzdaten.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  RFE_ZinsUeberz.BeforeLoadDFMValues;
  RFE_ZinsKurzfr.BeforeLoadDFMValues;
  RFE_ZinsLangfr.BeforeLoadDFMValues;
  RFE_ZinsAnlage.BeforeLoadDFMValues;
  RFE_SteuerSatz1.BeforeLoadDFMValues;
  RFE_SteuerSatz2.BeforeLoadDFMValues;
  RFE_KassenMind.BeforeLoadDFMValues;
  RFE_FoerderBett.BeforeLoadDFMValues;
  RFE_Sonstiges1.BeforeLoadDFMValues;
  pgSeite5.BeforeLoadDFMValues;
  pnCodierDienst.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel90.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebLabel93.BeforeLoadDFMValues;
  WebLabel95.BeforeLoadDFMValues;
  RFE_FallSatz.BeforeLoadDFMValues;
  RFE_FaellePro.BeforeLoadDFMValues;
  RFE_CodLeasing.BeforeLoadDFMValues;
  RFE_CodInfrStr.BeforeLoadDFMValues;
  pnGenerelles.BeforeLoadDFMValues;
  WebLabel81.BeforeLoadDFMValues;
  WebLabel82.BeforeLoadDFMValues;
  WebLabel83.BeforeLoadDFMValues;
  WebLabel84.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel86.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel88.BeforeLoadDFMValues;
  WebLabel94.BeforeLoadDFMValues;
  RFE_AbschrDAnl.BeforeLoadDFMValues;
  RFE_AbschrSGeb.BeforeLoadDFMValues;
  RFE_AbschrDEin.BeforeLoadDFMValues;
  RFE_AbtRestBdg.BeforeLoadDFMValues;
  RFE_Patientver.BeforeLoadDFMValues;
  RFE_AntWahlL.BeforeLoadDFMValues;
  RFE_InstndSI.BeforeLoadDFMValues;
  RFE_InstndSA.BeforeLoadDFMValues;
  pnKassenDaten.BeforeLoadDFMValues;
  WebLabel96.BeforeLoadDFMValues;
  WebLabel97.BeforeLoadDFMValues;
  WebLabel98.BeforeLoadDFMValues;
  WebLabel92.BeforeLoadDFMValues;
  WebLabel112.BeforeLoadDFMValues;
  WebLabel113.BeforeLoadDFMValues;
  RFE_PktKorrFkt.BeforeLoadDFMValues;
  RFE_PktWertPer.BeforeLoadDFMValues;
  RFE_PktWertMed.BeforeLoadDFMValues;
  RFE_AntRestErl.BeforeLoadDFMValues;
  RFE_VerwKosten.BeforeLoadDFMValues;
  pnSonstiges.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebLabel69.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel73.BeforeLoadDFMValues;
  WebLabel74.BeforeLoadDFMValues;
  WebLabel75.BeforeLoadDFMValues;
  lblKrankenhaus1.BeforeLoadDFMValues;
  lblKrankenhaus2.BeforeLoadDFMValues;
  lblKrankenhaus3.BeforeLoadDFMValues;
  lblKrankenhaus4.BeforeLoadDFMValues;
  lblKrankenhaus5.BeforeLoadDFMValues;
  WebLabel107.BeforeLoadDFMValues;
  WebLabel108.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  RFE_AusOrdAufw1.BeforeLoadDFMValues;
  RFE_AusOrdErtr1.BeforeLoadDFMValues;
  RFE_ForderTrag1.BeforeLoadDFMValues;
  RFE_Forder_KHG1.BeforeLoadDFMValues;
  RFE_Dummy1.BeforeLoadDFMValues;
  RFE_Verblk_KHG1.BeforeLoadDFMValues;
  RFE_Kapitalerh1.BeforeLoadDFMValues;
  RFE_FoerderMtl1.BeforeLoadDFMValues;
  RFE_AusOrdAufw2.BeforeLoadDFMValues;
  RFE_AusOrdErtr2.BeforeLoadDFMValues;
  RFE_ForderTrag2.BeforeLoadDFMValues;
  RFE_Forder_KHG2.BeforeLoadDFMValues;
  RFE_Dummy2.BeforeLoadDFMValues;
  RFE_Verblk_KHG2.BeforeLoadDFMValues;
  RFE_Kapitalerh2.BeforeLoadDFMValues;
  RFE_FoerderMtl2.BeforeLoadDFMValues;
  RFE_AusOrdAufw3.BeforeLoadDFMValues;
  RFE_AusOrdErtr3.BeforeLoadDFMValues;
  RFE_ForderTrag3.BeforeLoadDFMValues;
  RFE_Forder_KHG3.BeforeLoadDFMValues;
  RFE_Dummy3.BeforeLoadDFMValues;
  RFE_Verblk_KHG3.BeforeLoadDFMValues;
  RFE_Kapitalerh3.BeforeLoadDFMValues;
  RFE_FoerderMtl3.BeforeLoadDFMValues;
  RFE_AusOrdAufw4.BeforeLoadDFMValues;
  RFE_AusOrdErtr4.BeforeLoadDFMValues;
  RFE_ForderTrag4.BeforeLoadDFMValues;
  RFE_Forder_KHG4.BeforeLoadDFMValues;
  RFE_Dummy4.BeforeLoadDFMValues;
  RFE_Verblk_KHG4.BeforeLoadDFMValues;
  RFE_Kapitalerh4.BeforeLoadDFMValues;
  RFE_FoerderMtl4.BeforeLoadDFMValues;
  RFE_AusOrdAufw5.BeforeLoadDFMValues;
  RFE_AusOrdErtr5.BeforeLoadDFMValues;
  RFE_ForderTrag5.BeforeLoadDFMValues;
  RFE_Forder_KHG5.BeforeLoadDFMValues;
  RFE_Dummy5.BeforeLoadDFMValues;
  RFE_Verblk_KHG5.BeforeLoadDFMValues;
  RFE_Kapitalerh5.BeforeLoadDFMValues;
  RFE_FoerderMtl5.BeforeLoadDFMValues;
  pnVerwaltung.BeforeLoadDFMValues;
  WebLabel101.BeforeLoadDFMValues;
  pgSeite6.BeforeLoadDFMValues;
  pnSoftSkills.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  strGridSoftSkills.BeforeLoadDFMValues;
  DRGDataSource.BeforeLoadDFMValues;
  XDataWebDataSetDRG.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  XDataWebDataSetPeriode.BeforeLoadDFMValues;
  XDataWebDataSetPersonalDaten.BeforeLoadDFMValues;
  PersonalDataSource.BeforeLoadDFMValues;
  XDataWebDataSetHospitalMisc1.BeforeLoadDFMValues;
  HospitalMisc1WebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetHospital.BeforeLoadDFMValues;
  XDataWebDataSetWahlleistungen.BeforeLoadDFMValues;
  WahlleistungenWebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetHospitalMisc2.BeforeLoadDFMValues;
  XDataWebDataSetHospitalMisc3.BeforeLoadDFMValues;
  XDataWebDataSetHospitalMisc4.BeforeLoadDFMValues;
  XDataWebDataSetHospitalMisc5.BeforeLoadDFMValues;
  HospitalMisc2WebDataSource.BeforeLoadDFMValues;
  HospitalMisc3WebDataSource.BeforeLoadDFMValues;
  HospitalMisc4WebDataSource.BeforeLoadDFMValues;
  HospitalMisc5WebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetPeriodMisc.BeforeLoadDFMValues;
  PeriodMiscWebDataSource.BeforeLoadDFMValues;
  try
    Width := 2173;
    Height := 1526;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WaitMessage.Picture.LoadFromFile('PrjFormPeriodicData.WaitMessage.Picture.gif');
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 1901;
    pnLeftNavigation.Top := 0;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 1526;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Align := alRight;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 1;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 9;
    lblPeriode.Top := 256;
    lblPeriode.Width := 165;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftsjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    lblAbteilung.SetParentComponent(pnLeftNavigation);
    lblAbteilung.Name := 'lblAbteilung';
    lblAbteilung.Left := 9;
    lblAbteilung.Top := 368;
    lblAbteilung.Width := 114;
    lblAbteilung.Height := 29;
    lblAbteilung.Caption := 'Abteilung';
    lblAbteilung.ElementFont := efCSS;
    lblAbteilung.ElementPosition := epRelative;
    lblAbteilung.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung.Font.Color := clWindowText;
    lblAbteilung.Font.Height := -24;
    lblAbteilung.Font.Name := 'Tahoma';
    lblAbteilung.Font.Style := [fsBold];
    lblAbteilung.HeightStyle := ssAuto;
    lblAbteilung.HeightPercent := 100.00000000000000000;
    lblAbteilung.ParentFont := False;
    lblAbteilung.WidthStyle := ssAuto;
    lblAbteilung.WidthPercent := 100.00000000000000000;
    lblFallnummer.SetParentComponent(pnLeftNavigation);
    lblFallnummer.Name := 'lblFallnummer';
    lblFallnummer.Left := 9;
    lblFallnummer.Top := 488;
    lblFallnummer.Width := 142;
    lblFallnummer.Height := 29;
    lblFallnummer.Caption := 'Fallnummer';
    lblFallnummer.ElementFont := efCSS;
    lblFallnummer.ElementPosition := epRelative;
    lblFallnummer.Font.Charset := DEFAULT_CHARSET;
    lblFallnummer.Font.Color := clWindowText;
    lblFallnummer.Font.Height := -24;
    lblFallnummer.Font.Name := 'Tahoma';
    lblFallnummer.Font.Style := [fsBold];
    lblFallnummer.HeightStyle := ssAuto;
    lblFallnummer.HeightPercent := 100.00000000000000000;
    lblFallnummer.ParentFont := False;
    lblFallnummer.WidthStyle := ssAuto;
    lblFallnummer.WidthPercent := 100.00000000000000000;
    lblNAVFallName.SetParentComponent(pnLeftNavigation);
    lblNAVFallName.Name := 'lblNAVFallName';
    lblNAVFallName.Left := 25;
    lblNAVFallName.Top := 572;
    lblNAVFallName.Width := 108;
    lblNAVFallName.Height := 29;
    lblNAVFallName.Caption := 'Fallname';
    lblNAVFallName.ElementFont := efCSS;
    lblNAVFallName.ElementPosition := epRelative;
    lblNAVFallName.Font.Charset := DEFAULT_CHARSET;
    lblNAVFallName.Font.Color := clWindowText;
    lblNAVFallName.Font.Height := -24;
    lblNAVFallName.Font.Name := 'Tahoma';
    lblNAVFallName.Font.Style := [fsBold];
    lblNAVFallName.HeightStyle := ssAuto;
    lblNAVFallName.HeightPercent := 100.00000000000000000;
    lblNAVFallName.ParentFont := False;
    lblNAVFallName.WidthStyle := ssAuto;
    lblNAVFallName.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 13;
    btnClose.Top := 35;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 13;
    btnSave.Top := 116;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 6;
    spedPeriode.Top := 291;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.ElementClassName := 'input input-bordered';
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    SetEvent(spedPeriode, Self, 'OnChange', 'spedPeriodeChanged');
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 13;
    btnPrint.Top := 676;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.Enabled := False;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 13;
    btnCancel.Top := 771;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.Visible := False;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 13;
    brnHelp.Top := 861;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.Visible := False;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    spedAbteilung.SetParentComponent(pnLeftNavigation);
    spedAbteilung.Name := 'spedAbteilung';
    spedAbteilung.Left := 6;
    spedAbteilung.Top := 403;
    spedAbteilung.Width := 250;
    spedAbteilung.Height := 57;
    spedAbteilung.ElementClassName := 'input input-bordered';
    spedAbteilung.HeightStyle := ssAuto;
    spedAbteilung.WidthStyle := ssAuto;
    spedAbteilung.AutoSize := False;
    spedAbteilung.BorderStyle := bsSingle;
    spedAbteilung.ChildOrder := 7;
    spedAbteilung.Color := clWhite;
    spedAbteilung.ElementFont := efCSS;
    spedAbteilung.ElementPosition := epRelative;
    spedAbteilung.Increment := 1;
    spedAbteilung.MaxValue := 100;
    spedAbteilung.MinValue := 0;
    spedAbteilung.Role := '';
    spedAbteilung.Value := 0;
    SetEvent(spedAbteilung, Self, 'OnChange', 'spedAbteilungChanged');
    spedFallNummer.SetParentComponent(pnLeftNavigation);
    spedFallNummer.Name := 'spedFallNummer';
    spedFallNummer.Left := 6;
    spedFallNummer.Top := 523;
    spedFallNummer.Width := 250;
    spedFallNummer.Height := 57;
    spedFallNummer.ElementClassName := 'input input-bordered';
    spedFallNummer.HeightStyle := ssAuto;
    spedFallNummer.WidthStyle := ssAuto;
    spedFallNummer.AutoSize := False;
    spedFallNummer.BorderStyle := bsSingle;
    spedFallNummer.ChildOrder := 7;
    spedFallNummer.Color := clWhite;
    spedFallNummer.ElementFont := efCSS;
    spedFallNummer.ElementPosition := epRelative;
    spedFallNummer.Increment := 1;
    spedFallNummer.MaxValue := 100;
    spedFallNummer.MinValue := 0;
    spedFallNummer.Role := '';
    spedFallNummer.Value := 0;
    SetEvent(spedFallNummer, Self, 'OnChange', 'spedFallNummerChanged');
    cbxFallName.SetParentComponent(pnLeftNavigation);
    cbxFallName.Name := 'cbxFallName';
    cbxFallName.Left := 6;
    cbxFallName.Top := 607;
    cbxFallName.Width := 251;
    cbxFallName.Height := 26;
    cbxFallName.Hint := 'Fall '#252'ber dan Namen ausw'#228'hlen';
    cbxFallName.ElementFont := efCSS;
    cbxFallName.ElementPosition := epRelative;
    cbxFallName.HeightStyle := ssAuto;
    cbxFallName.HeightPercent := 100.00000000000000000;
    cbxFallName.ShowHint := True;
    cbxFallName.WidthPercent := 100.00000000000000000;
    SetEvent(cbxFallName, Self, 'OnChange', 'cbxFallNameChange');
    cbxFallName.ItemIndex := -1;
    PageControl.SetParentComponent(Self);
    PageControl.Name := 'PageControl';
    PageControl.Left := 0;
    PageControl.Top := 0;
    PageControl.Width := 1901;
    PageControl.Height := 1526;
    PageControl.ElementClassName := 'tabs tabs-boxed justify-start order-first rounded-none';
    PageControl.Align := alClient;
    PageControl.ChildOrder := 3;
    PageControl.ElementTabClassName := 'tabs ';
    PageControl.ElementTabActiveClassName := 'tab-active tab';
    PageControl.ElementTabItemClassName := 'tab px-2';
    PageControl.ElementFont := efCSS;
    PageControl.TabIndex := 1;
    PageControl.TabOrder := 2;
    SetEvent(PageControl, Self, 'OnChange', 'PageControlChange');
    pgSeite1.SetParentComponent(PageControl);
    pgSeite1.Name := 'pgSeite1';
    pgSeite1.Left := 0;
    pgSeite1.Top := 20;
    pgSeite1.Width := 1901;
    pgSeite1.Height := 1506;
    pgSeite1.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgSeite1.HeightStyle := ssAuto;
    pgSeite1.WidthStyle := ssAuto;
    pgSeite1.Caption := 'Wahlleistungen';
    pgSeite1.ElementFont := efCSS;
    pgSeite1.ElementPosition := epRelative;
    pnErloeseWahlleistung.SetParentComponent(pgSeite1);
    pnErloeseWahlleistung.Name := 'pnErloeseWahlleistung';
    pnErloeseWahlleistung.Left := 0;
    pnErloeseWahlleistung.Top := 0;
    pnErloeseWahlleistung.Width := 1901;
    pnErloeseWahlleistung.Height := 328;
    pnErloeseWahlleistung.HeightStyle := ssAuto;
    pnErloeseWahlleistung.WidthStyle := ssAuto;
    pnErloeseWahlleistung.Align := alTop;
    pnErloeseWahlleistung.ElementFont := efCSS;
    pnErloeseWahlleistung.TabOrder := 0;
    Lab0_Stat11.SetParentComponent(pnErloeseWahlleistung);
    Lab0_Stat11.Name := 'Lab0_Stat11';
    Lab0_Stat11.Left := 16;
    Lab0_Stat11.Top := 102;
    Lab0_Stat11.Width := 108;
    Lab0_Stat11.Height := 29;
    Lab0_Stat11.Caption := 'Station 1';
    Lab0_Stat11.ElementFont := efCSS;
    Lab0_Stat11.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat11.Font.Color := clWindowText;
    Lab0_Stat11.Font.Height := -24;
    Lab0_Stat11.Font.Name := 'Tahoma';
    Lab0_Stat11.Font.Style := [fsBold];
    Lab0_Stat11.HeightStyle := ssAuto;
    Lab0_Stat11.HeightPercent := 100.00000000000000000;
    Lab0_Stat11.ParentFont := False;
    Lab0_Stat11.WidthPercent := 100.00000000000000000;
    Lab0_Stat21.SetParentComponent(pnErloeseWahlleistung);
    Lab0_Stat21.Name := 'Lab0_Stat21';
    Lab0_Stat21.Left := 24;
    Lab0_Stat21.Top := 202;
    Lab0_Stat21.Width := 108;
    Lab0_Stat21.Height := 29;
    Lab0_Stat21.Caption := 'Station 2';
    Lab0_Stat21.ElementFont := efCSS;
    Lab0_Stat21.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat21.Font.Color := clWindowText;
    Lab0_Stat21.Font.Height := -24;
    Lab0_Stat21.Font.Name := 'Tahoma';
    Lab0_Stat21.Font.Style := [fsBold];
    Lab0_Stat21.HeightStyle := ssAuto;
    Lab0_Stat21.HeightPercent := 100.00000000000000000;
    Lab0_Stat21.ParentFont := False;
    Lab0_Stat21.WidthPercent := 100.00000000000000000;
    Lab0_Stat31.SetParentComponent(pnErloeseWahlleistung);
    Lab0_Stat31.Name := 'Lab0_Stat31';
    Lab0_Stat31.Left := 24;
    Lab0_Stat31.Top := 253;
    Lab0_Stat31.Width := 108;
    Lab0_Stat31.Height := 29;
    Lab0_Stat31.Caption := 'Station 3';
    Lab0_Stat31.ElementFont := efCSS;
    Lab0_Stat31.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat31.Font.Color := clWindowText;
    Lab0_Stat31.Font.Height := -24;
    Lab0_Stat31.Font.Name := 'Tahoma';
    Lab0_Stat31.Font.Style := [fsBold];
    Lab0_Stat31.HeightStyle := ssAuto;
    Lab0_Stat31.HeightPercent := 100.00000000000000000;
    Lab0_Stat31.ParentFont := False;
    Lab0_Stat31.WidthPercent := 100.00000000000000000;
    WebLabel5.SetParentComponent(pnErloeseWahlleistung);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 333;
    WebLabel5.Top := 80;
    WebLabel5.Width := 130;
    WebLabel5.Height := 29;
    WebLabel5.Caption := 'Unterkunft';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -24;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.00000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.00000000000000000;
    WebLabel6.SetParentComponent(pnErloeseWahlleistung);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 503;
    WebLabel6.Top := 115;
    WebLabel6.Width := 249;
    WebLabel6.Height := 29;
    WebLabel6.Caption := #196'rztliche Fachperson';
    WebLabel6.ElementFont := efCSS;
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -24;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.00000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.00000000000000000;
    WebImageControl1.SetParentComponent(pnErloeseWahlleistung);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 2803;
    WebImageControl1.Top := 28;
    WebImageControl1.Width := 241;
    WebImageControl1.Height := 136;
    WebImageControl1.HeightPercent := 100.00000000000000000;
    WebImageControl1.WidthPercent := 100.00000000000000000;
    WebImageControl1.Anchors := [akTop,akRight];
    WebImageControl1.ChildOrder := 20;
    WebImageControl1.Visible := False;
    WebImageControl1.Picture.LoadFromFile('PrjFormPeriodicData.pnErloeseWahlleistung.WebImageControl1.Picture.jpg');
    lblAbteilungsName.SetParentComponent(pnErloeseWahlleistung);
    lblAbteilungsName.Name := 'lblAbteilungsName';
    lblAbteilungsName.Left := 3;
    lblAbteilungsName.Top := 28;
    lblAbteilungsName.Width := 130;
    lblAbteilungsName.Height := 29;
    lblAbteilungsName.Caption := 'Unterkunft';
    lblAbteilungsName.ElementFont := efCSS;
    lblAbteilungsName.Font.Charset := DEFAULT_CHARSET;
    lblAbteilungsName.Font.Color := clBlue;
    lblAbteilungsName.Font.Height := -24;
    lblAbteilungsName.Font.Name := 'Tahoma';
    lblAbteilungsName.Font.Style := [fsBold];
    lblAbteilungsName.HeightStyle := ssAuto;
    lblAbteilungsName.HeightPercent := 100.00000000000000000;
    lblAbteilungsName.HTMLType := tH3;
    lblAbteilungsName.ParentFont := False;
    lblAbteilungsName.WidthPercent := 100.00000000000000000;
    WebLabel34.SetParentComponent(pnErloeseWahlleistung);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 17;
    WebLabel34.Top := 67;
    WebLabel34.Width := 167;
    WebLabel34.Height := 18;
    WebLabel34.Caption := 'Erl'#246'se aus Wahlleistungen';
    WebLabel34.ElementFont := efCSS;
    WebLabel34.ElementPosition := epRelative;
    WebLabel34.HeightStyle := ssAuto;
    WebLabel34.HeightPercent := 100.00000000000000000;
    WebLabel34.WidthPercent := 100.00000000000000000;
    WebLabel22.SetParentComponent(pnErloeseWahlleistung);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 187;
    WebLabel22.Top := 32;
    WebLabel22.Width := 167;
    WebLabel22.Height := 18;
    WebLabel22.Caption := 'Erl'#246'se aus Wahlleistungen';
    WebLabel22.ElementFont := efCSS;
    WebLabel22.ElementPosition := epRelative;
    WebLabel22.HeightStyle := ssAuto;
    WebLabel22.HeightPercent := 100.00000000000000000;
    WebLabel22.WidthPercent := 100.00000000000000000;
    WebLabel23.SetParentComponent(pnErloeseWahlleistung);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 381;
    WebLabel23.Top := 34;
    WebLabel23.Width := 167;
    WebLabel23.Height := 18;
    WebLabel23.Caption := 'Erl'#246'se aus Wahlleistungen';
    WebLabel23.ElementFont := efCSS;
    WebLabel23.ElementPosition := epRelative;
    WebLabel23.HeightStyle := ssAuto;
    WebLabel23.HeightPercent := 100.00000000000000000;
    WebLabel23.WidthPercent := 100.00000000000000000;
    WebLabel24.SetParentComponent(pnErloeseWahlleistung);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 333;
    WebLabel24.Top := 115;
    WebLabel24.Width := 130;
    WebLabel24.Height := 29;
    WebLabel24.Caption := 'Unterkunft';
    WebLabel24.ElementFont := efCSS;
    WebLabel24.Font.Charset := DEFAULT_CHARSET;
    WebLabel24.Font.Color := clWindowText;
    WebLabel24.Font.Height := -24;
    WebLabel24.Font.Name := 'Tahoma';
    WebLabel24.Font.Style := [fsBold];
    WebLabel24.HeightStyle := ssAuto;
    WebLabel24.HeightPercent := 100.00000000000000000;
    WebLabel24.ParentFont := False;
    WebLabel24.WidthPercent := 100.00000000000000000;
    WebLabel25.SetParentComponent(pnErloeseWahlleistung);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 333;
    WebLabel25.Top := 56;
    WebLabel25.Width := 130;
    WebLabel25.Height := 29;
    WebLabel25.Caption := 'Unterkunft';
    WebLabel25.ElementFont := efCSS;
    WebLabel25.Font.Charset := DEFAULT_CHARSET;
    WebLabel25.Font.Color := clWindowText;
    WebLabel25.Font.Height := -24;
    WebLabel25.Font.Name := 'Tahoma';
    WebLabel25.Font.Style := [fsBold];
    WebLabel25.HeightStyle := ssAuto;
    WebLabel25.HeightPercent := 100.00000000000000000;
    WebLabel25.ParentFont := False;
    WebLabel25.WidthPercent := 100.00000000000000000;
    WebLabel26.SetParentComponent(pnErloeseWahlleistung);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 503;
    WebLabel26.Top := 58;
    WebLabel26.Width := 249;
    WebLabel26.Height := 29;
    WebLabel26.Caption := #196'rztliche Fachperson';
    WebLabel26.ElementFont := efCSS;
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clWindowText;
    WebLabel26.Font.Height := -24;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightStyle := ssAuto;
    WebLabel26.HeightPercent := 100.00000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.00000000000000000;
    WebLabel27.SetParentComponent(pnErloeseWahlleistung);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 503;
    WebLabel27.Top := 84;
    WebLabel27.Width := 249;
    WebLabel27.Height := 29;
    WebLabel27.Caption := #196'rztliche Fachperson';
    WebLabel27.ElementFont := efCSS;
    WebLabel27.Font.Charset := DEFAULT_CHARSET;
    WebLabel27.Font.Color := clWindowText;
    WebLabel27.Font.Height := -24;
    WebLabel27.Font.Name := 'Tahoma';
    WebLabel27.Font.Style := [fsBold];
    WebLabel27.HeightStyle := ssAuto;
    WebLabel27.HeightPercent := 100.00000000000000000;
    WebLabel27.ParentFont := False;
    WebLabel27.WidthPercent := 100.00000000000000000;
    RFE_Stat1Unterk.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat1Unterk.Name := 'RFE_Stat1Unterk';
    RFE_Stat1Unterk.Left := 328;
    RFE_Stat1Unterk.Top := 150;
    RFE_Stat1Unterk.Width := 150;
    RFE_Stat1Unterk.Height := 46;
    RFE_Stat1Unterk.ChildOrder := 10;
    RFE_Stat1Unterk.EditType := weSignedFloat;
    RFE_Stat1Unterk.ElementFont := efCSS;
    RFE_Stat1Unterk.Font.Charset := ANSI_CHARSET;
    RFE_Stat1Unterk.Font.Color := clWindowText;
    RFE_Stat1Unterk.Font.Height := -24;
    RFE_Stat1Unterk.Font.Name := 'Segoe UI';
    RFE_Stat1Unterk.Font.Style := [fsBold];
    RFE_Stat1Unterk.HeightStyle := ssAuto;
    RFE_Stat1Unterk.HeightPercent := 100.00000000000000000;
    RFE_Stat1Unterk.ParentFont := False;
    RFE_Stat1Unterk.Text := 'RFE_Stat1Unterk';
    RFE_Stat1Unterk.WidthPercent := 100.00000000000000000;
    RFE_Stat1Unterk.DataField := 'Hbos_Profit1_Accomodation';
    RFE_Stat1Unterk.DataSource := WahlleistungenWebDataSource;
    RFE_Stat2Unterk.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat2Unterk.Name := 'RFE_Stat2Unterk';
    RFE_Stat2Unterk.Left := 328;
    RFE_Stat2Unterk.Top := 202;
    RFE_Stat2Unterk.Width := 150;
    RFE_Stat2Unterk.Height := 46;
    RFE_Stat2Unterk.ChildOrder := 11;
    RFE_Stat2Unterk.EditType := weSignedFloat;
    RFE_Stat2Unterk.ElementFont := efCSS;
    RFE_Stat2Unterk.Font.Charset := ANSI_CHARSET;
    RFE_Stat2Unterk.Font.Color := clWindowText;
    RFE_Stat2Unterk.Font.Height := -24;
    RFE_Stat2Unterk.Font.Name := 'Segoe UI';
    RFE_Stat2Unterk.Font.Style := [fsBold];
    RFE_Stat2Unterk.HeightStyle := ssAuto;
    RFE_Stat2Unterk.HeightPercent := 100.00000000000000000;
    RFE_Stat2Unterk.ParentFont := False;
    RFE_Stat2Unterk.TabOrder := 1;
    RFE_Stat2Unterk.Text := ' ';
    RFE_Stat2Unterk.WidthPercent := 100.00000000000000000;
    RFE_Stat2Unterk.DataField := 'Hbos_Profit2_Accomodation';
    RFE_Stat2Unterk.DataSource := WahlleistungenWebDataSource;
    RFE_Stat3Unterk.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat3Unterk.Name := 'RFE_Stat3Unterk';
    RFE_Stat3Unterk.Left := 328;
    RFE_Stat3Unterk.Top := 254;
    RFE_Stat3Unterk.Width := 150;
    RFE_Stat3Unterk.Height := 46;
    RFE_Stat3Unterk.ChildOrder := 12;
    RFE_Stat3Unterk.EditType := weSignedFloat;
    RFE_Stat3Unterk.ElementFont := efCSS;
    RFE_Stat3Unterk.Font.Charset := ANSI_CHARSET;
    RFE_Stat3Unterk.Font.Color := clWindowText;
    RFE_Stat3Unterk.Font.Height := -24;
    RFE_Stat3Unterk.Font.Name := 'Segoe UI';
    RFE_Stat3Unterk.Font.Style := [fsBold];
    RFE_Stat3Unterk.HeightStyle := ssAuto;
    RFE_Stat3Unterk.HeightPercent := 100.00000000000000000;
    RFE_Stat3Unterk.ParentFont := False;
    RFE_Stat3Unterk.TabOrder := 2;
    RFE_Stat3Unterk.Text := ' ';
    RFE_Stat3Unterk.WidthPercent := 100.00000000000000000;
    RFE_Stat3Unterk.DataField := 'Hbos_Profit3_Accomodation';
    RFE_Stat3Unterk.DataSource := WahlleistungenWebDataSource;
    RFE_Stat1Arzt.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat1Arzt.Name := 'RFE_Stat1Arzt';
    RFE_Stat1Arzt.Left := 505;
    RFE_Stat1Arzt.Top := 150;
    RFE_Stat1Arzt.Width := 150;
    RFE_Stat1Arzt.Height := 46;
    RFE_Stat1Arzt.ChildOrder := 13;
    RFE_Stat1Arzt.EditType := weSignedFloat;
    RFE_Stat1Arzt.ElementFont := efCSS;
    RFE_Stat1Arzt.Font.Charset := ANSI_CHARSET;
    RFE_Stat1Arzt.Font.Color := clWindowText;
    RFE_Stat1Arzt.Font.Height := -24;
    RFE_Stat1Arzt.Font.Name := 'Segoe UI';
    RFE_Stat1Arzt.Font.Style := [fsBold];
    RFE_Stat1Arzt.HeightStyle := ssAuto;
    RFE_Stat1Arzt.HeightPercent := 100.00000000000000000;
    RFE_Stat1Arzt.ParentFont := False;
    RFE_Stat1Arzt.TabOrder := 3;
    RFE_Stat1Arzt.Text := ' ';
    RFE_Stat1Arzt.WidthPercent := 100.00000000000000000;
    RFE_Stat1Arzt.DataField := 'Hbos_Profit1_Healthcare_Prof';
    RFE_Stat1Arzt.DataSource := WahlleistungenWebDataSource;
    RFE_Stat2Arzt.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat2Arzt.Name := 'RFE_Stat2Arzt';
    RFE_Stat2Arzt.Left := 505;
    RFE_Stat2Arzt.Top := 202;
    RFE_Stat2Arzt.Width := 150;
    RFE_Stat2Arzt.Height := 46;
    RFE_Stat2Arzt.ChildOrder := 14;
    RFE_Stat2Arzt.EditType := weSignedFloat;
    RFE_Stat2Arzt.ElementFont := efCSS;
    RFE_Stat2Arzt.Font.Charset := ANSI_CHARSET;
    RFE_Stat2Arzt.Font.Color := clWindowText;
    RFE_Stat2Arzt.Font.Height := -24;
    RFE_Stat2Arzt.Font.Name := 'Segoe UI';
    RFE_Stat2Arzt.Font.Style := [fsBold];
    RFE_Stat2Arzt.HeightStyle := ssAuto;
    RFE_Stat2Arzt.HeightPercent := 100.00000000000000000;
    RFE_Stat2Arzt.ParentFont := False;
    RFE_Stat2Arzt.TabOrder := 4;
    RFE_Stat2Arzt.Text := ' ';
    RFE_Stat2Arzt.WidthPercent := 100.00000000000000000;
    RFE_Stat2Arzt.DataField := 'Hbos_Profit2_Healthcare_Prof';
    RFE_Stat2Arzt.DataSource := WahlleistungenWebDataSource;
    RFE_Stat3Arzt.SetParentComponent(pnErloeseWahlleistung);
    RFE_Stat3Arzt.Name := 'RFE_Stat3Arzt';
    RFE_Stat3Arzt.Left := 505;
    RFE_Stat3Arzt.Top := 254;
    RFE_Stat3Arzt.Width := 150;
    RFE_Stat3Arzt.Height := 46;
    RFE_Stat3Arzt.ChildOrder := 15;
    RFE_Stat3Arzt.EditType := weSignedFloat;
    RFE_Stat3Arzt.ElementFont := efCSS;
    RFE_Stat3Arzt.Font.Charset := ANSI_CHARSET;
    RFE_Stat3Arzt.Font.Color := clWindowText;
    RFE_Stat3Arzt.Font.Height := -24;
    RFE_Stat3Arzt.Font.Name := 'Segoe UI';
    RFE_Stat3Arzt.Font.Style := [fsBold];
    RFE_Stat3Arzt.HeightStyle := ssAuto;
    RFE_Stat3Arzt.HeightPercent := 100.00000000000000000;
    RFE_Stat3Arzt.ParentFont := False;
    RFE_Stat3Arzt.TabOrder := 5;
    RFE_Stat3Arzt.Text := ' ';
    RFE_Stat3Arzt.WidthPercent := 100.00000000000000000;
    RFE_Stat3Arzt.DataField := 'Hbos_Profit3_Healthcare_Prof';
    RFE_Stat3Arzt.DataSource := WahlleistungenWebDataSource;
    pnErloesKorrekturen.SetParentComponent(pgSeite1);
    pnErloesKorrekturen.Name := 'pnErloesKorrekturen';
    pnErloesKorrekturen.Left := 0;
    pnErloesKorrekturen.Top := 328;
    pnErloesKorrekturen.Width := 1901;
    pnErloesKorrekturen.Height := 372;
    pnErloesKorrekturen.Align := alTop;
    pnErloesKorrekturen.ChildOrder := 1;
    pnErloesKorrekturen.ElementFont := efCSS;
    pnErloesKorrekturen.TabOrder := 1;
    WebLabel10.SetParentComponent(pnErloesKorrekturen);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 16;
    WebLabel10.Top := 155;
    WebLabel10.Width := 177;
    WebLabel10.Height := 29;
    WebLabel10.Caption := 'Krankenhaus 2';
    WebLabel10.ElementFont := efCSS;
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -24;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightStyle := ssAuto;
    WebLabel10.HeightPercent := 100.00000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.00000000000000000;
    WebLabel11.SetParentComponent(pnErloesKorrekturen);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 16;
    WebLabel11.Top := 207;
    WebLabel11.Width := 177;
    WebLabel11.Height := 29;
    WebLabel11.Caption := 'Krankenhaus 3';
    WebLabel11.ElementFont := efCSS;
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -24;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightStyle := ssAuto;
    WebLabel11.HeightPercent := 100.00000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.00000000000000000;
    WebLabel12.SetParentComponent(pnErloesKorrekturen);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 18;
    WebLabel12.Top := 259;
    WebLabel12.Width := 177;
    WebLabel12.Height := 29;
    WebLabel12.Caption := 'Krankenhaus 4';
    WebLabel12.ElementFont := efCSS;
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -24;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [fsBold];
    WebLabel12.HeightStyle := ssAuto;
    WebLabel12.HeightPercent := 100.00000000000000000;
    WebLabel12.ParentFont := False;
    WebLabel12.WidthPercent := 100.00000000000000000;
    WebLabel13.SetParentComponent(pnErloesKorrekturen);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 16;
    WebLabel13.Top := 311;
    WebLabel13.Width := 177;
    WebLabel13.Height := 29;
    WebLabel13.Caption := 'Krankenhaus 5';
    WebLabel13.ElementFont := efCSS;
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -24;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightStyle := ssAuto;
    WebLabel13.HeightPercent := 100.00000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.00000000000000000;
    WebLabel31.SetParentComponent(pnErloesKorrekturen);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 56;
    WebLabel31.Top := 32;
    WebLabel31.Width := 88;
    WebLabel31.Height := 18;
    WebLabel31.Caption := 'Erl'#246'skorrektur';
    WebLabel31.ElementFont := efCSS;
    WebLabel31.ElementPosition := epRelative;
    WebLabel31.HeightStyle := ssAuto;
    WebLabel31.HeightPercent := 100.00000000000000000;
    WebLabel31.HTMLType := tH3;
    WebLabel31.WidthPercent := 100.00000000000000000;
    WebLabel72.SetParentComponent(pnErloesKorrekturen);
    WebLabel72.Name := 'WebLabel72';
    WebLabel72.Left := 163;
    WebLabel72.Top := 32;
    WebLabel72.Width := 88;
    WebLabel72.Height := 18;
    WebLabel72.Caption := 'Erl'#246'skorrektur';
    WebLabel72.ElementFont := efCSS;
    WebLabel72.ElementPosition := epRelative;
    WebLabel72.HeightStyle := ssAuto;
    WebLabel72.HeightPercent := 100.00000000000000000;
    WebLabel72.HTMLType := tH3;
    WebLabel72.WidthPercent := 100.00000000000000000;
    WebLabel106.SetParentComponent(pnErloesKorrekturen);
    WebLabel106.Name := 'WebLabel106';
    WebLabel106.Left := 500;
    WebLabel106.Top := 21;
    WebLabel106.Width := 88;
    WebLabel106.Height := 18;
    WebLabel106.Caption := 'Erl'#246'skorrektur';
    WebLabel106.ElementFont := efCSS;
    WebLabel106.ElementPosition := epRelative;
    WebLabel106.HeightStyle := ssAuto;
    WebLabel106.HeightPercent := 100.00000000000000000;
    WebLabel106.HTMLType := tH3;
    WebLabel106.WidthPercent := 100.00000000000000000;
    WebLabel109.SetParentComponent(pnErloesKorrekturen);
    WebLabel109.Name := 'WebLabel109';
    WebLabel109.Left := 296;
    WebLabel109.Top := 22;
    WebLabel109.Width := 88;
    WebLabel109.Height := 18;
    WebLabel109.Caption := 'Erl'#246'skorrektur';
    WebLabel109.ElementFont := efCSS;
    WebLabel109.ElementPosition := epRelative;
    WebLabel109.HeightStyle := ssAuto;
    WebLabel109.HeightPercent := 100.00000000000000000;
    WebLabel109.HTMLType := tH3;
    WebLabel109.WidthPercent := 100.00000000000000000;
    WebLabel110.SetParentComponent(pnErloesKorrekturen);
    WebLabel110.Name := 'WebLabel110';
    WebLabel110.Left := 390;
    WebLabel110.Top := 23;
    WebLabel110.Width := 88;
    WebLabel110.Height := 18;
    WebLabel110.Caption := 'Erl'#246'skorrektur';
    WebLabel110.ElementFont := efCSS;
    WebLabel110.ElementPosition := epRelative;
    WebLabel110.HeightStyle := ssAuto;
    WebLabel110.HeightPercent := 100.00000000000000000;
    WebLabel110.HTMLType := tH3;
    WebLabel110.WidthPercent := 100.00000000000000000;
    WebLabel15.SetParentComponent(pnErloesKorrekturen);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 560;
    WebLabel15.Top := 104;
    WebLabel15.Width := 184;
    WebLabel15.Height := 18;
    WebLabel15.Caption := 'MVZ ab dieser Periode dabei';
    WebLabel15.ElementFont := efCSS;
    WebLabel15.HeightStyle := ssAuto;
    WebLabel15.HeightPercent := 100.00000000000000000;
    WebLabel15.WidthPercent := 100.00000000000000000;
    WebLabel16.SetParentComponent(pnErloesKorrekturen);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 23;
    WebLabel16.Top := 99;
    WebLabel16.Width := 177;
    WebLabel16.Height := 29;
    WebLabel16.Caption := 'Krankenhaus 1';
    WebLabel16.ElementFont := efCSS;
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -24;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.HeightStyle := ssAuto;
    WebLabel16.HeightPercent := 100.00000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.00000000000000000;
    WebLabel111.SetParentComponent(pnErloesKorrekturen);
    WebLabel111.Name := 'WebLabel111';
    WebLabel111.Left := 563;
    WebLabel111.Top := 160;
    WebLabel111.Width := 184;
    WebLabel111.Height := 18;
    WebLabel111.Caption := 'MVZ ab dieser Periode dabei';
    WebLabel111.ElementFont := efCSS;
    WebLabel111.HeightStyle := ssAuto;
    WebLabel111.HeightPercent := 100.00000000000000000;
    WebLabel111.WidthPercent := 100.00000000000000000;
    WebLabel114.SetParentComponent(pnErloesKorrekturen);
    WebLabel114.Name := 'WebLabel114';
    WebLabel114.Left := 554;
    WebLabel114.Top := 211;
    WebLabel114.Width := 184;
    WebLabel114.Height := 18;
    WebLabel114.Caption := 'MVZ ab dieser Periode dabei';
    WebLabel114.ElementFont := efCSS;
    WebLabel114.HeightStyle := ssAuto;
    WebLabel114.HeightPercent := 100.00000000000000000;
    WebLabel114.WidthPercent := 100.00000000000000000;
    WebLabel115.SetParentComponent(pnErloesKorrekturen);
    WebLabel115.Name := 'WebLabel115';
    WebLabel115.Left := 560;
    WebLabel115.Top := 262;
    WebLabel115.Width := 184;
    WebLabel115.Height := 18;
    WebLabel115.Caption := 'MVZ ab dieser Periode dabei';
    WebLabel115.ElementFont := efCSS;
    WebLabel115.HeightStyle := ssAuto;
    WebLabel115.HeightPercent := 100.00000000000000000;
    WebLabel115.WidthPercent := 100.00000000000000000;
    WebLabel116.SetParentComponent(pnErloesKorrekturen);
    WebLabel116.Name := 'WebLabel116';
    WebLabel116.Left := 560;
    WebLabel116.Top := 297;
    WebLabel116.Width := 184;
    WebLabel116.Height := 18;
    WebLabel116.Caption := 'MVZ ab dieser Periode dabei';
    WebLabel116.ElementFont := efCSS;
    WebLabel116.HeightStyle := ssAuto;
    WebLabel116.HeightPercent := 100.00000000000000000;
    WebLabel116.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU1.SetParentComponent(pnErloesKorrekturen);
    RFE_ErlKorrU1.Name := 'RFE_ErlKorrU1';
    RFE_ErlKorrU1.Left := 206;
    RFE_ErlKorrU1.Top := 96;
    RFE_ErlKorrU1.Width := 150;
    RFE_ErlKorrU1.Height := 46;
    RFE_ErlKorrU1.ChildOrder := 5;
    RFE_ErlKorrU1.EditType := weSignedFloat;
    RFE_ErlKorrU1.ElementFont := efCSS;
    RFE_ErlKorrU1.Font.Charset := ANSI_CHARSET;
    RFE_ErlKorrU1.Font.Color := clWindowText;
    RFE_ErlKorrU1.Font.Height := -24;
    RFE_ErlKorrU1.Font.Name := 'Segoe UI';
    RFE_ErlKorrU1.Font.Style := [fsBold];
    RFE_ErlKorrU1.HeightStyle := ssAuto;
    RFE_ErlKorrU1.HeightPercent := 100.00000000000000000;
    RFE_ErlKorrU1.ParentFont := False;
    RFE_ErlKorrU1.Text := ' ';
    RFE_ErlKorrU1.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU1.DataField := 'Hhmc_Profit_Correction';
    RFE_ErlKorrU1.DataSource := HospitalMisc1WebDataSource;
    RFE_ErlKorrU2.SetParentComponent(pnErloesKorrekturen);
    RFE_ErlKorrU2.Name := 'RFE_ErlKorrU2';
    RFE_ErlKorrU2.Left := 206;
    RFE_ErlKorrU2.Top := 149;
    RFE_ErlKorrU2.Width := 150;
    RFE_ErlKorrU2.Height := 46;
    RFE_ErlKorrU2.ChildOrder := 6;
    RFE_ErlKorrU2.EditType := weSignedFloat;
    RFE_ErlKorrU2.ElementFont := efCSS;
    RFE_ErlKorrU2.Font.Charset := ANSI_CHARSET;
    RFE_ErlKorrU2.Font.Color := clWindowText;
    RFE_ErlKorrU2.Font.Height := -24;
    RFE_ErlKorrU2.Font.Name := 'Segoe UI';
    RFE_ErlKorrU2.Font.Style := [fsBold];
    RFE_ErlKorrU2.HeightStyle := ssAuto;
    RFE_ErlKorrU2.HeightPercent := 100.00000000000000000;
    RFE_ErlKorrU2.ParentFont := False;
    RFE_ErlKorrU2.TabOrder := 1;
    RFE_ErlKorrU2.Text := ' ';
    RFE_ErlKorrU2.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU2.DataField := 'Hhmc_Profit_Correction';
    RFE_ErlKorrU2.DataSource := HospitalMisc2WebDataSource;
    RFE_ErlKorrU3.SetParentComponent(pnErloesKorrekturen);
    RFE_ErlKorrU3.Name := 'RFE_ErlKorrU3';
    RFE_ErlKorrU3.Left := 206;
    RFE_ErlKorrU3.Top := 201;
    RFE_ErlKorrU3.Width := 150;
    RFE_ErlKorrU3.Height := 46;
    RFE_ErlKorrU3.ChildOrder := 7;
    RFE_ErlKorrU3.EditType := weSignedFloat;
    RFE_ErlKorrU3.ElementFont := efCSS;
    RFE_ErlKorrU3.Font.Charset := ANSI_CHARSET;
    RFE_ErlKorrU3.Font.Color := clWindowText;
    RFE_ErlKorrU3.Font.Height := -24;
    RFE_ErlKorrU3.Font.Name := 'Segoe UI';
    RFE_ErlKorrU3.Font.Style := [fsBold];
    RFE_ErlKorrU3.HeightStyle := ssAuto;
    RFE_ErlKorrU3.HeightPercent := 100.00000000000000000;
    RFE_ErlKorrU3.ParentFont := False;
    RFE_ErlKorrU3.TabOrder := 2;
    RFE_ErlKorrU3.Text := ' ';
    RFE_ErlKorrU3.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU3.DataField := 'Hhmc_Profit_Correction';
    RFE_ErlKorrU3.DataSource := HospitalMisc3WebDataSource;
    RFE_ErlKorrU4.SetParentComponent(pnErloesKorrekturen);
    RFE_ErlKorrU4.Name := 'RFE_ErlKorrU4';
    RFE_ErlKorrU4.Left := 206;
    RFE_ErlKorrU4.Top := 253;
    RFE_ErlKorrU4.Width := 150;
    RFE_ErlKorrU4.Height := 46;
    RFE_ErlKorrU4.ChildOrder := 8;
    RFE_ErlKorrU4.EditType := weSignedFloat;
    RFE_ErlKorrU4.ElementFont := efCSS;
    RFE_ErlKorrU4.Font.Charset := ANSI_CHARSET;
    RFE_ErlKorrU4.Font.Color := clWindowText;
    RFE_ErlKorrU4.Font.Height := -24;
    RFE_ErlKorrU4.Font.Name := 'Segoe UI';
    RFE_ErlKorrU4.Font.Style := [fsBold];
    RFE_ErlKorrU4.HeightStyle := ssAuto;
    RFE_ErlKorrU4.HeightPercent := 100.00000000000000000;
    RFE_ErlKorrU4.ParentFont := False;
    RFE_ErlKorrU4.TabOrder := 3;
    RFE_ErlKorrU4.Text := ' ';
    RFE_ErlKorrU4.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU4.DataField := 'Hhmc_Profit_Correction';
    RFE_ErlKorrU4.DataSource := HospitalMisc4WebDataSource;
    RFE_ErlKorrU5.SetParentComponent(pnErloesKorrekturen);
    RFE_ErlKorrU5.Name := 'RFE_ErlKorrU5';
    RFE_ErlKorrU5.Left := 206;
    RFE_ErlKorrU5.Top := 305;
    RFE_ErlKorrU5.Width := 150;
    RFE_ErlKorrU5.Height := 46;
    RFE_ErlKorrU5.ChildOrder := 9;
    RFE_ErlKorrU5.EditType := weSignedFloat;
    RFE_ErlKorrU5.ElementFont := efCSS;
    RFE_ErlKorrU5.Font.Charset := ANSI_CHARSET;
    RFE_ErlKorrU5.Font.Color := clWindowText;
    RFE_ErlKorrU5.Font.Height := -24;
    RFE_ErlKorrU5.Font.Name := 'Segoe UI';
    RFE_ErlKorrU5.Font.Style := [fsBold];
    RFE_ErlKorrU5.HeightStyle := ssAuto;
    RFE_ErlKorrU5.HeightPercent := 100.00000000000000000;
    RFE_ErlKorrU5.ParentFont := False;
    RFE_ErlKorrU5.TabOrder := 4;
    RFE_ErlKorrU5.Text := ' ';
    RFE_ErlKorrU5.WidthPercent := 100.00000000000000000;
    RFE_ErlKorrU5.DataField := 'Hhmc_Profit_Correction';
    RFE_ErlKorrU5.DataSource := HospitalMisc5WebDataSource;
    pnInvestKosten.SetParentComponent(pnErloesKorrekturen);
    pnInvestKosten.Name := 'pnInvestKosten';
    pnInvestKosten.Left := 1218;
    pnInvestKosten.Top := 0;
    pnInvestKosten.Width := 683;
    pnInvestKosten.Height := 372;
    pnInvestKosten.Align := alRight;
    pnInvestKosten.ChildOrder := 10;
    pnInvestKosten.ElementFont := efCSS;
    pnInvestKosten.TabOrder := 5;
    WebLabel14.SetParentComponent(pnInvestKosten);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 29;
    WebLabel14.Top := 73;
    WebLabel14.Width := 223;
    WebLabel14.Height := 29;
    WebLabel14.Caption := 'Investitionskosten';
    WebLabel14.ElementFont := efCSS;
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -24;
    WebLabel14.Font.Name := 'Tahoma';
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.HeightStyle := ssAuto;
    WebLabel14.HeightPercent := 100.00000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.00000000000000000;
    WebLabel33.SetParentComponent(pnInvestKosten);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 64;
    WebLabel33.Top := 40;
    WebLabel33.Width := 117;
    WebLabel33.Height := 18;
    WebLabel33.Caption := 'Investitionskosten';
    WebLabel33.ElementFont := efCSS;
    WebLabel33.ElementPosition := epRelative;
    WebLabel33.HeightStyle := ssAuto;
    WebLabel33.HeightPercent := 100.00000000000000000;
    WebLabel33.HTMLType := tH3;
    WebLabel33.WidthPercent := 100.00000000000000000;
    RFE_InvestProBett.SetParentComponent(pnInvestKosten);
    RFE_InvestProBett.Name := 'RFE_InvestProBett';
    RFE_InvestProBett.Left := 465;
    RFE_InvestProBett.Top := 68;
    RFE_InvestProBett.Width := 150;
    RFE_InvestProBett.Height := 46;
    RFE_InvestProBett.ChildOrder := 3;
    RFE_InvestProBett.ElementFont := efCSS;
    RFE_InvestProBett.Font.Charset := ANSI_CHARSET;
    RFE_InvestProBett.Font.Color := clWindowText;
    RFE_InvestProBett.Font.Height := -24;
    RFE_InvestProBett.Font.Name := 'Segoe UI';
    RFE_InvestProBett.Font.Style := [fsBold];
    RFE_InvestProBett.HeightStyle := ssAuto;
    RFE_InvestProBett.HeightPercent := 100.00000000000000000;
    RFE_InvestProBett.ParentFont := False;
    RFE_InvestProBett.Text := ' ';
    RFE_InvestProBett.WidthPercent := 100.00000000000000000;
    RFE_InvestProBett.DataField := 'Hbos_Cost_Investment';
    RFE_InvestProBett.DataSource := WahlleistungenWebDataSource;
    cbxkhEinsMVZCheckbox.SetParentComponent(pnErloesKorrekturen);
    cbxkhEinsMVZCheckbox.Name := 'cbxkhEinsMVZCheckbox';
    cbxkhEinsMVZCheckbox.Left := 392;
    cbxkhEinsMVZCheckbox.Top := 104;
    cbxkhEinsMVZCheckbox.Width := 113;
    cbxkhEinsMVZCheckbox.Height := 22;
    cbxkhEinsMVZCheckbox.ChildOrder := 15;
    cbxkhEinsMVZCheckbox.ElementFont := efCSS;
    cbxkhEinsMVZCheckbox.HeightStyle := ssAuto;
    cbxkhEinsMVZCheckbox.HeightPercent := 100.00000000000000000;
    cbxkhEinsMVZCheckbox.WidthPercent := 100.00000000000000000;
    cbxkhEinsMVZCheckbox.DataField := 'Hhmc_Mvz';
    cbxkhEinsMVZCheckbox.DataSource := HospitalMisc1WebDataSource;
    cbxkhEinsMVZCheckbox.ValueChecked := '1';
    cbxkhEinsMVZCheckbox.ValueUnChecked := '0';
    cbxkhZweiMVZCheckbox.SetParentComponent(pnErloesKorrekturen);
    cbxkhZweiMVZCheckbox.Name := 'cbxkhZweiMVZCheckbox';
    cbxkhZweiMVZCheckbox.Left := 395;
    cbxkhZweiMVZCheckbox.Top := 168;
    cbxkhZweiMVZCheckbox.Width := 113;
    cbxkhZweiMVZCheckbox.Height := 22;
    cbxkhZweiMVZCheckbox.ChildOrder := 15;
    cbxkhZweiMVZCheckbox.ElementFont := efCSS;
    cbxkhZweiMVZCheckbox.HeightStyle := ssAuto;
    cbxkhZweiMVZCheckbox.HeightPercent := 100.00000000000000000;
    cbxkhZweiMVZCheckbox.WidthPercent := 100.00000000000000000;
    cbxkhZweiMVZCheckbox.DataField := 'Hhmc_Mvz';
    cbxkhZweiMVZCheckbox.DataSource := HospitalMisc2WebDataSource;
    cbxkhZweiMVZCheckbox.ValueChecked := '1';
    cbxkhZweiMVZCheckbox.ValueUnChecked := '0';
    cbxkhDreiMVZCheckbox.SetParentComponent(pnErloesKorrekturen);
    cbxkhDreiMVZCheckbox.Name := 'cbxkhDreiMVZCheckbox';
    cbxkhDreiMVZCheckbox.Left := 387;
    cbxkhDreiMVZCheckbox.Top := 212;
    cbxkhDreiMVZCheckbox.Width := 113;
    cbxkhDreiMVZCheckbox.Height := 22;
    cbxkhDreiMVZCheckbox.ChildOrder := 15;
    cbxkhDreiMVZCheckbox.ElementFont := efCSS;
    cbxkhDreiMVZCheckbox.HeightStyle := ssAuto;
    cbxkhDreiMVZCheckbox.HeightPercent := 100.00000000000000000;
    cbxkhDreiMVZCheckbox.WidthPercent := 100.00000000000000000;
    cbxkhDreiMVZCheckbox.DataField := 'Hhmc_Mvz';
    cbxkhDreiMVZCheckbox.DataSource := HospitalMisc3WebDataSource;
    cbxkhDreiMVZCheckbox.ValueChecked := '1';
    cbxkhDreiMVZCheckbox.ValueUnChecked := '0';
    cbxkhVierMVZCheckbox.SetParentComponent(pnErloesKorrekturen);
    cbxkhVierMVZCheckbox.Name := 'cbxkhVierMVZCheckbox';
    cbxkhVierMVZCheckbox.Left := 387;
    cbxkhVierMVZCheckbox.Top := 269;
    cbxkhVierMVZCheckbox.Width := 113;
    cbxkhVierMVZCheckbox.Height := 22;
    cbxkhVierMVZCheckbox.ChildOrder := 15;
    cbxkhVierMVZCheckbox.ElementFont := efCSS;
    cbxkhVierMVZCheckbox.HeightStyle := ssAuto;
    cbxkhVierMVZCheckbox.HeightPercent := 100.00000000000000000;
    cbxkhVierMVZCheckbox.WidthPercent := 100.00000000000000000;
    cbxkhVierMVZCheckbox.DataField := 'Hhmc_Mvz';
    cbxkhVierMVZCheckbox.DataSource := HospitalMisc4WebDataSource;
    cbxkhVierMVZCheckbox.ValueChecked := '1';
    cbxkhVierMVZCheckbox.ValueUnChecked := '0';
    cbxkhFuenfMVZCheckbox.SetParentComponent(pnErloesKorrekturen);
    cbxkhFuenfMVZCheckbox.Name := 'cbxkhFuenfMVZCheckbox';
    cbxkhFuenfMVZCheckbox.Left := 387;
    cbxkhFuenfMVZCheckbox.Top := 316;
    cbxkhFuenfMVZCheckbox.Width := 113;
    cbxkhFuenfMVZCheckbox.Height := 22;
    cbxkhFuenfMVZCheckbox.ChildOrder := 15;
    cbxkhFuenfMVZCheckbox.ElementFont := efCSS;
    cbxkhFuenfMVZCheckbox.HeightStyle := ssAuto;
    cbxkhFuenfMVZCheckbox.HeightPercent := 100.00000000000000000;
    cbxkhFuenfMVZCheckbox.WidthPercent := 100.00000000000000000;
    cbxkhFuenfMVZCheckbox.DataField := 'Hhmc_Mvz';
    cbxkhFuenfMVZCheckbox.DataSource := HospitalMisc5WebDataSource;
    cbxkhFuenfMVZCheckbox.ValueChecked := '1';
    cbxkhFuenfMVZCheckbox.ValueUnChecked := '0';
    pnUmwandlungKosten.SetParentComponent(pgSeite1);
    pnUmwandlungKosten.Name := 'pnUmwandlungKosten';
    pnUmwandlungKosten.Left := 0;
    pnUmwandlungKosten.Top := 700;
    pnUmwandlungKosten.Width := 1901;
    pnUmwandlungKosten.Height := 806;
    pnUmwandlungKosten.Align := alClient;
    pnUmwandlungKosten.ChildOrder := 2;
    pnUmwandlungKosten.ElementFont := efCSS;
    pnUmwandlungKosten.TabOrder := 2;
    pnUmwandlungKosten.Visible := False;
    Lab0_Stat14.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat14.Name := 'Lab0_Stat14';
    Lab0_Stat14.Left := 24;
    Lab0_Stat14.Top := 94;
    Lab0_Stat14.Width := 177;
    Lab0_Stat14.Height := 29;
    Lab0_Stat14.Caption := 'Krankenhaus 1';
    Lab0_Stat14.ElementFont := efCSS;
    Lab0_Stat14.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat14.Font.Color := clWindowText;
    Lab0_Stat14.Font.Height := -24;
    Lab0_Stat14.Font.Name := 'Tahoma';
    Lab0_Stat14.Font.Style := [fsBold];
    Lab0_Stat14.HeightStyle := ssAuto;
    Lab0_Stat14.HeightPercent := 100.00000000000000000;
    Lab0_Stat14.ParentFont := False;
    Lab0_Stat14.WidthPercent := 100.00000000000000000;
    Lab0_Stat24.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat24.Name := 'Lab0_Stat24';
    Lab0_Stat24.Left := 24;
    Lab0_Stat24.Top := 151;
    Lab0_Stat24.Width := 177;
    Lab0_Stat24.Height := 29;
    Lab0_Stat24.Caption := 'Krankenhaus 2';
    Lab0_Stat24.ElementFont := efCSS;
    Lab0_Stat24.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat24.Font.Color := clWindowText;
    Lab0_Stat24.Font.Height := -24;
    Lab0_Stat24.Font.Name := 'Tahoma';
    Lab0_Stat24.Font.Style := [fsBold];
    Lab0_Stat24.HeightStyle := ssAuto;
    Lab0_Stat24.HeightPercent := 100.00000000000000000;
    Lab0_Stat24.ParentFont := False;
    Lab0_Stat24.WidthPercent := 100.00000000000000000;
    Lab0_Stat34.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat34.Name := 'Lab0_Stat34';
    Lab0_Stat34.Left := 24;
    Lab0_Stat34.Top := 198;
    Lab0_Stat34.Width := 177;
    Lab0_Stat34.Height := 29;
    Lab0_Stat34.Caption := 'Krankenhaus 3';
    Lab0_Stat34.ElementFont := efCSS;
    Lab0_Stat34.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat34.Font.Color := clWindowText;
    Lab0_Stat34.Font.Height := -24;
    Lab0_Stat34.Font.Name := 'Tahoma';
    Lab0_Stat34.Font.Style := [fsBold];
    Lab0_Stat34.HeightStyle := ssAuto;
    Lab0_Stat34.HeightPercent := 100.00000000000000000;
    Lab0_Stat34.ParentFont := False;
    Lab0_Stat34.WidthPercent := 100.00000000000000000;
    Lab0_Stat13.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat13.Name := 'Lab0_Stat13';
    Lab0_Stat13.Left := 219;
    Lab0_Stat13.Top := 40;
    Lab0_Stat13.Width := 177;
    Lab0_Stat13.Height := 29;
    Lab0_Stat13.Caption := 'Krankenhaus 1';
    Lab0_Stat13.ElementFont := efCSS;
    Lab0_Stat13.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat13.Font.Color := clWindowText;
    Lab0_Stat13.Font.Height := -24;
    Lab0_Stat13.Font.Name := 'Tahoma';
    Lab0_Stat13.Font.Style := [fsBold];
    Lab0_Stat13.HeightStyle := ssAuto;
    Lab0_Stat13.HeightPercent := 100.00000000000000000;
    Lab0_Stat13.ParentFont := False;
    Lab0_Stat13.WidthPercent := 100.00000000000000000;
    Lab0_Stat23.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat23.Name := 'Lab0_Stat23';
    Lab0_Stat23.Left := 434;
    Lab0_Stat23.Top := 40;
    Lab0_Stat23.Width := 177;
    Lab0_Stat23.Height := 29;
    Lab0_Stat23.Caption := 'Krankenhaus 1';
    Lab0_Stat23.ElementFont := efCSS;
    Lab0_Stat23.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat23.Font.Color := clWindowText;
    Lab0_Stat23.Font.Height := -24;
    Lab0_Stat23.Font.Name := 'Tahoma';
    Lab0_Stat23.Font.Style := [fsBold];
    Lab0_Stat23.HeightStyle := ssAuto;
    Lab0_Stat23.HeightPercent := 100.00000000000000000;
    Lab0_Stat23.ParentFont := False;
    Lab0_Stat23.WidthPercent := 100.00000000000000000;
    Lab0_Stat33.SetParentComponent(pnUmwandlungKosten);
    Lab0_Stat33.Name := 'Lab0_Stat33';
    Lab0_Stat33.Left := 649;
    Lab0_Stat33.Top := 40;
    Lab0_Stat33.Width := 177;
    Lab0_Stat33.Height := 29;
    Lab0_Stat33.Caption := 'Krankenhaus 1';
    Lab0_Stat33.ElementFont := efCSS;
    Lab0_Stat33.Font.Charset := DEFAULT_CHARSET;
    Lab0_Stat33.Font.Color := clWindowText;
    Lab0_Stat33.Font.Height := -24;
    Lab0_Stat33.Font.Name := 'Tahoma';
    Lab0_Stat33.Font.Style := [fsBold];
    Lab0_Stat33.HeightStyle := ssAuto;
    Lab0_Stat33.HeightPercent := 100.00000000000000000;
    Lab0_Stat33.ParentFont := False;
    Lab0_Stat33.WidthPercent := 100.00000000000000000;
    WebLabel32.SetParentComponent(pnUmwandlungKosten);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 18;
    WebLabel32.Top := 16;
    WebLabel32.Width := 271;
    WebLabel32.Height := 18;
    WebLabel32.Caption := 'Kosten der Umwandlung pro Bett (TEUR)';
    WebLabel32.ElementFont := efCSS;
    WebLabel32.ElementPosition := epRelative;
    WebLabel32.HeightStyle := ssAuto;
    WebLabel32.HeightPercent := 100.00000000000000000;
    WebLabel32.HTMLType := tH3;
    WebLabel32.WidthPercent := 100.00000000000000000;
    WebLabel30.SetParentComponent(pnUmwandlungKosten);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 328;
    WebLabel30.Top := 16;
    WebLabel30.Width := 271;
    WebLabel30.Height := 18;
    WebLabel30.Caption := 'Kosten der Umwandlung pro Bett (TEUR)';
    WebLabel30.ElementFont := efCSS;
    WebLabel30.ElementPosition := epRelative;
    WebLabel30.HeightStyle := ssAuto;
    WebLabel30.HeightPercent := 100.00000000000000000;
    WebLabel30.HTMLType := tH3;
    WebLabel30.WidthPercent := 100.00000000000000000;
    WebLabel70.SetParentComponent(pnUmwandlungKosten);
    WebLabel70.Name := 'WebLabel70';
    WebLabel70.Left := 615;
    WebLabel70.Top := 16;
    WebLabel70.Width := 271;
    WebLabel70.Height := 18;
    WebLabel70.Caption := 'Kosten der Umwandlung pro Bett (TEUR)';
    WebLabel70.ElementFont := efCSS;
    WebLabel70.ElementPosition := epRelative;
    WebLabel70.HeightStyle := ssAuto;
    WebLabel70.HeightPercent := 100.00000000000000000;
    WebLabel70.HTMLType := tH3;
    WebLabel70.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS2toS1.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS2toS1.Name := 'RFE_UmwKoS2toS1';
    RFE_UmwKoS2toS1.Left := 219;
    RFE_UmwKoS2toS1.Top := 141;
    RFE_UmwKoS2toS1.Width := 209;
    RFE_UmwKoS2toS1.Height := 46;
    RFE_UmwKoS2toS1.ChildOrder := 6;
    RFE_UmwKoS2toS1.EditType := weSignedFloat;
    RFE_UmwKoS2toS1.ElementFont := efCSS;
    RFE_UmwKoS2toS1.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS2toS1.Font.Color := clWindowText;
    RFE_UmwKoS2toS1.Font.Height := -24;
    RFE_UmwKoS2toS1.Font.Name := 'Segoe UI';
    RFE_UmwKoS2toS1.Font.Style := [fsBold];
    RFE_UmwKoS2toS1.HeightStyle := ssAuto;
    RFE_UmwKoS2toS1.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS2toS1.ParentFont := False;
    RFE_UmwKoS2toS1.Text := ' ';
    RFE_UmwKoS2toS1.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS2toS1.DataField := 'Hbos_Cost_Conversion_Profit1_1';
    RFE_UmwKoS2toS1.DataSource := WahlleistungenWebDataSource;
    RFE_UmwKoS3toS1.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS3toS1.Name := 'RFE_UmwKoS3toS1';
    RFE_UmwKoS3toS1.Left := 219;
    RFE_UmwKoS3toS1.Top := 193;
    RFE_UmwKoS3toS1.Width := 209;
    RFE_UmwKoS3toS1.Height := 46;
    RFE_UmwKoS3toS1.ChildOrder := 7;
    RFE_UmwKoS3toS1.EditType := weSignedFloat;
    RFE_UmwKoS3toS1.ElementFont := efCSS;
    RFE_UmwKoS3toS1.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS3toS1.Font.Color := clWindowText;
    RFE_UmwKoS3toS1.Font.Height := -24;
    RFE_UmwKoS3toS1.Font.Name := 'Segoe UI';
    RFE_UmwKoS3toS1.Font.Style := [fsBold];
    RFE_UmwKoS3toS1.HeightStyle := ssAuto;
    RFE_UmwKoS3toS1.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS3toS1.ParentFont := False;
    RFE_UmwKoS3toS1.TabOrder := 1;
    RFE_UmwKoS3toS1.Text := ' ';
    RFE_UmwKoS3toS1.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS3toS1.DataField := 'Hbos_Cost_Conversion_Profit1_2';
    RFE_UmwKoS3toS1.DataSource := WahlleistungenWebDataSource;
    RFE_UmwKoS1toS2.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS1toS2.Name := 'RFE_UmwKoS1toS2';
    RFE_UmwKoS1toS2.Left := 434;
    RFE_UmwKoS1toS2.Top := 88;
    RFE_UmwKoS1toS2.Width := 209;
    RFE_UmwKoS1toS2.Height := 46;
    RFE_UmwKoS1toS2.ChildOrder := 9;
    RFE_UmwKoS1toS2.EditType := weSignedFloat;
    RFE_UmwKoS1toS2.ElementFont := efCSS;
    RFE_UmwKoS1toS2.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS1toS2.Font.Color := clWindowText;
    RFE_UmwKoS1toS2.Font.Height := -24;
    RFE_UmwKoS1toS2.Font.Name := 'Segoe UI';
    RFE_UmwKoS1toS2.Font.Style := [fsBold];
    RFE_UmwKoS1toS2.HeightStyle := ssAuto;
    RFE_UmwKoS1toS2.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS1toS2.ParentFont := False;
    RFE_UmwKoS1toS2.TabOrder := 3;
    RFE_UmwKoS1toS2.Text := ' ';
    RFE_UmwKoS1toS2.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS1toS2.DataField := 'Hbos_Cost_Conversion_Profit2_1';
    RFE_UmwKoS1toS2.DataSource := WahlleistungenWebDataSource;
    RFE_UmwKoS3toS2.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS3toS2.Name := 'RFE_UmwKoS3toS2';
    RFE_UmwKoS3toS2.Left := 434;
    RFE_UmwKoS3toS2.Top := 193;
    RFE_UmwKoS3toS2.Width := 209;
    RFE_UmwKoS3toS2.Height := 46;
    RFE_UmwKoS3toS2.ChildOrder := 10;
    RFE_UmwKoS3toS2.EditType := weSignedFloat;
    RFE_UmwKoS3toS2.ElementFont := efCSS;
    RFE_UmwKoS3toS2.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS3toS2.Font.Color := clWindowText;
    RFE_UmwKoS3toS2.Font.Height := -24;
    RFE_UmwKoS3toS2.Font.Name := 'Segoe UI';
    RFE_UmwKoS3toS2.Font.Style := [fsBold];
    RFE_UmwKoS3toS2.HeightStyle := ssAuto;
    RFE_UmwKoS3toS2.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS3toS2.ParentFont := False;
    RFE_UmwKoS3toS2.TabOrder := 4;
    RFE_UmwKoS3toS2.Text := ' ';
    RFE_UmwKoS3toS2.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS3toS2.DataField := 'Hbos_Cost_Conversion_Profit2_2';
    RFE_UmwKoS3toS2.DataSource := WahlleistungenWebDataSource;
    RFE_UmwKoS1toS3.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS1toS3.Name := 'RFE_UmwKoS1toS3';
    RFE_UmwKoS1toS3.Left := 649;
    RFE_UmwKoS1toS3.Top := 88;
    RFE_UmwKoS1toS3.Width := 209;
    RFE_UmwKoS1toS3.Height := 46;
    RFE_UmwKoS1toS3.ChildOrder := 11;
    RFE_UmwKoS1toS3.EditType := weSignedFloat;
    RFE_UmwKoS1toS3.ElementFont := efCSS;
    RFE_UmwKoS1toS3.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS1toS3.Font.Color := clWindowText;
    RFE_UmwKoS1toS3.Font.Height := -24;
    RFE_UmwKoS1toS3.Font.Name := 'Segoe UI';
    RFE_UmwKoS1toS3.Font.Style := [fsBold];
    RFE_UmwKoS1toS3.HeightStyle := ssAuto;
    RFE_UmwKoS1toS3.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS1toS3.ParentFont := False;
    RFE_UmwKoS1toS3.TabOrder := 5;
    RFE_UmwKoS1toS3.Text := ' ';
    RFE_UmwKoS1toS3.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS1toS3.DataField := 'Hbos_Cost_Conversion_Profit3_1';
    RFE_UmwKoS1toS3.DataSource := WahlleistungenWebDataSource;
    RFE_UmwKoS2toS3.SetParentComponent(pnUmwandlungKosten);
    RFE_UmwKoS2toS3.Name := 'RFE_UmwKoS2toS3';
    RFE_UmwKoS2toS3.Left := 649;
    RFE_UmwKoS2toS3.Top := 141;
    RFE_UmwKoS2toS3.Width := 209;
    RFE_UmwKoS2toS3.Height := 46;
    RFE_UmwKoS2toS3.ChildOrder := 12;
    RFE_UmwKoS2toS3.EditType := weSignedFloat;
    RFE_UmwKoS2toS3.ElementFont := efCSS;
    RFE_UmwKoS2toS3.Font.Charset := ANSI_CHARSET;
    RFE_UmwKoS2toS3.Font.Color := clWindowText;
    RFE_UmwKoS2toS3.Font.Height := -24;
    RFE_UmwKoS2toS3.Font.Name := 'Segoe UI';
    RFE_UmwKoS2toS3.Font.Style := [fsBold];
    RFE_UmwKoS2toS3.HeightStyle := ssAuto;
    RFE_UmwKoS2toS3.HeightPercent := 100.00000000000000000;
    RFE_UmwKoS2toS3.ParentFont := False;
    RFE_UmwKoS2toS3.TabOrder := 6;
    RFE_UmwKoS2toS3.Text := ' ';
    RFE_UmwKoS2toS3.WidthPercent := 100.00000000000000000;
    RFE_UmwKoS2toS3.DataField := 'Hbos_Cost_Conversion_Profit3_2';
    RFE_UmwKoS2toS3.DataSource := WahlleistungenWebDataSource;
    WebMessageDlg.SetParentComponent(pnUmwandlungKosten);
    WebMessageDlg.Name := 'WebMessageDlg';
    WebMessageDlg.Left := 792;
    WebMessageDlg.Top := 368;
    WebMessageDlg.Width := 24;
    WebMessageDlg.Height := 24;
    WebMessageDlg.Buttons := [];
    WebMessageDlg.Opacity := 0.20000000000000000;
    pgSeite3.SetParentComponent(PageControl);
    pgSeite3.Name := 'pgSeite3';
    pgSeite3.Left := 0;
    pgSeite3.Top := 20;
    pgSeite3.Width := 1901;
    pgSeite3.Height := 1506;
    pgSeite3.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgSeite3.HeightStyle := ssAuto;
    pgSeite3.WidthStyle := ssAuto;
    pgSeite3.Caption := 'aG-DRG-Vorkalkulation';
    pgSeite3.ChildOrder := 2;
    pgSeite3.ElementFont := efCSS;
    pgSeite3.ElementPosition := epRelative;
    pnDRGVerwaltung.SetParentComponent(pgSeite3);
    pnDRGVerwaltung.Name := 'pnDRGVerwaltung';
    pnDRGVerwaltung.Left := 0;
    pnDRGVerwaltung.Top := 0;
    pnDRGVerwaltung.Width := 1901;
    pnDRGVerwaltung.Height := 626;
    pnDRGVerwaltung.Align := alTop;
    pnDRGVerwaltung.ElementFont := efCSS;
    pnDRGVerwaltung.TabOrder := 0;
    WebLabel102.SetParentComponent(pnDRGVerwaltung);
    WebLabel102.Name := 'WebLabel102';
    WebLabel102.Left := 80;
    WebLabel102.Top := 32;
    WebLabel102.Width := 227;
    WebLabel102.Height := 18;
    WebLabel102.Caption := 'aG-DRG-Vorkalkulation-Einzelkosten';
    WebLabel102.ElementFont := efCSS;
    WebLabel102.ElementPosition := epRelative;
    WebLabel102.HeightStyle := ssAuto;
    WebLabel102.HeightPercent := 100.00000000000000000;
    WebLabel102.HTMLType := tH3;
    WebLabel102.WidthPercent := 100.00000000000000000;
    strGridStationCosts.SetParentComponent(pnDRGVerwaltung);
    strGridStationCosts.Name := 'strGridStationCosts';
    strGridStationCosts.Left := 24;
    strGridStationCosts.Top := 63;
    strGridStationCosts.Width := 412;
    strGridStationCosts.Height := 483;
    strGridStationCosts.ColCount := 4;
    strGridStationCosts.DefaultColAlignment := taRightJustify;
    strGridStationCosts.RowCount := 33;
    strGridStationCosts.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goEditing,goFixedRowDefAlign];
    strGridStationCosts.TabOrder := 0;
    SetEvent(strGridStationCosts, Self, 'OnGetEditText', 'strGridStationCostsGetEditText');
    SetEvent(strGridStationCosts, Self, 'OnSetEditText', 'strGridStationCostsSetEditText');
    strGridStationCosts.ElementFont := efCSS;
    strGridStationCosts.ElementPosition := epRelative;
    strGridStationCosts.FixedFont.Charset := DEFAULT_CHARSET;
    strGridStationCosts.FixedFont.Color := clWindowText;
    strGridStationCosts.FixedFont.Height := -18;
    strGridStationCosts.FixedFont.Name := 'Segoe UI';
    strGridStationCosts.FixedFont.Style := [];
    strGridStationCosts.RangeEdit.Max := 100.00000000000000000;
    strGridStationCosts.RangeEdit.Step := 1.00000000000000000;
    strGridStationCosts.HeightStyle := ssAuto;
    strGridStationCosts.HeightPercent := 100.00000000000000000;
    strGridStationCosts.WidthStyle := ssAuto;
    strGridStationCosts.WidthPercent := 100.00000000000000000;
    pnErloeseKorrekturen.SetParentComponent(pgSeite3);
    pnErloeseKorrekturen.Name := 'pnErloeseKorrekturen';
    pnErloeseKorrekturen.Left := 0;
    pnErloeseKorrekturen.Top := 626;
    pnErloeseKorrekturen.Width := 1901;
    pnErloeseKorrekturen.Height := 78;
    pnErloeseKorrekturen.Align := alTop;
    pnErloeseKorrekturen.ChildOrder := 1;
    pnErloeseKorrekturen.ElementFont := efCSS;
    pnErloeseKorrekturen.TabOrder := 1;
    Lab_ErloesKor.SetParentComponent(pnErloeseKorrekturen);
    Lab_ErloesKor.Name := 'Lab_ErloesKor';
    Lab_ErloesKor.Left := 16;
    Lab_ErloesKor.Top := 37;
    Lab_ErloesKor.Width := 247;
    Lab_ErloesKor.Height := 29;
    Lab_ErloesKor.Caption := 'Erl'#246'skorrektur : 1,00';
    Lab_ErloesKor.ElementFont := efCSS;
    Lab_ErloesKor.Font.Charset := DEFAULT_CHARSET;
    Lab_ErloesKor.Font.Color := clWindowText;
    Lab_ErloesKor.Font.Height := -24;
    Lab_ErloesKor.Font.Name := 'Tahoma';
    Lab_ErloesKor.Font.Style := [fsBold];
    Lab_ErloesKor.HeightStyle := ssAuto;
    Lab_ErloesKor.HeightPercent := 100.00000000000000000;
    Lab_ErloesKor.ParentFont := False;
    Lab_ErloesKor.WidthPercent := 100.00000000000000000;
    Lab_agErloes.SetParentComponent(pnErloeseKorrekturen);
    Lab_agErloes.Name := 'Lab_agErloes';
    Lab_agErloes.Left := 552;
    Lab_agErloes.Top := 26;
    Lab_agErloes.Width := 329;
    Lab_agErloes.Height := 29;
    Lab_agErloes.Caption := 'aG-DRG-Erl'#246's ('#8364') 2644,99: ';
    Lab_agErloes.ElementFont := efCSS;
    Lab_agErloes.Font.Charset := DEFAULT_CHARSET;
    Lab_agErloes.Font.Color := clWindowText;
    Lab_agErloes.Font.Height := -24;
    Lab_agErloes.Font.Name := 'Tahoma';
    Lab_agErloes.Font.Style := [fsBold];
    Lab_agErloes.HeightStyle := ssAuto;
    Lab_agErloes.HeightPercent := 100.00000000000000000;
    Lab_agErloes.ParentFont := False;
    Lab_agErloes.WidthPercent := 100.00000000000000000;
    Lab_PflgErloes.SetParentComponent(pnErloeseKorrekturen);
    Lab_PflgErloes.Name := 'Lab_PflgErloes';
    Lab_PflgErloes.Left := 1114;
    Lab_PflgErloes.Top := 26;
    Lab_PflgErloes.Width := 98;
    Lab_PflgErloes.Height := 29;
    Lab_PflgErloes.Caption := '999,99'#8364;
    Lab_PflgErloes.ElementFont := efCSS;
    Lab_PflgErloes.Font.Charset := DEFAULT_CHARSET;
    Lab_PflgErloes.Font.Color := clWindowText;
    Lab_PflgErloes.Font.Height := -24;
    Lab_PflgErloes.Font.Name := 'Tahoma';
    Lab_PflgErloes.Font.Style := [fsBold];
    Lab_PflgErloes.HeightStyle := ssAuto;
    Lab_PflgErloes.HeightPercent := 100.00000000000000000;
    Lab_PflgErloes.ParentFont := False;
    Lab_PflgErloes.WidthPercent := 100.00000000000000000;
    WebLabel7.SetParentComponent(pnErloeseKorrekturen);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 16;
    WebLabel7.Top := 2;
    WebLabel7.Width := 171;
    WebLabel7.Height := 29;
    WebLabel7.Caption := 'Erl'#246'skorrektur';
    WebLabel7.ElementFont := efCSS;
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -24;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.00000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.00000000000000000;
    WebLabel103.SetParentComponent(pnErloeseKorrekturen);
    WebLabel103.Name := 'WebLabel103';
    WebLabel103.Left := 551;
    WebLabel103.Top := -3;
    WebLabel103.Width := 164;
    WebLabel103.Height := 29;
    WebLabel103.Caption := 'aG-DRG-Erl'#246's';
    WebLabel103.ElementFont := efCSS;
    WebLabel103.Font.Charset := DEFAULT_CHARSET;
    WebLabel103.Font.Color := clWindowText;
    WebLabel103.Font.Height := -24;
    WebLabel103.Font.Name := 'Tahoma';
    WebLabel103.Font.Style := [fsBold];
    WebLabel103.HeightStyle := ssAuto;
    WebLabel103.HeightPercent := 100.00000000000000000;
    WebLabel103.ParentFont := False;
    WebLabel103.WidthPercent := 100.00000000000000000;
    WebLabel104.SetParentComponent(pnErloeseKorrekturen);
    WebLabel104.Name := 'WebLabel104';
    WebLabel104.Left := 828;
    WebLabel104.Top := -3;
    WebLabel104.Width := 133;
    WebLabel104.Height := 29;
    WebLabel104.Caption := 'Pflegeerl'#246's';
    WebLabel104.ElementFont := efCSS;
    WebLabel104.Font.Charset := DEFAULT_CHARSET;
    WebLabel104.Font.Color := clWindowText;
    WebLabel104.Font.Height := -24;
    WebLabel104.Font.Name := 'Tahoma';
    WebLabel104.Font.Style := [fsBold];
    WebLabel104.HeightStyle := ssAuto;
    WebLabel104.HeightPercent := 100.00000000000000000;
    WebLabel104.ParentFont := False;
    WebLabel104.WidthPercent := 100.00000000000000000;
    pnAnteileMode.SetParentComponent(pgSeite3);
    pnAnteileMode.Name := 'pnAnteileMode';
    pnAnteileMode.Left := 469;
    pnAnteileMode.Top := 58;
    pnAnteileMode.Width := 931;
    pnAnteileMode.Height := 495;
    pnAnteileMode.ChildOrder := 1;
    pnAnteileMode.ElementFont := efCSS;
    pnAnteileMode.Font.Charset := DEFAULT_CHARSET;
    pnAnteileMode.Font.Color := clWindowText;
    pnAnteileMode.Font.Height := -24;
    pnAnteileMode.Font.Name := 'Tahoma';
    pnAnteileMode.Font.Style := [fsBold];
    pnAnteileMode.ParentFont := False;
    pnAnteileMode.TabOrder := 2;
    WebLabel20.SetParentComponent(pnAnteileMode);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 34;
    WebLabel20.Top := 66;
    WebLabel20.Width := 112;
    WebLabel20.Height := 29;
    WebLabel20.Caption := 'Bew. Rel.';
    WebLabel20.ElementFont := efCSS;
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -24;
    WebLabel20.Font.Name := 'Tahoma';
    WebLabel20.Font.Style := [fsBold];
    WebLabel20.HeightStyle := ssAuto;
    WebLabel20.HeightPercent := 100.00000000000000000;
    WebLabel20.ParentFont := False;
    WebLabel20.WidthPercent := 100.00000000000000000;
    WebLabel21.SetParentComponent(pnAnteileMode);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 34;
    WebLabel21.Top := 133;
    WebLabel21.Width := 194;
    WebLabel21.Height := 29;
    WebLabel21.Caption := 'Bew. Rel. Pflege';
    WebLabel21.ElementFont := efCSS;
    WebLabel21.Font.Charset := DEFAULT_CHARSET;
    WebLabel21.Font.Color := clWindowText;
    WebLabel21.Font.Height := -24;
    WebLabel21.Font.Name := 'Tahoma';
    WebLabel21.Font.Style := [fsBold];
    WebLabel21.HeightStyle := ssAuto;
    WebLabel21.HeightPercent := 100.00000000000000000;
    WebLabel21.ParentFont := False;
    WebLabel21.WidthPercent := 100.00000000000000000;
    lblFallName.SetParentComponent(pnAnteileMode);
    lblFallName.Name := 'lblFallName';
    lblFallName.Left := 0;
    lblFallName.Top := 0;
    lblFallName.Width := 931;
    lblFallName.Height := 29;
    lblFallName.Align := alTop;
    lblFallName.Caption := 'Basis Daten';
    lblFallName.ElementFont := efCSS;
    lblFallName.Font.Charset := DEFAULT_CHARSET;
    lblFallName.Font.Color := clBlue;
    lblFallName.Font.Height := -24;
    lblFallName.Font.Name := 'Tahoma';
    lblFallName.Font.Style := [fsBold];
    lblFallName.HeightStyle := ssAuto;
    lblFallName.HeightPercent := 100.00000000000000000;
    lblFallName.HTMLType := tH3;
    lblFallName.ParentFont := False;
    lblFallName.WidthPercent := 100.00000000000000000;
    WebLabel100.SetParentComponent(pnAnteileMode);
    WebLabel100.Name := 'WebLabel100';
    WebLabel100.Left := 24;
    WebLabel100.Top := 216;
    WebLabel100.Width := 259;
    WebLabel100.Height := 29;
    WebLabel100.Caption := 'Pflegeentgeltwert ('#8364')';
    WebLabel100.ElementFont := efCSS;
    WebLabel100.Font.Charset := DEFAULT_CHARSET;
    WebLabel100.Font.Color := clWindowText;
    WebLabel100.Font.Height := -24;
    WebLabel100.Font.Name := 'Tahoma';
    WebLabel100.Font.Style := [fsBold];
    WebLabel100.HeightStyle := ssAuto;
    WebLabel100.HeightPercent := 100.00000000000000000;
    WebLabel100.ParentFont := False;
    WebLabel100.WidthPercent := 100.00000000000000000;
    WebLabel99.SetParentComponent(pnAnteileMode);
    WebLabel99.Name := 'WebLabel99';
    WebLabel99.Left := 24;
    WebLabel99.Top := 291;
    WebLabel99.Width := 280;
    WebLabel99.Height := 29;
    WebLabel99.Caption := 'Landesbasisfallwert ('#8364')';
    WebLabel99.ElementFont := efCSS;
    WebLabel99.Font.Charset := DEFAULT_CHARSET;
    WebLabel99.Font.Color := clWindowText;
    WebLabel99.Font.Height := -24;
    WebLabel99.Font.Name := 'Tahoma';
    WebLabel99.Font.Style := [fsBold];
    WebLabel99.HeightStyle := ssAuto;
    WebLabel99.HeightPercent := 100.00000000000000000;
    WebLabel99.ParentFont := False;
    WebLabel99.WidthPercent := 100.00000000000000000;
    RF2_agBewRel.SetParentComponent(pnAnteileMode);
    RF2_agBewRel.Name := 'RF2_agBewRel';
    RF2_agBewRel.Left := 242;
    RF2_agBewRel.Top := 61;
    RF2_agBewRel.Width := 150;
    RF2_agBewRel.Height := 46;
    RF2_agBewRel.ChildOrder := 9;
    RF2_agBewRel.EditType := weSignedFloat;
    RF2_agBewRel.ElementFont := efCSS;
    RF2_agBewRel.Font.Charset := ANSI_CHARSET;
    RF2_agBewRel.Font.Color := clWindowText;
    RF2_agBewRel.Font.Height := -24;
    RF2_agBewRel.Font.Name := 'Segoe UI';
    RF2_agBewRel.Font.Style := [fsBold];
    RF2_agBewRel.HeightStyle := ssAuto;
    RF2_agBewRel.HeightPercent := 100.00000000000000000;
    RF2_agBewRel.ParentFont := False;
    RF2_agBewRel.Text := ' ';
    RF2_agBewRel.WidthPercent := 100.00000000000000000;
    RF2_agBewRel.DataField := 'DDRG_RELATIVE_FACTOR';
    RF2_agBewRel.DataSource := DRGDataSource;
    RF2_PflgBewRel.SetParentComponent(pnAnteileMode);
    RF2_PflgBewRel.Name := 'RF2_PflgBewRel';
    RF2_PflgBewRel.Left := 242;
    RF2_PflgBewRel.Top := 127;
    RF2_PflgBewRel.Width := 150;
    RF2_PflgBewRel.Height := 46;
    RF2_PflgBewRel.ChildOrder := 10;
    RF2_PflgBewRel.EditType := weSignedFloat;
    RF2_PflgBewRel.ElementFont := efCSS;
    RF2_PflgBewRel.Font.Charset := ANSI_CHARSET;
    RF2_PflgBewRel.Font.Color := clWindowText;
    RF2_PflgBewRel.Font.Height := -24;
    RF2_PflgBewRel.Font.Name := 'Segoe UI';
    RF2_PflgBewRel.Font.Style := [fsBold];
    RF2_PflgBewRel.HeightStyle := ssAuto;
    RF2_PflgBewRel.HeightPercent := 100.00000000000000000;
    RF2_PflgBewRel.ParentFont := False;
    RF2_PflgBewRel.TabOrder := 1;
    RF2_PflgBewRel.Text := ' ';
    RF2_PflgBewRel.WidthPercent := 100.00000000000000000;
    RF2_PflgBewRel.DataField := 'DDRG_RELATIVE_CARE_FACTOR';
    RF2_PflgBewRel.DataSource := DRGDataSource;
    RFE_PflgWert.SetParentComponent(pnAnteileMode);
    RFE_PflgWert.Name := 'RFE_PflgWert';
    RFE_PflgWert.Left := 330;
    RFE_PflgWert.Top := 211;
    RFE_PflgWert.Width := 150;
    RFE_PflgWert.Height := 46;
    RFE_PflgWert.ChildOrder := 10;
    RFE_PflgWert.EditType := weSignedFloat;
    RFE_PflgWert.ElementFont := efCSS;
    RFE_PflgWert.Font.Charset := ANSI_CHARSET;
    RFE_PflgWert.Font.Color := clWindowText;
    RFE_PflgWert.Font.Height := -24;
    RFE_PflgWert.Font.Name := 'Segoe UI';
    RFE_PflgWert.Font.Style := [fsBold];
    RFE_PflgWert.HeightStyle := ssAuto;
    RFE_PflgWert.HeightPercent := 100.00000000000000000;
    RFE_PflgWert.ParentFont := False;
    RFE_PflgWert.TabOrder := 3;
    RFE_PflgWert.Text := ' ';
    RFE_PflgWert.WidthPercent := 100.00000000000000000;
    RFE_PflgWert.DataField := 'DDRG_CARE_PAYMENT_VALUE';
    RFE_PflgWert.DataSource := DRGDataSource;
    RFE_FallBaWert.SetParentComponent(pnAnteileMode);
    RFE_FallBaWert.Name := 'RFE_FallBaWert';
    RFE_FallBaWert.Left := 330;
    RFE_FallBaWert.Top := 285;
    RFE_FallBaWert.Width := 150;
    RFE_FallBaWert.Height := 46;
    RFE_FallBaWert.ChildOrder := 11;
    RFE_FallBaWert.EditType := weSignedFloat;
    RFE_FallBaWert.ElementFont := efCSS;
    RFE_FallBaWert.Font.Charset := ANSI_CHARSET;
    RFE_FallBaWert.Font.Color := clWindowText;
    RFE_FallBaWert.Font.Height := -24;
    RFE_FallBaWert.Font.Name := 'Segoe UI';
    RFE_FallBaWert.Font.Style := [fsBold];
    RFE_FallBaWert.HeightStyle := ssAuto;
    RFE_FallBaWert.HeightPercent := 100.00000000000000000;
    RFE_FallBaWert.ParentFont := False;
    RFE_FallBaWert.TabOrder := 4;
    RFE_FallBaWert.Text := ' ';
    RFE_FallBaWert.WidthPercent := 100.00000000000000000;
    RFE_FallBaWert.DataField := 'DDRG_COUNTRY_BASE_DRG_VALUE';
    RFE_FallBaWert.DataSource := DRGDataSource;
    pnFallZahlen.SetParentComponent(pgSeite3);
    pnFallZahlen.Name := 'pnFallZahlen';
    pnFallZahlen.Left := 0;
    pnFallZahlen.Top := 704;
    pnFallZahlen.Width := 1901;
    pnFallZahlen.Height := 802;
    pnFallZahlen.HeightStyle := ssAuto;
    pnFallZahlen.WidthStyle := ssAuto;
    pnFallZahlen.Align := alClient;
    pnFallZahlen.ChildOrder := 2;
    pnFallZahlen.ElementFont := efCSS;
    pnFallZahlen.ElementPosition := epIgnore;
    pnFallZahlen.TabOrder := 3;
    WebLabel40.SetParentComponent(pnFallZahlen);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 130;
    WebLabel40.Top := 48;
    WebLabel40.Width := 479;
    WebLabel40.Height := 29;
    WebLabel40.Caption := 'Fallzahlen und -Verteilung auf Stationen';
    WebLabel40.ElementFont := efCSS;
    WebLabel40.Font.Charset := DEFAULT_CHARSET;
    WebLabel40.Font.Color := clWindowText;
    WebLabel40.Font.Height := -24;
    WebLabel40.Font.Name := 'Tahoma';
    WebLabel40.Font.Style := [fsBold];
    WebLabel40.HeightStyle := ssAuto;
    WebLabel40.HeightPercent := 100.00000000000000000;
    WebLabel40.ParentFont := False;
    WebLabel40.WidthPercent := 100.00000000000000000;
    weblabStation1.SetParentComponent(pnFallZahlen);
    weblabStation1.Name := 'weblabStation1';
    weblabStation1.Left := 223;
    weblabStation1.Top := 109;
    weblabStation1.Width := 108;
    weblabStation1.Height := 29;
    weblabStation1.Caption := 'Station 1';
    weblabStation1.ElementFont := efCSS;
    weblabStation1.Font.Charset := DEFAULT_CHARSET;
    weblabStation1.Font.Color := clWindowText;
    weblabStation1.Font.Height := -24;
    weblabStation1.Font.Name := 'Tahoma';
    weblabStation1.Font.Style := [fsBold];
    weblabStation1.HeightStyle := ssAuto;
    weblabStation1.HeightPercent := 100.00000000000000000;
    weblabStation1.ParentFont := False;
    weblabStation1.WidthPercent := 100.00000000000000000;
    weblabStation2.SetParentComponent(pnFallZahlen);
    weblabStation2.Name := 'weblabStation2';
    weblabStation2.Left := 403;
    weblabStation2.Top := 109;
    weblabStation2.Width := 108;
    weblabStation2.Height := 29;
    weblabStation2.Caption := 'Station 2';
    weblabStation2.ElementFont := efCSS;
    weblabStation2.Font.Charset := DEFAULT_CHARSET;
    weblabStation2.Font.Color := clWindowText;
    weblabStation2.Font.Height := -24;
    weblabStation2.Font.Name := 'Tahoma';
    weblabStation2.Font.Style := [fsBold];
    weblabStation2.HeightStyle := ssAuto;
    weblabStation2.HeightPercent := 100.00000000000000000;
    weblabStation2.ParentFont := False;
    weblabStation2.WidthPercent := 100.00000000000000000;
    weblabStation3.SetParentComponent(pnFallZahlen);
    weblabStation3.Name := 'weblabStation3';
    weblabStation3.Left := 574;
    weblabStation3.Top := 109;
    weblabStation3.Width := 108;
    weblabStation3.Height := 29;
    weblabStation3.Caption := 'Station 3';
    weblabStation3.ElementFont := efCSS;
    weblabStation3.Font.Charset := DEFAULT_CHARSET;
    weblabStation3.Font.Color := clWindowText;
    weblabStation3.Font.Height := -24;
    weblabStation3.Font.Name := 'Tahoma';
    weblabStation3.Font.Style := [fsBold];
    weblabStation3.HeightStyle := ssAuto;
    weblabStation3.HeightPercent := 100.00000000000000000;
    weblabStation3.ParentFont := False;
    weblabStation3.WidthPercent := 100.00000000000000000;
    WebLabel44.SetParentComponent(pnFallZahlen);
    WebLabel44.Name := 'WebLabel44';
    WebLabel44.Left := 50;
    WebLabel44.Top := 109;
    WebLabel44.Width := 105;
    WebLabel44.Height := 29;
    WebLabel44.Caption := 'Volumen';
    WebLabel44.ElementFont := efCSS;
    WebLabel44.Font.Charset := DEFAULT_CHARSET;
    WebLabel44.Font.Color := clWindowText;
    WebLabel44.Font.Height := -24;
    WebLabel44.Font.Name := 'Tahoma';
    WebLabel44.Font.Style := [fsBold];
    WebLabel44.HeightStyle := ssAuto;
    WebLabel44.HeightPercent := 100.00000000000000000;
    WebLabel44.ParentFont := False;
    WebLabel44.WidthPercent := 100.00000000000000000;
    WebLabel45.SetParentComponent(pnFallZahlen);
    WebLabel45.Name := 'WebLabel45';
    WebLabel45.Left := 1055;
    WebLabel45.Top := 48;
    WebLabel45.Width := 157;
    WebLabel45.Height := 29;
    WebLabel45.Caption := 'Verweildauer';
    WebLabel45.ElementFont := efCSS;
    WebLabel45.Font.Charset := DEFAULT_CHARSET;
    WebLabel45.Font.Color := clWindowText;
    WebLabel45.Font.Height := -24;
    WebLabel45.Font.Name := 'Tahoma';
    WebLabel45.Font.Style := [fsBold];
    WebLabel45.HeightStyle := ssAuto;
    WebLabel45.HeightPercent := 100.00000000000000000;
    WebLabel45.ParentFont := False;
    WebLabel45.WidthPercent := 100.00000000000000000;
    WebLabel46.SetParentComponent(pnFallZahlen);
    WebLabel46.Name := 'WebLabel46';
    WebLabel46.Left := 811;
    WebLabel46.Top := 109;
    WebLabel46.Width := 103;
    WebLabel46.Height := 29;
    WebLabel46.Caption := 'Mittlere-';
    WebLabel46.ElementFont := efCSS;
    WebLabel46.Font.Charset := DEFAULT_CHARSET;
    WebLabel46.Font.Color := clWindowText;
    WebLabel46.Font.Height := -24;
    WebLabel46.Font.Name := 'Tahoma';
    WebLabel46.Font.Style := [fsBold];
    WebLabel46.HeightStyle := ssAuto;
    WebLabel46.HeightPercent := 100.00000000000000000;
    WebLabel46.ParentFont := False;
    WebLabel46.WidthPercent := 100.00000000000000000;
    WebLabel47.SetParentComponent(pnFallZahlen);
    WebLabel47.Name := 'WebLabel47';
    WebLabel47.Left := 987;
    WebLabel47.Top := 109;
    WebLabel47.Width := 80;
    WebLabel47.Height := 29;
    WebLabel47.Caption := 'Grenz-';
    WebLabel47.ElementFont := efCSS;
    WebLabel47.Font.Charset := DEFAULT_CHARSET;
    WebLabel47.Font.Color := clWindowText;
    WebLabel47.Font.Height := -24;
    WebLabel47.Font.Name := 'Tahoma';
    WebLabel47.Font.Style := [fsBold];
    WebLabel47.HeightStyle := ssAuto;
    WebLabel47.HeightPercent := 100.00000000000000000;
    WebLabel47.ParentFont := False;
    WebLabel47.WidthPercent := 100.00000000000000000;
    WebLabel48.SetParentComponent(pnFallZahlen);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 1179;
    WebLabel48.Top := 109;
    WebLabel48.Width := 78;
    WebLabel48.Height := 29;
    WebLabel48.Caption := #220'berz.';
    WebLabel48.ElementFont := efCSS;
    WebLabel48.Font.Charset := DEFAULT_CHARSET;
    WebLabel48.Font.Color := clWindowText;
    WebLabel48.Font.Height := -24;
    WebLabel48.Font.Name := 'Tahoma';
    WebLabel48.Font.Style := [fsBold];
    WebLabel48.HeightStyle := ssAuto;
    WebLabel48.HeightPercent := 100.00000000000000000;
    WebLabel48.ParentFont := False;
    WebLabel48.WidthPercent := 100.00000000000000000;
    WebLabel105.SetParentComponent(pnFallZahlen);
    WebLabel105.Name := 'WebLabel105';
    WebLabel105.Left := 1328;
    WebLabel105.Top := 109;
    WebLabel105.Width := 101;
    WebLabel105.Height := 29;
    WebLabel105.Caption := #220'b-Tage';
    WebLabel105.ElementFont := efCSS;
    WebLabel105.Font.Charset := DEFAULT_CHARSET;
    WebLabel105.Font.Color := clWindowText;
    WebLabel105.Font.Height := -24;
    WebLabel105.Font.Name := 'Tahoma';
    WebLabel105.Font.Style := [fsBold];
    WebLabel105.HeightStyle := ssAuto;
    WebLabel105.HeightPercent := 100.00000000000000000;
    WebLabel105.ParentFont := False;
    WebLabel105.WidthPercent := 100.00000000000000000;
    LF2_Fallzahl.SetParentComponent(pnFallZahlen);
    LF2_Fallzahl.Name := 'LF2_Fallzahl';
    LF2_Fallzahl.Left := 34;
    LF2_Fallzahl.Top := 144;
    LF2_Fallzahl.Width := 150;
    LF2_Fallzahl.Height := 46;
    LF2_Fallzahl.ChildOrder := 10;
    LF2_Fallzahl.EditType := weSignedFloat;
    LF2_Fallzahl.ElementFont := efCSS;
    LF2_Fallzahl.ElementPosition := epIgnore;
    LF2_Fallzahl.Font.Charset := ANSI_CHARSET;
    LF2_Fallzahl.Font.Color := clWindowText;
    LF2_Fallzahl.Font.Height := -24;
    LF2_Fallzahl.Font.Name := 'Segoe UI';
    LF2_Fallzahl.Font.Style := [fsBold];
    LF2_Fallzahl.HeightStyle := ssAuto;
    LF2_Fallzahl.HeightPercent := 100.00000000000000000;
    LF2_Fallzahl.ParentFont := False;
    LF2_Fallzahl.Text := ' ';
    LF2_Fallzahl.WidthStyle := ssAuto;
    LF2_Fallzahl.WidthPercent := 100.00000000000000000;
    LF2_Fallzahl.DataField := 'Ddrg_Volume';
    LF2_Fallzahl.DataSource := DRGDataSource;
    LF2_Stati1.SetParentComponent(pnFallZahlen);
    LF2_Stati1.Name := 'LF2_Stati1';
    LF2_Stati1.Left := 205;
    LF2_Stati1.Top := 144;
    LF2_Stati1.Width := 150;
    LF2_Stati1.Height := 46;
    LF2_Stati1.ChildOrder := 11;
    LF2_Stati1.EditType := weSignedFloat;
    LF2_Stati1.ElementFont := efCSS;
    LF2_Stati1.ElementPosition := epIgnore;
    LF2_Stati1.Font.Charset := ANSI_CHARSET;
    LF2_Stati1.Font.Color := clWindowText;
    LF2_Stati1.Font.Height := -24;
    LF2_Stati1.Font.Name := 'Segoe UI';
    LF2_Stati1.Font.Style := [fsBold];
    LF2_Stati1.HeightStyle := ssAuto;
    LF2_Stati1.HeightPercent := 100.00000000000000000;
    LF2_Stati1.ParentFont := False;
    LF2_Stati1.TabOrder := 1;
    LF2_Stati1.Text := ' ';
    LF2_Stati1.WidthStyle := ssAuto;
    LF2_Stati1.WidthPercent := 100.00000000000000000;
    LF2_Stati1.DataField := 'Ddrg_Station_1';
    LF2_Stati1.DataSource := DRGDataSource;
    LF2_Stati2.SetParentComponent(pnFallZahlen);
    LF2_Stati2.Name := 'LF2_Stati2';
    LF2_Stati2.Left := 376;
    LF2_Stati2.Top := 144;
    LF2_Stati2.Width := 150;
    LF2_Stati2.Height := 46;
    LF2_Stati2.ChildOrder := 12;
    LF2_Stati2.EditType := weSignedFloat;
    LF2_Stati2.ElementFont := efCSS;
    LF2_Stati2.ElementPosition := epIgnore;
    LF2_Stati2.Font.Charset := ANSI_CHARSET;
    LF2_Stati2.Font.Color := clWindowText;
    LF2_Stati2.Font.Height := -24;
    LF2_Stati2.Font.Name := 'Segoe UI';
    LF2_Stati2.Font.Style := [fsBold];
    LF2_Stati2.HeightStyle := ssAuto;
    LF2_Stati2.HeightPercent := 100.00000000000000000;
    LF2_Stati2.ParentFont := False;
    LF2_Stati2.TabOrder := 2;
    LF2_Stati2.Text := ' ';
    LF2_Stati2.WidthStyle := ssAuto;
    LF2_Stati2.WidthPercent := 100.00000000000000000;
    LF2_Stati2.DataField := 'Ddrg_Station_2';
    LF2_Stati2.DataSource := DRGDataSource;
    LF2_Stati3.SetParentComponent(pnFallZahlen);
    LF2_Stati3.Name := 'LF2_Stati3';
    LF2_Stati3.Left := 548;
    LF2_Stati3.Top := 144;
    LF2_Stati3.Width := 150;
    LF2_Stati3.Height := 46;
    LF2_Stati3.ChildOrder := 13;
    LF2_Stati3.EditType := weSignedFloat;
    LF2_Stati3.ElementFont := efCSS;
    LF2_Stati3.ElementPosition := epIgnore;
    LF2_Stati3.Font.Charset := ANSI_CHARSET;
    LF2_Stati3.Font.Color := clWindowText;
    LF2_Stati3.Font.Height := -24;
    LF2_Stati3.Font.Name := 'Segoe UI';
    LF2_Stati3.Font.Style := [fsBold];
    LF2_Stati3.HeightStyle := ssAuto;
    LF2_Stati3.HeightPercent := 100.00000000000000000;
    LF2_Stati3.ParentFont := False;
    LF2_Stati3.TabOrder := 3;
    LF2_Stati3.Text := ' ';
    LF2_Stati3.WidthStyle := ssAuto;
    LF2_Stati3.WidthPercent := 100.00000000000000000;
    LF2_Stati3.DataField := 'Ddrg_Station_3';
    LF2_Stati3.DataSource := DRGDataSource;
    RF2_MVerwd.SetParentComponent(pnFallZahlen);
    RF2_MVerwd.Name := 'RF2_MVerwd';
    RF2_MVerwd.Left := 792;
    RF2_MVerwd.Top := 144;
    RF2_MVerwd.Width := 150;
    RF2_MVerwd.Height := 46;
    RF2_MVerwd.ChildOrder := 14;
    RF2_MVerwd.EditType := weSignedFloat;
    RF2_MVerwd.ElementFont := efCSS;
    RF2_MVerwd.ElementPosition := epIgnore;
    RF2_MVerwd.Font.Charset := ANSI_CHARSET;
    RF2_MVerwd.Font.Color := clWindowText;
    RF2_MVerwd.Font.Height := -24;
    RF2_MVerwd.Font.Name := 'Segoe UI';
    RF2_MVerwd.Font.Style := [fsBold];
    RF2_MVerwd.HeightStyle := ssAuto;
    RF2_MVerwd.HeightPercent := 100.00000000000000000;
    RF2_MVerwd.ParentFont := False;
    RF2_MVerwd.TabOrder := 4;
    RF2_MVerwd.Text := ' ';
    RF2_MVerwd.WidthStyle := ssAuto;
    RF2_MVerwd.WidthPercent := 100.00000000000000000;
    RF2_MVerwd.DataField := 'DDRG_MEDIUM_STAY';
    RF2_MVerwd.DataSource := DRGDataSource;
    RF2_GVerwD.SetParentComponent(pnFallZahlen);
    RF2_GVerwD.Name := 'RF2_GVerwD';
    RF2_GVerwD.Left := 964;
    RF2_GVerwD.Top := 141;
    RF2_GVerwD.Width := 150;
    RF2_GVerwD.Height := 46;
    RF2_GVerwD.ChildOrder := 15;
    RF2_GVerwD.EditType := weSignedFloat;
    RF2_GVerwD.ElementFont := efCSS;
    RF2_GVerwD.ElementPosition := epIgnore;
    RF2_GVerwD.Font.Charset := ANSI_CHARSET;
    RF2_GVerwD.Font.Color := clWindowText;
    RF2_GVerwD.Font.Height := -24;
    RF2_GVerwD.Font.Name := 'Segoe UI';
    RF2_GVerwD.Font.Style := [fsBold];
    RF2_GVerwD.HeightStyle := ssAuto;
    RF2_GVerwD.HeightPercent := 100.00000000000000000;
    RF2_GVerwD.ParentFont := False;
    RF2_GVerwD.TabOrder := 5;
    RF2_GVerwD.Text := ' ';
    RF2_GVerwD.WidthStyle := ssAuto;
    RF2_GVerwD.WidthPercent := 100.00000000000000000;
    RF2_GVerwD.DataField := 'DDRG_BORDER_STAY';
    RF2_GVerwD.DataSource := DRGDataSource;
    RF2_UebAnt.SetParentComponent(pnFallZahlen);
    RF2_UebAnt.Name := 'RF2_UebAnt';
    RF2_UebAnt.Left := 1138;
    RF2_UebAnt.Top := 144;
    RF2_UebAnt.Width := 150;
    RF2_UebAnt.Height := 46;
    RF2_UebAnt.ChildOrder := 16;
    RF2_UebAnt.EditType := weSignedFloat;
    RF2_UebAnt.ElementFont := efCSS;
    RF2_UebAnt.ElementPosition := epIgnore;
    RF2_UebAnt.Font.Charset := ANSI_CHARSET;
    RF2_UebAnt.Font.Color := clWindowText;
    RF2_UebAnt.Font.Height := -24;
    RF2_UebAnt.Font.Name := 'Segoe UI';
    RF2_UebAnt.Font.Style := [fsBold];
    RF2_UebAnt.HeightStyle := ssAuto;
    RF2_UebAnt.HeightPercent := 100.00000000000000000;
    RF2_UebAnt.ParentFont := False;
    RF2_UebAnt.TabOrder := 6;
    RF2_UebAnt.Text := ' ';
    RF2_UebAnt.WidthStyle := ssAuto;
    RF2_UebAnt.WidthPercent := 100.00000000000000000;
    RF2_UebAnt.DataField := 'DDRG_OVERDRAW_STAY';
    RF2_UebAnt.DataSource := DRGDataSource;
    RF2_UebTag.SetParentComponent(pnFallZahlen);
    RF2_UebTag.Name := 'RF2_UebTag';
    RF2_UebTag.Left := 1313;
    RF2_UebTag.Top := 144;
    RF2_UebTag.Width := 150;
    RF2_UebTag.Height := 46;
    RF2_UebTag.ChildOrder := 17;
    RF2_UebTag.EditType := weSignedFloat;
    RF2_UebTag.ElementFont := efCSS;
    RF2_UebTag.ElementPosition := epIgnore;
    RF2_UebTag.Font.Charset := ANSI_CHARSET;
    RF2_UebTag.Font.Color := clWindowText;
    RF2_UebTag.Font.Height := -24;
    RF2_UebTag.Font.Name := 'Segoe UI';
    RF2_UebTag.Font.Style := [fsBold];
    RF2_UebTag.HeightStyle := ssAuto;
    RF2_UebTag.HeightPercent := 100.00000000000000000;
    RF2_UebTag.ParentFont := False;
    RF2_UebTag.TabOrder := 7;
    RF2_UebTag.Text := ' ';
    RF2_UebTag.WidthStyle := ssAuto;
    RF2_UebTag.WidthPercent := 100.00000000000000000;
    RF2_UebTag.DataField := 'DDRG_OVERDRAW_DAYS_STAY';
    RF2_UebTag.DataSource := DRGDataSource;
    pgSeite4.SetParentComponent(PageControl);
    pgSeite4.Name := 'pgSeite4';
    pgSeite4.Left := 0;
    pgSeite4.Top := 20;
    pgSeite4.Width := 1901;
    pgSeite4.Height := 1506;
    pgSeite4.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite4.HeightStyle := ssAuto;
    pgSeite4.WidthStyle := ssAuto;
    pgSeite4.Caption := 'Personal- / Finanzdaten';
    pgSeite4.ChildOrder := 3;
    pgSeite4.ElementFont := efCSS;
    pgSeite4.ElementPosition := epRelative;
    pnPersonalDaten.SetParentComponent(pgSeite4);
    pnPersonalDaten.Name := 'pnPersonalDaten';
    pnPersonalDaten.Left := 83;
    pnPersonalDaten.Top := 28;
    pnPersonalDaten.Width := 1049;
    pnPersonalDaten.Height := 1054;
    pnPersonalDaten.ElementFont := efCSS;
    pnPersonalDaten.TabOrder := 0;
    WebLabel49.SetParentComponent(pnPersonalDaten);
    WebLabel49.Name := 'WebLabel49';
    WebLabel49.Left := 24;
    WebLabel49.Top := 143;
    WebLabel49.Width := 255;
    WebLabel49.Height := 29;
    WebLabel49.Caption := 'Jahresarbeitsstunden';
    WebLabel49.ElementFont := efCSS;
    WebLabel49.Font.Charset := DEFAULT_CHARSET;
    WebLabel49.Font.Color := clWindowText;
    WebLabel49.Font.Height := -24;
    WebLabel49.Font.Name := 'Tahoma';
    WebLabel49.Font.Style := [fsBold];
    WebLabel49.HeightStyle := ssAuto;
    WebLabel49.HeightPercent := 100.00000000000000000;
    WebLabel49.ParentFont := False;
    WebLabel49.WidthPercent := 100.00000000000000000;
    WebLabel50.SetParentComponent(pnPersonalDaten);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 24;
    WebLabel50.Top := 195;
    WebLabel50.Width := 148;
    WebLabel50.Height := 29;
    WebLabel50.Caption := 'Stundensatz';
    WebLabel50.ElementFont := efCSS;
    WebLabel50.Font.Charset := DEFAULT_CHARSET;
    WebLabel50.Font.Color := clWindowText;
    WebLabel50.Font.Height := -24;
    WebLabel50.Font.Name := 'Tahoma';
    WebLabel50.Font.Style := [fsBold];
    WebLabel50.HeightStyle := ssAuto;
    WebLabel50.HeightPercent := 100.00000000000000000;
    WebLabel50.ParentFont := False;
    WebLabel50.WidthPercent := 100.00000000000000000;
    WebLabel51.SetParentComponent(pnPersonalDaten);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 24;
    WebLabel51.Top := 247;
    WebLabel51.Width := 359;
    WebLabel51.Height := 29;
    WebLabel51.Caption := 'Min. Gehaltsnebenkosten (%)';
    WebLabel51.ElementFont := efCSS;
    WebLabel51.Font.Charset := DEFAULT_CHARSET;
    WebLabel51.Font.Color := clWindowText;
    WebLabel51.Font.Height := -24;
    WebLabel51.Font.Name := 'Tahoma';
    WebLabel51.Font.Style := [fsBold];
    WebLabel51.HeightStyle := ssAuto;
    WebLabel51.HeightPercent := 100.00000000000000000;
    WebLabel51.ParentFont := False;
    WebLabel51.WidthPercent := 100.00000000000000000;
    WebLabel52.SetParentComponent(pnPersonalDaten);
    WebLabel52.Name := 'WebLabel52';
    WebLabel52.Left := 24;
    WebLabel52.Top := 300;
    WebLabel52.Width := 333;
    WebLabel52.Height := 29;
    WebLabel52.Caption := 'Maximale '#220'berstunden (%)';
    WebLabel52.ElementFont := efCSS;
    WebLabel52.Font.Charset := DEFAULT_CHARSET;
    WebLabel52.Font.Color := clWindowText;
    WebLabel52.Font.Height := -24;
    WebLabel52.Font.Name := 'Tahoma';
    WebLabel52.Font.Style := [fsBold];
    WebLabel52.HeightStyle := ssAuto;
    WebLabel52.HeightPercent := 100.00000000000000000;
    WebLabel52.ParentFont := False;
    WebLabel52.WidthPercent := 100.00000000000000000;
    WebLabel53.SetParentComponent(pnPersonalDaten);
    WebLabel53.Name := 'WebLabel53';
    WebLabel53.Left := 24;
    WebLabel53.Top := 351;
    WebLabel53.Width := 315;
    WebLabel53.Height := 29;
    WebLabel53.Caption := #220'berstundenzuschlag (%)';
    WebLabel53.ElementFont := efCSS;
    WebLabel53.Font.Charset := DEFAULT_CHARSET;
    WebLabel53.Font.Color := clWindowText;
    WebLabel53.Font.Height := -24;
    WebLabel53.Font.Name := 'Tahoma';
    WebLabel53.Font.Style := [fsBold];
    WebLabel53.HeightStyle := ssAuto;
    WebLabel53.HeightPercent := 100.00000000000000000;
    WebLabel53.ParentFont := False;
    WebLabel53.WidthPercent := 100.00000000000000000;
    WebLabel54.SetParentComponent(pnPersonalDaten);
    WebLabel54.Name := 'WebLabel54';
    WebLabel54.Left := 24;
    WebLabel54.Top := 404;
    WebLabel54.Width := 318;
    WebLabel54.Height := 29;
    WebLabel54.Caption := 'Einstellungskosten (TEUR)';
    WebLabel54.ElementFont := efCSS;
    WebLabel54.Font.Charset := DEFAULT_CHARSET;
    WebLabel54.Font.Color := clWindowText;
    WebLabel54.Font.Height := -24;
    WebLabel54.Font.Name := 'Tahoma';
    WebLabel54.Font.Style := [fsBold];
    WebLabel54.HeightStyle := ssAuto;
    WebLabel54.HeightPercent := 100.00000000000000000;
    WebLabel54.ParentFont := False;
    WebLabel54.WidthPercent := 100.00000000000000000;
    WebLabel55.SetParentComponent(pnPersonalDaten);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 24;
    WebLabel55.Top := 455;
    WebLabel55.Width := 316;
    WebLabel55.Height := 29;
    WebLabel55.Caption := 'Entlassungskosten (TEUR)';
    WebLabel55.ElementFont := efCSS;
    WebLabel55.Font.Charset := DEFAULT_CHARSET;
    WebLabel55.Font.Color := clWindowText;
    WebLabel55.Font.Height := -24;
    WebLabel55.Font.Name := 'Tahoma';
    WebLabel55.Font.Style := [fsBold];
    WebLabel55.HeightStyle := ssAuto;
    WebLabel55.HeightPercent := 100.00000000000000000;
    WebLabel55.ParentFont := False;
    WebLabel55.WidthPercent := 100.00000000000000000;
    WebLabel56.SetParentComponent(pnPersonalDaten);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 24;
    WebLabel56.Top := 508;
    WebLabel56.Width := 421;
    WebLabel56.Height := 29;
    WebLabel56.Caption := 'Max. Einstellungen (Mitarbeitende)';
    WebLabel56.ElementFont := efCSS;
    WebLabel56.Font.Charset := DEFAULT_CHARSET;
    WebLabel56.Font.Color := clWindowText;
    WebLabel56.Font.Height := -24;
    WebLabel56.Font.Name := 'Tahoma';
    WebLabel56.Font.Style := [fsBold];
    WebLabel56.HeightStyle := ssAuto;
    WebLabel56.HeightPercent := 100.00000000000000000;
    WebLabel56.ParentFont := False;
    WebLabel56.WidthPercent := 100.00000000000000000;
    WebLabel57.SetParentComponent(pnPersonalDaten);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 24;
    WebLabel57.Top := 559;
    WebLabel57.Width := 419;
    WebLabel57.Height := 29;
    WebLabel57.Caption := 'Max. Entlassungen (Mitarbeitende)';
    WebLabel57.ElementFont := efCSS;
    WebLabel57.Font.Charset := DEFAULT_CHARSET;
    WebLabel57.Font.Color := clWindowText;
    WebLabel57.Font.Height := -24;
    WebLabel57.Font.Name := 'Tahoma';
    WebLabel57.Font.Style := [fsBold];
    WebLabel57.HeightStyle := ssAuto;
    WebLabel57.HeightPercent := 100.00000000000000000;
    WebLabel57.ParentFont := False;
    WebLabel57.WidthPercent := 100.00000000000000000;
    WebLabel58.SetParentComponent(pnPersonalDaten);
    WebLabel58.Name := 'WebLabel58';
    WebLabel58.Left := 24;
    WebLabel58.Top := 612;
    WebLabel58.Width := 466;
    WebLabel58.Height := 29;
    WebLabel58.Caption := 'Trainingskosten / Tag / Mitarbeitender';
    WebLabel58.ElementFont := efCSS;
    WebLabel58.Font.Charset := DEFAULT_CHARSET;
    WebLabel58.Font.Color := clWindowText;
    WebLabel58.Font.Height := -24;
    WebLabel58.Font.Name := 'Tahoma';
    WebLabel58.Font.Style := [fsBold];
    WebLabel58.HeightStyle := ssAuto;
    WebLabel58.HeightPercent := 100.00000000000000000;
    WebLabel58.ParentFont := False;
    WebLabel58.WidthPercent := 100.00000000000000000;
    WebLabel59.SetParentComponent(pnPersonalDaten);
    WebLabel59.Name := 'WebLabel59';
    WebLabel59.Left := 24;
    WebLabel59.Top := 663;
    WebLabel59.Width := 441;
    WebLabel59.Height := 29;
    WebLabel59.Caption := 'Kosten Fremdpersonal / Jahr (TEUR)';
    WebLabel59.ElementFont := efCSS;
    WebLabel59.Font.Charset := DEFAULT_CHARSET;
    WebLabel59.Font.Color := clWindowText;
    WebLabel59.Font.Height := -24;
    WebLabel59.Font.Name := 'Tahoma';
    WebLabel59.Font.Style := [fsBold];
    WebLabel59.HeightStyle := ssAuto;
    WebLabel59.HeightPercent := 100.00000000000000000;
    WebLabel59.ParentFont := False;
    WebLabel59.WidthPercent := 100.00000000000000000;
    WebLabel60.SetParentComponent(pnPersonalDaten);
    WebLabel60.Name := 'WebLabel60';
    WebLabel60.Left := 24;
    WebLabel60.Top := 747;
    WebLabel60.Width := 280;
    WebLabel60.Height := 29;
    WebLabel60.Caption := 'Gehalt Chefarzt (TEUR)';
    WebLabel60.ElementFont := efCSS;
    WebLabel60.Font.Charset := DEFAULT_CHARSET;
    WebLabel60.Font.Color := clWindowText;
    WebLabel60.Font.Height := -24;
    WebLabel60.Font.Name := 'Tahoma';
    WebLabel60.Font.Style := [fsBold];
    WebLabel60.HeightStyle := ssAuto;
    WebLabel60.HeightPercent := 100.00000000000000000;
    WebLabel60.ParentFont := False;
    WebLabel60.WidthPercent := 100.00000000000000000;
    WebLabel61.SetParentComponent(pnPersonalDaten);
    WebLabel61.Name := 'WebLabel61';
    WebLabel61.Left := 535;
    WebLabel61.Top := 103;
    WebLabel61.Width := 49;
    WebLabel61.Height := 29;
    WebLabel61.Caption := 'Arzt';
    WebLabel61.ElementFont := efCSS;
    WebLabel61.Font.Charset := DEFAULT_CHARSET;
    WebLabel61.Font.Color := clWindowText;
    WebLabel61.Font.Height := -24;
    WebLabel61.Font.Name := 'Tahoma';
    WebLabel61.Font.Style := [fsBold];
    WebLabel61.HeightStyle := ssAuto;
    WebLabel61.HeightPercent := 100.00000000000000000;
    WebLabel61.ParentFont := False;
    WebLabel61.WidthPercent := 100.00000000000000000;
    WebLabel62.SetParentComponent(pnPersonalDaten);
    WebLabel62.Name := 'WebLabel62';
    WebLabel62.Left := 691;
    WebLabel62.Top := 103;
    WebLabel62.Width := 75;
    WebLabel62.Height := 29;
    WebLabel62.Caption := 'Pflege';
    WebLabel62.ElementFont := efCSS;
    WebLabel62.Font.Charset := DEFAULT_CHARSET;
    WebLabel62.Font.Color := clWindowText;
    WebLabel62.Font.Height := -24;
    WebLabel62.Font.Name := 'Tahoma';
    WebLabel62.Font.Style := [fsBold];
    WebLabel62.HeightStyle := ssAuto;
    WebLabel62.HeightPercent := 100.00000000000000000;
    WebLabel62.ParentFont := False;
    WebLabel62.WidthPercent := 100.00000000000000000;
    WebLabel63.SetParentComponent(pnPersonalDaten);
    WebLabel63.Name := 'WebLabel63';
    WebLabel63.Left := 848;
    WebLabel63.Top := 103;
    WebLabel63.Width := 91;
    WebLabel63.Height := 29;
    WebLabel63.Caption := 'Institut';
    WebLabel63.ElementFont := efCSS;
    WebLabel63.Font.Charset := DEFAULT_CHARSET;
    WebLabel63.Font.Color := clWindowText;
    WebLabel63.Font.Height := -24;
    WebLabel63.Font.Name := 'Tahoma';
    WebLabel63.Font.Style := [fsBold];
    WebLabel63.HeightStyle := ssAuto;
    WebLabel63.HeightPercent := 100.00000000000000000;
    WebLabel63.ParentFont := False;
    WebLabel63.WidthPercent := 100.00000000000000000;
    WebLabel64.SetParentComponent(pnPersonalDaten);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 24;
    WebLabel64.Top := 797;
    WebLabel64.Width := 390;
    WebLabel64.Height := 29;
    WebLabel64.Caption := 'Gehalt Gesch'#228'ftsf'#252'hrung (TEUR)';
    WebLabel64.ElementFont := efCSS;
    WebLabel64.Font.Charset := DEFAULT_CHARSET;
    WebLabel64.Font.Color := clWindowText;
    WebLabel64.Font.Height := -24;
    WebLabel64.Font.Name := 'Tahoma';
    WebLabel64.Font.Style := [fsBold];
    WebLabel64.HeightStyle := ssAuto;
    WebLabel64.HeightPercent := 100.00000000000000000;
    WebLabel64.ParentFont := False;
    WebLabel64.WidthPercent := 100.00000000000000000;
    WebLabel65.SetParentComponent(pnPersonalDaten);
    WebLabel65.Name := 'WebLabel65';
    WebLabel65.Left := 24;
    WebLabel65.Top := 876;
    WebLabel65.Width := 340;
    WebLabel65.Height := 29;
    WebLabel65.Caption := 'Pensionsr'#252'ckstellungen (%)';
    WebLabel65.ElementFont := efCSS;
    WebLabel65.Font.Charset := DEFAULT_CHARSET;
    WebLabel65.Font.Color := clWindowText;
    WebLabel65.Font.Height := -24;
    WebLabel65.Font.Name := 'Tahoma';
    WebLabel65.Font.Style := [fsBold];
    WebLabel65.HeightStyle := ssAuto;
    WebLabel65.HeightPercent := 100.00000000000000000;
    WebLabel65.ParentFont := False;
    WebLabel65.WidthPercent := 100.00000000000000000;
    WebLabel66.SetParentComponent(pnPersonalDaten);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 24;
    WebLabel66.Top := 936;
    WebLabel66.Width := 441;
    WebLabel66.Height := 29;
    WebLabel66.Caption := 'Anrechnung  gespart. Codierzeit (%)';
    WebLabel66.ElementFont := efCSS;
    WebLabel66.Font.Charset := DEFAULT_CHARSET;
    WebLabel66.Font.Color := clWindowText;
    WebLabel66.Font.Height := -24;
    WebLabel66.Font.Name := 'Tahoma';
    WebLabel66.Font.Style := [fsBold];
    WebLabel66.HeightStyle := ssAuto;
    WebLabel66.HeightPercent := 100.00000000000000000;
    WebLabel66.ParentFont := False;
    WebLabel66.WidthPercent := 100.00000000000000000;
    WebLabel67.SetParentComponent(pnPersonalDaten);
    WebLabel67.Name := 'WebLabel67';
    WebLabel67.Left := 724;
    WebLabel67.Top := 876;
    WebLabel67.Width := 315;
    WebLabel67.Height := 29;
    WebLabel67.Caption := 'Aufbaufkt.  Geh. Neb. (%)';
    WebLabel67.ElementFont := efCSS;
    WebLabel67.Font.Charset := DEFAULT_CHARSET;
    WebLabel67.Font.Color := clWindowText;
    WebLabel67.Font.Height := -24;
    WebLabel67.Font.Name := 'Tahoma';
    WebLabel67.Font.Style := [fsBold];
    WebLabel67.HeightStyle := ssAuto;
    WebLabel67.HeightPercent := 100.00000000000000000;
    WebLabel67.ParentFont := False;
    WebLabel67.WidthPercent := 100.00000000000000000;
    WebLabel36.SetParentComponent(pnPersonalDaten);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 80;
    WebLabel36.Top := 32;
    WebLabel36.Width := 91;
    WebLabel36.Height := 18;
    WebLabel36.Caption := 'Personaldaten';
    WebLabel36.ElementFont := efCSS;
    WebLabel36.ElementPosition := epRelative;
    WebLabel36.HeightStyle := ssAuto;
    WebLabel36.HeightPercent := 100.00000000000000000;
    WebLabel36.HTMLType := tH3;
    WebLabel36.WidthPercent := 100.00000000000000000;
    LFE_ArbZeitA.SetParentComponent(pnPersonalDaten);
    LFE_ArbZeitA.Name := 'LFE_ArbZeitA';
    LFE_ArbZeitA.Left := 488;
    LFE_ArbZeitA.Top := 138;
    LFE_ArbZeitA.Width := 150;
    LFE_ArbZeitA.Height := 46;
    LFE_ArbZeitA.ChildOrder := 20;
    LFE_ArbZeitA.EditType := weSignedFloat;
    LFE_ArbZeitA.ElementFont := efCSS;
    LFE_ArbZeitA.Font.Charset := ANSI_CHARSET;
    LFE_ArbZeitA.Font.Color := clWindowText;
    LFE_ArbZeitA.Font.Height := -24;
    LFE_ArbZeitA.Font.Name := 'Segoe UI';
    LFE_ArbZeitA.Font.Style := [fsBold];
    LFE_ArbZeitA.HeightStyle := ssAuto;
    LFE_ArbZeitA.HeightPercent := 100.00000000000000000;
    LFE_ArbZeitA.ParentFont := False;
    LFE_ArbZeitA.Text := ' ';
    LFE_ArbZeitA.WidthPercent := 100.00000000000000000;
    LFE_ArbZeitA.DataField := 'Hfnd_Pers_Whours_Doctor';
    LFE_ArbZeitA.DataSource := PersonalDataSource;
    RFE_StdSatzA.SetParentComponent(pnPersonalDaten);
    RFE_StdSatzA.Name := 'RFE_StdSatzA';
    RFE_StdSatzA.Left := 488;
    RFE_StdSatzA.Top := 190;
    RFE_StdSatzA.Width := 150;
    RFE_StdSatzA.Height := 46;
    RFE_StdSatzA.ChildOrder := 21;
    RFE_StdSatzA.EditType := weSignedFloat;
    RFE_StdSatzA.ElementFont := efCSS;
    RFE_StdSatzA.Font.Charset := ANSI_CHARSET;
    RFE_StdSatzA.Font.Color := clWindowText;
    RFE_StdSatzA.Font.Height := -24;
    RFE_StdSatzA.Font.Name := 'Segoe UI';
    RFE_StdSatzA.Font.Style := [fsBold];
    RFE_StdSatzA.HeightStyle := ssAuto;
    RFE_StdSatzA.HeightPercent := 100.00000000000000000;
    RFE_StdSatzA.ParentFont := False;
    RFE_StdSatzA.TabOrder := 1;
    RFE_StdSatzA.Text := ' ';
    RFE_StdSatzA.WidthPercent := 100.00000000000000000;
    RFE_StdSatzA.DataField := 'Hfnd_Pers_Hrate_Doctor';
    RFE_StdSatzA.DataSource := PersonalDataSource;
    RFE_GehNebKoA.SetParentComponent(pnPersonalDaten);
    RFE_GehNebKoA.Name := 'RFE_GehNebKoA';
    RFE_GehNebKoA.Left := 488;
    RFE_GehNebKoA.Top := 242;
    RFE_GehNebKoA.Width := 150;
    RFE_GehNebKoA.Height := 46;
    RFE_GehNebKoA.ChildOrder := 22;
    RFE_GehNebKoA.EditType := weSignedFloat;
    RFE_GehNebKoA.ElementFont := efCSS;
    RFE_GehNebKoA.Font.Charset := ANSI_CHARSET;
    RFE_GehNebKoA.Font.Color := clWindowText;
    RFE_GehNebKoA.Font.Height := -24;
    RFE_GehNebKoA.Font.Name := 'Segoe UI';
    RFE_GehNebKoA.Font.Style := [fsBold];
    RFE_GehNebKoA.HeightStyle := ssAuto;
    RFE_GehNebKoA.HeightPercent := 100.00000000000000000;
    RFE_GehNebKoA.ParentFont := False;
    RFE_GehNebKoA.TabOrder := 2;
    RFE_GehNebKoA.Text := ' ';
    RFE_GehNebKoA.WidthPercent := 100.00000000000000000;
    RFE_GehNebKoA.DataField := 'Hfnd_Pers_Salcost_Doctor';
    RFE_GehNebKoA.DataSource := PersonalDataSource;
    RFE_MaxUeberA.SetParentComponent(pnPersonalDaten);
    RFE_MaxUeberA.Name := 'RFE_MaxUeberA';
    RFE_MaxUeberA.Left := 488;
    RFE_MaxUeberA.Top := 294;
    RFE_MaxUeberA.Width := 150;
    RFE_MaxUeberA.Height := 46;
    RFE_MaxUeberA.ChildOrder := 23;
    RFE_MaxUeberA.EditType := weSignedFloat;
    RFE_MaxUeberA.ElementFont := efCSS;
    RFE_MaxUeberA.Font.Charset := ANSI_CHARSET;
    RFE_MaxUeberA.Font.Color := clWindowText;
    RFE_MaxUeberA.Font.Height := -24;
    RFE_MaxUeberA.Font.Name := 'Segoe UI';
    RFE_MaxUeberA.Font.Style := [fsBold];
    RFE_MaxUeberA.HeightStyle := ssAuto;
    RFE_MaxUeberA.HeightPercent := 100.00000000000000000;
    RFE_MaxUeberA.ParentFont := False;
    RFE_MaxUeberA.TabOrder := 3;
    RFE_MaxUeberA.Text := ' ';
    RFE_MaxUeberA.WidthPercent := 100.00000000000000000;
    RFE_MaxUeberA.DataField := 'Hfnd_Pers_Otime_Doctor';
    RFE_MaxUeberA.DataSource := PersonalDataSource;
    RFE_UeZuschlA.SetParentComponent(pnPersonalDaten);
    RFE_UeZuschlA.Name := 'RFE_UeZuschlA';
    RFE_UeZuschlA.Left := 488;
    RFE_UeZuschlA.Top := 346;
    RFE_UeZuschlA.Width := 150;
    RFE_UeZuschlA.Height := 46;
    RFE_UeZuschlA.ChildOrder := 24;
    RFE_UeZuschlA.EditType := weSignedFloat;
    RFE_UeZuschlA.ElementFont := efCSS;
    RFE_UeZuschlA.Font.Charset := ANSI_CHARSET;
    RFE_UeZuschlA.Font.Color := clWindowText;
    RFE_UeZuschlA.Font.Height := -24;
    RFE_UeZuschlA.Font.Name := 'Segoe UI';
    RFE_UeZuschlA.Font.Style := [fsBold];
    RFE_UeZuschlA.HeightStyle := ssAuto;
    RFE_UeZuschlA.HeightPercent := 100.00000000000000000;
    RFE_UeZuschlA.ParentFont := False;
    RFE_UeZuschlA.TabOrder := 4;
    RFE_UeZuschlA.Text := ' ';
    RFE_UeZuschlA.WidthPercent := 100.00000000000000000;
    RFE_UeZuschlA.DataField := 'Hfnd_Pers_Otimepay_Doctor';
    RFE_UeZuschlA.DataSource := PersonalDataSource;
    RFE_EinstlKoA.SetParentComponent(pnPersonalDaten);
    RFE_EinstlKoA.Name := 'RFE_EinstlKoA';
    RFE_EinstlKoA.Left := 488;
    RFE_EinstlKoA.Top := 398;
    RFE_EinstlKoA.Width := 150;
    RFE_EinstlKoA.Height := 46;
    RFE_EinstlKoA.ChildOrder := 25;
    RFE_EinstlKoA.EditType := weSignedFloat;
    RFE_EinstlKoA.ElementFont := efCSS;
    RFE_EinstlKoA.Font.Charset := ANSI_CHARSET;
    RFE_EinstlKoA.Font.Color := clWindowText;
    RFE_EinstlKoA.Font.Height := -24;
    RFE_EinstlKoA.Font.Name := 'Segoe UI';
    RFE_EinstlKoA.Font.Style := [fsBold];
    RFE_EinstlKoA.HeightStyle := ssAuto;
    RFE_EinstlKoA.HeightPercent := 100.00000000000000000;
    RFE_EinstlKoA.ParentFont := False;
    RFE_EinstlKoA.TabOrder := 5;
    RFE_EinstlKoA.Text := ' ';
    RFE_EinstlKoA.WidthPercent := 100.00000000000000000;
    RFE_EinstlKoA.DataField := 'Hfnd_Pers_Recruit_Doctor';
    RFE_EinstlKoA.DataSource := PersonalDataSource;
    RFE_EntlasKoA.SetParentComponent(pnPersonalDaten);
    RFE_EntlasKoA.Name := 'RFE_EntlasKoA';
    RFE_EntlasKoA.Left := 488;
    RFE_EntlasKoA.Top := 450;
    RFE_EntlasKoA.Width := 150;
    RFE_EntlasKoA.Height := 46;
    RFE_EntlasKoA.ChildOrder := 26;
    RFE_EntlasKoA.EditType := weSignedFloat;
    RFE_EntlasKoA.ElementFont := efCSS;
    RFE_EntlasKoA.Font.Charset := ANSI_CHARSET;
    RFE_EntlasKoA.Font.Color := clWindowText;
    RFE_EntlasKoA.Font.Height := -24;
    RFE_EntlasKoA.Font.Name := 'Segoe UI';
    RFE_EntlasKoA.Font.Style := [fsBold];
    RFE_EntlasKoA.HeightStyle := ssAuto;
    RFE_EntlasKoA.HeightPercent := 100.00000000000000000;
    RFE_EntlasKoA.ParentFont := False;
    RFE_EntlasKoA.TabOrder := 6;
    RFE_EntlasKoA.Text := ' ';
    RFE_EntlasKoA.WidthPercent := 100.00000000000000000;
    RFE_EntlasKoA.DataField := 'Hfnd_Pers_Dismiss_Doctor';
    RFE_EntlasKoA.DataSource := PersonalDataSource;
    RFE_MaxEinstA.SetParentComponent(pnPersonalDaten);
    RFE_MaxEinstA.Name := 'RFE_MaxEinstA';
    RFE_MaxEinstA.Left := 488;
    RFE_MaxEinstA.Top := 502;
    RFE_MaxEinstA.Width := 150;
    RFE_MaxEinstA.Height := 46;
    RFE_MaxEinstA.ChildOrder := 27;
    RFE_MaxEinstA.EditType := weSignedFloat;
    RFE_MaxEinstA.ElementFont := efCSS;
    RFE_MaxEinstA.Font.Charset := ANSI_CHARSET;
    RFE_MaxEinstA.Font.Color := clWindowText;
    RFE_MaxEinstA.Font.Height := -24;
    RFE_MaxEinstA.Font.Name := 'Segoe UI';
    RFE_MaxEinstA.Font.Style := [fsBold];
    RFE_MaxEinstA.HeightStyle := ssAuto;
    RFE_MaxEinstA.HeightPercent := 100.00000000000000000;
    RFE_MaxEinstA.ParentFont := False;
    RFE_MaxEinstA.TabOrder := 7;
    RFE_MaxEinstA.Text := ' ';
    RFE_MaxEinstA.WidthPercent := 100.00000000000000000;
    RFE_MaxEinstA.DataField := 'Hfnd_Pers_Maxrecruit_Doctor';
    RFE_MaxEinstA.DataSource := PersonalDataSource;
    RFE_MaxEntlaA.SetParentComponent(pnPersonalDaten);
    RFE_MaxEntlaA.Name := 'RFE_MaxEntlaA';
    RFE_MaxEntlaA.Left := 488;
    RFE_MaxEntlaA.Top := 554;
    RFE_MaxEntlaA.Width := 150;
    RFE_MaxEntlaA.Height := 46;
    RFE_MaxEntlaA.ChildOrder := 28;
    RFE_MaxEntlaA.EditType := weSignedFloat;
    RFE_MaxEntlaA.ElementFont := efCSS;
    RFE_MaxEntlaA.Font.Charset := ANSI_CHARSET;
    RFE_MaxEntlaA.Font.Color := clWindowText;
    RFE_MaxEntlaA.Font.Height := -24;
    RFE_MaxEntlaA.Font.Name := 'Segoe UI';
    RFE_MaxEntlaA.Font.Style := [fsBold];
    RFE_MaxEntlaA.HeightStyle := ssAuto;
    RFE_MaxEntlaA.HeightPercent := 100.00000000000000000;
    RFE_MaxEntlaA.ParentFont := False;
    RFE_MaxEntlaA.TabOrder := 8;
    RFE_MaxEntlaA.Text := ' ';
    RFE_MaxEntlaA.WidthPercent := 100.00000000000000000;
    RFE_MaxEntlaA.DataField := 'Hfnd_Pers_Maxdismiss_Doctor';
    RFE_MaxEntlaA.DataSource := PersonalDataSource;
    RFE_TrainKstA.SetParentComponent(pnPersonalDaten);
    RFE_TrainKstA.Name := 'RFE_TrainKstA';
    RFE_TrainKstA.Left := 488;
    RFE_TrainKstA.Top := 606;
    RFE_TrainKstA.Width := 150;
    RFE_TrainKstA.Height := 46;
    RFE_TrainKstA.ChildOrder := 29;
    RFE_TrainKstA.EditType := weSignedFloat;
    RFE_TrainKstA.ElementFont := efCSS;
    RFE_TrainKstA.Font.Charset := ANSI_CHARSET;
    RFE_TrainKstA.Font.Color := clWindowText;
    RFE_TrainKstA.Font.Height := -24;
    RFE_TrainKstA.Font.Name := 'Segoe UI';
    RFE_TrainKstA.Font.Style := [fsBold];
    RFE_TrainKstA.HeightStyle := ssAuto;
    RFE_TrainKstA.HeightPercent := 100.00000000000000000;
    RFE_TrainKstA.ParentFont := False;
    RFE_TrainKstA.TabOrder := 9;
    RFE_TrainKstA.Text := ' ';
    RFE_TrainKstA.WidthPercent := 100.00000000000000000;
    RFE_TrainKstA.DataField := 'Hfnd_Pers_Training_Doctor';
    RFE_TrainKstA.DataSource := PersonalDataSource;
    RFE_FremdPKoA.SetParentComponent(pnPersonalDaten);
    RFE_FremdPKoA.Name := 'RFE_FremdPKoA';
    RFE_FremdPKoA.Left := 488;
    RFE_FremdPKoA.Top := 658;
    RFE_FremdPKoA.Width := 150;
    RFE_FremdPKoA.Height := 46;
    RFE_FremdPKoA.ChildOrder := 30;
    RFE_FremdPKoA.EditType := weSignedFloat;
    RFE_FremdPKoA.ElementFont := efCSS;
    RFE_FremdPKoA.Font.Charset := ANSI_CHARSET;
    RFE_FremdPKoA.Font.Color := clWindowText;
    RFE_FremdPKoA.Font.Height := -24;
    RFE_FremdPKoA.Font.Name := 'Segoe UI';
    RFE_FremdPKoA.Font.Style := [fsBold];
    RFE_FremdPKoA.HeightStyle := ssAuto;
    RFE_FremdPKoA.HeightPercent := 100.00000000000000000;
    RFE_FremdPKoA.ParentFont := False;
    RFE_FremdPKoA.TabOrder := 10;
    RFE_FremdPKoA.Text := ' ';
    RFE_FremdPKoA.WidthPercent := 100.00000000000000000;
    RFE_FremdPKoA.DataField := 'Hfnd_Pers_External_Doctor';
    RFE_FremdPKoA.DataSource := PersonalDataSource;
    RFE_GehChefA.SetParentComponent(pnPersonalDaten);
    RFE_GehChefA.Name := 'RFE_GehChefA';
    RFE_GehChefA.Left := 488;
    RFE_GehChefA.Top := 739;
    RFE_GehChefA.Width := 150;
    RFE_GehChefA.Height := 46;
    RFE_GehChefA.ChildOrder := 31;
    RFE_GehChefA.EditType := weSignedFloat;
    RFE_GehChefA.ElementFont := efCSS;
    RFE_GehChefA.Font.Charset := ANSI_CHARSET;
    RFE_GehChefA.Font.Color := clWindowText;
    RFE_GehChefA.Font.Height := -24;
    RFE_GehChefA.Font.Name := 'Segoe UI';
    RFE_GehChefA.Font.Style := [fsBold];
    RFE_GehChefA.HeightStyle := ssAuto;
    RFE_GehChefA.HeightPercent := 100.00000000000000000;
    RFE_GehChefA.ParentFont := False;
    RFE_GehChefA.TabOrder := 11;
    RFE_GehChefA.Text := ' ';
    RFE_GehChefA.WidthPercent := 100.00000000000000000;
    RFE_GehChefA.DataField := 'Hfnd_Chief_Physician_Salary';
    RFE_GehChefA.DataSource := PersonalDataSource;
    LFE_ArbZeitP.SetParentComponent(pnPersonalDaten);
    LFE_ArbZeitP.Name := 'LFE_ArbZeitP';
    LFE_ArbZeitP.Left := 660;
    LFE_ArbZeitP.Top := 138;
    LFE_ArbZeitP.Width := 150;
    LFE_ArbZeitP.Height := 46;
    LFE_ArbZeitP.ChildOrder := 32;
    LFE_ArbZeitP.EditType := weSignedFloat;
    LFE_ArbZeitP.ElementFont := efCSS;
    LFE_ArbZeitP.Font.Charset := ANSI_CHARSET;
    LFE_ArbZeitP.Font.Color := clWindowText;
    LFE_ArbZeitP.Font.Height := -24;
    LFE_ArbZeitP.Font.Name := 'Segoe UI';
    LFE_ArbZeitP.Font.Style := [fsBold];
    LFE_ArbZeitP.HeightStyle := ssAuto;
    LFE_ArbZeitP.HeightPercent := 100.00000000000000000;
    LFE_ArbZeitP.ParentFont := False;
    LFE_ArbZeitP.TabOrder := 12;
    LFE_ArbZeitP.Text := ' ';
    LFE_ArbZeitP.WidthPercent := 100.00000000000000000;
    LFE_ArbZeitP.DataField := 'Hfnd_Pers_Whours_Care';
    LFE_ArbZeitP.DataSource := PersonalDataSource;
    RFE_StdSatzP.SetParentComponent(pnPersonalDaten);
    RFE_StdSatzP.Name := 'RFE_StdSatzP';
    RFE_StdSatzP.Left := 660;
    RFE_StdSatzP.Top := 190;
    RFE_StdSatzP.Width := 150;
    RFE_StdSatzP.Height := 46;
    RFE_StdSatzP.ChildOrder := 33;
    RFE_StdSatzP.EditType := weSignedFloat;
    RFE_StdSatzP.ElementFont := efCSS;
    RFE_StdSatzP.Font.Charset := ANSI_CHARSET;
    RFE_StdSatzP.Font.Color := clWindowText;
    RFE_StdSatzP.Font.Height := -24;
    RFE_StdSatzP.Font.Name := 'Segoe UI';
    RFE_StdSatzP.Font.Style := [fsBold];
    RFE_StdSatzP.HeightStyle := ssAuto;
    RFE_StdSatzP.HeightPercent := 100.00000000000000000;
    RFE_StdSatzP.ParentFont := False;
    RFE_StdSatzP.TabOrder := 13;
    RFE_StdSatzP.Text := ' ';
    RFE_StdSatzP.WidthPercent := 100.00000000000000000;
    RFE_StdSatzP.DataField := 'Hfnd_Pers_Hrate_Care';
    RFE_StdSatzP.DataSource := PersonalDataSource;
    RFE_GehNebKoP.SetParentComponent(pnPersonalDaten);
    RFE_GehNebKoP.Name := 'RFE_GehNebKoP';
    RFE_GehNebKoP.Left := 661;
    RFE_GehNebKoP.Top := 242;
    RFE_GehNebKoP.Width := 150;
    RFE_GehNebKoP.Height := 46;
    RFE_GehNebKoP.ChildOrder := 34;
    RFE_GehNebKoP.EditType := weSignedFloat;
    RFE_GehNebKoP.ElementFont := efCSS;
    RFE_GehNebKoP.Font.Charset := ANSI_CHARSET;
    RFE_GehNebKoP.Font.Color := clWindowText;
    RFE_GehNebKoP.Font.Height := -24;
    RFE_GehNebKoP.Font.Name := 'Segoe UI';
    RFE_GehNebKoP.Font.Style := [fsBold];
    RFE_GehNebKoP.HeightStyle := ssAuto;
    RFE_GehNebKoP.HeightPercent := 100.00000000000000000;
    RFE_GehNebKoP.ParentFont := False;
    RFE_GehNebKoP.TabOrder := 14;
    RFE_GehNebKoP.Text := ' ';
    RFE_GehNebKoP.WidthPercent := 100.00000000000000000;
    RFE_GehNebKoP.DataField := 'Hfnd_Pers_Salcost_Care';
    RFE_GehNebKoP.DataSource := PersonalDataSource;
    RFE_MaxUeberP.SetParentComponent(pnPersonalDaten);
    RFE_MaxUeberP.Name := 'RFE_MaxUeberP';
    RFE_MaxUeberP.Left := 663;
    RFE_MaxUeberP.Top := 294;
    RFE_MaxUeberP.Width := 150;
    RFE_MaxUeberP.Height := 46;
    RFE_MaxUeberP.ChildOrder := 35;
    RFE_MaxUeberP.EditType := weSignedFloat;
    RFE_MaxUeberP.ElementFont := efCSS;
    RFE_MaxUeberP.Font.Charset := ANSI_CHARSET;
    RFE_MaxUeberP.Font.Color := clWindowText;
    RFE_MaxUeberP.Font.Height := -24;
    RFE_MaxUeberP.Font.Name := 'Segoe UI';
    RFE_MaxUeberP.Font.Style := [fsBold];
    RFE_MaxUeberP.HeightStyle := ssAuto;
    RFE_MaxUeberP.HeightPercent := 100.00000000000000000;
    RFE_MaxUeberP.ParentFont := False;
    RFE_MaxUeberP.TabOrder := 15;
    RFE_MaxUeberP.Text := ' ';
    RFE_MaxUeberP.WidthPercent := 100.00000000000000000;
    RFE_MaxUeberP.DataField := 'Hfnd_Pers_Otime_Care';
    RFE_MaxUeberP.DataSource := PersonalDataSource;
    RFE_UeZuschlP.SetParentComponent(pnPersonalDaten);
    RFE_UeZuschlP.Name := 'RFE_UeZuschlP';
    RFE_UeZuschlP.Left := 662;
    RFE_UeZuschlP.Top := 347;
    RFE_UeZuschlP.Width := 150;
    RFE_UeZuschlP.Height := 46;
    RFE_UeZuschlP.ChildOrder := 36;
    RFE_UeZuschlP.EditType := weSignedFloat;
    RFE_UeZuschlP.ElementFont := efCSS;
    RFE_UeZuschlP.Font.Charset := ANSI_CHARSET;
    RFE_UeZuschlP.Font.Color := clWindowText;
    RFE_UeZuschlP.Font.Height := -24;
    RFE_UeZuschlP.Font.Name := 'Segoe UI';
    RFE_UeZuschlP.Font.Style := [fsBold];
    RFE_UeZuschlP.HeightStyle := ssAuto;
    RFE_UeZuschlP.HeightPercent := 100.00000000000000000;
    RFE_UeZuschlP.ParentFont := False;
    RFE_UeZuschlP.TabOrder := 16;
    RFE_UeZuschlP.Text := ' ';
    RFE_UeZuschlP.WidthPercent := 100.00000000000000000;
    RFE_UeZuschlP.DataField := 'Hfnd_Pers_Otimepay_Care';
    RFE_UeZuschlP.DataSource := PersonalDataSource;
    RFE_EinstlKoP.SetParentComponent(pnPersonalDaten);
    RFE_EinstlKoP.Name := 'RFE_EinstlKoP';
    RFE_EinstlKoP.Left := 660;
    RFE_EinstlKoP.Top := 399;
    RFE_EinstlKoP.Width := 150;
    RFE_EinstlKoP.Height := 46;
    RFE_EinstlKoP.ChildOrder := 37;
    RFE_EinstlKoP.EditType := weSignedFloat;
    RFE_EinstlKoP.ElementFont := efCSS;
    RFE_EinstlKoP.Font.Charset := ANSI_CHARSET;
    RFE_EinstlKoP.Font.Color := clWindowText;
    RFE_EinstlKoP.Font.Height := -24;
    RFE_EinstlKoP.Font.Name := 'Segoe UI';
    RFE_EinstlKoP.Font.Style := [fsBold];
    RFE_EinstlKoP.HeightStyle := ssAuto;
    RFE_EinstlKoP.HeightPercent := 100.00000000000000000;
    RFE_EinstlKoP.ParentFont := False;
    RFE_EinstlKoP.TabOrder := 17;
    RFE_EinstlKoP.Text := ' ';
    RFE_EinstlKoP.WidthPercent := 100.00000000000000000;
    RFE_EinstlKoP.DataField := 'Hfnd_Pers_Recruit_Care';
    RFE_EinstlKoP.DataSource := PersonalDataSource;
    RFE_EntlasKoP.SetParentComponent(pnPersonalDaten);
    RFE_EntlasKoP.Name := 'RFE_EntlasKoP';
    RFE_EntlasKoP.Left := 660;
    RFE_EntlasKoP.Top := 451;
    RFE_EntlasKoP.Width := 150;
    RFE_EntlasKoP.Height := 46;
    RFE_EntlasKoP.ChildOrder := 38;
    RFE_EntlasKoP.EditType := weSignedFloat;
    RFE_EntlasKoP.ElementFont := efCSS;
    RFE_EntlasKoP.Font.Charset := ANSI_CHARSET;
    RFE_EntlasKoP.Font.Color := clWindowText;
    RFE_EntlasKoP.Font.Height := -24;
    RFE_EntlasKoP.Font.Name := 'Segoe UI';
    RFE_EntlasKoP.Font.Style := [fsBold];
    RFE_EntlasKoP.HeightStyle := ssAuto;
    RFE_EntlasKoP.HeightPercent := 100.00000000000000000;
    RFE_EntlasKoP.ParentFont := False;
    RFE_EntlasKoP.TabOrder := 18;
    RFE_EntlasKoP.Text := ' ';
    RFE_EntlasKoP.WidthPercent := 100.00000000000000000;
    RFE_EntlasKoP.DataField := 'Hfnd_Pers_Dismiss_Care';
    RFE_EntlasKoP.DataSource := PersonalDataSource;
    RFE_MaxEinstP.SetParentComponent(pnPersonalDaten);
    RFE_MaxEinstP.Name := 'RFE_MaxEinstP';
    RFE_MaxEinstP.Left := 660;
    RFE_MaxEinstP.Top := 504;
    RFE_MaxEinstP.Width := 150;
    RFE_MaxEinstP.Height := 46;
    RFE_MaxEinstP.ChildOrder := 39;
    RFE_MaxEinstP.EditType := weSignedFloat;
    RFE_MaxEinstP.ElementFont := efCSS;
    RFE_MaxEinstP.Font.Charset := ANSI_CHARSET;
    RFE_MaxEinstP.Font.Color := clWindowText;
    RFE_MaxEinstP.Font.Height := -24;
    RFE_MaxEinstP.Font.Name := 'Segoe UI';
    RFE_MaxEinstP.Font.Style := [fsBold];
    RFE_MaxEinstP.HeightStyle := ssAuto;
    RFE_MaxEinstP.HeightPercent := 100.00000000000000000;
    RFE_MaxEinstP.ParentFont := False;
    RFE_MaxEinstP.TabOrder := 19;
    RFE_MaxEinstP.Text := ' ';
    RFE_MaxEinstP.WidthPercent := 100.00000000000000000;
    RFE_MaxEinstP.DataField := 'Hfnd_Pers_Maxrecruit_Care';
    RFE_MaxEinstP.DataSource := PersonalDataSource;
    RFE_MaxEntlaP.SetParentComponent(pnPersonalDaten);
    RFE_MaxEntlaP.Name := 'RFE_MaxEntlaP';
    RFE_MaxEntlaP.Left := 660;
    RFE_MaxEntlaP.Top := 556;
    RFE_MaxEntlaP.Width := 150;
    RFE_MaxEntlaP.Height := 46;
    RFE_MaxEntlaP.ChildOrder := 40;
    RFE_MaxEntlaP.EditType := weSignedFloat;
    RFE_MaxEntlaP.ElementFont := efCSS;
    RFE_MaxEntlaP.Font.Charset := ANSI_CHARSET;
    RFE_MaxEntlaP.Font.Color := clWindowText;
    RFE_MaxEntlaP.Font.Height := -24;
    RFE_MaxEntlaP.Font.Name := 'Segoe UI';
    RFE_MaxEntlaP.Font.Style := [fsBold];
    RFE_MaxEntlaP.HeightStyle := ssAuto;
    RFE_MaxEntlaP.HeightPercent := 100.00000000000000000;
    RFE_MaxEntlaP.ParentFont := False;
    RFE_MaxEntlaP.TabOrder := 20;
    RFE_MaxEntlaP.Text := ' ';
    RFE_MaxEntlaP.WidthPercent := 100.00000000000000000;
    RFE_MaxEntlaP.DataField := 'Hfnd_Pers_Maxdismiss_Care';
    RFE_MaxEntlaP.DataSource := PersonalDataSource;
    RFE_TrainKstP.SetParentComponent(pnPersonalDaten);
    RFE_TrainKstP.Name := 'RFE_TrainKstP';
    RFE_TrainKstP.Left := 659;
    RFE_TrainKstP.Top := 608;
    RFE_TrainKstP.Width := 150;
    RFE_TrainKstP.Height := 46;
    RFE_TrainKstP.ChildOrder := 41;
    RFE_TrainKstP.EditType := weSignedFloat;
    RFE_TrainKstP.ElementFont := efCSS;
    RFE_TrainKstP.Font.Charset := ANSI_CHARSET;
    RFE_TrainKstP.Font.Color := clWindowText;
    RFE_TrainKstP.Font.Height := -24;
    RFE_TrainKstP.Font.Name := 'Segoe UI';
    RFE_TrainKstP.Font.Style := [fsBold];
    RFE_TrainKstP.HeightStyle := ssAuto;
    RFE_TrainKstP.HeightPercent := 100.00000000000000000;
    RFE_TrainKstP.ParentFont := False;
    RFE_TrainKstP.TabOrder := 21;
    RFE_TrainKstP.Text := ' ';
    RFE_TrainKstP.WidthPercent := 100.00000000000000000;
    RFE_TrainKstP.DataField := 'Hfnd_Pers_Training_Care';
    RFE_TrainKstP.DataSource := PersonalDataSource;
    RFE_FremdPKoP.SetParentComponent(pnPersonalDaten);
    RFE_FremdPKoP.Name := 'RFE_FremdPKoP';
    RFE_FremdPKoP.Left := 658;
    RFE_FremdPKoP.Top := 661;
    RFE_FremdPKoP.Width := 150;
    RFE_FremdPKoP.Height := 46;
    RFE_FremdPKoP.ChildOrder := 42;
    RFE_FremdPKoP.EditType := weSignedFloat;
    RFE_FremdPKoP.ElementFont := efCSS;
    RFE_FremdPKoP.Font.Charset := ANSI_CHARSET;
    RFE_FremdPKoP.Font.Color := clWindowText;
    RFE_FremdPKoP.Font.Height := -24;
    RFE_FremdPKoP.Font.Name := 'Segoe UI';
    RFE_FremdPKoP.Font.Style := [fsBold];
    RFE_FremdPKoP.HeightStyle := ssAuto;
    RFE_FremdPKoP.HeightPercent := 100.00000000000000000;
    RFE_FremdPKoP.ParentFont := False;
    RFE_FremdPKoP.TabOrder := 22;
    RFE_FremdPKoP.Text := ' ';
    RFE_FremdPKoP.WidthPercent := 100.00000000000000000;
    RFE_FremdPKoP.DataField := 'Hfnd_Pers_External_Care';
    RFE_FremdPKoP.DataSource := PersonalDataSource;
    LFE_ArbZeitM.SetParentComponent(pnPersonalDaten);
    LFE_ArbZeitM.Name := 'LFE_ArbZeitM';
    LFE_ArbZeitM.Left := 832;
    LFE_ArbZeitM.Top := 138;
    LFE_ArbZeitM.Width := 150;
    LFE_ArbZeitM.Height := 46;
    LFE_ArbZeitM.ChildOrder := 43;
    LFE_ArbZeitM.EditType := weSignedFloat;
    LFE_ArbZeitM.ElementFont := efCSS;
    LFE_ArbZeitM.Font.Charset := ANSI_CHARSET;
    LFE_ArbZeitM.Font.Color := clWindowText;
    LFE_ArbZeitM.Font.Height := -24;
    LFE_ArbZeitM.Font.Name := 'Segoe UI';
    LFE_ArbZeitM.Font.Style := [fsBold];
    LFE_ArbZeitM.HeightStyle := ssAuto;
    LFE_ArbZeitM.HeightPercent := 100.00000000000000000;
    LFE_ArbZeitM.ParentFont := False;
    LFE_ArbZeitM.TabOrder := 23;
    LFE_ArbZeitM.Text := ' ';
    LFE_ArbZeitM.WidthPercent := 100.00000000000000000;
    LFE_ArbZeitM.DataField := 'Hfnd_Pers_Whours_Institut';
    LFE_ArbZeitM.DataSource := PersonalDataSource;
    RFE_StdSatzM.SetParentComponent(pnPersonalDaten);
    RFE_StdSatzM.Name := 'RFE_StdSatzM';
    RFE_StdSatzM.Left := 831;
    RFE_StdSatzM.Top := 190;
    RFE_StdSatzM.Width := 150;
    RFE_StdSatzM.Height := 46;
    RFE_StdSatzM.ChildOrder := 44;
    RFE_StdSatzM.EditType := weSignedFloat;
    RFE_StdSatzM.ElementFont := efCSS;
    RFE_StdSatzM.Font.Charset := ANSI_CHARSET;
    RFE_StdSatzM.Font.Color := clWindowText;
    RFE_StdSatzM.Font.Height := -24;
    RFE_StdSatzM.Font.Name := 'Segoe UI';
    RFE_StdSatzM.Font.Style := [fsBold];
    RFE_StdSatzM.HeightStyle := ssAuto;
    RFE_StdSatzM.HeightPercent := 100.00000000000000000;
    RFE_StdSatzM.ParentFont := False;
    RFE_StdSatzM.TabOrder := 24;
    RFE_StdSatzM.Text := ' ';
    RFE_StdSatzM.WidthPercent := 100.00000000000000000;
    RFE_StdSatzM.DataField := 'Hfnd_Pers_Hrate_Institut';
    RFE_StdSatzM.DataSource := PersonalDataSource;
    RFE_GehNebKoM.SetParentComponent(pnPersonalDaten);
    RFE_GehNebKoM.Name := 'RFE_GehNebKoM';
    RFE_GehNebKoM.Left := 831;
    RFE_GehNebKoM.Top := 242;
    RFE_GehNebKoM.Width := 150;
    RFE_GehNebKoM.Height := 46;
    RFE_GehNebKoM.ChildOrder := 45;
    RFE_GehNebKoM.EditType := weSignedFloat;
    RFE_GehNebKoM.ElementFont := efCSS;
    RFE_GehNebKoM.Font.Charset := ANSI_CHARSET;
    RFE_GehNebKoM.Font.Color := clWindowText;
    RFE_GehNebKoM.Font.Height := -24;
    RFE_GehNebKoM.Font.Name := 'Segoe UI';
    RFE_GehNebKoM.Font.Style := [fsBold];
    RFE_GehNebKoM.HeightStyle := ssAuto;
    RFE_GehNebKoM.HeightPercent := 100.00000000000000000;
    RFE_GehNebKoM.ParentFont := False;
    RFE_GehNebKoM.TabOrder := 25;
    RFE_GehNebKoM.Text := ' ';
    RFE_GehNebKoM.WidthPercent := 100.00000000000000000;
    RFE_GehNebKoM.DataField := 'Hfnd_Pers_Salcost_Institut';
    RFE_GehNebKoM.DataSource := PersonalDataSource;
    RFE_MaxUeberM.SetParentComponent(pnPersonalDaten);
    RFE_MaxUeberM.Name := 'RFE_MaxUeberM';
    RFE_MaxUeberM.Left := 831;
    RFE_MaxUeberM.Top := 294;
    RFE_MaxUeberM.Width := 150;
    RFE_MaxUeberM.Height := 46;
    RFE_MaxUeberM.ChildOrder := 46;
    RFE_MaxUeberM.EditType := weSignedFloat;
    RFE_MaxUeberM.ElementFont := efCSS;
    RFE_MaxUeberM.Font.Charset := ANSI_CHARSET;
    RFE_MaxUeberM.Font.Color := clWindowText;
    RFE_MaxUeberM.Font.Height := -24;
    RFE_MaxUeberM.Font.Name := 'Segoe UI';
    RFE_MaxUeberM.Font.Style := [fsBold];
    RFE_MaxUeberM.HeightStyle := ssAuto;
    RFE_MaxUeberM.HeightPercent := 100.00000000000000000;
    RFE_MaxUeberM.ParentFont := False;
    RFE_MaxUeberM.TabOrder := 26;
    RFE_MaxUeberM.Text := ' ';
    RFE_MaxUeberM.WidthPercent := 100.00000000000000000;
    RFE_MaxUeberM.DataField := 'Hfnd_Pers_Otime_Institut';
    RFE_MaxUeberM.DataSource := PersonalDataSource;
    RFE_UeZuschlM.SetParentComponent(pnPersonalDaten);
    RFE_UeZuschlM.Name := 'RFE_UeZuschlM';
    RFE_UeZuschlM.Left := 828;
    RFE_UeZuschlM.Top := 346;
    RFE_UeZuschlM.Width := 150;
    RFE_UeZuschlM.Height := 46;
    RFE_UeZuschlM.ChildOrder := 47;
    RFE_UeZuschlM.EditType := weSignedFloat;
    RFE_UeZuschlM.ElementFont := efCSS;
    RFE_UeZuschlM.Font.Charset := ANSI_CHARSET;
    RFE_UeZuschlM.Font.Color := clWindowText;
    RFE_UeZuschlM.Font.Height := -24;
    RFE_UeZuschlM.Font.Name := 'Segoe UI';
    RFE_UeZuschlM.Font.Style := [fsBold];
    RFE_UeZuschlM.HeightStyle := ssAuto;
    RFE_UeZuschlM.HeightPercent := 100.00000000000000000;
    RFE_UeZuschlM.ParentFont := False;
    RFE_UeZuschlM.TabOrder := 27;
    RFE_UeZuschlM.Text := ' ';
    RFE_UeZuschlM.WidthPercent := 100.00000000000000000;
    RFE_UeZuschlM.DataField := 'Hfnd_Pers_Otimepay_Institut';
    RFE_UeZuschlM.DataSource := PersonalDataSource;
    RFE_EinstlKoM.SetParentComponent(pnPersonalDaten);
    RFE_EinstlKoM.Name := 'RFE_EinstlKoM';
    RFE_EinstlKoM.Left := 831;
    RFE_EinstlKoM.Top := 398;
    RFE_EinstlKoM.Width := 150;
    RFE_EinstlKoM.Height := 46;
    RFE_EinstlKoM.ChildOrder := 48;
    RFE_EinstlKoM.EditType := weSignedFloat;
    RFE_EinstlKoM.ElementFont := efCSS;
    RFE_EinstlKoM.Font.Charset := ANSI_CHARSET;
    RFE_EinstlKoM.Font.Color := clWindowText;
    RFE_EinstlKoM.Font.Height := -24;
    RFE_EinstlKoM.Font.Name := 'Segoe UI';
    RFE_EinstlKoM.Font.Style := [fsBold];
    RFE_EinstlKoM.HeightStyle := ssAuto;
    RFE_EinstlKoM.HeightPercent := 100.00000000000000000;
    RFE_EinstlKoM.ParentFont := False;
    RFE_EinstlKoM.TabOrder := 28;
    RFE_EinstlKoM.Text := ' ';
    RFE_EinstlKoM.WidthPercent := 100.00000000000000000;
    RFE_EinstlKoM.DataField := 'Hfnd_Pers_Recruit_Institut';
    RFE_EinstlKoM.DataSource := PersonalDataSource;
    RFE_EntlasKoM.SetParentComponent(pnPersonalDaten);
    RFE_EntlasKoM.Name := 'RFE_EntlasKoM';
    RFE_EntlasKoM.Left := 831;
    RFE_EntlasKoM.Top := 450;
    RFE_EntlasKoM.Width := 150;
    RFE_EntlasKoM.Height := 46;
    RFE_EntlasKoM.ChildOrder := 49;
    RFE_EntlasKoM.EditType := weSignedFloat;
    RFE_EntlasKoM.ElementFont := efCSS;
    RFE_EntlasKoM.Font.Charset := ANSI_CHARSET;
    RFE_EntlasKoM.Font.Color := clWindowText;
    RFE_EntlasKoM.Font.Height := -24;
    RFE_EntlasKoM.Font.Name := 'Segoe UI';
    RFE_EntlasKoM.Font.Style := [fsBold];
    RFE_EntlasKoM.HeightStyle := ssAuto;
    RFE_EntlasKoM.HeightPercent := 100.00000000000000000;
    RFE_EntlasKoM.ParentFont := False;
    RFE_EntlasKoM.TabOrder := 29;
    RFE_EntlasKoM.Text := ' ';
    RFE_EntlasKoM.WidthPercent := 100.00000000000000000;
    RFE_EntlasKoM.DataField := 'Hfnd_Pers_Dismiss_Institut';
    RFE_EntlasKoM.DataSource := PersonalDataSource;
    RFE_MaxEinstM.SetParentComponent(pnPersonalDaten);
    RFE_MaxEinstM.Name := 'RFE_MaxEinstM';
    RFE_MaxEinstM.Left := 831;
    RFE_MaxEinstM.Top := 502;
    RFE_MaxEinstM.Width := 150;
    RFE_MaxEinstM.Height := 46;
    RFE_MaxEinstM.ChildOrder := 50;
    RFE_MaxEinstM.EditType := weSignedFloat;
    RFE_MaxEinstM.ElementFont := efCSS;
    RFE_MaxEinstM.Font.Charset := ANSI_CHARSET;
    RFE_MaxEinstM.Font.Color := clWindowText;
    RFE_MaxEinstM.Font.Height := -24;
    RFE_MaxEinstM.Font.Name := 'Segoe UI';
    RFE_MaxEinstM.Font.Style := [fsBold];
    RFE_MaxEinstM.HeightStyle := ssAuto;
    RFE_MaxEinstM.HeightPercent := 100.00000000000000000;
    RFE_MaxEinstM.ParentFont := False;
    RFE_MaxEinstM.TabOrder := 30;
    RFE_MaxEinstM.Text := ' ';
    RFE_MaxEinstM.WidthPercent := 100.00000000000000000;
    RFE_MaxEinstM.DataField := 'Hfnd_Pers_Maxrecruit_Institut';
    RFE_MaxEinstM.DataSource := PersonalDataSource;
    RFE_MaxEntlaM.SetParentComponent(pnPersonalDaten);
    RFE_MaxEntlaM.Name := 'RFE_MaxEntlaM';
    RFE_MaxEntlaM.Left := 831;
    RFE_MaxEntlaM.Top := 554;
    RFE_MaxEntlaM.Width := 150;
    RFE_MaxEntlaM.Height := 46;
    RFE_MaxEntlaM.ChildOrder := 51;
    RFE_MaxEntlaM.EditType := weSignedFloat;
    RFE_MaxEntlaM.ElementFont := efCSS;
    RFE_MaxEntlaM.Font.Charset := ANSI_CHARSET;
    RFE_MaxEntlaM.Font.Color := clWindowText;
    RFE_MaxEntlaM.Font.Height := -24;
    RFE_MaxEntlaM.Font.Name := 'Segoe UI';
    RFE_MaxEntlaM.Font.Style := [fsBold];
    RFE_MaxEntlaM.HeightStyle := ssAuto;
    RFE_MaxEntlaM.HeightPercent := 100.00000000000000000;
    RFE_MaxEntlaM.ParentFont := False;
    RFE_MaxEntlaM.TabOrder := 31;
    RFE_MaxEntlaM.Text := ' ';
    RFE_MaxEntlaM.WidthPercent := 100.00000000000000000;
    RFE_MaxEntlaM.DataField := 'Hfnd_Pers_Maxdismiss_Institut';
    RFE_MaxEntlaM.DataSource := PersonalDataSource;
    RFE_TrainKstM.SetParentComponent(pnPersonalDaten);
    RFE_TrainKstM.Name := 'RFE_TrainKstM';
    RFE_TrainKstM.Left := 831;
    RFE_TrainKstM.Top := 606;
    RFE_TrainKstM.Width := 150;
    RFE_TrainKstM.Height := 46;
    RFE_TrainKstM.ChildOrder := 52;
    RFE_TrainKstM.EditType := weSignedFloat;
    RFE_TrainKstM.ElementFont := efCSS;
    RFE_TrainKstM.Font.Charset := ANSI_CHARSET;
    RFE_TrainKstM.Font.Color := clWindowText;
    RFE_TrainKstM.Font.Height := -24;
    RFE_TrainKstM.Font.Name := 'Segoe UI';
    RFE_TrainKstM.Font.Style := [fsBold];
    RFE_TrainKstM.HeightStyle := ssAuto;
    RFE_TrainKstM.HeightPercent := 100.00000000000000000;
    RFE_TrainKstM.ParentFont := False;
    RFE_TrainKstM.TabOrder := 32;
    RFE_TrainKstM.Text := ' ';
    RFE_TrainKstM.WidthPercent := 100.00000000000000000;
    RFE_TrainKstM.DataField := 'Hfnd_Pers_Training_Institut';
    RFE_TrainKstM.DataSource := PersonalDataSource;
    RFE_FremdPKoM.SetParentComponent(pnPersonalDaten);
    RFE_FremdPKoM.Name := 'RFE_FremdPKoM';
    RFE_FremdPKoM.Left := 831;
    RFE_FremdPKoM.Top := 658;
    RFE_FremdPKoM.Width := 150;
    RFE_FremdPKoM.Height := 46;
    RFE_FremdPKoM.ChildOrder := 53;
    RFE_FremdPKoM.EditType := weSignedFloat;
    RFE_FremdPKoM.ElementFont := efCSS;
    RFE_FremdPKoM.Font.Charset := ANSI_CHARSET;
    RFE_FremdPKoM.Font.Color := clWindowText;
    RFE_FremdPKoM.Font.Height := -24;
    RFE_FremdPKoM.Font.Name := 'Segoe UI';
    RFE_FremdPKoM.Font.Style := [fsBold];
    RFE_FremdPKoM.HeightStyle := ssAuto;
    RFE_FremdPKoM.HeightPercent := 100.00000000000000000;
    RFE_FremdPKoM.ParentFont := False;
    RFE_FremdPKoM.TabOrder := 33;
    RFE_FremdPKoM.Text := ' ';
    RFE_FremdPKoM.WidthPercent := 100.00000000000000000;
    RFE_FremdPKoM.DataField := 'Hfnd_Pers_External_Institut';
    RFE_FremdPKoM.DataSource := PersonalDataSource;
    RFE_GehDirek.SetParentComponent(pnPersonalDaten);
    RFE_GehDirek.Name := 'RFE_GehDirek';
    RFE_GehDirek.Left := 488;
    RFE_GehDirek.Top := 791;
    RFE_GehDirek.Width := 150;
    RFE_GehDirek.Height := 46;
    RFE_GehDirek.ChildOrder := 54;
    RFE_GehDirek.EditType := weSignedFloat;
    RFE_GehDirek.ElementFont := efCSS;
    RFE_GehDirek.Font.Charset := ANSI_CHARSET;
    RFE_GehDirek.Font.Color := clWindowText;
    RFE_GehDirek.Font.Height := -24;
    RFE_GehDirek.Font.Name := 'Segoe UI';
    RFE_GehDirek.Font.Style := [fsBold];
    RFE_GehDirek.HeightStyle := ssAuto;
    RFE_GehDirek.HeightPercent := 100.00000000000000000;
    RFE_GehDirek.ParentFont := False;
    RFE_GehDirek.TabOrder := 34;
    RFE_GehDirek.Text := ' ';
    RFE_GehDirek.WidthPercent := 100.00000000000000000;
    RFE_GehDirek.DataField := 'Hfnd_Management_Salary';
    RFE_GehDirek.DataSource := PersonalDataSource;
    RFE_Rueckst.SetParentComponent(pnPersonalDaten);
    RFE_Rueckst.Name := 'RFE_Rueckst';
    RFE_Rueckst.Left := 488;
    RFE_Rueckst.Top := 872;
    RFE_Rueckst.Width := 150;
    RFE_Rueckst.Height := 46;
    RFE_Rueckst.ChildOrder := 55;
    RFE_Rueckst.EditType := weSignedFloat;
    RFE_Rueckst.ElementFont := efCSS;
    RFE_Rueckst.Font.Charset := ANSI_CHARSET;
    RFE_Rueckst.Font.Color := clWindowText;
    RFE_Rueckst.Font.Height := -24;
    RFE_Rueckst.Font.Name := 'Segoe UI';
    RFE_Rueckst.Font.Style := [fsBold];
    RFE_Rueckst.HeightStyle := ssAuto;
    RFE_Rueckst.HeightPercent := 100.00000000000000000;
    RFE_Rueckst.ParentFont := False;
    RFE_Rueckst.TabOrder := 35;
    RFE_Rueckst.Text := ' ';
    RFE_Rueckst.WidthPercent := 100.00000000000000000;
    RFE_Rueckst.DataField := 'Hfnd_Pension_Provision';
    RFE_Rueckst.DataSource := PersonalDataSource;
    RFE_AbFktGN.SetParentComponent(pnPersonalDaten);
    RFE_AbFktGN.Name := 'RFE_AbFktGN';
    RFE_AbFktGN.Left := 1007;
    RFE_AbFktGN.Top := 871;
    RFE_AbFktGN.Width := 150;
    RFE_AbFktGN.Height := 46;
    RFE_AbFktGN.ChildOrder := 56;
    RFE_AbFktGN.EditType := weSignedFloat;
    RFE_AbFktGN.ElementFont := efCSS;
    RFE_AbFktGN.Font.Charset := ANSI_CHARSET;
    RFE_AbFktGN.Font.Color := clWindowText;
    RFE_AbFktGN.Font.Height := -24;
    RFE_AbFktGN.Font.Name := 'Segoe UI';
    RFE_AbFktGN.Font.Style := [fsBold];
    RFE_AbFktGN.HeightStyle := ssAuto;
    RFE_AbFktGN.HeightPercent := 100.00000000000000000;
    RFE_AbFktGN.ParentFont := False;
    RFE_AbFktGN.TabOrder := 36;
    RFE_AbFktGN.Text := ' ';
    RFE_AbFktGN.WidthPercent := 100.00000000000000000;
    RFE_AbFktGN.DataField := 'Hfnd_Salary_Sidecosts';
    RFE_AbFktGN.DataSource := PersonalDataSource;
    RFE_AnGZeit.SetParentComponent(pnPersonalDaten);
    RFE_AnGZeit.Name := 'RFE_AnGZeit';
    RFE_AnGZeit.Left := 488;
    RFE_AnGZeit.Top := 931;
    RFE_AnGZeit.Width := 150;
    RFE_AnGZeit.Height := 46;
    RFE_AnGZeit.ChildOrder := 57;
    RFE_AnGZeit.EditType := weSignedFloat;
    RFE_AnGZeit.ElementFont := efCSS;
    RFE_AnGZeit.Font.Charset := ANSI_CHARSET;
    RFE_AnGZeit.Font.Color := clWindowText;
    RFE_AnGZeit.Font.Height := -24;
    RFE_AnGZeit.Font.Name := 'Segoe UI';
    RFE_AnGZeit.Font.Style := [fsBold];
    RFE_AnGZeit.HeightStyle := ssAuto;
    RFE_AnGZeit.HeightPercent := 100.00000000000000000;
    RFE_AnGZeit.ParentFont := False;
    RFE_AnGZeit.TabOrder := 37;
    RFE_AnGZeit.Text := ' ';
    RFE_AnGZeit.WidthPercent := 100.00000000000000000;
    RFE_AnGZeit.DataField := 'Hfnd_Coding_Time_Saved';
    RFE_AnGZeit.DataSource := PersonalDataSource;
    pnFinanzdaten.SetParentComponent(pgSeite4);
    pnFinanzdaten.Name := 'pnFinanzdaten';
    pnFinanzdaten.Left := 1138;
    pnFinanzdaten.Top := 146;
    pnFinanzdaten.Width := 930;
    pnFinanzdaten.Height := 635;
    pnFinanzdaten.HeightStyle := ssAuto;
    pnFinanzdaten.WidthStyle := ssAuto;
    pnFinanzdaten.BorderStyle := bsNone;
    pnFinanzdaten.Caption := 'pnFinanzdaten';
    pnFinanzdaten.ChildOrder := 1;
    pnFinanzdaten.ElementFont := efCSS;
    pnFinanzdaten.ShowCaption := False;
    pnFinanzdaten.TabOrder := 1;
    WebLabel1.SetParentComponent(pnFinanzdaten);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 4;
    WebLabel1.Top := 35;
    WebLabel1.Width := 420;
    WebLabel1.Height := 29;
    WebLabel1.Anchors := [];
    WebLabel1.Caption := 'Zinssatz f. '#220'berziehungskredit (%)';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -24;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnFinanzdaten);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 3;
    WebLabel2.Top := 77;
    WebLabel2.Width := 425;
    WebLabel2.Height := 29;
    WebLabel2.Anchors := [];
    WebLabel2.Caption := 'Zinssatz f. kurzfristigen Kredit  (%)';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -24;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.00000000000000000;
    WebLabel3.SetParentComponent(pnFinanzdaten);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 122;
    WebLabel3.Width := 437;
    WebLabel3.Height := 29;
    WebLabel3.Anchors := [];
    WebLabel3.Caption := 'Zinssatz f. mittelfristigen Kredit (%)';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -24;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.00000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.00000000000000000;
    WebLabel4.SetParentComponent(pnFinanzdaten);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 10;
    WebLabel4.Top := 176;
    WebLabel4.Width := 352;
    WebLabel4.Height := 29;
    WebLabel4.Anchors := [];
    WebLabel4.Caption := 'Zinssatz f'#252'r Geldanlagen (%)';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -24;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.00000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.00000000000000000;
    WebLabel17.SetParentComponent(pnFinanzdaten);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 22;
    WebLabel17.Top := 221;
    WebLabel17.Width := 207;
    WebLabel17.Height := 29;
    WebLabel17.Anchors := [];
    WebLabel17.Caption := 'Steuersatz 1 (%)';
    WebLabel17.ElementFont := efCSS;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -24;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightStyle := ssAuto;
    WebLabel17.HeightPercent := 100.00000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.WidthPercent := 100.00000000000000000;
    WebLabel18.SetParentComponent(pnFinanzdaten);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 18;
    WebLabel18.Top := 274;
    WebLabel18.Width := 207;
    WebLabel18.Height := 29;
    WebLabel18.Anchors := [];
    WebLabel18.Caption := 'Steuersatz 2 (%)';
    WebLabel18.ElementFont := efCSS;
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -24;
    WebLabel18.Font.Name := 'Tahoma';
    WebLabel18.Font.Style := [fsBold];
    WebLabel18.HeightStyle := ssAuto;
    WebLabel18.HeightPercent := 100.00000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.WidthPercent := 100.00000000000000000;
    WebLabel19.SetParentComponent(pnFinanzdaten);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := -1;
    WebLabel19.Top := 320;
    WebLabel19.Width := 369;
    WebLabel19.Height := 29;
    WebLabel19.Anchors := [];
    WebLabel19.Caption := 'Kassenmindestbestand (TEUR)';
    WebLabel19.ElementFont := efCSS;
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -24;
    WebLabel19.Font.Name := 'Tahoma';
    WebLabel19.Font.Style := [fsBold];
    WebLabel19.HeightStyle := ssAuto;
    WebLabel19.HeightPercent := 100.00000000000000000;
    WebLabel19.ParentFont := False;
    WebLabel19.WidthPercent := 100.00000000000000000;
    WebLabel28.SetParentComponent(pnFinanzdaten);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 8;
    WebLabel28.Top := 365;
    WebLabel28.Width := 339;
    WebLabel28.Height := 29;
    WebLabel28.Anchors := [];
    WebLabel28.Caption := 'F'#246'rderbetrag pro Bett (EUR)';
    WebLabel28.ElementFont := efCSS;
    WebLabel28.Font.Charset := DEFAULT_CHARSET;
    WebLabel28.Font.Color := clWindowText;
    WebLabel28.Font.Height := -24;
    WebLabel28.Font.Name := 'Tahoma';
    WebLabel28.Font.Style := [fsBold];
    WebLabel28.HeightStyle := ssAuto;
    WebLabel28.HeightPercent := 100.00000000000000000;
    WebLabel28.ParentFont := False;
    WebLabel28.WidthPercent := 100.00000000000000000;
    WebLabel29.SetParentComponent(pnFinanzdaten);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 24;
    WebLabel29.Top := 412;
    WebLabel29.Width := 122;
    WebLabel29.Height := 29;
    WebLabel29.Anchors := [];
    WebLabel29.Caption := 'Sonstiges ';
    WebLabel29.ElementFont := efCSS;
    WebLabel29.Font.Charset := DEFAULT_CHARSET;
    WebLabel29.Font.Color := clWindowText;
    WebLabel29.Font.Height := -24;
    WebLabel29.Font.Name := 'Tahoma';
    WebLabel29.Font.Style := [fsBold];
    WebLabel29.HeightStyle := ssAuto;
    WebLabel29.HeightPercent := 100.00000000000000000;
    WebLabel29.ParentFont := False;
    WebLabel29.WidthPercent := 100.00000000000000000;
    WebLabel38.SetParentComponent(pnFinanzdaten);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 64;
    WebLabel38.Top := 16;
    WebLabel38.Width := 78;
    WebLabel38.Height := 18;
    WebLabel38.Caption := 'Finanzdaten';
    WebLabel38.ElementFont := efCSS;
    WebLabel38.ElementPosition := epRelative;
    WebLabel38.HeightStyle := ssAuto;
    WebLabel38.HeightPercent := 100.00000000000000000;
    WebLabel38.HTMLType := tH3;
    WebLabel38.WidthPercent := 100.00000000000000000;
    RFE_ZinsUeberz.SetParentComponent(pnFinanzdaten);
    RFE_ZinsUeberz.Name := 'RFE_ZinsUeberz';
    RFE_ZinsUeberz.Left := 468;
    RFE_ZinsUeberz.Top := 20;
    RFE_ZinsUeberz.Width := 150;
    RFE_ZinsUeberz.Height := 46;
    RFE_ZinsUeberz.Alignment := taRightJustify;
    RFE_ZinsUeberz.Anchors := [];
    RFE_ZinsUeberz.ChildOrder := 1;
    RFE_ZinsUeberz.EditType := weSignedFloat;
    RFE_ZinsUeberz.ElementFont := efCSS;
    RFE_ZinsUeberz.HeightStyle := ssAuto;
    RFE_ZinsUeberz.HeightPercent := 100.00000000000000000;
    RFE_ZinsUeberz.Text := '0,00';
    RFE_ZinsUeberz.WidthPercent := 100.00000000000000000;
    RFE_ZinsUeberz.DataField := 'Hfnd_Interest_Rate_Overdraft';
    RFE_ZinsUeberz.DataSource := PersonalDataSource;
    RFE_ZinsKurzfr.SetParentComponent(pnFinanzdaten);
    RFE_ZinsKurzfr.Name := 'RFE_ZinsKurzfr';
    RFE_ZinsKurzfr.Left := 468;
    RFE_ZinsKurzfr.Top := 68;
    RFE_ZinsKurzfr.Width := 150;
    RFE_ZinsKurzfr.Height := 46;
    RFE_ZinsKurzfr.Alignment := taRightJustify;
    RFE_ZinsKurzfr.Anchors := [];
    RFE_ZinsKurzfr.ChildOrder := 3;
    RFE_ZinsKurzfr.EditType := weSignedFloat;
    RFE_ZinsKurzfr.ElementFont := efCSS;
    RFE_ZinsKurzfr.HeightStyle := ssAuto;
    RFE_ZinsKurzfr.HeightPercent := 100.00000000000000000;
    RFE_ZinsKurzfr.Text := '0,00';
    RFE_ZinsKurzfr.WidthPercent := 100.00000000000000000;
    RFE_ZinsKurzfr.DataField := 'Hfnd_Interest_Rate_Short_Credit';
    RFE_ZinsKurzfr.DataSource := PersonalDataSource;
    RFE_ZinsLangfr.SetParentComponent(pnFinanzdaten);
    RFE_ZinsLangfr.Name := 'RFE_ZinsLangfr';
    RFE_ZinsLangfr.Left := 468;
    RFE_ZinsLangfr.Top := 117;
    RFE_ZinsLangfr.Width := 150;
    RFE_ZinsLangfr.Height := 46;
    RFE_ZinsLangfr.Alignment := taRightJustify;
    RFE_ZinsLangfr.Anchors := [];
    RFE_ZinsLangfr.ChildOrder := 5;
    RFE_ZinsLangfr.EditType := weSignedFloat;
    RFE_ZinsLangfr.ElementFont := efCSS;
    RFE_ZinsLangfr.HeightStyle := ssAuto;
    RFE_ZinsLangfr.HeightPercent := 100.00000000000000000;
    RFE_ZinsLangfr.Text := '0,00';
    RFE_ZinsLangfr.WidthPercent := 100.00000000000000000;
    RFE_ZinsLangfr.DataField := 'Hfnd_Interest_Rate_Midrange_Credit';
    RFE_ZinsLangfr.DataSource := PersonalDataSource;
    RFE_ZinsAnlage.SetParentComponent(pnFinanzdaten);
    RFE_ZinsAnlage.Name := 'RFE_ZinsAnlage';
    RFE_ZinsAnlage.Left := 468;
    RFE_ZinsAnlage.Top := 168;
    RFE_ZinsAnlage.Width := 150;
    RFE_ZinsAnlage.Height := 46;
    RFE_ZinsAnlage.Alignment := taRightJustify;
    RFE_ZinsAnlage.Anchors := [];
    RFE_ZinsAnlage.ChildOrder := 7;
    RFE_ZinsAnlage.EditType := weSignedFloat;
    RFE_ZinsAnlage.ElementFont := efCSS;
    RFE_ZinsAnlage.HeightStyle := ssAuto;
    RFE_ZinsAnlage.HeightPercent := 100.00000000000000000;
    RFE_ZinsAnlage.Text := '0,00';
    RFE_ZinsAnlage.WidthPercent := 100.00000000000000000;
    RFE_ZinsAnlage.DataField := 'Hfnd_Interest_Rate_Invest';
    RFE_ZinsAnlage.DataSource := PersonalDataSource;
    RFE_SteuerSatz1.SetParentComponent(pnFinanzdaten);
    RFE_SteuerSatz1.Name := 'RFE_SteuerSatz1';
    RFE_SteuerSatz1.Left := 468;
    RFE_SteuerSatz1.Top := 217;
    RFE_SteuerSatz1.Width := 150;
    RFE_SteuerSatz1.Height := 46;
    RFE_SteuerSatz1.Alignment := taRightJustify;
    RFE_SteuerSatz1.Anchors := [];
    RFE_SteuerSatz1.ChildOrder := 9;
    RFE_SteuerSatz1.EditType := weSignedFloat;
    RFE_SteuerSatz1.ElementFont := efCSS;
    RFE_SteuerSatz1.HeightStyle := ssAuto;
    RFE_SteuerSatz1.HeightPercent := 100.00000000000000000;
    RFE_SteuerSatz1.Text := '0,00';
    RFE_SteuerSatz1.WidthPercent := 100.00000000000000000;
    RFE_SteuerSatz1.DataField := 'Hfnd_Tax_Rate1';
    RFE_SteuerSatz1.DataSource := PersonalDataSource;
    RFE_SteuerSatz2.SetParentComponent(pnFinanzdaten);
    RFE_SteuerSatz2.Name := 'RFE_SteuerSatz2';
    RFE_SteuerSatz2.Left := 468;
    RFE_SteuerSatz2.Top := 265;
    RFE_SteuerSatz2.Width := 150;
    RFE_SteuerSatz2.Height := 46;
    RFE_SteuerSatz2.Alignment := taRightJustify;
    RFE_SteuerSatz2.Anchors := [];
    RFE_SteuerSatz2.ChildOrder := 11;
    RFE_SteuerSatz2.EditType := weSignedFloat;
    RFE_SteuerSatz2.ElementFont := efCSS;
    RFE_SteuerSatz2.HeightStyle := ssAuto;
    RFE_SteuerSatz2.HeightPercent := 100.00000000000000000;
    RFE_SteuerSatz2.Text := '0,00';
    RFE_SteuerSatz2.WidthPercent := 100.00000000000000000;
    RFE_SteuerSatz2.DataField := 'Hfnd_Tax_Rate2';
    RFE_SteuerSatz2.DataSource := PersonalDataSource;
    RFE_KassenMind.SetParentComponent(pnFinanzdaten);
    RFE_KassenMind.Name := 'RFE_KassenMind';
    RFE_KassenMind.Left := 468;
    RFE_KassenMind.Top := 313;
    RFE_KassenMind.Width := 150;
    RFE_KassenMind.Height := 46;
    RFE_KassenMind.Alignment := taRightJustify;
    RFE_KassenMind.Anchors := [];
    RFE_KassenMind.ChildOrder := 13;
    RFE_KassenMind.EditType := weSignedFloat;
    RFE_KassenMind.ElementFont := efCSS;
    RFE_KassenMind.HeightStyle := ssAuto;
    RFE_KassenMind.HeightPercent := 100.00000000000000000;
    RFE_KassenMind.Text := '0,00';
    RFE_KassenMind.WidthPercent := 100.00000000000000000;
    RFE_KassenMind.DataField := 'Hfnd_Min_Cash_Balance';
    RFE_KassenMind.DataSource := PersonalDataSource;
    RFE_FoerderBett.SetParentComponent(pnFinanzdaten);
    RFE_FoerderBett.Name := 'RFE_FoerderBett';
    RFE_FoerderBett.Left := 468;
    RFE_FoerderBett.Top := 360;
    RFE_FoerderBett.Width := 150;
    RFE_FoerderBett.Height := 46;
    RFE_FoerderBett.Alignment := taRightJustify;
    RFE_FoerderBett.Anchors := [];
    RFE_FoerderBett.ChildOrder := 15;
    RFE_FoerderBett.EditType := weSignedFloat;
    RFE_FoerderBett.ElementFont := efCSS;
    RFE_FoerderBett.HeightStyle := ssAuto;
    RFE_FoerderBett.HeightPercent := 100.00000000000000000;
    RFE_FoerderBett.Text := '0,00';
    RFE_FoerderBett.WidthPercent := 100.00000000000000000;
    RFE_FoerderBett.DataField := 'Hfnd_Funding_Amount_Per_Bed';
    RFE_FoerderBett.DataSource := PersonalDataSource;
    RFE_Sonstiges1.SetParentComponent(pnFinanzdaten);
    RFE_Sonstiges1.Name := 'RFE_Sonstiges1';
    RFE_Sonstiges1.Left := 468;
    RFE_Sonstiges1.Top := 411;
    RFE_Sonstiges1.Width := 150;
    RFE_Sonstiges1.Height := 46;
    RFE_Sonstiges1.Alignment := taRightJustify;
    RFE_Sonstiges1.Anchors := [];
    RFE_Sonstiges1.ChildOrder := 17;
    RFE_Sonstiges1.EditType := weSignedFloat;
    RFE_Sonstiges1.ElementFont := efCSS;
    RFE_Sonstiges1.HeightStyle := ssAuto;
    RFE_Sonstiges1.HeightPercent := 100.00000000000000000;
    RFE_Sonstiges1.Text := '0,00';
    RFE_Sonstiges1.WidthPercent := 100.00000000000000000;
    RFE_Sonstiges1.DataField := 'Hfnd_Miscellaneous';
    RFE_Sonstiges1.DataSource := PersonalDataSource;
    pgSeite5.SetParentComponent(PageControl);
    pgSeite5.Name := 'pgSeite5';
    pgSeite5.Left := 0;
    pgSeite5.Top := 20;
    pgSeite5.Width := 1901;
    pgSeite5.Height := 1506;
    pgSeite5.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgSeite5.HeightStyle := ssAuto;
    pgSeite5.WidthStyle := ssAuto;
    pgSeite5.Caption := 'Generelles';
    pgSeite5.ChildOrder := 4;
    pgSeite5.ElementFont := efCSS;
    pgSeite5.ElementPosition := epRelative;
    pnCodierDienst.SetParentComponent(pgSeite5);
    pnCodierDienst.Name := 'pnCodierDienst';
    pnCodierDienst.Left := 1209;
    pnCodierDienst.Top := 512;
    pnCodierDienst.Width := 661;
    pnCodierDienst.Height := 994;
    pnCodierDienst.Align := alLeft;
    pnCodierDienst.ElementFont := efCSS;
    pnCodierDienst.TabOrder := 0;
    WebLabel89.SetParentComponent(pnCodierDienst);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 6;
    WebLabel89.Top := 55;
    WebLabel89.Width := 135;
    WebLabel89.Height := 29;
    WebLabel89.Caption := 'Fallsatz ('#8364')';
    WebLabel89.ElementFont := efCSS;
    WebLabel89.Font.Charset := DEFAULT_CHARSET;
    WebLabel89.Font.Color := clWindowText;
    WebLabel89.Font.Height := -24;
    WebLabel89.Font.Name := 'Tahoma';
    WebLabel89.Font.Style := [fsBold];
    WebLabel89.HeightStyle := ssAuto;
    WebLabel89.HeightPercent := 100.00000000000000000;
    WebLabel89.ParentFont := False;
    WebLabel89.WidthPercent := 100.00000000000000000;
    WebLabel90.SetParentComponent(pnCodierDienst);
    WebLabel90.Name := 'WebLabel90';
    WebLabel90.Left := 5;
    WebLabel90.Top := 148;
    WebLabel90.Width := 239;
    WebLabel90.Height := 29;
    WebLabel90.Caption := 'F'#228'lle pro Codier p.a.';
    WebLabel90.ElementFont := efCSS;
    WebLabel90.Font.Charset := DEFAULT_CHARSET;
    WebLabel90.Font.Color := clWindowText;
    WebLabel90.Font.Height := -24;
    WebLabel90.Font.Name := 'Tahoma';
    WebLabel90.Font.Style := [fsBold];
    WebLabel90.HeightStyle := ssAuto;
    WebLabel90.HeightPercent := 100.00000000000000000;
    WebLabel90.ParentFont := False;
    WebLabel90.WidthPercent := 100.00000000000000000;
    WebLabel91.SetParentComponent(pnCodierDienst);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 6;
    WebLabel91.Top := 235;
    WebLabel91.Width := 323;
    WebLabel91.Height := 29;
    WebLabel91.Caption := 'Leasingrate / Platz p.a. ('#8364')';
    WebLabel91.ElementFont := efCSS;
    WebLabel91.Font.Charset := DEFAULT_CHARSET;
    WebLabel91.Font.Color := clWindowText;
    WebLabel91.Font.Height := -24;
    WebLabel91.Font.Name := 'Tahoma';
    WebLabel91.Font.Style := [fsBold];
    WebLabel91.HeightStyle := ssAuto;
    WebLabel91.HeightPercent := 100.00000000000000000;
    WebLabel91.ParentFont := False;
    WebLabel91.WidthPercent := 100.00000000000000000;
    WebLabel93.SetParentComponent(pnCodierDienst);
    WebLabel93.Name := 'WebLabel93';
    WebLabel93.Left := 6;
    WebLabel93.Top := 328;
    WebLabel93.Width := 344;
    WebLabel93.Height := 29;
    WebLabel93.Caption := 'Inf.str. Kost . / Platz p.a. ('#8364')';
    WebLabel93.ElementFont := efCSS;
    WebLabel93.Font.Charset := DEFAULT_CHARSET;
    WebLabel93.Font.Color := clWindowText;
    WebLabel93.Font.Height := -24;
    WebLabel93.Font.Name := 'Tahoma';
    WebLabel93.Font.Style := [fsBold];
    WebLabel93.HeightStyle := ssAuto;
    WebLabel93.HeightPercent := 100.00000000000000000;
    WebLabel93.ParentFont := False;
    WebLabel93.WidthPercent := 100.00000000000000000;
    WebLabel95.SetParentComponent(pnCodierDienst);
    WebLabel95.Name := 'WebLabel95';
    WebLabel95.Left := 27;
    WebLabel95.Top := 26;
    WebLabel95.Width := 78;
    WebLabel95.Height := 18;
    WebLabel95.Caption := 'Codierdienst';
    WebLabel95.ElementFont := efCSS;
    WebLabel95.ElementPosition := epRelative;
    WebLabel95.HeightStyle := ssAuto;
    WebLabel95.HeightPercent := 100.00000000000000000;
    WebLabel95.HTMLType := tH3;
    WebLabel95.WidthPercent := 100.00000000000000000;
    RFE_FallSatz.SetParentComponent(pnCodierDienst);
    RFE_FallSatz.Name := 'RFE_FallSatz';
    RFE_FallSatz.Left := 5;
    RFE_FallSatz.Top := 90;
    RFE_FallSatz.Width := 209;
    RFE_FallSatz.Height := 46;
    RFE_FallSatz.ChildOrder := 4;
    RFE_FallSatz.ElementFont := efCSS;
    RFE_FallSatz.Font.Charset := ANSI_CHARSET;
    RFE_FallSatz.Font.Color := clWindowText;
    RFE_FallSatz.Font.Height := -24;
    RFE_FallSatz.Font.Name := 'Segoe UI';
    RFE_FallSatz.Font.Style := [fsBold];
    RFE_FallSatz.HeightStyle := ssAuto;
    RFE_FallSatz.HeightPercent := 100.00000000000000000;
    RFE_FallSatz.ParentFont := False;
    RFE_FallSatz.Text := ' ';
    RFE_FallSatz.WidthPercent := 100.00000000000000000;
    RFE_FallSatz.DataField := 'Hmpm_Coding_Case';
    RFE_FallSatz.DataSource := PeriodMiscWebDataSource;
    RFE_FaellePro.SetParentComponent(pnCodierDienst);
    RFE_FaellePro.Name := 'RFE_FaellePro';
    RFE_FaellePro.Left := 6;
    RFE_FaellePro.Top := 183;
    RFE_FaellePro.Width := 209;
    RFE_FaellePro.Height := 46;
    RFE_FaellePro.ChildOrder := 5;
    RFE_FaellePro.ElementFont := efCSS;
    RFE_FaellePro.Font.Charset := ANSI_CHARSET;
    RFE_FaellePro.Font.Color := clWindowText;
    RFE_FaellePro.Font.Height := -24;
    RFE_FaellePro.Font.Name := 'Segoe UI';
    RFE_FaellePro.Font.Style := [fsBold];
    RFE_FaellePro.HeightStyle := ssAuto;
    RFE_FaellePro.HeightPercent := 100.00000000000000000;
    RFE_FaellePro.ParentFont := False;
    RFE_FaellePro.TabOrder := 1;
    RFE_FaellePro.Text := ' ';
    RFE_FaellePro.WidthPercent := 100.00000000000000000;
    RFE_FaellePro.DataField := 'Hmpm_Coding_Cases_Per_Anno';
    RFE_FaellePro.DataSource := PeriodMiscWebDataSource;
    RFE_CodLeasing.SetParentComponent(pnCodierDienst);
    RFE_CodLeasing.Name := 'RFE_CodLeasing';
    RFE_CodLeasing.Left := 9;
    RFE_CodLeasing.Top := 275;
    RFE_CodLeasing.Width := 209;
    RFE_CodLeasing.Height := 46;
    RFE_CodLeasing.ChildOrder := 6;
    RFE_CodLeasing.ElementFont := efCSS;
    RFE_CodLeasing.Font.Charset := ANSI_CHARSET;
    RFE_CodLeasing.Font.Color := clWindowText;
    RFE_CodLeasing.Font.Height := -24;
    RFE_CodLeasing.Font.Name := 'Segoe UI';
    RFE_CodLeasing.Font.Style := [fsBold];
    RFE_CodLeasing.HeightStyle := ssAuto;
    RFE_CodLeasing.HeightPercent := 100.00000000000000000;
    RFE_CodLeasing.ParentFont := False;
    RFE_CodLeasing.TabOrder := 2;
    RFE_CodLeasing.Text := ' ';
    RFE_CodLeasing.WidthPercent := 100.00000000000000000;
    RFE_CodLeasing.DataField := 'Hmpm_Coding_Leasing_Rate';
    RFE_CodLeasing.DataSource := PeriodMiscWebDataSource;
    RFE_CodInfrStr.SetParentComponent(pnCodierDienst);
    RFE_CodInfrStr.Name := 'RFE_CodInfrStr';
    RFE_CodInfrStr.Left := 6;
    RFE_CodInfrStr.Top := 363;
    RFE_CodInfrStr.Width := 209;
    RFE_CodInfrStr.Height := 46;
    RFE_CodInfrStr.ChildOrder := 7;
    RFE_CodInfrStr.ElementFont := efCSS;
    RFE_CodInfrStr.Font.Charset := ANSI_CHARSET;
    RFE_CodInfrStr.Font.Color := clWindowText;
    RFE_CodInfrStr.Font.Height := -24;
    RFE_CodInfrStr.Font.Name := 'Segoe UI';
    RFE_CodInfrStr.Font.Style := [fsBold];
    RFE_CodInfrStr.HeightStyle := ssAuto;
    RFE_CodInfrStr.HeightPercent := 100.00000000000000000;
    RFE_CodInfrStr.ParentFont := False;
    RFE_CodInfrStr.TabOrder := 3;
    RFE_CodInfrStr.Text := ' ';
    RFE_CodInfrStr.WidthPercent := 100.00000000000000000;
    RFE_CodInfrStr.DataField := 'Hmpm_Coding_Infra_Costs';
    RFE_CodInfrStr.DataSource := PeriodMiscWebDataSource;
    pnGenerelles.SetParentComponent(pgSeite5);
    pnGenerelles.Name := 'pnGenerelles';
    pnGenerelles.Left := 0;
    pnGenerelles.Top := 512;
    pnGenerelles.Width := 655;
    pnGenerelles.Height := 994;
    pnGenerelles.Align := alLeft;
    pnGenerelles.ChildOrder := 1;
    pnGenerelles.ElementFont := efCSS;
    pnGenerelles.TabOrder := 1;
    WebLabel81.SetParentComponent(pnGenerelles);
    WebLabel81.Name := 'WebLabel81';
    WebLabel81.Left := 3;
    WebLabel81.Top := 55;
    WebLabel81.Width := 260;
    WebLabel81.Height := 29;
    WebLabel81.Caption := 'Absch. Dauer Anlagen';
    WebLabel81.ElementFont := efCSS;
    WebLabel81.Font.Charset := DEFAULT_CHARSET;
    WebLabel81.Font.Color := clWindowText;
    WebLabel81.Font.Height := -24;
    WebLabel81.Font.Name := 'Tahoma';
    WebLabel81.Font.Style := [fsBold];
    WebLabel81.HeightStyle := ssAuto;
    WebLabel81.HeightPercent := 100.00000000000000000;
    WebLabel81.ParentFont := False;
    WebLabel81.WidthPercent := 100.00000000000000000;
    WebLabel82.SetParentComponent(pnGenerelles);
    WebLabel82.Name := 'WebLabel82';
    WebLabel82.Left := 3;
    WebLabel82.Top := 107;
    WebLabel82.Width := 250;
    WebLabel82.Height := 29;
    WebLabel82.Caption := 'Absch. Satz Geb'#228'ude';
    WebLabel82.ElementFont := efCSS;
    WebLabel82.Font.Charset := DEFAULT_CHARSET;
    WebLabel82.Font.Color := clWindowText;
    WebLabel82.Font.Height := -24;
    WebLabel82.Font.Name := 'Tahoma';
    WebLabel82.Font.Style := [fsBold];
    WebLabel82.HeightStyle := ssAuto;
    WebLabel82.HeightPercent := 100.00000000000000000;
    WebLabel82.ParentFont := False;
    WebLabel82.WidthPercent := 100.00000000000000000;
    WebLabel83.SetParentComponent(pnGenerelles);
    WebLabel83.Name := 'WebLabel83';
    WebLabel83.Left := 3;
    WebLabel83.Top := 159;
    WebLabel83.Width := 301;
    WebLabel83.Height := 29;
    WebLabel83.Caption := 'Absch. Dauer Einrichtung';
    WebLabel83.ElementFont := efCSS;
    WebLabel83.Font.Charset := DEFAULT_CHARSET;
    WebLabel83.Font.Color := clWindowText;
    WebLabel83.Font.Height := -24;
    WebLabel83.Font.Name := 'Tahoma';
    WebLabel83.Font.Style := [fsBold];
    WebLabel83.HeightStyle := ssAuto;
    WebLabel83.HeightPercent := 100.00000000000000000;
    WebLabel83.ParentFont := False;
    WebLabel83.WidthPercent := 100.00000000000000000;
    WebLabel84.SetParentComponent(pnGenerelles);
    WebLabel84.Name := 'WebLabel84';
    WebLabel84.Left := 3;
    WebLabel84.Top := 211;
    WebLabel84.Width := 40;
    WebLabel84.Height := 29;
    WebLabel84.Caption := 'frei';
    WebLabel84.ElementFont := efCSS;
    WebLabel84.Font.Charset := DEFAULT_CHARSET;
    WebLabel84.Font.Color := clWindowText;
    WebLabel84.Font.Height := -24;
    WebLabel84.Font.Name := 'Tahoma';
    WebLabel84.Font.Style := [fsBold];
    WebLabel84.HeightStyle := ssAuto;
    WebLabel84.HeightPercent := 100.00000000000000000;
    WebLabel84.ParentFont := False;
    WebLabel84.WidthPercent := 100.00000000000000000;
    WebLabel85.SetParentComponent(pnGenerelles);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 3;
    WebLabel85.Top := 263;
    WebLabel85.Width := 442;
    WebLabel85.Height := 29;
    WebLabel85.Caption := 'Verteilung der behandelten Personen';
    WebLabel85.ElementFont := efCSS;
    WebLabel85.Font.Charset := DEFAULT_CHARSET;
    WebLabel85.Font.Color := clWindowText;
    WebLabel85.Font.Height := -24;
    WebLabel85.Font.Name := 'Tahoma';
    WebLabel85.Font.Style := [fsBold];
    WebLabel85.HeightStyle := ssAuto;
    WebLabel85.HeightPercent := 100.00000000000000000;
    WebLabel85.ParentFont := False;
    WebLabel85.WidthPercent := 100.00000000000000000;
    WebLabel86.SetParentComponent(pnGenerelles);
    WebLabel86.Name := 'WebLabel86';
    WebLabel86.Left := 3;
    WebLabel86.Top := 315;
    WebLabel86.Width := 357;
    WebLabel86.Height := 29;
    WebLabel86.Caption := 'Anteil Wahlleistungen Unterk.';
    WebLabel86.ElementFont := efCSS;
    WebLabel86.Font.Charset := DEFAULT_CHARSET;
    WebLabel86.Font.Color := clWindowText;
    WebLabel86.Font.Height := -24;
    WebLabel86.Font.Name := 'Tahoma';
    WebLabel86.Font.Style := [fsBold];
    WebLabel86.HeightStyle := ssAuto;
    WebLabel86.HeightPercent := 100.00000000000000000;
    WebLabel86.ParentFont := False;
    WebLabel86.WidthPercent := 100.00000000000000000;
    WebLabel87.SetParentComponent(pnGenerelles);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 3;
    WebLabel87.Top := 367;
    WebLabel87.Width := 354;
    WebLabel87.Height := 29;
    WebLabel87.Caption := 'Instandhaltung Geb'#228'ude (%)';
    WebLabel87.ElementFont := efCSS;
    WebLabel87.Font.Charset := DEFAULT_CHARSET;
    WebLabel87.Font.Color := clWindowText;
    WebLabel87.Font.Height := -24;
    WebLabel87.Font.Name := 'Tahoma';
    WebLabel87.Font.Style := [fsBold];
    WebLabel87.HeightStyle := ssAuto;
    WebLabel87.HeightPercent := 100.00000000000000000;
    WebLabel87.ParentFont := False;
    WebLabel87.WidthPercent := 100.00000000000000000;
    WebLabel88.SetParentComponent(pnGenerelles);
    WebLabel88.Name := 'WebLabel88';
    WebLabel88.Left := 3;
    WebLabel88.Top := 419;
    WebLabel88.Width := 394;
    WebLabel88.Height := 29;
    WebLabel88.Caption := 'Instandhaltung Med. Ger'#228'te (%)';
    WebLabel88.ElementFont := efCSS;
    WebLabel88.Font.Charset := DEFAULT_CHARSET;
    WebLabel88.Font.Color := clWindowText;
    WebLabel88.Font.Height := -24;
    WebLabel88.Font.Name := 'Tahoma';
    WebLabel88.Font.Style := [fsBold];
    WebLabel88.HeightStyle := ssAuto;
    WebLabel88.HeightPercent := 100.00000000000000000;
    WebLabel88.ParentFont := False;
    WebLabel88.WidthPercent := 100.00000000000000000;
    WebLabel94.SetParentComponent(pnGenerelles);
    WebLabel94.Name := 'WebLabel94';
    WebLabel94.Left := 19;
    WebLabel94.Top := 18;
    WebLabel94.Width := 66;
    WebLabel94.Height := 18;
    WebLabel94.Caption := 'Generelles';
    WebLabel94.ElementFont := efCSS;
    WebLabel94.ElementPosition := epRelative;
    WebLabel94.HeightStyle := ssAuto;
    WebLabel94.HeightPercent := 100.00000000000000000;
    WebLabel94.HTMLType := tH3;
    WebLabel94.WidthPercent := 100.00000000000000000;
    RFE_AbschrDAnl.SetParentComponent(pnGenerelles);
    RFE_AbschrDAnl.Name := 'RFE_AbschrDAnl';
    RFE_AbschrDAnl.Left := 434;
    RFE_AbschrDAnl.Top := 50;
    RFE_AbschrDAnl.Width := 150;
    RFE_AbschrDAnl.Height := 46;
    RFE_AbschrDAnl.ChildOrder := 8;
    RFE_AbschrDAnl.ElementFont := efCSS;
    RFE_AbschrDAnl.Font.Charset := ANSI_CHARSET;
    RFE_AbschrDAnl.Font.Color := clWindowText;
    RFE_AbschrDAnl.Font.Height := -24;
    RFE_AbschrDAnl.Font.Name := 'Segoe UI';
    RFE_AbschrDAnl.Font.Style := [fsBold];
    RFE_AbschrDAnl.HeightStyle := ssAuto;
    RFE_AbschrDAnl.HeightPercent := 100.00000000000000000;
    RFE_AbschrDAnl.ParentFont := False;
    RFE_AbschrDAnl.Text := ' ';
    RFE_AbschrDAnl.WidthPercent := 100.00000000000000000;
    RFE_AbschrDAnl.DataField := 'Hmpm_Deprecation_Duration_Invest';
    RFE_AbschrDAnl.DataSource := PeriodMiscWebDataSource;
    RFE_AbschrSGeb.SetParentComponent(pnGenerelles);
    RFE_AbschrSGeb.Name := 'RFE_AbschrSGeb';
    RFE_AbschrSGeb.Left := 434;
    RFE_AbschrSGeb.Top := 102;
    RFE_AbschrSGeb.Width := 150;
    RFE_AbschrSGeb.Height := 46;
    RFE_AbschrSGeb.ChildOrder := 9;
    RFE_AbschrSGeb.ElementFont := efCSS;
    RFE_AbschrSGeb.Font.Charset := ANSI_CHARSET;
    RFE_AbschrSGeb.Font.Color := clWindowText;
    RFE_AbschrSGeb.Font.Height := -24;
    RFE_AbschrSGeb.Font.Name := 'Segoe UI';
    RFE_AbschrSGeb.Font.Style := [fsBold];
    RFE_AbschrSGeb.HeightStyle := ssAuto;
    RFE_AbschrSGeb.HeightPercent := 100.00000000000000000;
    RFE_AbschrSGeb.ParentFont := False;
    RFE_AbschrSGeb.TabOrder := 1;
    RFE_AbschrSGeb.Text := ' ';
    RFE_AbschrSGeb.WidthPercent := 100.00000000000000000;
    RFE_AbschrSGeb.DataField := 'Hmpm_Deprecation_Value_Buildings';
    RFE_AbschrSGeb.DataSource := PeriodMiscWebDataSource;
    RFE_AbschrDEin.SetParentComponent(pnGenerelles);
    RFE_AbschrDEin.Name := 'RFE_AbschrDEin';
    RFE_AbschrDEin.Left := 434;
    RFE_AbschrDEin.Top := 154;
    RFE_AbschrDEin.Width := 150;
    RFE_AbschrDEin.Height := 46;
    RFE_AbschrDEin.ChildOrder := 10;
    RFE_AbschrDEin.ElementFont := efCSS;
    RFE_AbschrDEin.Font.Charset := ANSI_CHARSET;
    RFE_AbschrDEin.Font.Color := clWindowText;
    RFE_AbschrDEin.Font.Height := -24;
    RFE_AbschrDEin.Font.Name := 'Segoe UI';
    RFE_AbschrDEin.Font.Style := [fsBold];
    RFE_AbschrDEin.HeightStyle := ssAuto;
    RFE_AbschrDEin.HeightPercent := 100.00000000000000000;
    RFE_AbschrDEin.ParentFont := False;
    RFE_AbschrDEin.TabOrder := 2;
    RFE_AbschrDEin.Text := ' ';
    RFE_AbschrDEin.WidthPercent := 100.00000000000000000;
    RFE_AbschrDEin.DataField := 'Hmpm_Deprecation_Time_Installations';
    RFE_AbschrDEin.DataSource := PeriodMiscWebDataSource;
    RFE_AbtRestBdg.SetParentComponent(pnGenerelles);
    RFE_AbtRestBdg.Name := 'RFE_AbtRestBdg';
    RFE_AbtRestBdg.Left := 434;
    RFE_AbtRestBdg.Top := 206;
    RFE_AbtRestBdg.Width := 150;
    RFE_AbtRestBdg.Height := 46;
    RFE_AbtRestBdg.ChildOrder := 11;
    RFE_AbtRestBdg.ElementFont := efCSS;
    RFE_AbtRestBdg.Font.Charset := ANSI_CHARSET;
    RFE_AbtRestBdg.Font.Color := clWindowText;
    RFE_AbtRestBdg.Font.Height := -24;
    RFE_AbtRestBdg.Font.Name := 'Segoe UI';
    RFE_AbtRestBdg.Font.Style := [fsBold];
    RFE_AbtRestBdg.HeightStyle := ssAuto;
    RFE_AbtRestBdg.HeightPercent := 100.00000000000000000;
    RFE_AbtRestBdg.ParentFont := False;
    RFE_AbtRestBdg.TabOrder := 3;
    RFE_AbtRestBdg.Text := ' ';
    RFE_AbtRestBdg.WidthPercent := 100.00000000000000000;
    RFE_AbtRestBdg.DataField := 'Hmpm_Misc1';
    RFE_AbtRestBdg.DataSource := PeriodMiscWebDataSource;
    RFE_Patientver.SetParentComponent(pnGenerelles);
    RFE_Patientver.Name := 'RFE_Patientver';
    RFE_Patientver.Left := 434;
    RFE_Patientver.Top := 258;
    RFE_Patientver.Width := 150;
    RFE_Patientver.Height := 46;
    RFE_Patientver.ChildOrder := 12;
    RFE_Patientver.ElementFont := efCSS;
    RFE_Patientver.Font.Charset := ANSI_CHARSET;
    RFE_Patientver.Font.Color := clWindowText;
    RFE_Patientver.Font.Height := -24;
    RFE_Patientver.Font.Name := 'Segoe UI';
    RFE_Patientver.Font.Style := [fsBold];
    RFE_Patientver.HeightStyle := ssAuto;
    RFE_Patientver.HeightPercent := 100.00000000000000000;
    RFE_Patientver.ParentFont := False;
    RFE_Patientver.TabOrder := 4;
    RFE_Patientver.Text := ' ';
    RFE_Patientver.WidthPercent := 100.00000000000000000;
    RFE_Patientver.DataField := 'HMPM_DISTRIBUTION_TREATED_PERSON';
    RFE_Patientver.DataSource := PeriodMiscWebDataSource;
    RFE_AntWahlL.SetParentComponent(pnGenerelles);
    RFE_AntWahlL.Name := 'RFE_AntWahlL';
    RFE_AntWahlL.Left := 434;
    RFE_AntWahlL.Top := 310;
    RFE_AntWahlL.Width := 150;
    RFE_AntWahlL.Height := 46;
    RFE_AntWahlL.ChildOrder := 13;
    RFE_AntWahlL.ElementFont := efCSS;
    RFE_AntWahlL.Font.Charset := ANSI_CHARSET;
    RFE_AntWahlL.Font.Color := clWindowText;
    RFE_AntWahlL.Font.Height := -24;
    RFE_AntWahlL.Font.Name := 'Segoe UI';
    RFE_AntWahlL.Font.Style := [fsBold];
    RFE_AntWahlL.HeightStyle := ssAuto;
    RFE_AntWahlL.HeightPercent := 100.00000000000000000;
    RFE_AntWahlL.ParentFont := False;
    RFE_AntWahlL.TabOrder := 5;
    RFE_AntWahlL.Text := ' ';
    RFE_AntWahlL.WidthPercent := 100.00000000000000000;
    RFE_AntWahlL.DataField := 'Hmpm_Part_Opt_Services';
    RFE_AntWahlL.DataSource := PeriodMiscWebDataSource;
    RFE_InstndSI.SetParentComponent(pnGenerelles);
    RFE_InstndSI.Name := 'RFE_InstndSI';
    RFE_InstndSI.Left := 434;
    RFE_InstndSI.Top := 362;
    RFE_InstndSI.Width := 150;
    RFE_InstndSI.Height := 46;
    RFE_InstndSI.ChildOrder := 14;
    RFE_InstndSI.ElementFont := efCSS;
    RFE_InstndSI.Font.Charset := ANSI_CHARSET;
    RFE_InstndSI.Font.Color := clWindowText;
    RFE_InstndSI.Font.Height := -24;
    RFE_InstndSI.Font.Name := 'Segoe UI';
    RFE_InstndSI.Font.Style := [fsBold];
    RFE_InstndSI.HeightStyle := ssAuto;
    RFE_InstndSI.HeightPercent := 100.00000000000000000;
    RFE_InstndSI.ParentFont := False;
    RFE_InstndSI.TabOrder := 6;
    RFE_InstndSI.Text := ' ';
    RFE_InstndSI.WidthPercent := 100.00000000000000000;
    RFE_InstndSI.DataField := 'Hmpm_Maintenance_Building';
    RFE_InstndSI.DataSource := PeriodMiscWebDataSource;
    RFE_InstndSA.SetParentComponent(pnGenerelles);
    RFE_InstndSA.Name := 'RFE_InstndSA';
    RFE_InstndSA.Left := 434;
    RFE_InstndSA.Top := 414;
    RFE_InstndSA.Width := 150;
    RFE_InstndSA.Height := 46;
    RFE_InstndSA.ChildOrder := 15;
    RFE_InstndSA.ElementFont := efCSS;
    RFE_InstndSA.Font.Charset := ANSI_CHARSET;
    RFE_InstndSA.Font.Color := clWindowText;
    RFE_InstndSA.Font.Height := -24;
    RFE_InstndSA.Font.Name := 'Segoe UI';
    RFE_InstndSA.Font.Style := [fsBold];
    RFE_InstndSA.HeightStyle := ssAuto;
    RFE_InstndSA.HeightPercent := 100.00000000000000000;
    RFE_InstndSA.ParentFont := False;
    RFE_InstndSA.TabOrder := 7;
    RFE_InstndSA.Text := ' ';
    RFE_InstndSA.WidthPercent := 100.00000000000000000;
    RFE_InstndSA.DataField := 'Hmpm_Maintenance_Devices';
    RFE_InstndSA.DataSource := PeriodMiscWebDataSource;
    pnKassenDaten.SetParentComponent(pgSeite5);
    pnKassenDaten.Name := 'pnKassenDaten';
    pnKassenDaten.Left := 655;
    pnKassenDaten.Top := 512;
    pnKassenDaten.Width := 554;
    pnKassenDaten.Height := 994;
    pnKassenDaten.Align := alLeft;
    pnKassenDaten.ChildOrder := 2;
    pnKassenDaten.ElementFont := efCSS;
    pnKassenDaten.TabOrder := 2;
    WebLabel96.SetParentComponent(pnKassenDaten);
    WebLabel96.Name := 'WebLabel96';
    WebLabel96.Left := 6;
    WebLabel96.Top := 56;
    WebLabel96.Width := 253;
    WebLabel96.Height := 29;
    WebLabel96.Caption := 'Korrekturfaktor Erl'#246's';
    WebLabel96.ElementFont := efCSS;
    WebLabel96.Font.Charset := DEFAULT_CHARSET;
    WebLabel96.Font.Color := clWindowText;
    WebLabel96.Font.Height := -24;
    WebLabel96.Font.Name := 'Tahoma';
    WebLabel96.Font.Style := [fsBold];
    WebLabel96.HeightStyle := ssAuto;
    WebLabel96.HeightPercent := 100.00000000000000000;
    WebLabel96.ParentFont := False;
    WebLabel96.WidthPercent := 100.00000000000000000;
    WebLabel97.SetParentComponent(pnKassenDaten);
    WebLabel97.Name := 'WebLabel97';
    WebLabel97.Left := 6;
    WebLabel97.Top := 108;
    WebLabel97.Width := 297;
    WebLabel97.Height := 29;
    WebLabel97.Caption := 'Korrekturfaktor Personal';
    WebLabel97.ElementFont := efCSS;
    WebLabel97.Font.Charset := DEFAULT_CHARSET;
    WebLabel97.Font.Color := clWindowText;
    WebLabel97.Font.Height := -24;
    WebLabel97.Font.Name := 'Tahoma';
    WebLabel97.Font.Style := [fsBold];
    WebLabel97.HeightStyle := ssAuto;
    WebLabel97.HeightPercent := 100.00000000000000000;
    WebLabel97.ParentFont := False;
    WebLabel97.WidthPercent := 100.00000000000000000;
    WebLabel98.SetParentComponent(pnKassenDaten);
    WebLabel98.Name := 'WebLabel98';
    WebLabel98.Left := 6;
    WebLabel98.Top := 160;
    WebLabel98.Width := 331;
    WebLabel98.Height := 29;
    WebLabel98.Caption := 'Korrekturfaktor Sachkosten';
    WebLabel98.ElementFont := efCSS;
    WebLabel98.Font.Charset := DEFAULT_CHARSET;
    WebLabel98.Font.Color := clWindowText;
    WebLabel98.Font.Height := -24;
    WebLabel98.Font.Name := 'Tahoma';
    WebLabel98.Font.Style := [fsBold];
    WebLabel98.HeightStyle := ssAuto;
    WebLabel98.HeightPercent := 100.00000000000000000;
    WebLabel98.ParentFont := False;
    WebLabel98.WidthPercent := 100.00000000000000000;
    WebLabel92.SetParentComponent(pnKassenDaten);
    WebLabel92.Name := 'WebLabel92';
    WebLabel92.Left := 30;
    WebLabel92.Top := 23;
    WebLabel92.Width := 84;
    WebLabel92.Height := 18;
    WebLabel92.Caption := 'Kassendaten';
    WebLabel92.ElementFont := efCSS;
    WebLabel92.ElementPosition := epRelative;
    WebLabel92.HeightStyle := ssAuto;
    WebLabel92.HeightPercent := 100.00000000000000000;
    WebLabel92.HTMLType := tH3;
    WebLabel92.WidthPercent := 100.00000000000000000;
    WebLabel112.SetParentComponent(pnKassenDaten);
    WebLabel112.Name := 'WebLabel112';
    WebLabel112.Left := 5;
    WebLabel112.Top := 368;
    WebLabel112.Width := 293;
    WebLabel112.Height := 29;
    WebLabel112.Caption := 'Resterl'#246's Einr. und Aust.';
    WebLabel112.ElementFont := efCSS;
    WebLabel112.Font.Charset := DEFAULT_CHARSET;
    WebLabel112.Font.Color := clWindowText;
    WebLabel112.Font.Height := -24;
    WebLabel112.Font.Name := 'Tahoma';
    WebLabel112.Font.Style := [fsBold];
    WebLabel112.HeightStyle := ssAuto;
    WebLabel112.HeightPercent := 100.00000000000000000;
    WebLabel112.ParentFont := False;
    WebLabel112.WidthPercent := 100.00000000000000000;
    WebLabel113.SetParentComponent(pnKassenDaten);
    WebLabel113.Name := 'WebLabel113';
    WebLabel113.Left := 5;
    WebLabel113.Top := 316;
    WebLabel113.Width := 363;
    WebLabel113.Height := 29;
    WebLabel113.Caption := 'Anteil Verwaltungskosten (%)';
    WebLabel113.ElementFont := efCSS;
    WebLabel113.Font.Charset := DEFAULT_CHARSET;
    WebLabel113.Font.Color := clWindowText;
    WebLabel113.Font.Height := -24;
    WebLabel113.Font.Name := 'Tahoma';
    WebLabel113.Font.Style := [fsBold];
    WebLabel113.HeightStyle := ssAuto;
    WebLabel113.HeightPercent := 100.00000000000000000;
    WebLabel113.ParentFont := False;
    WebLabel113.WidthPercent := 100.00000000000000000;
    RFE_PktKorrFkt.SetParentComponent(pnKassenDaten);
    RFE_PktKorrFkt.Name := 'RFE_PktKorrFkt';
    RFE_PktKorrFkt.Left := 373;
    RFE_PktKorrFkt.Top := 51;
    RFE_PktKorrFkt.Width := 150;
    RFE_PktKorrFkt.Height := 46;
    RFE_PktKorrFkt.ChildOrder := 7;
    RFE_PktKorrFkt.ElementFont := efCSS;
    RFE_PktKorrFkt.Font.Charset := ANSI_CHARSET;
    RFE_PktKorrFkt.Font.Color := clWindowText;
    RFE_PktKorrFkt.Font.Height := -24;
    RFE_PktKorrFkt.Font.Name := 'Segoe UI';
    RFE_PktKorrFkt.Font.Style := [fsBold];
    RFE_PktKorrFkt.HeightStyle := ssAuto;
    RFE_PktKorrFkt.HeightPercent := 100.00000000000000000;
    RFE_PktKorrFkt.ParentFont := False;
    RFE_PktKorrFkt.Text := ' ';
    RFE_PktKorrFkt.WidthPercent := 100.00000000000000000;
    RFE_PktKorrFkt.DataField := 'Hmpm_Correction_Factor_Cash';
    RFE_PktKorrFkt.DataSource := PeriodMiscWebDataSource;
    RFE_PktWertPer.SetParentComponent(pnKassenDaten);
    RFE_PktWertPer.Name := 'RFE_PktWertPer';
    RFE_PktWertPer.Left := 373;
    RFE_PktWertPer.Top := 102;
    RFE_PktWertPer.Width := 150;
    RFE_PktWertPer.Height := 46;
    RFE_PktWertPer.ChildOrder := 8;
    RFE_PktWertPer.ElementFont := efCSS;
    RFE_PktWertPer.Font.Charset := ANSI_CHARSET;
    RFE_PktWertPer.Font.Color := clWindowText;
    RFE_PktWertPer.Font.Height := -24;
    RFE_PktWertPer.Font.Name := 'Segoe UI';
    RFE_PktWertPer.Font.Style := [fsBold];
    RFE_PktWertPer.HeightStyle := ssAuto;
    RFE_PktWertPer.HeightPercent := 100.00000000000000000;
    RFE_PktWertPer.ParentFont := False;
    RFE_PktWertPer.TabOrder := 1;
    RFE_PktWertPer.Text := ' ';
    RFE_PktWertPer.WidthPercent := 100.00000000000000000;
    RFE_PktWertPer.DataField := 'Hmpm_Correction_Factor_Personnel';
    RFE_PktWertPer.DataSource := PeriodMiscWebDataSource;
    RFE_PktWertMed.SetParentComponent(pnKassenDaten);
    RFE_PktWertMed.Name := 'RFE_PktWertMed';
    RFE_PktWertMed.Left := 373;
    RFE_PktWertMed.Top := 155;
    RFE_PktWertMed.Width := 150;
    RFE_PktWertMed.Height := 46;
    RFE_PktWertMed.ChildOrder := 9;
    RFE_PktWertMed.ElementFont := efCSS;
    RFE_PktWertMed.Font.Charset := ANSI_CHARSET;
    RFE_PktWertMed.Font.Color := clWindowText;
    RFE_PktWertMed.Font.Height := -24;
    RFE_PktWertMed.Font.Name := 'Segoe UI';
    RFE_PktWertMed.Font.Style := [fsBold];
    RFE_PktWertMed.HeightStyle := ssAuto;
    RFE_PktWertMed.HeightPercent := 100.00000000000000000;
    RFE_PktWertMed.ParentFont := False;
    RFE_PktWertMed.TabOrder := 2;
    RFE_PktWertMed.Text := ' ';
    RFE_PktWertMed.WidthPercent := 100.00000000000000000;
    RFE_PktWertMed.DataField := 'Hmpm_Correction_Factor_Mat_Cost';
    RFE_PktWertMed.DataSource := PeriodMiscWebDataSource;
    RFE_AntRestErl.SetParentComponent(pnKassenDaten);
    RFE_AntRestErl.Name := 'RFE_AntRestErl';
    RFE_AntRestErl.Left := 373;
    RFE_AntRestErl.Top := 362;
    RFE_AntRestErl.Width := 150;
    RFE_AntRestErl.Height := 46;
    RFE_AntRestErl.ChildOrder := 13;
    RFE_AntRestErl.ElementFont := efCSS;
    RFE_AntRestErl.Font.Charset := ANSI_CHARSET;
    RFE_AntRestErl.Font.Color := clWindowText;
    RFE_AntRestErl.Font.Height := -24;
    RFE_AntRestErl.Font.Name := 'Segoe UI';
    RFE_AntRestErl.Font.Style := [fsBold];
    RFE_AntRestErl.HeightStyle := ssAuto;
    RFE_AntRestErl.HeightPercent := 100.00000000000000000;
    RFE_AntRestErl.ParentFont := False;
    RFE_AntRestErl.TabOrder := 6;
    RFE_AntRestErl.Text := ' ';
    RFE_AntRestErl.WidthPercent := 100.00000000000000000;
    RFE_AntRestErl.DataField := 'Hmpm_Admin_Residual_Proceeds';
    RFE_AntRestErl.DataSource := PeriodMiscWebDataSource;
    RFE_VerwKosten.SetParentComponent(pnKassenDaten);
    RFE_VerwKosten.Name := 'RFE_VerwKosten';
    RFE_VerwKosten.Left := 372;
    RFE_VerwKosten.Top := 310;
    RFE_VerwKosten.Width := 150;
    RFE_VerwKosten.Height := 46;
    RFE_VerwKosten.ChildOrder := 12;
    RFE_VerwKosten.ElementFont := efCSS;
    RFE_VerwKosten.ElementPosition := epIgnore;
    RFE_VerwKosten.Font.Charset := ANSI_CHARSET;
    RFE_VerwKosten.Font.Color := clWindowText;
    RFE_VerwKosten.Font.Height := -24;
    RFE_VerwKosten.Font.Name := 'Segoe UI';
    RFE_VerwKosten.Font.Style := [fsBold];
    RFE_VerwKosten.HeightStyle := ssAuto;
    RFE_VerwKosten.HeightPercent := 100.00000000000000000;
    RFE_VerwKosten.ParentFont := False;
    RFE_VerwKosten.TabOrder := 5;
    RFE_VerwKosten.Text := ' ';
    RFE_VerwKosten.WidthStyle := ssAuto;
    RFE_VerwKosten.WidthPercent := 100.00000000000000000;
    RFE_VerwKosten.DataField := 'Hmpm_Admin_Rate_Costs';
    RFE_VerwKosten.DataSource := PeriodMiscWebDataSource;
    pnSonstiges.SetParentComponent(pgSeite5);
    pnSonstiges.Name := 'pnSonstiges';
    pnSonstiges.Left := 0;
    pnSonstiges.Top := 0;
    pnSonstiges.Width := 1901;
    pnSonstiges.Height := 512;
    pnSonstiges.Align := alTop;
    pnSonstiges.ChildOrder := 3;
    pnSonstiges.ElementFont := efCSS;
    pnSonstiges.TabOrder := 3;
    WebLabel68.SetParentComponent(pnSonstiges);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 8;
    WebLabel68.Top := 91;
    WebLabel68.Width := 328;
    WebLabel68.Height := 29;
    WebLabel68.Caption := 'Au'#223'erordentlicher Aufwand';
    WebLabel68.ElementFont := efCSS;
    WebLabel68.Font.Charset := DEFAULT_CHARSET;
    WebLabel68.Font.Color := clWindowText;
    WebLabel68.Font.Height := -24;
    WebLabel68.Font.Name := 'Tahoma';
    WebLabel68.Font.Style := [fsBold];
    WebLabel68.HeightStyle := ssAuto;
    WebLabel68.HeightPercent := 100.00000000000000000;
    WebLabel68.ParentFont := False;
    WebLabel68.WidthPercent := 100.00000000000000000;
    WebLabel69.SetParentComponent(pnSonstiges);
    WebLabel69.Name := 'WebLabel69';
    WebLabel69.Left := 8;
    WebLabel69.Top := 143;
    WebLabel69.Width := 297;
    WebLabel69.Height := 29;
    WebLabel69.Caption := 'Au'#223'erordentlicher Ertrag';
    WebLabel69.ElementFont := efCSS;
    WebLabel69.Font.Charset := DEFAULT_CHARSET;
    WebLabel69.Font.Color := clWindowText;
    WebLabel69.Font.Height := -24;
    WebLabel69.Font.Name := 'Tahoma';
    WebLabel69.Font.Style := [fsBold];
    WebLabel69.HeightStyle := ssAuto;
    WebLabel69.HeightPercent := 100.00000000000000000;
    WebLabel69.ParentFont := False;
    WebLabel69.WidthPercent := 100.00000000000000000;
    WebLabel71.SetParentComponent(pnSonstiges);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 8;
    WebLabel71.Top := 247;
    WebLabel71.Width := 276;
    WebLabel71.Height := 29;
    WebLabel71.Caption := 'Forderungen nach KHG';
    WebLabel71.ElementFont := efCSS;
    WebLabel71.Font.Charset := DEFAULT_CHARSET;
    WebLabel71.Font.Color := clWindowText;
    WebLabel71.Font.Height := -24;
    WebLabel71.Font.Name := 'Tahoma';
    WebLabel71.Font.Style := [fsBold];
    WebLabel71.HeightStyle := ssAuto;
    WebLabel71.HeightPercent := 100.00000000000000000;
    WebLabel71.ParentFont := False;
    WebLabel71.WidthPercent := 100.00000000000000000;
    WebLabel73.SetParentComponent(pnSonstiges);
    WebLabel73.Name := 'WebLabel73';
    WebLabel73.Left := 8;
    WebLabel73.Top := 351;
    WebLabel73.Width := 332;
    WebLabel73.Height := 29;
    WebLabel73.Caption := 'Verbindlichkeiten nach KHG';
    WebLabel73.ElementFont := efCSS;
    WebLabel73.Font.Charset := DEFAULT_CHARSET;
    WebLabel73.Font.Color := clWindowText;
    WebLabel73.Font.Height := -24;
    WebLabel73.Font.Name := 'Tahoma';
    WebLabel73.Font.Style := [fsBold];
    WebLabel73.HeightStyle := ssAuto;
    WebLabel73.HeightPercent := 100.00000000000000000;
    WebLabel73.ParentFont := False;
    WebLabel73.WidthPercent := 100.00000000000000000;
    WebLabel74.SetParentComponent(pnSonstiges);
    WebLabel74.Name := 'WebLabel74';
    WebLabel74.Left := 8;
    WebLabel74.Top := 403;
    WebLabel74.Width := 198;
    WebLabel74.Height := 29;
    WebLabel74.Caption := 'Kapitalerh'#246'hung';
    WebLabel74.ElementFont := efCSS;
    WebLabel74.Font.Charset := DEFAULT_CHARSET;
    WebLabel74.Font.Color := clWindowText;
    WebLabel74.Font.Height := -24;
    WebLabel74.Font.Name := 'Tahoma';
    WebLabel74.Font.Style := [fsBold];
    WebLabel74.HeightStyle := ssAuto;
    WebLabel74.HeightPercent := 100.00000000000000000;
    WebLabel74.ParentFont := False;
    WebLabel74.WidthPercent := 100.00000000000000000;
    WebLabel75.SetParentComponent(pnSonstiges);
    WebLabel75.Name := 'WebLabel75';
    WebLabel75.Left := 8;
    WebLabel75.Top := 455;
    WebLabel75.Width := 365;
    WebLabel75.Height := 29;
    WebLabel75.Caption := 'Zweckgebundene F'#246'rdermittel';
    WebLabel75.ElementFont := efCSS;
    WebLabel75.Font.Charset := DEFAULT_CHARSET;
    WebLabel75.Font.Color := clWindowText;
    WebLabel75.Font.Height := -24;
    WebLabel75.Font.Name := 'Tahoma';
    WebLabel75.Font.Style := [fsBold];
    WebLabel75.HeightStyle := ssAuto;
    WebLabel75.HeightPercent := 100.00000000000000000;
    WebLabel75.ParentFont := False;
    WebLabel75.WidthPercent := 100.00000000000000000;
    lblKrankenhaus1.SetParentComponent(pnSonstiges);
    lblKrankenhaus1.Name := 'lblKrankenhaus1';
    lblKrankenhaus1.Left := 493;
    lblKrankenhaus1.Top := 51;
    lblKrankenhaus1.Width := 177;
    lblKrankenhaus1.Height := 29;
    lblKrankenhaus1.Caption := 'Krankenhaus 1';
    lblKrankenhaus1.ElementFont := efCSS;
    lblKrankenhaus1.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus1.Font.Color := clWindowText;
    lblKrankenhaus1.Font.Height := -24;
    lblKrankenhaus1.Font.Name := 'Tahoma';
    lblKrankenhaus1.Font.Style := [fsBold];
    lblKrankenhaus1.HeightStyle := ssAuto;
    lblKrankenhaus1.HeightPercent := 100.00000000000000000;
    lblKrankenhaus1.ParentFont := False;
    lblKrankenhaus1.WidthPercent := 100.00000000000000000;
    lblKrankenhaus2.SetParentComponent(pnSonstiges);
    lblKrankenhaus2.Name := 'lblKrankenhaus2';
    lblKrankenhaus2.Left := 681;
    lblKrankenhaus2.Top := 51;
    lblKrankenhaus2.Width := 177;
    lblKrankenhaus2.Height := 29;
    lblKrankenhaus2.Caption := 'Krankenhaus 2';
    lblKrankenhaus2.ElementFont := efCSS;
    lblKrankenhaus2.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus2.Font.Color := clWindowText;
    lblKrankenhaus2.Font.Height := -24;
    lblKrankenhaus2.Font.Name := 'Tahoma';
    lblKrankenhaus2.Font.Style := [fsBold];
    lblKrankenhaus2.HeightStyle := ssAuto;
    lblKrankenhaus2.HeightPercent := 100.00000000000000000;
    lblKrankenhaus2.ParentFont := False;
    lblKrankenhaus2.WidthPercent := 100.00000000000000000;
    lblKrankenhaus3.SetParentComponent(pnSonstiges);
    lblKrankenhaus3.Name := 'lblKrankenhaus3';
    lblKrankenhaus3.Left := 863;
    lblKrankenhaus3.Top := 51;
    lblKrankenhaus3.Width := 177;
    lblKrankenhaus3.Height := 29;
    lblKrankenhaus3.Caption := 'Krankenhaus 3';
    lblKrankenhaus3.ElementFont := efCSS;
    lblKrankenhaus3.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus3.Font.Color := clWindowText;
    lblKrankenhaus3.Font.Height := -24;
    lblKrankenhaus3.Font.Name := 'Tahoma';
    lblKrankenhaus3.Font.Style := [fsBold];
    lblKrankenhaus3.HeightStyle := ssAuto;
    lblKrankenhaus3.HeightPercent := 100.00000000000000000;
    lblKrankenhaus3.ParentFont := False;
    lblKrankenhaus3.WidthPercent := 100.00000000000000000;
    lblKrankenhaus4.SetParentComponent(pnSonstiges);
    lblKrankenhaus4.Name := 'lblKrankenhaus4';
    lblKrankenhaus4.Left := 1044;
    lblKrankenhaus4.Top := 51;
    lblKrankenhaus4.Width := 177;
    lblKrankenhaus4.Height := 29;
    lblKrankenhaus4.Caption := 'Krankenhaus 4';
    lblKrankenhaus4.ElementFont := efCSS;
    lblKrankenhaus4.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus4.Font.Color := clWindowText;
    lblKrankenhaus4.Font.Height := -24;
    lblKrankenhaus4.Font.Name := 'Tahoma';
    lblKrankenhaus4.Font.Style := [fsBold];
    lblKrankenhaus4.HeightStyle := ssAuto;
    lblKrankenhaus4.HeightPercent := 100.00000000000000000;
    lblKrankenhaus4.ParentFont := False;
    lblKrankenhaus4.WidthPercent := 100.00000000000000000;
    lblKrankenhaus5.SetParentComponent(pnSonstiges);
    lblKrankenhaus5.Name := 'lblKrankenhaus5';
    lblKrankenhaus5.Left := 1221;
    lblKrankenhaus5.Top := 51;
    lblKrankenhaus5.Width := 177;
    lblKrankenhaus5.Height := 29;
    lblKrankenhaus5.Caption := 'Krankenhaus 5';
    lblKrankenhaus5.ElementFont := efCSS;
    lblKrankenhaus5.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus5.Font.Color := clWindowText;
    lblKrankenhaus5.Font.Height := -24;
    lblKrankenhaus5.Font.Name := 'Tahoma';
    lblKrankenhaus5.Font.Style := [fsBold];
    lblKrankenhaus5.HeightStyle := ssAuto;
    lblKrankenhaus5.HeightPercent := 100.00000000000000000;
    lblKrankenhaus5.ParentFont := False;
    lblKrankenhaus5.WidthPercent := 100.00000000000000000;
    WebLabel107.SetParentComponent(pnSonstiges);
    WebLabel107.Name := 'WebLabel107';
    WebLabel107.Left := 8;
    WebLabel107.Top := 195;
    WebLabel107.Width := 40;
    WebLabel107.Height := 29;
    WebLabel107.Caption := 'frei';
    WebLabel107.ElementFont := efCSS;
    WebLabel107.Font.Charset := DEFAULT_CHARSET;
    WebLabel107.Font.Color := clWindowText;
    WebLabel107.Font.Height := -24;
    WebLabel107.Font.Name := 'Tahoma';
    WebLabel107.Font.Style := [fsBold];
    WebLabel107.HeightStyle := ssAuto;
    WebLabel107.HeightPercent := 100.00000000000000000;
    WebLabel107.ParentFont := False;
    WebLabel107.WidthPercent := 100.00000000000000000;
    WebLabel108.SetParentComponent(pnSonstiges);
    WebLabel108.Name := 'WebLabel108';
    WebLabel108.Left := 8;
    WebLabel108.Top := 299;
    WebLabel108.Width := 40;
    WebLabel108.Height := 29;
    WebLabel108.Caption := 'frei';
    WebLabel108.ElementFont := efCSS;
    WebLabel108.Font.Charset := DEFAULT_CHARSET;
    WebLabel108.Font.Color := clWindowText;
    WebLabel108.Font.Height := -24;
    WebLabel108.Font.Name := 'Tahoma';
    WebLabel108.Font.Style := [fsBold];
    WebLabel108.HeightStyle := ssAuto;
    WebLabel108.HeightPercent := 100.00000000000000000;
    WebLabel108.ParentFont := False;
    WebLabel108.WidthPercent := 100.00000000000000000;
    WebLabel39.SetParentComponent(pnSonstiges);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 48;
    WebLabel39.Top := 40;
    WebLabel39.Width := 98;
    WebLabel39.Height := 18;
    WebLabel39.Caption := 'Sonstige Daten';
    WebLabel39.ElementFont := efCSS;
    WebLabel39.ElementPosition := epRelative;
    WebLabel39.HeightStyle := ssAuto;
    WebLabel39.HeightPercent := 100.00000000000000000;
    WebLabel39.HTMLType := tH3;
    WebLabel39.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw1.SetParentComponent(pnSonstiges);
    RFE_AusOrdAufw1.Name := 'RFE_AusOrdAufw1';
    RFE_AusOrdAufw1.Left := 493;
    RFE_AusOrdAufw1.Top := 86;
    RFE_AusOrdAufw1.Width := 150;
    RFE_AusOrdAufw1.Height := 46;
    RFE_AusOrdAufw1.ChildOrder := 15;
    RFE_AusOrdAufw1.EditType := weSignedNumeric;
    RFE_AusOrdAufw1.ElementFont := efCSS;
    RFE_AusOrdAufw1.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdAufw1.Font.Color := clWindowText;
    RFE_AusOrdAufw1.Font.Height := -24;
    RFE_AusOrdAufw1.Font.Name := 'Segoe UI';
    RFE_AusOrdAufw1.Font.Style := [fsBold];
    RFE_AusOrdAufw1.HeightStyle := ssAuto;
    RFE_AusOrdAufw1.HeightPercent := 100.00000000000000000;
    RFE_AusOrdAufw1.ParentFont := False;
    RFE_AusOrdAufw1.Text := ' ';
    RFE_AusOrdAufw1.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw1.DataField := 'Hhmc_Extra_Expenses';
    RFE_AusOrdAufw1.DataSource := HospitalMisc1WebDataSource;
    RFE_AusOrdErtr1.SetParentComponent(pnSonstiges);
    RFE_AusOrdErtr1.Name := 'RFE_AusOrdErtr1';
    RFE_AusOrdErtr1.Left := 493;
    RFE_AusOrdErtr1.Top := 138;
    RFE_AusOrdErtr1.Width := 150;
    RFE_AusOrdErtr1.Height := 46;
    RFE_AusOrdErtr1.ChildOrder := 16;
    RFE_AusOrdErtr1.EditType := weSignedNumeric;
    RFE_AusOrdErtr1.ElementFont := efCSS;
    RFE_AusOrdErtr1.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdErtr1.Font.Color := clWindowText;
    RFE_AusOrdErtr1.Font.Height := -24;
    RFE_AusOrdErtr1.Font.Name := 'Segoe UI';
    RFE_AusOrdErtr1.Font.Style := [fsBold];
    RFE_AusOrdErtr1.HeightStyle := ssAuto;
    RFE_AusOrdErtr1.HeightPercent := 100.00000000000000000;
    RFE_AusOrdErtr1.ParentFont := False;
    RFE_AusOrdErtr1.TabOrder := 1;
    RFE_AusOrdErtr1.Text := ' ';
    RFE_AusOrdErtr1.WidthPercent := 100.00000000000000000;
    RFE_AusOrdErtr1.DataField := 'Hhmc_Extra_Profit';
    RFE_AusOrdErtr1.DataSource := HospitalMisc1WebDataSource;
    RFE_ForderTrag1.SetParentComponent(pnSonstiges);
    RFE_ForderTrag1.Name := 'RFE_ForderTrag1';
    RFE_ForderTrag1.Left := 493;
    RFE_ForderTrag1.Top := 190;
    RFE_ForderTrag1.Width := 150;
    RFE_ForderTrag1.Height := 46;
    RFE_ForderTrag1.ChildOrder := 17;
    RFE_ForderTrag1.EditType := weSignedNumeric;
    RFE_ForderTrag1.ElementFont := efCSS;
    RFE_ForderTrag1.Font.Charset := ANSI_CHARSET;
    RFE_ForderTrag1.Font.Color := clWindowText;
    RFE_ForderTrag1.Font.Height := -24;
    RFE_ForderTrag1.Font.Name := 'Segoe UI';
    RFE_ForderTrag1.Font.Style := [fsBold];
    RFE_ForderTrag1.HeightStyle := ssAuto;
    RFE_ForderTrag1.HeightPercent := 100.00000000000000000;
    RFE_ForderTrag1.ParentFont := False;
    RFE_ForderTrag1.TabOrder := 2;
    RFE_ForderTrag1.Text := ' ';
    RFE_ForderTrag1.WidthPercent := 100.00000000000000000;
    RFE_ForderTrag1.DataField := 'Hhmc_Misc_1';
    RFE_ForderTrag1.DataSource := HospitalMisc1WebDataSource;
    RFE_Forder_KHG1.SetParentComponent(pnSonstiges);
    RFE_Forder_KHG1.Name := 'RFE_Forder_KHG1';
    RFE_Forder_KHG1.Left := 493;
    RFE_Forder_KHG1.Top := 242;
    RFE_Forder_KHG1.Width := 150;
    RFE_Forder_KHG1.Height := 46;
    RFE_Forder_KHG1.ChildOrder := 18;
    RFE_Forder_KHG1.EditType := weSignedNumeric;
    RFE_Forder_KHG1.ElementFont := efCSS;
    RFE_Forder_KHG1.Font.Charset := ANSI_CHARSET;
    RFE_Forder_KHG1.Font.Color := clWindowText;
    RFE_Forder_KHG1.Font.Height := -24;
    RFE_Forder_KHG1.Font.Name := 'Segoe UI';
    RFE_Forder_KHG1.Font.Style := [fsBold];
    RFE_Forder_KHG1.HeightStyle := ssAuto;
    RFE_Forder_KHG1.HeightPercent := 100.00000000000000000;
    RFE_Forder_KHG1.ParentFont := False;
    RFE_Forder_KHG1.TabOrder := 3;
    RFE_Forder_KHG1.Text := ' ';
    RFE_Forder_KHG1.WidthPercent := 100.00000000000000000;
    RFE_Forder_KHG1.DataField := 'Hhmc_Requirements';
    RFE_Forder_KHG1.DataSource := HospitalMisc1WebDataSource;
    RFE_Dummy1.SetParentComponent(pnSonstiges);
    RFE_Dummy1.Name := 'RFE_Dummy1';
    RFE_Dummy1.Left := 493;
    RFE_Dummy1.Top := 294;
    RFE_Dummy1.Width := 150;
    RFE_Dummy1.Height := 46;
    RFE_Dummy1.ChildOrder := 19;
    RFE_Dummy1.EditType := weSignedNumeric;
    RFE_Dummy1.ElementFont := efCSS;
    RFE_Dummy1.Font.Charset := ANSI_CHARSET;
    RFE_Dummy1.Font.Color := clWindowText;
    RFE_Dummy1.Font.Height := -24;
    RFE_Dummy1.Font.Name := 'Segoe UI';
    RFE_Dummy1.Font.Style := [fsBold];
    RFE_Dummy1.HeightStyle := ssAuto;
    RFE_Dummy1.HeightPercent := 100.00000000000000000;
    RFE_Dummy1.ParentFont := False;
    RFE_Dummy1.TabOrder := 4;
    RFE_Dummy1.Text := ' ';
    RFE_Dummy1.WidthPercent := 100.00000000000000000;
    RFE_Dummy1.DataField := 'Hhmc_Misc_2';
    RFE_Dummy1.DataSource := HospitalMisc1WebDataSource;
    RFE_Verblk_KHG1.SetParentComponent(pnSonstiges);
    RFE_Verblk_KHG1.Name := 'RFE_Verblk_KHG1';
    RFE_Verblk_KHG1.Left := 493;
    RFE_Verblk_KHG1.Top := 346;
    RFE_Verblk_KHG1.Width := 150;
    RFE_Verblk_KHG1.Height := 46;
    RFE_Verblk_KHG1.ChildOrder := 20;
    RFE_Verblk_KHG1.EditType := weSignedNumeric;
    RFE_Verblk_KHG1.ElementFont := efCSS;
    RFE_Verblk_KHG1.Font.Charset := ANSI_CHARSET;
    RFE_Verblk_KHG1.Font.Color := clWindowText;
    RFE_Verblk_KHG1.Font.Height := -24;
    RFE_Verblk_KHG1.Font.Name := 'Segoe UI';
    RFE_Verblk_KHG1.Font.Style := [fsBold];
    RFE_Verblk_KHG1.HeightStyle := ssAuto;
    RFE_Verblk_KHG1.HeightPercent := 100.00000000000000000;
    RFE_Verblk_KHG1.ParentFont := False;
    RFE_Verblk_KHG1.TabOrder := 5;
    RFE_Verblk_KHG1.Text := ' ';
    RFE_Verblk_KHG1.WidthPercent := 100.00000000000000000;
    RFE_Verblk_KHG1.DataField := 'Hhmc_Liabilities';
    RFE_Verblk_KHG1.DataSource := HospitalMisc1WebDataSource;
    RFE_Kapitalerh1.SetParentComponent(pnSonstiges);
    RFE_Kapitalerh1.Name := 'RFE_Kapitalerh1';
    RFE_Kapitalerh1.Left := 493;
    RFE_Kapitalerh1.Top := 398;
    RFE_Kapitalerh1.Width := 150;
    RFE_Kapitalerh1.Height := 46;
    RFE_Kapitalerh1.ChildOrder := 21;
    RFE_Kapitalerh1.EditType := weSignedNumeric;
    RFE_Kapitalerh1.ElementFont := efCSS;
    RFE_Kapitalerh1.Font.Charset := ANSI_CHARSET;
    RFE_Kapitalerh1.Font.Color := clWindowText;
    RFE_Kapitalerh1.Font.Height := -24;
    RFE_Kapitalerh1.Font.Name := 'Segoe UI';
    RFE_Kapitalerh1.Font.Style := [fsBold];
    RFE_Kapitalerh1.HeightStyle := ssAuto;
    RFE_Kapitalerh1.HeightPercent := 100.00000000000000000;
    RFE_Kapitalerh1.ParentFont := False;
    RFE_Kapitalerh1.TabOrder := 6;
    RFE_Kapitalerh1.Text := ' ';
    RFE_Kapitalerh1.WidthPercent := 100.00000000000000000;
    RFE_Kapitalerh1.DataField := 'Hhmc_Capital_Increase';
    RFE_Kapitalerh1.DataSource := HospitalMisc1WebDataSource;
    RFE_FoerderMtl1.SetParentComponent(pnSonstiges);
    RFE_FoerderMtl1.Name := 'RFE_FoerderMtl1';
    RFE_FoerderMtl1.Left := 493;
    RFE_FoerderMtl1.Top := 450;
    RFE_FoerderMtl1.Width := 150;
    RFE_FoerderMtl1.Height := 46;
    RFE_FoerderMtl1.ChildOrder := 22;
    RFE_FoerderMtl1.EditType := weSignedNumeric;
    RFE_FoerderMtl1.ElementFont := efCSS;
    RFE_FoerderMtl1.Font.Charset := ANSI_CHARSET;
    RFE_FoerderMtl1.Font.Color := clWindowText;
    RFE_FoerderMtl1.Font.Height := -24;
    RFE_FoerderMtl1.Font.Name := 'Segoe UI';
    RFE_FoerderMtl1.Font.Style := [fsBold];
    RFE_FoerderMtl1.HeightStyle := ssAuto;
    RFE_FoerderMtl1.HeightPercent := 100.00000000000000000;
    RFE_FoerderMtl1.ParentFont := False;
    RFE_FoerderMtl1.TabOrder := 7;
    RFE_FoerderMtl1.Text := ' ';
    RFE_FoerderMtl1.WidthPercent := 100.00000000000000000;
    RFE_FoerderMtl1.DataField := 'Hhmc_Earmarked_Funding';
    RFE_FoerderMtl1.DataSource := HospitalMisc1WebDataSource;
    RFE_AusOrdAufw2.SetParentComponent(pnSonstiges);
    RFE_AusOrdAufw2.Name := 'RFE_AusOrdAufw2';
    RFE_AusOrdAufw2.Left := 679;
    RFE_AusOrdAufw2.Top := 86;
    RFE_AusOrdAufw2.Width := 150;
    RFE_AusOrdAufw2.Height := 46;
    RFE_AusOrdAufw2.ChildOrder := 23;
    RFE_AusOrdAufw2.EditType := weSignedNumeric;
    RFE_AusOrdAufw2.ElementFont := efCSS;
    RFE_AusOrdAufw2.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdAufw2.Font.Color := clWindowText;
    RFE_AusOrdAufw2.Font.Height := -24;
    RFE_AusOrdAufw2.Font.Name := 'Segoe UI';
    RFE_AusOrdAufw2.Font.Style := [fsBold];
    RFE_AusOrdAufw2.HeightStyle := ssAuto;
    RFE_AusOrdAufw2.HeightPercent := 100.00000000000000000;
    RFE_AusOrdAufw2.ParentFont := False;
    RFE_AusOrdAufw2.TabOrder := 8;
    RFE_AusOrdAufw2.Text := ' ';
    RFE_AusOrdAufw2.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw2.DataField := 'Hhmc_Extra_Expenses';
    RFE_AusOrdAufw2.DataSource := HospitalMisc2WebDataSource;
    RFE_AusOrdErtr2.SetParentComponent(pnSonstiges);
    RFE_AusOrdErtr2.Name := 'RFE_AusOrdErtr2';
    RFE_AusOrdErtr2.Left := 679;
    RFE_AusOrdErtr2.Top := 138;
    RFE_AusOrdErtr2.Width := 150;
    RFE_AusOrdErtr2.Height := 46;
    RFE_AusOrdErtr2.ChildOrder := 24;
    RFE_AusOrdErtr2.EditType := weSignedNumeric;
    RFE_AusOrdErtr2.ElementFont := efCSS;
    RFE_AusOrdErtr2.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdErtr2.Font.Color := clWindowText;
    RFE_AusOrdErtr2.Font.Height := -24;
    RFE_AusOrdErtr2.Font.Name := 'Segoe UI';
    RFE_AusOrdErtr2.Font.Style := [fsBold];
    RFE_AusOrdErtr2.HeightStyle := ssAuto;
    RFE_AusOrdErtr2.HeightPercent := 100.00000000000000000;
    RFE_AusOrdErtr2.ParentFont := False;
    RFE_AusOrdErtr2.TabOrder := 9;
    RFE_AusOrdErtr2.Text := ' ';
    RFE_AusOrdErtr2.WidthPercent := 100.00000000000000000;
    RFE_AusOrdErtr2.DataField := 'Hhmc_Extra_Profit';
    RFE_AusOrdErtr2.DataSource := HospitalMisc2WebDataSource;
    RFE_ForderTrag2.SetParentComponent(pnSonstiges);
    RFE_ForderTrag2.Name := 'RFE_ForderTrag2';
    RFE_ForderTrag2.Left := 679;
    RFE_ForderTrag2.Top := 190;
    RFE_ForderTrag2.Width := 150;
    RFE_ForderTrag2.Height := 46;
    RFE_ForderTrag2.ChildOrder := 25;
    RFE_ForderTrag2.EditType := weSignedNumeric;
    RFE_ForderTrag2.ElementFont := efCSS;
    RFE_ForderTrag2.Font.Charset := ANSI_CHARSET;
    RFE_ForderTrag2.Font.Color := clWindowText;
    RFE_ForderTrag2.Font.Height := -24;
    RFE_ForderTrag2.Font.Name := 'Segoe UI';
    RFE_ForderTrag2.Font.Style := [fsBold];
    RFE_ForderTrag2.HeightStyle := ssAuto;
    RFE_ForderTrag2.HeightPercent := 100.00000000000000000;
    RFE_ForderTrag2.ParentFont := False;
    RFE_ForderTrag2.TabOrder := 10;
    RFE_ForderTrag2.Text := ' ';
    RFE_ForderTrag2.WidthPercent := 100.00000000000000000;
    RFE_ForderTrag2.DataField := 'Hhmc_Misc_1';
    RFE_ForderTrag2.DataSource := HospitalMisc2WebDataSource;
    RFE_Forder_KHG2.SetParentComponent(pnSonstiges);
    RFE_Forder_KHG2.Name := 'RFE_Forder_KHG2';
    RFE_Forder_KHG2.Left := 679;
    RFE_Forder_KHG2.Top := 242;
    RFE_Forder_KHG2.Width := 150;
    RFE_Forder_KHG2.Height := 46;
    RFE_Forder_KHG2.ChildOrder := 26;
    RFE_Forder_KHG2.EditType := weSignedNumeric;
    RFE_Forder_KHG2.ElementFont := efCSS;
    RFE_Forder_KHG2.Font.Charset := ANSI_CHARSET;
    RFE_Forder_KHG2.Font.Color := clWindowText;
    RFE_Forder_KHG2.Font.Height := -24;
    RFE_Forder_KHG2.Font.Name := 'Segoe UI';
    RFE_Forder_KHG2.Font.Style := [fsBold];
    RFE_Forder_KHG2.HeightStyle := ssAuto;
    RFE_Forder_KHG2.HeightPercent := 100.00000000000000000;
    RFE_Forder_KHG2.ParentFont := False;
    RFE_Forder_KHG2.TabOrder := 11;
    RFE_Forder_KHG2.Text := ' ';
    RFE_Forder_KHG2.WidthPercent := 100.00000000000000000;
    RFE_Forder_KHG2.DataField := 'Hhmc_Requirements';
    RFE_Forder_KHG2.DataSource := HospitalMisc2WebDataSource;
    RFE_Dummy2.SetParentComponent(pnSonstiges);
    RFE_Dummy2.Name := 'RFE_Dummy2';
    RFE_Dummy2.Left := 679;
    RFE_Dummy2.Top := 294;
    RFE_Dummy2.Width := 150;
    RFE_Dummy2.Height := 46;
    RFE_Dummy2.ChildOrder := 27;
    RFE_Dummy2.EditType := weSignedNumeric;
    RFE_Dummy2.ElementFont := efCSS;
    RFE_Dummy2.Font.Charset := ANSI_CHARSET;
    RFE_Dummy2.Font.Color := clWindowText;
    RFE_Dummy2.Font.Height := -24;
    RFE_Dummy2.Font.Name := 'Segoe UI';
    RFE_Dummy2.Font.Style := [fsBold];
    RFE_Dummy2.HeightStyle := ssAuto;
    RFE_Dummy2.HeightPercent := 100.00000000000000000;
    RFE_Dummy2.ParentFont := False;
    RFE_Dummy2.TabOrder := 12;
    RFE_Dummy2.Text := ' ';
    RFE_Dummy2.WidthPercent := 100.00000000000000000;
    RFE_Dummy2.DataField := 'Hhmc_Misc_2';
    RFE_Dummy2.DataSource := HospitalMisc2WebDataSource;
    RFE_Verblk_KHG2.SetParentComponent(pnSonstiges);
    RFE_Verblk_KHG2.Name := 'RFE_Verblk_KHG2';
    RFE_Verblk_KHG2.Left := 679;
    RFE_Verblk_KHG2.Top := 346;
    RFE_Verblk_KHG2.Width := 150;
    RFE_Verblk_KHG2.Height := 46;
    RFE_Verblk_KHG2.ChildOrder := 28;
    RFE_Verblk_KHG2.EditType := weSignedNumeric;
    RFE_Verblk_KHG2.ElementFont := efCSS;
    RFE_Verblk_KHG2.Font.Charset := ANSI_CHARSET;
    RFE_Verblk_KHG2.Font.Color := clWindowText;
    RFE_Verblk_KHG2.Font.Height := -24;
    RFE_Verblk_KHG2.Font.Name := 'Segoe UI';
    RFE_Verblk_KHG2.Font.Style := [fsBold];
    RFE_Verblk_KHG2.HeightStyle := ssAuto;
    RFE_Verblk_KHG2.HeightPercent := 100.00000000000000000;
    RFE_Verblk_KHG2.ParentFont := False;
    RFE_Verblk_KHG2.TabOrder := 13;
    RFE_Verblk_KHG2.Text := ' ';
    RFE_Verblk_KHG2.WidthPercent := 100.00000000000000000;
    RFE_Verblk_KHG2.DataField := 'Hhmc_Liabilities';
    RFE_Verblk_KHG2.DataSource := HospitalMisc2WebDataSource;
    RFE_Kapitalerh2.SetParentComponent(pnSonstiges);
    RFE_Kapitalerh2.Name := 'RFE_Kapitalerh2';
    RFE_Kapitalerh2.Left := 679;
    RFE_Kapitalerh2.Top := 398;
    RFE_Kapitalerh2.Width := 150;
    RFE_Kapitalerh2.Height := 46;
    RFE_Kapitalerh2.ChildOrder := 29;
    RFE_Kapitalerh2.EditType := weSignedNumeric;
    RFE_Kapitalerh2.ElementFont := efCSS;
    RFE_Kapitalerh2.Font.Charset := ANSI_CHARSET;
    RFE_Kapitalerh2.Font.Color := clWindowText;
    RFE_Kapitalerh2.Font.Height := -24;
    RFE_Kapitalerh2.Font.Name := 'Segoe UI';
    RFE_Kapitalerh2.Font.Style := [fsBold];
    RFE_Kapitalerh2.HeightStyle := ssAuto;
    RFE_Kapitalerh2.HeightPercent := 100.00000000000000000;
    RFE_Kapitalerh2.ParentFont := False;
    RFE_Kapitalerh2.TabOrder := 14;
    RFE_Kapitalerh2.Text := ' ';
    RFE_Kapitalerh2.WidthPercent := 100.00000000000000000;
    RFE_Kapitalerh2.DataField := 'Hhmc_Capital_Increase';
    RFE_Kapitalerh2.DataSource := HospitalMisc2WebDataSource;
    RFE_FoerderMtl2.SetParentComponent(pnSonstiges);
    RFE_FoerderMtl2.Name := 'RFE_FoerderMtl2';
    RFE_FoerderMtl2.Left := 679;
    RFE_FoerderMtl2.Top := 450;
    RFE_FoerderMtl2.Width := 150;
    RFE_FoerderMtl2.Height := 46;
    RFE_FoerderMtl2.ChildOrder := 30;
    RFE_FoerderMtl2.EditType := weSignedNumeric;
    RFE_FoerderMtl2.ElementFont := efCSS;
    RFE_FoerderMtl2.Font.Charset := ANSI_CHARSET;
    RFE_FoerderMtl2.Font.Color := clWindowText;
    RFE_FoerderMtl2.Font.Height := -24;
    RFE_FoerderMtl2.Font.Name := 'Segoe UI';
    RFE_FoerderMtl2.Font.Style := [fsBold];
    RFE_FoerderMtl2.HeightStyle := ssAuto;
    RFE_FoerderMtl2.HeightPercent := 100.00000000000000000;
    RFE_FoerderMtl2.ParentFont := False;
    RFE_FoerderMtl2.TabOrder := 15;
    RFE_FoerderMtl2.Text := ' ';
    RFE_FoerderMtl2.WidthPercent := 100.00000000000000000;
    RFE_FoerderMtl2.DataField := 'Hhmc_Earmarked_Funding';
    RFE_FoerderMtl2.DataSource := HospitalMisc2WebDataSource;
    RFE_AusOrdAufw3.SetParentComponent(pnSonstiges);
    RFE_AusOrdAufw3.Name := 'RFE_AusOrdAufw3';
    RFE_AusOrdAufw3.Left := 863;
    RFE_AusOrdAufw3.Top := 86;
    RFE_AusOrdAufw3.Width := 150;
    RFE_AusOrdAufw3.Height := 46;
    RFE_AusOrdAufw3.ChildOrder := 31;
    RFE_AusOrdAufw3.EditType := weSignedNumeric;
    RFE_AusOrdAufw3.ElementFont := efCSS;
    RFE_AusOrdAufw3.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdAufw3.Font.Color := clWindowText;
    RFE_AusOrdAufw3.Font.Height := -24;
    RFE_AusOrdAufw3.Font.Name := 'Segoe UI';
    RFE_AusOrdAufw3.Font.Style := [fsBold];
    RFE_AusOrdAufw3.HeightStyle := ssAuto;
    RFE_AusOrdAufw3.HeightPercent := 100.00000000000000000;
    RFE_AusOrdAufw3.ParentFont := False;
    RFE_AusOrdAufw3.TabOrder := 16;
    RFE_AusOrdAufw3.Text := ' ';
    RFE_AusOrdAufw3.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw3.DataField := 'Hhmc_Extra_Expenses';
    RFE_AusOrdAufw3.DataSource := HospitalMisc3WebDataSource;
    RFE_AusOrdErtr3.SetParentComponent(pnSonstiges);
    RFE_AusOrdErtr3.Name := 'RFE_AusOrdErtr3';
    RFE_AusOrdErtr3.Left := 863;
    RFE_AusOrdErtr3.Top := 138;
    RFE_AusOrdErtr3.Width := 150;
    RFE_AusOrdErtr3.Height := 46;
    RFE_AusOrdErtr3.ChildOrder := 32;
    RFE_AusOrdErtr3.EditType := weSignedNumeric;
    RFE_AusOrdErtr3.ElementFont := efCSS;
    RFE_AusOrdErtr3.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdErtr3.Font.Color := clWindowText;
    RFE_AusOrdErtr3.Font.Height := -24;
    RFE_AusOrdErtr3.Font.Name := 'Segoe UI';
    RFE_AusOrdErtr3.Font.Style := [fsBold];
    RFE_AusOrdErtr3.HeightStyle := ssAuto;
    RFE_AusOrdErtr3.HeightPercent := 100.00000000000000000;
    RFE_AusOrdErtr3.ParentFont := False;
    RFE_AusOrdErtr3.TabOrder := 17;
    RFE_AusOrdErtr3.Text := ' ';
    RFE_AusOrdErtr3.WidthPercent := 100.00000000000000000;
    RFE_AusOrdErtr3.DataField := 'Hhmc_Extra_Profit';
    RFE_AusOrdErtr3.DataSource := HospitalMisc3WebDataSource;
    RFE_ForderTrag3.SetParentComponent(pnSonstiges);
    RFE_ForderTrag3.Name := 'RFE_ForderTrag3';
    RFE_ForderTrag3.Left := 863;
    RFE_ForderTrag3.Top := 190;
    RFE_ForderTrag3.Width := 150;
    RFE_ForderTrag3.Height := 46;
    RFE_ForderTrag3.ChildOrder := 33;
    RFE_ForderTrag3.EditType := weSignedNumeric;
    RFE_ForderTrag3.ElementFont := efCSS;
    RFE_ForderTrag3.Font.Charset := ANSI_CHARSET;
    RFE_ForderTrag3.Font.Color := clWindowText;
    RFE_ForderTrag3.Font.Height := -24;
    RFE_ForderTrag3.Font.Name := 'Segoe UI';
    RFE_ForderTrag3.Font.Style := [fsBold];
    RFE_ForderTrag3.HeightStyle := ssAuto;
    RFE_ForderTrag3.HeightPercent := 100.00000000000000000;
    RFE_ForderTrag3.ParentFont := False;
    RFE_ForderTrag3.TabOrder := 18;
    RFE_ForderTrag3.Text := ' ';
    RFE_ForderTrag3.WidthPercent := 100.00000000000000000;
    RFE_ForderTrag3.DataField := 'Hhmc_Misc_1';
    RFE_ForderTrag3.DataSource := HospitalMisc3WebDataSource;
    RFE_Forder_KHG3.SetParentComponent(pnSonstiges);
    RFE_Forder_KHG3.Name := 'RFE_Forder_KHG3';
    RFE_Forder_KHG3.Left := 863;
    RFE_Forder_KHG3.Top := 242;
    RFE_Forder_KHG3.Width := 150;
    RFE_Forder_KHG3.Height := 46;
    RFE_Forder_KHG3.ChildOrder := 34;
    RFE_Forder_KHG3.EditType := weSignedNumeric;
    RFE_Forder_KHG3.ElementFont := efCSS;
    RFE_Forder_KHG3.Font.Charset := ANSI_CHARSET;
    RFE_Forder_KHG3.Font.Color := clWindowText;
    RFE_Forder_KHG3.Font.Height := -24;
    RFE_Forder_KHG3.Font.Name := 'Segoe UI';
    RFE_Forder_KHG3.Font.Style := [fsBold];
    RFE_Forder_KHG3.HeightStyle := ssAuto;
    RFE_Forder_KHG3.HeightPercent := 100.00000000000000000;
    RFE_Forder_KHG3.ParentFont := False;
    RFE_Forder_KHG3.TabOrder := 19;
    RFE_Forder_KHG3.Text := ' ';
    RFE_Forder_KHG3.WidthPercent := 100.00000000000000000;
    RFE_Forder_KHG3.DataField := 'Hhmc_Requirements';
    RFE_Forder_KHG3.DataSource := HospitalMisc3WebDataSource;
    RFE_Dummy3.SetParentComponent(pnSonstiges);
    RFE_Dummy3.Name := 'RFE_Dummy3';
    RFE_Dummy3.Left := 863;
    RFE_Dummy3.Top := 294;
    RFE_Dummy3.Width := 150;
    RFE_Dummy3.Height := 46;
    RFE_Dummy3.ChildOrder := 35;
    RFE_Dummy3.EditType := weSignedNumeric;
    RFE_Dummy3.ElementFont := efCSS;
    RFE_Dummy3.Font.Charset := ANSI_CHARSET;
    RFE_Dummy3.Font.Color := clWindowText;
    RFE_Dummy3.Font.Height := -24;
    RFE_Dummy3.Font.Name := 'Segoe UI';
    RFE_Dummy3.Font.Style := [fsBold];
    RFE_Dummy3.HeightStyle := ssAuto;
    RFE_Dummy3.HeightPercent := 100.00000000000000000;
    RFE_Dummy3.ParentFont := False;
    RFE_Dummy3.TabOrder := 20;
    RFE_Dummy3.Text := ' ';
    RFE_Dummy3.WidthPercent := 100.00000000000000000;
    RFE_Dummy3.DataField := 'Hhmc_Misc_2';
    RFE_Dummy3.DataSource := HospitalMisc3WebDataSource;
    RFE_Verblk_KHG3.SetParentComponent(pnSonstiges);
    RFE_Verblk_KHG3.Name := 'RFE_Verblk_KHG3';
    RFE_Verblk_KHG3.Left := 863;
    RFE_Verblk_KHG3.Top := 346;
    RFE_Verblk_KHG3.Width := 150;
    RFE_Verblk_KHG3.Height := 46;
    RFE_Verblk_KHG3.ChildOrder := 36;
    RFE_Verblk_KHG3.EditType := weSignedNumeric;
    RFE_Verblk_KHG3.ElementFont := efCSS;
    RFE_Verblk_KHG3.Font.Charset := ANSI_CHARSET;
    RFE_Verblk_KHG3.Font.Color := clWindowText;
    RFE_Verblk_KHG3.Font.Height := -24;
    RFE_Verblk_KHG3.Font.Name := 'Segoe UI';
    RFE_Verblk_KHG3.Font.Style := [fsBold];
    RFE_Verblk_KHG3.HeightStyle := ssAuto;
    RFE_Verblk_KHG3.HeightPercent := 100.00000000000000000;
    RFE_Verblk_KHG3.ParentFont := False;
    RFE_Verblk_KHG3.TabOrder := 21;
    RFE_Verblk_KHG3.Text := ' ';
    RFE_Verblk_KHG3.WidthPercent := 100.00000000000000000;
    RFE_Verblk_KHG3.DataField := 'Hhmc_Liabilities';
    RFE_Verblk_KHG3.DataSource := HospitalMisc3WebDataSource;
    RFE_Kapitalerh3.SetParentComponent(pnSonstiges);
    RFE_Kapitalerh3.Name := 'RFE_Kapitalerh3';
    RFE_Kapitalerh3.Left := 863;
    RFE_Kapitalerh3.Top := 398;
    RFE_Kapitalerh3.Width := 150;
    RFE_Kapitalerh3.Height := 46;
    RFE_Kapitalerh3.ChildOrder := 37;
    RFE_Kapitalerh3.EditType := weSignedNumeric;
    RFE_Kapitalerh3.ElementFont := efCSS;
    RFE_Kapitalerh3.Font.Charset := ANSI_CHARSET;
    RFE_Kapitalerh3.Font.Color := clWindowText;
    RFE_Kapitalerh3.Font.Height := -24;
    RFE_Kapitalerh3.Font.Name := 'Segoe UI';
    RFE_Kapitalerh3.Font.Style := [fsBold];
    RFE_Kapitalerh3.HeightStyle := ssAuto;
    RFE_Kapitalerh3.HeightPercent := 100.00000000000000000;
    RFE_Kapitalerh3.ParentFont := False;
    RFE_Kapitalerh3.TabOrder := 22;
    RFE_Kapitalerh3.Text := ' ';
    RFE_Kapitalerh3.WidthPercent := 100.00000000000000000;
    RFE_Kapitalerh3.DataField := 'Hhmc_Capital_Increase';
    RFE_Kapitalerh3.DataSource := HospitalMisc3WebDataSource;
    RFE_FoerderMtl3.SetParentComponent(pnSonstiges);
    RFE_FoerderMtl3.Name := 'RFE_FoerderMtl3';
    RFE_FoerderMtl3.Left := 863;
    RFE_FoerderMtl3.Top := 450;
    RFE_FoerderMtl3.Width := 150;
    RFE_FoerderMtl3.Height := 46;
    RFE_FoerderMtl3.ChildOrder := 38;
    RFE_FoerderMtl3.EditType := weSignedNumeric;
    RFE_FoerderMtl3.ElementFont := efCSS;
    RFE_FoerderMtl3.Font.Charset := ANSI_CHARSET;
    RFE_FoerderMtl3.Font.Color := clWindowText;
    RFE_FoerderMtl3.Font.Height := -24;
    RFE_FoerderMtl3.Font.Name := 'Segoe UI';
    RFE_FoerderMtl3.Font.Style := [fsBold];
    RFE_FoerderMtl3.HeightStyle := ssAuto;
    RFE_FoerderMtl3.HeightPercent := 100.00000000000000000;
    RFE_FoerderMtl3.ParentFont := False;
    RFE_FoerderMtl3.TabOrder := 23;
    RFE_FoerderMtl3.Text := ' ';
    RFE_FoerderMtl3.WidthPercent := 100.00000000000000000;
    RFE_FoerderMtl3.DataField := 'Hhmc_Earmarked_Funding';
    RFE_FoerderMtl3.DataSource := HospitalMisc3WebDataSource;
    RFE_AusOrdAufw4.SetParentComponent(pnSonstiges);
    RFE_AusOrdAufw4.Name := 'RFE_AusOrdAufw4';
    RFE_AusOrdAufw4.Left := 1042;
    RFE_AusOrdAufw4.Top := 86;
    RFE_AusOrdAufw4.Width := 150;
    RFE_AusOrdAufw4.Height := 46;
    RFE_AusOrdAufw4.ChildOrder := 39;
    RFE_AusOrdAufw4.EditType := weSignedNumeric;
    RFE_AusOrdAufw4.ElementFont := efCSS;
    RFE_AusOrdAufw4.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdAufw4.Font.Color := clWindowText;
    RFE_AusOrdAufw4.Font.Height := -24;
    RFE_AusOrdAufw4.Font.Name := 'Segoe UI';
    RFE_AusOrdAufw4.Font.Style := [fsBold];
    RFE_AusOrdAufw4.HeightStyle := ssAuto;
    RFE_AusOrdAufw4.HeightPercent := 100.00000000000000000;
    RFE_AusOrdAufw4.ParentFont := False;
    RFE_AusOrdAufw4.TabOrder := 24;
    RFE_AusOrdAufw4.Text := ' ';
    RFE_AusOrdAufw4.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw4.DataField := 'Hhmc_Extra_Expenses';
    RFE_AusOrdAufw4.DataSource := HospitalMisc4WebDataSource;
    RFE_AusOrdErtr4.SetParentComponent(pnSonstiges);
    RFE_AusOrdErtr4.Name := 'RFE_AusOrdErtr4';
    RFE_AusOrdErtr4.Left := 1042;
    RFE_AusOrdErtr4.Top := 138;
    RFE_AusOrdErtr4.Width := 150;
    RFE_AusOrdErtr4.Height := 46;
    RFE_AusOrdErtr4.ChildOrder := 40;
    RFE_AusOrdErtr4.EditType := weSignedNumeric;
    RFE_AusOrdErtr4.ElementFont := efCSS;
    RFE_AusOrdErtr4.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdErtr4.Font.Color := clWindowText;
    RFE_AusOrdErtr4.Font.Height := -24;
    RFE_AusOrdErtr4.Font.Name := 'Segoe UI';
    RFE_AusOrdErtr4.Font.Style := [fsBold];
    RFE_AusOrdErtr4.HeightStyle := ssAuto;
    RFE_AusOrdErtr4.HeightPercent := 100.00000000000000000;
    RFE_AusOrdErtr4.ParentFont := False;
    RFE_AusOrdErtr4.TabOrder := 25;
    RFE_AusOrdErtr4.Text := ' ';
    RFE_AusOrdErtr4.WidthPercent := 100.00000000000000000;
    RFE_AusOrdErtr4.DataField := 'Hhmc_Extra_Profit';
    RFE_AusOrdErtr4.DataSource := HospitalMisc4WebDataSource;
    RFE_ForderTrag4.SetParentComponent(pnSonstiges);
    RFE_ForderTrag4.Name := 'RFE_ForderTrag4';
    RFE_ForderTrag4.Left := 1042;
    RFE_ForderTrag4.Top := 190;
    RFE_ForderTrag4.Width := 150;
    RFE_ForderTrag4.Height := 46;
    RFE_ForderTrag4.ChildOrder := 41;
    RFE_ForderTrag4.EditType := weSignedNumeric;
    RFE_ForderTrag4.ElementFont := efCSS;
    RFE_ForderTrag4.Font.Charset := ANSI_CHARSET;
    RFE_ForderTrag4.Font.Color := clWindowText;
    RFE_ForderTrag4.Font.Height := -24;
    RFE_ForderTrag4.Font.Name := 'Segoe UI';
    RFE_ForderTrag4.Font.Style := [fsBold];
    RFE_ForderTrag4.HeightStyle := ssAuto;
    RFE_ForderTrag4.HeightPercent := 100.00000000000000000;
    RFE_ForderTrag4.ParentFont := False;
    RFE_ForderTrag4.TabOrder := 26;
    RFE_ForderTrag4.Text := ' ';
    RFE_ForderTrag4.WidthPercent := 100.00000000000000000;
    RFE_ForderTrag4.DataField := 'Hhmc_Misc_1';
    RFE_ForderTrag4.DataSource := HospitalMisc4WebDataSource;
    RFE_Forder_KHG4.SetParentComponent(pnSonstiges);
    RFE_Forder_KHG4.Name := 'RFE_Forder_KHG4';
    RFE_Forder_KHG4.Left := 1042;
    RFE_Forder_KHG4.Top := 242;
    RFE_Forder_KHG4.Width := 150;
    RFE_Forder_KHG4.Height := 46;
    RFE_Forder_KHG4.ChildOrder := 42;
    RFE_Forder_KHG4.EditType := weSignedNumeric;
    RFE_Forder_KHG4.ElementFont := efCSS;
    RFE_Forder_KHG4.Font.Charset := ANSI_CHARSET;
    RFE_Forder_KHG4.Font.Color := clWindowText;
    RFE_Forder_KHG4.Font.Height := -24;
    RFE_Forder_KHG4.Font.Name := 'Segoe UI';
    RFE_Forder_KHG4.Font.Style := [fsBold];
    RFE_Forder_KHG4.HeightStyle := ssAuto;
    RFE_Forder_KHG4.HeightPercent := 100.00000000000000000;
    RFE_Forder_KHG4.ParentFont := False;
    RFE_Forder_KHG4.TabOrder := 27;
    RFE_Forder_KHG4.Text := ' ';
    RFE_Forder_KHG4.WidthPercent := 100.00000000000000000;
    RFE_Forder_KHG4.DataField := 'Hhmc_Requirements';
    RFE_Forder_KHG4.DataSource := HospitalMisc4WebDataSource;
    RFE_Dummy4.SetParentComponent(pnSonstiges);
    RFE_Dummy4.Name := 'RFE_Dummy4';
    RFE_Dummy4.Left := 1042;
    RFE_Dummy4.Top := 294;
    RFE_Dummy4.Width := 150;
    RFE_Dummy4.Height := 46;
    RFE_Dummy4.ChildOrder := 43;
    RFE_Dummy4.EditType := weSignedNumeric;
    RFE_Dummy4.ElementFont := efCSS;
    RFE_Dummy4.Font.Charset := ANSI_CHARSET;
    RFE_Dummy4.Font.Color := clWindowText;
    RFE_Dummy4.Font.Height := -24;
    RFE_Dummy4.Font.Name := 'Segoe UI';
    RFE_Dummy4.Font.Style := [fsBold];
    RFE_Dummy4.HeightStyle := ssAuto;
    RFE_Dummy4.HeightPercent := 100.00000000000000000;
    RFE_Dummy4.ParentFont := False;
    RFE_Dummy4.TabOrder := 28;
    RFE_Dummy4.Text := ' ';
    RFE_Dummy4.WidthPercent := 100.00000000000000000;
    RFE_Dummy4.DataField := 'Hhmc_Misc_2';
    RFE_Dummy4.DataSource := HospitalMisc4WebDataSource;
    RFE_Verblk_KHG4.SetParentComponent(pnSonstiges);
    RFE_Verblk_KHG4.Name := 'RFE_Verblk_KHG4';
    RFE_Verblk_KHG4.Left := 1042;
    RFE_Verblk_KHG4.Top := 346;
    RFE_Verblk_KHG4.Width := 150;
    RFE_Verblk_KHG4.Height := 46;
    RFE_Verblk_KHG4.ChildOrder := 44;
    RFE_Verblk_KHG4.EditType := weSignedNumeric;
    RFE_Verblk_KHG4.ElementFont := efCSS;
    RFE_Verblk_KHG4.Font.Charset := ANSI_CHARSET;
    RFE_Verblk_KHG4.Font.Color := clWindowText;
    RFE_Verblk_KHG4.Font.Height := -24;
    RFE_Verblk_KHG4.Font.Name := 'Segoe UI';
    RFE_Verblk_KHG4.Font.Style := [fsBold];
    RFE_Verblk_KHG4.HeightStyle := ssAuto;
    RFE_Verblk_KHG4.HeightPercent := 100.00000000000000000;
    RFE_Verblk_KHG4.ParentFont := False;
    RFE_Verblk_KHG4.TabOrder := 29;
    RFE_Verblk_KHG4.Text := ' ';
    RFE_Verblk_KHG4.WidthPercent := 100.00000000000000000;
    RFE_Verblk_KHG4.DataField := 'Hhmc_Liabilities';
    RFE_Verblk_KHG4.DataSource := HospitalMisc4WebDataSource;
    RFE_Kapitalerh4.SetParentComponent(pnSonstiges);
    RFE_Kapitalerh4.Name := 'RFE_Kapitalerh4';
    RFE_Kapitalerh4.Left := 1042;
    RFE_Kapitalerh4.Top := 398;
    RFE_Kapitalerh4.Width := 150;
    RFE_Kapitalerh4.Height := 46;
    RFE_Kapitalerh4.ChildOrder := 45;
    RFE_Kapitalerh4.EditType := weSignedNumeric;
    RFE_Kapitalerh4.ElementFont := efCSS;
    RFE_Kapitalerh4.Font.Charset := ANSI_CHARSET;
    RFE_Kapitalerh4.Font.Color := clWindowText;
    RFE_Kapitalerh4.Font.Height := -24;
    RFE_Kapitalerh4.Font.Name := 'Segoe UI';
    RFE_Kapitalerh4.Font.Style := [fsBold];
    RFE_Kapitalerh4.HeightStyle := ssAuto;
    RFE_Kapitalerh4.HeightPercent := 100.00000000000000000;
    RFE_Kapitalerh4.ParentFont := False;
    RFE_Kapitalerh4.TabOrder := 30;
    RFE_Kapitalerh4.Text := ' ';
    RFE_Kapitalerh4.WidthPercent := 100.00000000000000000;
    RFE_Kapitalerh4.DataField := 'Hhmc_Capital_Increase';
    RFE_Kapitalerh4.DataSource := HospitalMisc4WebDataSource;
    RFE_FoerderMtl4.SetParentComponent(pnSonstiges);
    RFE_FoerderMtl4.Name := 'RFE_FoerderMtl4';
    RFE_FoerderMtl4.Left := 1042;
    RFE_FoerderMtl4.Top := 450;
    RFE_FoerderMtl4.Width := 150;
    RFE_FoerderMtl4.Height := 46;
    RFE_FoerderMtl4.ChildOrder := 46;
    RFE_FoerderMtl4.EditType := weSignedNumeric;
    RFE_FoerderMtl4.ElementFont := efCSS;
    RFE_FoerderMtl4.Font.Charset := ANSI_CHARSET;
    RFE_FoerderMtl4.Font.Color := clWindowText;
    RFE_FoerderMtl4.Font.Height := -24;
    RFE_FoerderMtl4.Font.Name := 'Segoe UI';
    RFE_FoerderMtl4.Font.Style := [fsBold];
    RFE_FoerderMtl4.HeightStyle := ssAuto;
    RFE_FoerderMtl4.HeightPercent := 100.00000000000000000;
    RFE_FoerderMtl4.ParentFont := False;
    RFE_FoerderMtl4.TabOrder := 31;
    RFE_FoerderMtl4.Text := ' ';
    RFE_FoerderMtl4.WidthPercent := 100.00000000000000000;
    RFE_FoerderMtl4.DataField := 'Hhmc_Earmarked_Funding';
    RFE_FoerderMtl4.DataSource := HospitalMisc4WebDataSource;
    RFE_AusOrdAufw5.SetParentComponent(pnSonstiges);
    RFE_AusOrdAufw5.Name := 'RFE_AusOrdAufw5';
    RFE_AusOrdAufw5.Left := 1221;
    RFE_AusOrdAufw5.Top := 86;
    RFE_AusOrdAufw5.Width := 150;
    RFE_AusOrdAufw5.Height := 46;
    RFE_AusOrdAufw5.ChildOrder := 47;
    RFE_AusOrdAufw5.EditType := weSignedNumeric;
    RFE_AusOrdAufw5.ElementFont := efCSS;
    RFE_AusOrdAufw5.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdAufw5.Font.Color := clWindowText;
    RFE_AusOrdAufw5.Font.Height := -24;
    RFE_AusOrdAufw5.Font.Name := 'Segoe UI';
    RFE_AusOrdAufw5.Font.Style := [fsBold];
    RFE_AusOrdAufw5.HeightStyle := ssAuto;
    RFE_AusOrdAufw5.HeightPercent := 100.00000000000000000;
    RFE_AusOrdAufw5.ParentFont := False;
    RFE_AusOrdAufw5.TabOrder := 32;
    RFE_AusOrdAufw5.Text := ' ';
    RFE_AusOrdAufw5.WidthPercent := 100.00000000000000000;
    RFE_AusOrdAufw5.DataField := 'Hhmc_Extra_Expenses';
    RFE_AusOrdAufw5.DataSource := HospitalMisc5WebDataSource;
    RFE_AusOrdErtr5.SetParentComponent(pnSonstiges);
    RFE_AusOrdErtr5.Name := 'RFE_AusOrdErtr5';
    RFE_AusOrdErtr5.Left := 1221;
    RFE_AusOrdErtr5.Top := 138;
    RFE_AusOrdErtr5.Width := 150;
    RFE_AusOrdErtr5.Height := 46;
    RFE_AusOrdErtr5.ChildOrder := 48;
    RFE_AusOrdErtr5.EditType := weSignedNumeric;
    RFE_AusOrdErtr5.ElementFont := efCSS;
    RFE_AusOrdErtr5.Font.Charset := ANSI_CHARSET;
    RFE_AusOrdErtr5.Font.Color := clWindowText;
    RFE_AusOrdErtr5.Font.Height := -24;
    RFE_AusOrdErtr5.Font.Name := 'Segoe UI';
    RFE_AusOrdErtr5.Font.Style := [fsBold];
    RFE_AusOrdErtr5.HeightStyle := ssAuto;
    RFE_AusOrdErtr5.HeightPercent := 100.00000000000000000;
    RFE_AusOrdErtr5.ParentFont := False;
    RFE_AusOrdErtr5.TabOrder := 33;
    RFE_AusOrdErtr5.Text := ' ';
    RFE_AusOrdErtr5.WidthPercent := 100.00000000000000000;
    RFE_AusOrdErtr5.DataField := 'Hhmc_Extra_Profit';
    RFE_AusOrdErtr5.DataSource := HospitalMisc5WebDataSource;
    RFE_ForderTrag5.SetParentComponent(pnSonstiges);
    RFE_ForderTrag5.Name := 'RFE_ForderTrag5';
    RFE_ForderTrag5.Left := 1221;
    RFE_ForderTrag5.Top := 190;
    RFE_ForderTrag5.Width := 150;
    RFE_ForderTrag5.Height := 46;
    RFE_ForderTrag5.ChildOrder := 49;
    RFE_ForderTrag5.EditType := weSignedNumeric;
    RFE_ForderTrag5.ElementFont := efCSS;
    RFE_ForderTrag5.Font.Charset := ANSI_CHARSET;
    RFE_ForderTrag5.Font.Color := clWindowText;
    RFE_ForderTrag5.Font.Height := -24;
    RFE_ForderTrag5.Font.Name := 'Segoe UI';
    RFE_ForderTrag5.Font.Style := [fsBold];
    RFE_ForderTrag5.HeightStyle := ssAuto;
    RFE_ForderTrag5.HeightPercent := 100.00000000000000000;
    RFE_ForderTrag5.ParentFont := False;
    RFE_ForderTrag5.TabOrder := 34;
    RFE_ForderTrag5.Text := ' ';
    RFE_ForderTrag5.WidthPercent := 100.00000000000000000;
    RFE_ForderTrag5.DataField := 'Hhmc_Misc_1';
    RFE_ForderTrag5.DataSource := HospitalMisc5WebDataSource;
    RFE_Forder_KHG5.SetParentComponent(pnSonstiges);
    RFE_Forder_KHG5.Name := 'RFE_Forder_KHG5';
    RFE_Forder_KHG5.Left := 1221;
    RFE_Forder_KHG5.Top := 242;
    RFE_Forder_KHG5.Width := 150;
    RFE_Forder_KHG5.Height := 46;
    RFE_Forder_KHG5.ChildOrder := 50;
    RFE_Forder_KHG5.EditType := weSignedNumeric;
    RFE_Forder_KHG5.ElementFont := efCSS;
    RFE_Forder_KHG5.Font.Charset := ANSI_CHARSET;
    RFE_Forder_KHG5.Font.Color := clWindowText;
    RFE_Forder_KHG5.Font.Height := -24;
    RFE_Forder_KHG5.Font.Name := 'Segoe UI';
    RFE_Forder_KHG5.Font.Style := [fsBold];
    RFE_Forder_KHG5.HeightStyle := ssAuto;
    RFE_Forder_KHG5.HeightPercent := 100.00000000000000000;
    RFE_Forder_KHG5.ParentFont := False;
    RFE_Forder_KHG5.TabOrder := 35;
    RFE_Forder_KHG5.Text := ' ';
    RFE_Forder_KHG5.WidthPercent := 100.00000000000000000;
    RFE_Forder_KHG5.DataField := 'Hhmc_Requirements';
    RFE_Forder_KHG5.DataSource := HospitalMisc5WebDataSource;
    RFE_Dummy5.SetParentComponent(pnSonstiges);
    RFE_Dummy5.Name := 'RFE_Dummy5';
    RFE_Dummy5.Left := 1221;
    RFE_Dummy5.Top := 294;
    RFE_Dummy5.Width := 150;
    RFE_Dummy5.Height := 46;
    RFE_Dummy5.ChildOrder := 51;
    RFE_Dummy5.EditType := weSignedNumeric;
    RFE_Dummy5.ElementFont := efCSS;
    RFE_Dummy5.Font.Charset := ANSI_CHARSET;
    RFE_Dummy5.Font.Color := clWindowText;
    RFE_Dummy5.Font.Height := -24;
    RFE_Dummy5.Font.Name := 'Segoe UI';
    RFE_Dummy5.Font.Style := [fsBold];
    RFE_Dummy5.HeightStyle := ssAuto;
    RFE_Dummy5.HeightPercent := 100.00000000000000000;
    RFE_Dummy5.ParentFont := False;
    RFE_Dummy5.TabOrder := 36;
    RFE_Dummy5.Text := ' ';
    RFE_Dummy5.WidthPercent := 100.00000000000000000;
    RFE_Dummy5.DataField := 'Hhmc_Misc_2';
    RFE_Dummy5.DataSource := HospitalMisc5WebDataSource;
    RFE_Verblk_KHG5.SetParentComponent(pnSonstiges);
    RFE_Verblk_KHG5.Name := 'RFE_Verblk_KHG5';
    RFE_Verblk_KHG5.Left := 1221;
    RFE_Verblk_KHG5.Top := 346;
    RFE_Verblk_KHG5.Width := 150;
    RFE_Verblk_KHG5.Height := 46;
    RFE_Verblk_KHG5.ChildOrder := 52;
    RFE_Verblk_KHG5.EditType := weSignedNumeric;
    RFE_Verblk_KHG5.ElementFont := efCSS;
    RFE_Verblk_KHG5.Font.Charset := ANSI_CHARSET;
    RFE_Verblk_KHG5.Font.Color := clWindowText;
    RFE_Verblk_KHG5.Font.Height := -24;
    RFE_Verblk_KHG5.Font.Name := 'Segoe UI';
    RFE_Verblk_KHG5.Font.Style := [fsBold];
    RFE_Verblk_KHG5.HeightStyle := ssAuto;
    RFE_Verblk_KHG5.HeightPercent := 100.00000000000000000;
    RFE_Verblk_KHG5.ParentFont := False;
    RFE_Verblk_KHG5.TabOrder := 37;
    RFE_Verblk_KHG5.Text := ' ';
    RFE_Verblk_KHG5.WidthPercent := 100.00000000000000000;
    RFE_Verblk_KHG5.DataField := 'Hhmc_Liabilities';
    RFE_Verblk_KHG5.DataSource := HospitalMisc5WebDataSource;
    RFE_Kapitalerh5.SetParentComponent(pnSonstiges);
    RFE_Kapitalerh5.Name := 'RFE_Kapitalerh5';
    RFE_Kapitalerh5.Left := 1221;
    RFE_Kapitalerh5.Top := 398;
    RFE_Kapitalerh5.Width := 150;
    RFE_Kapitalerh5.Height := 46;
    RFE_Kapitalerh5.ChildOrder := 53;
    RFE_Kapitalerh5.EditType := weSignedNumeric;
    RFE_Kapitalerh5.ElementFont := efCSS;
    RFE_Kapitalerh5.Font.Charset := ANSI_CHARSET;
    RFE_Kapitalerh5.Font.Color := clWindowText;
    RFE_Kapitalerh5.Font.Height := -24;
    RFE_Kapitalerh5.Font.Name := 'Segoe UI';
    RFE_Kapitalerh5.Font.Style := [fsBold];
    RFE_Kapitalerh5.HeightStyle := ssAuto;
    RFE_Kapitalerh5.HeightPercent := 100.00000000000000000;
    RFE_Kapitalerh5.ParentFont := False;
    RFE_Kapitalerh5.TabOrder := 38;
    RFE_Kapitalerh5.Text := ' ';
    RFE_Kapitalerh5.WidthPercent := 100.00000000000000000;
    RFE_Kapitalerh5.DataField := 'Hhmc_Capital_Increase';
    RFE_Kapitalerh5.DataSource := HospitalMisc5WebDataSource;
    RFE_FoerderMtl5.SetParentComponent(pnSonstiges);
    RFE_FoerderMtl5.Name := 'RFE_FoerderMtl5';
    RFE_FoerderMtl5.Left := 1221;
    RFE_FoerderMtl5.Top := 450;
    RFE_FoerderMtl5.Width := 150;
    RFE_FoerderMtl5.Height := 46;
    RFE_FoerderMtl5.ChildOrder := 54;
    RFE_FoerderMtl5.EditType := weSignedNumeric;
    RFE_FoerderMtl5.ElementFont := efCSS;
    RFE_FoerderMtl5.Font.Charset := ANSI_CHARSET;
    RFE_FoerderMtl5.Font.Color := clWindowText;
    RFE_FoerderMtl5.Font.Height := -24;
    RFE_FoerderMtl5.Font.Name := 'Segoe UI';
    RFE_FoerderMtl5.Font.Style := [fsBold];
    RFE_FoerderMtl5.HeightStyle := ssAuto;
    RFE_FoerderMtl5.HeightPercent := 100.00000000000000000;
    RFE_FoerderMtl5.ParentFont := False;
    RFE_FoerderMtl5.TabOrder := 39;
    RFE_FoerderMtl5.Text := ' ';
    RFE_FoerderMtl5.WidthPercent := 100.00000000000000000;
    RFE_FoerderMtl5.DataField := 'Hhmc_Earmarked_Funding';
    RFE_FoerderMtl5.DataSource := HospitalMisc5WebDataSource;
    pnVerwaltung.SetParentComponent(pgSeite5);
    pnVerwaltung.Name := 'pnVerwaltung';
    pnVerwaltung.Left := 283;
    pnVerwaltung.Top := 235;
    pnVerwaltung.Width := 150;
    pnVerwaltung.Height := 60;
    pnVerwaltung.HeightStyle := ssAuto;
    pnVerwaltung.WidthStyle := ssAuto;
    pnVerwaltung.ChildOrder := 16;
    pnVerwaltung.ElementFont := efCSS;
    pnVerwaltung.ElementPosition := epIgnore;
    pnVerwaltung.TabOrder := 4;
    WebLabel101.SetParentComponent(pnVerwaltung);
    WebLabel101.Name := 'WebLabel101';
    WebLabel101.Left := 12;
    WebLabel101.Top := 19;
    WebLabel101.Width := 71;
    WebLabel101.Height := 18;
    WebLabel101.Caption := 'Verwaltung';
    WebLabel101.ElementFont := efCSS;
    WebLabel101.ElementPosition := epRelative;
    WebLabel101.HeightStyle := ssAuto;
    WebLabel101.HeightPercent := 100.00000000000000000;
    WebLabel101.HTMLType := tH3;
    WebLabel101.WidthPercent := 100.00000000000000000;
    pgSeite6.SetParentComponent(PageControl);
    pgSeite6.Name := 'pgSeite6';
    pgSeite6.Left := 0;
    pgSeite6.Top := 20;
    pgSeite6.Width := 1901;
    pgSeite6.Height := 1506;
    pgSeite6.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite6.HeightStyle := ssAuto;
    pgSeite6.WidthStyle := ssAuto;
    pgSeite6.Caption := 'Softskills';
    pgSeite6.ChildOrder := 5;
    pgSeite6.ElementFont := efCSS;
    pgSeite6.ElementPosition := epRelative;
    pnSoftSkills.SetParentComponent(pgSeite6);
    pnSoftSkills.Name := 'pnSoftSkills';
    pnSoftSkills.Left := 0;
    pnSoftSkills.Top := 0;
    pnSoftSkills.Width := 1901;
    pnSoftSkills.Height := 897;
    pnSoftSkills.Align := alTop;
    pnSoftSkills.ElementFont := efCSS;
    pnSoftSkills.TabOrder := 0;
    WebLabel37.SetParentComponent(pnSoftSkills);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 128;
    WebLabel37.Top := 32;
    WebLabel37.Width := 53;
    WebLabel37.Height := 18;
    WebLabel37.Caption := 'Softskills';
    WebLabel37.ElementFont := efCSS;
    WebLabel37.ElementPosition := epRelative;
    WebLabel37.HeightStyle := ssAuto;
    WebLabel37.HeightPercent := 100.00000000000000000;
    WebLabel37.HTMLType := tH3;
    WebLabel37.WidthPercent := 100.00000000000000000;
    strGridSoftSkills.SetParentComponent(pnSoftSkills);
    strGridSoftSkills.Name := 'strGridSoftSkills';
    strGridSoftSkills.Left := 138;
    strGridSoftSkills.Top := 109;
    strGridSoftSkills.Width := 613;
    strGridSoftSkills.Height := 494;
    strGridSoftSkills.ColCount := 6;
    strGridSoftSkills.RowCount := 12;
    strGridSoftSkills.TabOrder := 0;
    SetEvent(strGridSoftSkills, Self, 'OnGetEditText', 'strGridSoftSkillsGetEditText');
    SetEvent(strGridSoftSkills, Self, 'OnSetEditText', 'strGridSoftSkillsSetEditText');
    strGridSoftSkills.ElementFont := efCSS;
    strGridSoftSkills.ElementPosition := epRelative;
    strGridSoftSkills.FixedFont.Charset := DEFAULT_CHARSET;
    strGridSoftSkills.FixedFont.Color := clWindowText;
    strGridSoftSkills.FixedFont.Height := -18;
    strGridSoftSkills.FixedFont.Name := 'Segoe UI';
    strGridSoftSkills.FixedFont.Style := [];
    strGridSoftSkills.RangeEdit.Max := 100.00000000000000000;
    strGridSoftSkills.RangeEdit.Step := 1.00000000000000000;
    strGridSoftSkills.HeightStyle := ssAuto;
    strGridSoftSkills.HeightPercent := 100.00000000000000000;
    strGridSoftSkills.WidthStyle := ssAuto;
    strGridSoftSkills.WidthPercent := 100.00000000000000000;
    DRGDataSource.SetParentComponent(Self);
    DRGDataSource.Name := 'DRGDataSource';
    DRGDataSource.DataSet := XDataWebDataSetDRG;
    SetEvent(DRGDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    DRGDataSource.Left := 1346;
    DRGDataSource.Top := 960;
    XDataWebDataSetDRG.SetParentComponent(Self);
    XDataWebDataSetDRG.Name := 'XDataWebDataSetDRG';
    XDataWebDataSetDRG.AfterOpen := XDataWebDataSetDRGAfterOpen;
    XDataWebDataSetDRG.EntitySetName := 'Tblhbm_Department_Related_Drg';
    XDataWebDataSetDRG.Connection := XDataWebConnection1;
    XDataWebDataSetDRG.Left := 1186;
    XDataWebDataSetDRG.Top := 968;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://hbm-online.eu/MFCWebServices/';
    XDataWebConnection1.Left := 1626;
    XDataWebConnection1.Top := 1144;
    XDataWebDataSetPeriode.SetParentComponent(Self);
    XDataWebDataSetPeriode.Name := 'XDataWebDataSetPeriode';
    XDataWebDataSetPeriode.AfterOpen := XDataWebDataSetPeriodeAfterOpen;
    XDataWebDataSetPeriode.EntitySetName := 'Tblhbm_Periodic_Data';
    XDataWebDataSetPeriode.Connection := XDataWebConnection1;
    XDataWebDataSetPeriode.Left := 1626;
    XDataWebDataSetPeriode.Top := 961;
    XDataWebDataSetPersonalDaten.SetParentComponent(Self);
    XDataWebDataSetPersonalDaten.Name := 'XDataWebDataSetPersonalDaten';
    XDataWebDataSetPersonalDaten.AfterOpen := XDataWebDataSetPersonalDatenAfterOpen;
    XDataWebDataSetPersonalDaten.EntitySetName := 'Tblhbm_Finance_Data';
    XDataWebDataSetPersonalDaten.Connection := XDataWebConnection1;
    XDataWebDataSetPersonalDaten.Left := 1186;
    XDataWebDataSetPersonalDaten.Top := 1048;
    PersonalDataSource.SetParentComponent(Self);
    PersonalDataSource.Name := 'PersonalDataSource';
    PersonalDataSource.DataSet := XDataWebDataSetPersonalDaten;
    SetEvent(PersonalDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    PersonalDataSource.Left := 1346;
    PersonalDataSource.Top := 1048;
    XDataWebDataSetHospitalMisc1.SetParentComponent(Self);
    XDataWebDataSetHospitalMisc1.Name := 'XDataWebDataSetHospitalMisc1';
    XDataWebDataSetHospitalMisc1.AfterOpen := XDataWebDataSetHospitalMisc1AfterOpen;
    XDataWebDataSetHospitalMisc1.EntitySetName := 'Tblhbm_Hospital_Miscellaneous';
    XDataWebDataSetHospitalMisc1.Connection := XDataWebConnection1;
    XDataWebDataSetHospitalMisc1.Left := 154;
    XDataWebDataSetHospitalMisc1.Top := 1032;
    HospitalMisc1WebDataSource.SetParentComponent(Self);
    HospitalMisc1WebDataSource.Name := 'HospitalMisc1WebDataSource';
    HospitalMisc1WebDataSource.DataSet := XDataWebDataSetHospitalMisc1;
    SetEvent(HospitalMisc1WebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    HospitalMisc1WebDataSource.Left := 338;
    HospitalMisc1WebDataSource.Top := 1032;
    XDataWebDataSetHospital.SetParentComponent(Self);
    XDataWebDataSetHospital.Name := 'XDataWebDataSetHospital';
    XDataWebDataSetHospital.AfterOpen := XDataWebDataSetHospitalAfterOpen;
    XDataWebDataSetHospital.EntitySetName := 'Tblhbm_Hospitals';
    XDataWebDataSetHospital.Connection := XDataWebConnection1;
    XDataWebDataSetHospital.Left := 1626;
    XDataWebDataSetHospital.Top := 1041;
    XDataWebDataSetWahlleistungen.SetParentComponent(Self);
    XDataWebDataSetWahlleistungen.Name := 'XDataWebDataSetWahlleistungen';
    XDataWebDataSetWahlleistungen.AfterOpen := XDataWebDataSetWahlleistungenAfterOpen;
    XDataWebDataSetWahlleistungen.EntitySetName := 'Tblhbm_Optional_Services';
    XDataWebDataSetWahlleistungen.Connection := XDataWebConnection1;
    XDataWebDataSetWahlleistungen.Left := 1162;
    XDataWebDataSetWahlleistungen.Top := 1232;
    WahlleistungenWebDataSource.SetParentComponent(Self);
    WahlleistungenWebDataSource.Name := 'WahlleistungenWebDataSource';
    WahlleistungenWebDataSource.DataSet := XDataWebDataSetWahlleistungen;
    SetEvent(WahlleistungenWebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    WahlleistungenWebDataSource.Left := 1394;
    WahlleistungenWebDataSource.Top := 1232;
    XDataWebDataSetHospitalMisc2.SetParentComponent(Self);
    XDataWebDataSetHospitalMisc2.Name := 'XDataWebDataSetHospitalMisc2';
    XDataWebDataSetHospitalMisc2.AfterOpen := XDataWebDataSetHospitalMisc2AfterOpen;
    XDataWebDataSetHospitalMisc2.EntitySetName := 'Tblhbm_Hospital_Miscellaneous';
    XDataWebDataSetHospitalMisc2.Connection := XDataWebConnection1;
    XDataWebDataSetHospitalMisc2.Left := 154;
    XDataWebDataSetHospitalMisc2.Top := 1096;
    XDataWebDataSetHospitalMisc3.SetParentComponent(Self);
    XDataWebDataSetHospitalMisc3.Name := 'XDataWebDataSetHospitalMisc3';
    XDataWebDataSetHospitalMisc3.AfterOpen := XDataWebDataSetHospitalMisc3AfterOpen;
    XDataWebDataSetHospitalMisc3.EntitySetName := 'Tblhbm_Hospital_Miscellaneous';
    XDataWebDataSetHospitalMisc3.Connection := XDataWebConnection1;
    XDataWebDataSetHospitalMisc3.Left := 154;
    XDataWebDataSetHospitalMisc3.Top := 1160;
    XDataWebDataSetHospitalMisc4.SetParentComponent(Self);
    XDataWebDataSetHospitalMisc4.Name := 'XDataWebDataSetHospitalMisc4';
    XDataWebDataSetHospitalMisc4.AfterOpen := XDataWebDataSetHospitalMisc4AfterOpen;
    XDataWebDataSetHospitalMisc4.EntitySetName := 'Tblhbm_Hospital_Miscellaneous';
    XDataWebDataSetHospitalMisc4.Connection := XDataWebConnection1;
    XDataWebDataSetHospitalMisc4.Left := 154;
    XDataWebDataSetHospitalMisc4.Top := 1224;
    XDataWebDataSetHospitalMisc5.SetParentComponent(Self);
    XDataWebDataSetHospitalMisc5.Name := 'XDataWebDataSetHospitalMisc5';
    XDataWebDataSetHospitalMisc5.AfterOpen := XDataWebDataSetHospitalMisc5AfterOpen;
    XDataWebDataSetHospitalMisc5.EntitySetName := 'Tblhbm_Hospital_Miscellaneous';
    XDataWebDataSetHospitalMisc5.Connection := XDataWebConnection1;
    XDataWebDataSetHospitalMisc5.Left := 154;
    XDataWebDataSetHospitalMisc5.Top := 1288;
    HospitalMisc2WebDataSource.SetParentComponent(Self);
    HospitalMisc2WebDataSource.Name := 'HospitalMisc2WebDataSource';
    HospitalMisc2WebDataSource.DataSet := XDataWebDataSetHospitalMisc2;
    SetEvent(HospitalMisc2WebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    HospitalMisc2WebDataSource.Left := 338;
    HospitalMisc2WebDataSource.Top := 1104;
    HospitalMisc3WebDataSource.SetParentComponent(Self);
    HospitalMisc3WebDataSource.Name := 'HospitalMisc3WebDataSource';
    HospitalMisc3WebDataSource.DataSet := XDataWebDataSetHospitalMisc3;
    SetEvent(HospitalMisc3WebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    HospitalMisc3WebDataSource.Left := 346;
    HospitalMisc3WebDataSource.Top := 1176;
    HospitalMisc4WebDataSource.SetParentComponent(Self);
    HospitalMisc4WebDataSource.Name := 'HospitalMisc4WebDataSource';
    HospitalMisc4WebDataSource.DataSet := XDataWebDataSetHospitalMisc4;
    SetEvent(HospitalMisc4WebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    HospitalMisc4WebDataSource.Left := 346;
    HospitalMisc4WebDataSource.Top := 1232;
    HospitalMisc5WebDataSource.SetParentComponent(Self);
    HospitalMisc5WebDataSource.Name := 'HospitalMisc5WebDataSource';
    HospitalMisc5WebDataSource.DataSet := XDataWebDataSetHospitalMisc5;
    SetEvent(HospitalMisc5WebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    HospitalMisc5WebDataSource.Left := 346;
    HospitalMisc5WebDataSource.Top := 1288;
    XDataWebDataSetPeriodMisc.SetParentComponent(Self);
    XDataWebDataSetPeriodMisc.Name := 'XDataWebDataSetPeriodMisc';
    XDataWebDataSetPeriodMisc.AfterOpen := XDataWebDataSetPeriodMiscAfterOpen;
    XDataWebDataSetPeriodMisc.EntitySetName := 'Tblhbm_Periodic_Miscellaneous';
    XDataWebDataSetPeriodMisc.Connection := XDataWebConnection1;
    XDataWebDataSetPeriodMisc.Left := 154;
    XDataWebDataSetPeriodMisc.Top := 1408;
    PeriodMiscWebDataSource.SetParentComponent(Self);
    PeriodMiscWebDataSource.Name := 'PeriodMiscWebDataSource';
    PeriodMiscWebDataSource.DataSet := XDataWebDataSetPeriodMisc;
    SetEvent(PeriodMiscWebDataSource, Self, 'OnDataChange', 'DRGDataSourceDataChange');
    PeriodMiscWebDataSource.Left := 370;
    PeriodMiscWebDataSource.Top := 1408;
  finally
    WaitMessage.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    lblAbteilung.AfterLoadDFMValues;
    lblFallnummer.AfterLoadDFMValues;
    lblNAVFallName.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    spedAbteilung.AfterLoadDFMValues;
    spedFallNummer.AfterLoadDFMValues;
    cbxFallName.AfterLoadDFMValues;
    PageControl.AfterLoadDFMValues;
    pgSeite1.AfterLoadDFMValues;
    pnErloeseWahlleistung.AfterLoadDFMValues;
    Lab0_Stat11.AfterLoadDFMValues;
    Lab0_Stat21.AfterLoadDFMValues;
    Lab0_Stat31.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    lblAbteilungsName.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    RFE_Stat1Unterk.AfterLoadDFMValues;
    RFE_Stat2Unterk.AfterLoadDFMValues;
    RFE_Stat3Unterk.AfterLoadDFMValues;
    RFE_Stat1Arzt.AfterLoadDFMValues;
    RFE_Stat2Arzt.AfterLoadDFMValues;
    RFE_Stat3Arzt.AfterLoadDFMValues;
    pnErloesKorrekturen.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel72.AfterLoadDFMValues;
    WebLabel106.AfterLoadDFMValues;
    WebLabel109.AfterLoadDFMValues;
    WebLabel110.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel111.AfterLoadDFMValues;
    WebLabel114.AfterLoadDFMValues;
    WebLabel115.AfterLoadDFMValues;
    WebLabel116.AfterLoadDFMValues;
    RFE_ErlKorrU1.AfterLoadDFMValues;
    RFE_ErlKorrU2.AfterLoadDFMValues;
    RFE_ErlKorrU3.AfterLoadDFMValues;
    RFE_ErlKorrU4.AfterLoadDFMValues;
    RFE_ErlKorrU5.AfterLoadDFMValues;
    pnInvestKosten.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    RFE_InvestProBett.AfterLoadDFMValues;
    cbxkhEinsMVZCheckbox.AfterLoadDFMValues;
    cbxkhZweiMVZCheckbox.AfterLoadDFMValues;
    cbxkhDreiMVZCheckbox.AfterLoadDFMValues;
    cbxkhVierMVZCheckbox.AfterLoadDFMValues;
    cbxkhFuenfMVZCheckbox.AfterLoadDFMValues;
    pnUmwandlungKosten.AfterLoadDFMValues;
    Lab0_Stat14.AfterLoadDFMValues;
    Lab0_Stat24.AfterLoadDFMValues;
    Lab0_Stat34.AfterLoadDFMValues;
    Lab0_Stat13.AfterLoadDFMValues;
    Lab0_Stat23.AfterLoadDFMValues;
    Lab0_Stat33.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel70.AfterLoadDFMValues;
    RFE_UmwKoS2toS1.AfterLoadDFMValues;
    RFE_UmwKoS3toS1.AfterLoadDFMValues;
    RFE_UmwKoS1toS2.AfterLoadDFMValues;
    RFE_UmwKoS3toS2.AfterLoadDFMValues;
    RFE_UmwKoS1toS3.AfterLoadDFMValues;
    RFE_UmwKoS2toS3.AfterLoadDFMValues;
    WebMessageDlg.AfterLoadDFMValues;
    pgSeite3.AfterLoadDFMValues;
    pnDRGVerwaltung.AfterLoadDFMValues;
    WebLabel102.AfterLoadDFMValues;
    strGridStationCosts.AfterLoadDFMValues;
    pnErloeseKorrekturen.AfterLoadDFMValues;
    Lab_ErloesKor.AfterLoadDFMValues;
    Lab_agErloes.AfterLoadDFMValues;
    Lab_PflgErloes.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel103.AfterLoadDFMValues;
    WebLabel104.AfterLoadDFMValues;
    pnAnteileMode.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    lblFallName.AfterLoadDFMValues;
    WebLabel100.AfterLoadDFMValues;
    WebLabel99.AfterLoadDFMValues;
    RF2_agBewRel.AfterLoadDFMValues;
    RF2_PflgBewRel.AfterLoadDFMValues;
    RFE_PflgWert.AfterLoadDFMValues;
    RFE_FallBaWert.AfterLoadDFMValues;
    pnFallZahlen.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    weblabStation1.AfterLoadDFMValues;
    weblabStation2.AfterLoadDFMValues;
    weblabStation3.AfterLoadDFMValues;
    WebLabel44.AfterLoadDFMValues;
    WebLabel45.AfterLoadDFMValues;
    WebLabel46.AfterLoadDFMValues;
    WebLabel47.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel105.AfterLoadDFMValues;
    LF2_Fallzahl.AfterLoadDFMValues;
    LF2_Stati1.AfterLoadDFMValues;
    LF2_Stati2.AfterLoadDFMValues;
    LF2_Stati3.AfterLoadDFMValues;
    RF2_MVerwd.AfterLoadDFMValues;
    RF2_GVerwD.AfterLoadDFMValues;
    RF2_UebAnt.AfterLoadDFMValues;
    RF2_UebTag.AfterLoadDFMValues;
    pgSeite4.AfterLoadDFMValues;
    pnPersonalDaten.AfterLoadDFMValues;
    WebLabel49.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel52.AfterLoadDFMValues;
    WebLabel53.AfterLoadDFMValues;
    WebLabel54.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    WebLabel58.AfterLoadDFMValues;
    WebLabel59.AfterLoadDFMValues;
    WebLabel60.AfterLoadDFMValues;
    WebLabel61.AfterLoadDFMValues;
    WebLabel62.AfterLoadDFMValues;
    WebLabel63.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel65.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel67.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    LFE_ArbZeitA.AfterLoadDFMValues;
    RFE_StdSatzA.AfterLoadDFMValues;
    RFE_GehNebKoA.AfterLoadDFMValues;
    RFE_MaxUeberA.AfterLoadDFMValues;
    RFE_UeZuschlA.AfterLoadDFMValues;
    RFE_EinstlKoA.AfterLoadDFMValues;
    RFE_EntlasKoA.AfterLoadDFMValues;
    RFE_MaxEinstA.AfterLoadDFMValues;
    RFE_MaxEntlaA.AfterLoadDFMValues;
    RFE_TrainKstA.AfterLoadDFMValues;
    RFE_FremdPKoA.AfterLoadDFMValues;
    RFE_GehChefA.AfterLoadDFMValues;
    LFE_ArbZeitP.AfterLoadDFMValues;
    RFE_StdSatzP.AfterLoadDFMValues;
    RFE_GehNebKoP.AfterLoadDFMValues;
    RFE_MaxUeberP.AfterLoadDFMValues;
    RFE_UeZuschlP.AfterLoadDFMValues;
    RFE_EinstlKoP.AfterLoadDFMValues;
    RFE_EntlasKoP.AfterLoadDFMValues;
    RFE_MaxEinstP.AfterLoadDFMValues;
    RFE_MaxEntlaP.AfterLoadDFMValues;
    RFE_TrainKstP.AfterLoadDFMValues;
    RFE_FremdPKoP.AfterLoadDFMValues;
    LFE_ArbZeitM.AfterLoadDFMValues;
    RFE_StdSatzM.AfterLoadDFMValues;
    RFE_GehNebKoM.AfterLoadDFMValues;
    RFE_MaxUeberM.AfterLoadDFMValues;
    RFE_UeZuschlM.AfterLoadDFMValues;
    RFE_EinstlKoM.AfterLoadDFMValues;
    RFE_EntlasKoM.AfterLoadDFMValues;
    RFE_MaxEinstM.AfterLoadDFMValues;
    RFE_MaxEntlaM.AfterLoadDFMValues;
    RFE_TrainKstM.AfterLoadDFMValues;
    RFE_FremdPKoM.AfterLoadDFMValues;
    RFE_GehDirek.AfterLoadDFMValues;
    RFE_Rueckst.AfterLoadDFMValues;
    RFE_AbFktGN.AfterLoadDFMValues;
    RFE_AnGZeit.AfterLoadDFMValues;
    pnFinanzdaten.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    RFE_ZinsUeberz.AfterLoadDFMValues;
    RFE_ZinsKurzfr.AfterLoadDFMValues;
    RFE_ZinsLangfr.AfterLoadDFMValues;
    RFE_ZinsAnlage.AfterLoadDFMValues;
    RFE_SteuerSatz1.AfterLoadDFMValues;
    RFE_SteuerSatz2.AfterLoadDFMValues;
    RFE_KassenMind.AfterLoadDFMValues;
    RFE_FoerderBett.AfterLoadDFMValues;
    RFE_Sonstiges1.AfterLoadDFMValues;
    pgSeite5.AfterLoadDFMValues;
    pnCodierDienst.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel90.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebLabel93.AfterLoadDFMValues;
    WebLabel95.AfterLoadDFMValues;
    RFE_FallSatz.AfterLoadDFMValues;
    RFE_FaellePro.AfterLoadDFMValues;
    RFE_CodLeasing.AfterLoadDFMValues;
    RFE_CodInfrStr.AfterLoadDFMValues;
    pnGenerelles.AfterLoadDFMValues;
    WebLabel81.AfterLoadDFMValues;
    WebLabel82.AfterLoadDFMValues;
    WebLabel83.AfterLoadDFMValues;
    WebLabel84.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel86.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel88.AfterLoadDFMValues;
    WebLabel94.AfterLoadDFMValues;
    RFE_AbschrDAnl.AfterLoadDFMValues;
    RFE_AbschrSGeb.AfterLoadDFMValues;
    RFE_AbschrDEin.AfterLoadDFMValues;
    RFE_AbtRestBdg.AfterLoadDFMValues;
    RFE_Patientver.AfterLoadDFMValues;
    RFE_AntWahlL.AfterLoadDFMValues;
    RFE_InstndSI.AfterLoadDFMValues;
    RFE_InstndSA.AfterLoadDFMValues;
    pnKassenDaten.AfterLoadDFMValues;
    WebLabel96.AfterLoadDFMValues;
    WebLabel97.AfterLoadDFMValues;
    WebLabel98.AfterLoadDFMValues;
    WebLabel92.AfterLoadDFMValues;
    WebLabel112.AfterLoadDFMValues;
    WebLabel113.AfterLoadDFMValues;
    RFE_PktKorrFkt.AfterLoadDFMValues;
    RFE_PktWertPer.AfterLoadDFMValues;
    RFE_PktWertMed.AfterLoadDFMValues;
    RFE_AntRestErl.AfterLoadDFMValues;
    RFE_VerwKosten.AfterLoadDFMValues;
    pnSonstiges.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebLabel69.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel73.AfterLoadDFMValues;
    WebLabel74.AfterLoadDFMValues;
    WebLabel75.AfterLoadDFMValues;
    lblKrankenhaus1.AfterLoadDFMValues;
    lblKrankenhaus2.AfterLoadDFMValues;
    lblKrankenhaus3.AfterLoadDFMValues;
    lblKrankenhaus4.AfterLoadDFMValues;
    lblKrankenhaus5.AfterLoadDFMValues;
    WebLabel107.AfterLoadDFMValues;
    WebLabel108.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    RFE_AusOrdAufw1.AfterLoadDFMValues;
    RFE_AusOrdErtr1.AfterLoadDFMValues;
    RFE_ForderTrag1.AfterLoadDFMValues;
    RFE_Forder_KHG1.AfterLoadDFMValues;
    RFE_Dummy1.AfterLoadDFMValues;
    RFE_Verblk_KHG1.AfterLoadDFMValues;
    RFE_Kapitalerh1.AfterLoadDFMValues;
    RFE_FoerderMtl1.AfterLoadDFMValues;
    RFE_AusOrdAufw2.AfterLoadDFMValues;
    RFE_AusOrdErtr2.AfterLoadDFMValues;
    RFE_ForderTrag2.AfterLoadDFMValues;
    RFE_Forder_KHG2.AfterLoadDFMValues;
    RFE_Dummy2.AfterLoadDFMValues;
    RFE_Verblk_KHG2.AfterLoadDFMValues;
    RFE_Kapitalerh2.AfterLoadDFMValues;
    RFE_FoerderMtl2.AfterLoadDFMValues;
    RFE_AusOrdAufw3.AfterLoadDFMValues;
    RFE_AusOrdErtr3.AfterLoadDFMValues;
    RFE_ForderTrag3.AfterLoadDFMValues;
    RFE_Forder_KHG3.AfterLoadDFMValues;
    RFE_Dummy3.AfterLoadDFMValues;
    RFE_Verblk_KHG3.AfterLoadDFMValues;
    RFE_Kapitalerh3.AfterLoadDFMValues;
    RFE_FoerderMtl3.AfterLoadDFMValues;
    RFE_AusOrdAufw4.AfterLoadDFMValues;
    RFE_AusOrdErtr4.AfterLoadDFMValues;
    RFE_ForderTrag4.AfterLoadDFMValues;
    RFE_Forder_KHG4.AfterLoadDFMValues;
    RFE_Dummy4.AfterLoadDFMValues;
    RFE_Verblk_KHG4.AfterLoadDFMValues;
    RFE_Kapitalerh4.AfterLoadDFMValues;
    RFE_FoerderMtl4.AfterLoadDFMValues;
    RFE_AusOrdAufw5.AfterLoadDFMValues;
    RFE_AusOrdErtr5.AfterLoadDFMValues;
    RFE_ForderTrag5.AfterLoadDFMValues;
    RFE_Forder_KHG5.AfterLoadDFMValues;
    RFE_Dummy5.AfterLoadDFMValues;
    RFE_Verblk_KHG5.AfterLoadDFMValues;
    RFE_Kapitalerh5.AfterLoadDFMValues;
    RFE_FoerderMtl5.AfterLoadDFMValues;
    pnVerwaltung.AfterLoadDFMValues;
    WebLabel101.AfterLoadDFMValues;
    pgSeite6.AfterLoadDFMValues;
    pnSoftSkills.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    strGridSoftSkills.AfterLoadDFMValues;
    DRGDataSource.AfterLoadDFMValues;
    XDataWebDataSetDRG.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
    XDataWebDataSetPeriode.AfterLoadDFMValues;
    XDataWebDataSetPersonalDaten.AfterLoadDFMValues;
    PersonalDataSource.AfterLoadDFMValues;
    XDataWebDataSetHospitalMisc1.AfterLoadDFMValues;
    HospitalMisc1WebDataSource.AfterLoadDFMValues;
    XDataWebDataSetHospital.AfterLoadDFMValues;
    XDataWebDataSetWahlleistungen.AfterLoadDFMValues;
    WahlleistungenWebDataSource.AfterLoadDFMValues;
    XDataWebDataSetHospitalMisc2.AfterLoadDFMValues;
    XDataWebDataSetHospitalMisc3.AfterLoadDFMValues;
    XDataWebDataSetHospitalMisc4.AfterLoadDFMValues;
    XDataWebDataSetHospitalMisc5.AfterLoadDFMValues;
    HospitalMisc2WebDataSource.AfterLoadDFMValues;
    HospitalMisc3WebDataSource.AfterLoadDFMValues;
    HospitalMisc4WebDataSource.AfterLoadDFMValues;
    HospitalMisc5WebDataSource.AfterLoadDFMValues;
    XDataWebDataSetPeriodMisc.AfterLoadDFMValues;
    PeriodMiscWebDataSource.AfterLoadDFMValues;
  end;
end;

end.

